'use strict';

var _objectWithoutProperties = require('@babel/runtime-corejs3/helpers/objectWithoutProperties');
var _asyncToGenerator = require('@babel/runtime-corejs3/helpers/asyncToGenerator');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _globalThis = require('@babel/runtime-corejs3/core-js/global-this');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _globalThis__default = /*#__PURE__*/_interopDefaultLegacy(_globalThis);

var defaults = (() => ({
  translateURL: typeof window != 'undefined' && window.location.origin || '',
  translatePrefix: '',
  fetchConfig: {},
  initialItems: [],
  request: {},
  storage: typeof window != 'undefined' && 'localStorage' in window && window.localStorage || {},
  persist: true,
  override: false,
  storagePrefix: 'zotero-bib'
}));

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var utilities_item = {exports: {}};

/*
	***** BEGIN LICENSE BLOCK *****
	
	Copyright © 2021 Corporation for Digital Scholarship
                     Vienna, Virginia, USA
					http://zotero.org
	
	This file is part of Zotero.
	
	Zotero is free software: you can redistribute it and/or modify
	it under the terms of the GNU Affero General Public License as published by
	the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.
	
	Zotero is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU Affero General Public License for more details.

	You should have received a copy of the GNU Affero General Public License
	along with Zotero.  If not, see <http://www.gnu.org/licenses/>.
	
	***** END LICENSE BLOCK *****
*/

(function (module) {
(function() {

// Various Utility functions related to Zotero, API, Translation Item formats
// and their conversion or field access.

var Utilities_Item = {
	PARTICLE_GIVEN_REGEXP: /^([^ ]+(?:\u02bb |\u2019 | |\' ) *)(.+)$/,
	PARTICLE_FAMILY_REGEXP: /^([^ ]+(?:\-|\u02bb|\u2019| |\') *)(.+)$/,
	
	/**
	 * Tests if an item type exists
	 *
	 * @param {String} type Item type
	 * @type Boolean
	 */
	itemTypeExists: function(type) {
		return !!Zotero.ItemTypes.getID(type);
	},

	/**
	 * Converts an item from toArray() format to citeproc-js JSON
	 * @param {Zotero.Item} zoteroItem
	 * @return {Object|Promise<Object>} A CSL item, or a promise for a CSL item if a Zotero.Item
	 *     is passed
	 */
	itemToCSLJSON: function(zoteroItem) {
		// If a Zotero.Item was passed, convert it to the proper format (skipping child items) and
		// call this function again with that object
		//
		// (Zotero.Item won't be defined in translation-server)
		if (typeof Zotero.Item !== 'undefined' && zoteroItem instanceof Zotero.Item) {
			return Utilities_Item.itemToCSLJSON(
				Zotero.Utilities.Internal.itemToExportFormat(zoteroItem, false, true)
			);
		}

		var cslType = Zotero.Schema.CSL_TYPE_MAPPINGS[zoteroItem.itemType];
		if (!cslType) {
			throw new Error('Unexpected Zotero Item type "' + zoteroItem.itemType + '"');
		}

		var itemTypeID = Zotero.ItemTypes.getID(zoteroItem.itemType);

		var cslItem = {
			'id':zoteroItem.uri,
			'type':cslType
		};

		// get all text variables (there must be a better way)
		for(var variable in Zotero.Schema.CSL_TEXT_MAPPINGS) {
			if (variable === "shortTitle") continue; // read both title-short and shortTitle, but write only title-short
			var fields = Zotero.Schema.CSL_TEXT_MAPPINGS[variable];
			for(var i=0, n=fields.length; i<n; i++) {
				var field = fields[i],
					value = null;

				if(field in zoteroItem) {
					value = zoteroItem[field];
				} else {
					if (field == 'versionNumber') field = 'version'; // Until https://github.com/zotero/zotero/issues/670
					var fieldID = Zotero.ItemFields.getID(field),
						typeFieldID;
					if(fieldID
						&& (typeFieldID = Zotero.ItemFields.getFieldIDFromTypeAndBase(itemTypeID, fieldID))
					) {
						value = zoteroItem[Zotero.ItemFields.getName(typeFieldID)];
					}
				}

				if (!value) continue;

				if (typeof value == 'string') {
					if (field == 'ISBN') {
						// Only use the first ISBN in CSL JSON
						var isbn = value.match(/^(?:97[89]-?)?(?:\d-?){9}[\dx](?!-)\b/i);
						if (isbn) value = isbn[0];
					}
					else if (field == 'extra') {
						value = Zotero.Utilities.Item.extraToCSL(value);
					}

					// Strip enclosing quotes
					if(value.charAt(0) == '"' && value.indexOf('"', 1) == value.length - 1) {
						value = value.substring(1, value.length-1);
					}
					cslItem[variable] = value;
					break;
				}
			}
		}

		// separate name variables
		if (zoteroItem.type != "attachment" && zoteroItem.type != "note") {
			let primaryCreatorType = Zotero.CreatorTypes.getName(Zotero.CreatorTypes.getPrimaryIDForType(itemTypeID));
			var creators = zoteroItem.creators;
			for(var i=0; creators && i<creators.length; i++) {
				var creator = creators[i];
				var creatorType = creator.creatorType;
				let cslCreatorType = Zotero.Schema.CSL_NAME_MAPPINGS[creatorType];
				if (!cslCreatorType && creatorType == primaryCreatorType) {
					cslCreatorType = "author";
				}
				if (!cslCreatorType) continue;

				var nameObj;
				if (creator.name || (creator.fieldMode === 1 && creator.lastName && !creator.firstName)) {
					nameObj = {'literal': creator.name || creator.lastName};
				}
				else if (creator.lastName || creator.firstName) {
					nameObj = {
						family: creator.lastName || '',
						given: creator.firstName || ''
					};

					// Parse name particles
					// Replicate citeproc-js logic for what should be parsed so we don't
					// break current behavior.
					if (nameObj.family && nameObj.given) {
						// Don't parse if last name is quoted
						if (nameObj.family.length > 1
							&& nameObj.family.charAt(0) == '"'
							&& nameObj.family.charAt(nameObj.family.length - 1) == '"'
						) {
							nameObj.family = nameObj.family.substr(1, nameObj.family.length - 2);
						} else {
							Zotero.Utilities.Item.parseParticles(nameObj);
						}
					}
				}

				if(cslItem[cslCreatorType]) {
					cslItem[cslCreatorType].push(nameObj);
				} else {
					cslItem[cslCreatorType] = [nameObj];
				}
			}
		}

		// get date variables
		for(var variable in Zotero.Schema.CSL_DATE_MAPPINGS) {
			var date = zoteroItem[Zotero.Schema.CSL_DATE_MAPPINGS[variable]];
			if (!date) {
				var typeSpecificFieldID = Zotero.ItemFields.getFieldIDFromTypeAndBase(itemTypeID, Zotero.Schema.CSL_DATE_MAPPINGS[variable]);
				if (typeSpecificFieldID) {
					date = zoteroItem[Zotero.ItemFields.getName(typeSpecificFieldID)];
				}
			}

			if(date) {
				// Convert UTC timestamp to local timestamp for access date
				if (Zotero.Schema.CSL_DATE_MAPPINGS[variable] == 'accessDate' && !Zotero.Date.isSQLDate(date)) {
					// Accept ISO date
					if (Zotero.Date.isISODate(date)) {
						let d = Zotero.Date.isoToDate(date);
						date = Zotero.Date.dateToSQL(d, true);
					}
					let localDate = Zotero.Date.sqlToDate(date, true);
					date = Zotero.Date.dateToSQL(localDate);
				}
				var dateObj = Zotero.Date.strToDate(date);
				// otherwise, use date-parts
				var dateParts = [];
				if(dateObj.year) {
					// add year, month, and day, if they exist
					dateParts.push(dateObj.year);
					if(dateObj.month !== undefined) {
						// strToDate() returns a JS-style 0-indexed month, so we add 1 to it
						dateParts.push(dateObj.month+1);
						if(dateObj.day) {
							dateParts.push(dateObj.day);
						}
					}
					cslItem[variable] = {"date-parts":[dateParts]};

					// if no month, use season as month
					if(dateObj.part && dateObj.month === undefined) {
						cslItem[variable].season = dateObj.part;
					}
				} else {
					// if no year, pass date literally
					cslItem[variable] = {"literal":date};
				}
			}
		}

		// Special mapping for note title
		if (zoteroItem.itemType == 'note' && zoteroItem.note) {
			cslItem.title = Zotero.Utilities.Item.noteToTitle(zoteroItem.note);
		}

		//this._cache[zoteroItem.id] = cslItem;
		return cslItem;
	},

	/**
	 * Converts an item in CSL JSON format to a Zotero item
	 * @param {Zotero.Item} item
	 * @param {Object} cslItem
	 */
	itemFromCSLJSON: function(item, cslItem) {
		var isZoteroItem = !!item.setType,
			zoteroType;

		if (!cslItem.type) {
			Zotero.debug(cslItem, 1);
			throw new Error("No 'type' provided in CSL-JSON");
		}

		// Some special cases to help us map item types correctly
		// This ensures that we don't lose data on import. The fields
		// we check are incompatible with the alternative item types
		if (cslItem.type == 'bill' && (cslItem.publisher || cslItem['number-of-volumes'])) {
			zoteroType = 'hearing';
		}
		else if (cslItem.type == 'broadcast'
			&& (cslItem['archive']
				|| cslItem['archive_location']
				|| cslItem['container-title']
				|| cslItem['event-place']
				|| cslItem['publisher']
				|| cslItem['publisher-place']
				|| cslItem['source'])) {
			zoteroType = 'tvBroadcast';
		}
		else if (cslItem.type == 'book' && cslItem.version) {
			zoteroType = 'computerProgram';
		}
		else if (cslItem.type == 'song' && cslItem.number) {
			zoteroType = 'podcast';
		}
		else if (cslItem.type == 'motion_picture'
			&& (cslItem['collection-title'] || cslItem['publisher-place']
				|| cslItem['event-place'] || cslItem.volume
				|| cslItem['number-of-volumes'] || cslItem.ISBN)) {
			zoteroType = 'videoRecording';
		}
		else if (Zotero.Schema.CSL_TYPE_MAPPINGS_REVERSE[cslItem.type]) {
			zoteroType = Zotero.Schema.CSL_TYPE_MAPPINGS_REVERSE[cslItem.type][0];
		}
		else {
			Zotero.debug(`Unknown CSL type '${cslItem.type}' -- using 'document'`, 2);
			zoteroType = "document";
		}

		var itemTypeID = Zotero.ItemTypes.getID(zoteroType);
		if(isZoteroItem) {
			item.setType(itemTypeID);
		} else {
			item.itemID = cslItem.id;
			item.itemType = zoteroType;
		}

		// map text fields
		for (let variable in Zotero.Schema.CSL_TEXT_MAPPINGS) {
			if(variable in cslItem) {
				let textMappings = Zotero.Schema.CSL_TEXT_MAPPINGS[variable];
				for(var i=0; i<textMappings.length; i++) {
					var field = textMappings[i];
					var fieldID = Zotero.ItemFields.getID(field);

					if(Zotero.ItemFields.isBaseField(fieldID)) {
						var newFieldID = Zotero.ItemFields.getFieldIDFromTypeAndBase(itemTypeID, fieldID);
						if(newFieldID) fieldID = newFieldID;
					}

					if(Zotero.ItemFields.isValidForType(fieldID, itemTypeID)) {
						// TODO: Convert restrictive Extra cheater syntax ('original-date: 2018')
						// to nicer format we allow ('Original Date: 2018'), unless we've added
						// those fields before we get to that
						if(isZoteroItem) {
							item.setField(fieldID, cslItem[variable]);
						} else {
							item[field] = cslItem[variable];
						}

						break;
					}
				}
			}
		}

		// separate name variables
		for (let field in Zotero.Schema.CSL_NAME_MAPPINGS) {
			if (Zotero.Schema.CSL_NAME_MAPPINGS[field] in cslItem) {
				var creatorTypeID = Zotero.CreatorTypes.getID(field);
				if(!Zotero.CreatorTypes.isValidForItemType(creatorTypeID, itemTypeID)) {
					creatorTypeID = Zotero.CreatorTypes.getPrimaryIDForType(itemTypeID);
				}

				let nameMappings = cslItem[Zotero.Schema.CSL_NAME_MAPPINGS[field]];
				for(var i in nameMappings) {
					var cslAuthor = nameMappings[i];
					let creator = {};
					if(cslAuthor.family || cslAuthor.given) {
						creator.lastName = cslAuthor.family || '';
						creator.firstName = cslAuthor.given || '';
					} else if(cslAuthor.literal) {
						creator.lastName = cslAuthor.literal;
						creator.fieldMode = 1;
					} else {
						continue;
					}
					creator.creatorTypeID = creatorTypeID;

					if(isZoteroItem) {
						item.setCreator(item.getCreators().length, creator);
					} else {
						creator.creatorType = Zotero.CreatorTypes.getName(creatorTypeID);
						if (Zotero.isFx && !Zotero.isBookmarklet) {
							creator = Components.utils.cloneInto(creator, item);
						}
						item.creators.push(creator);
					}
				}
			}
		}

		// get date variables
		for (let variable in Zotero.Schema.CSL_DATE_MAPPINGS) {
			if(variable in cslItem) {
				let field = Zotero.Schema.CSL_DATE_MAPPINGS[variable];
				let fieldID = Zotero.ItemFields.getID(field);
				let cslDate = cslItem[variable];
				if(Zotero.ItemFields.isBaseField(fieldID)) {
					var newFieldID = Zotero.ItemFields.getFieldIDFromTypeAndBase(itemTypeID, fieldID);
					if(newFieldID) fieldID = newFieldID;
				}

				if(Zotero.ItemFields.isValidForType(fieldID, itemTypeID)) {
					var date = "";
					if(cslDate.literal || cslDate.raw) {
						date = cslDate.literal || cslDate.raw;
						if(variable === "accessed") {
							date = Zotero.Date.strToISO(date);
						}
					} else {
						var newDate = Zotero.Utilities.deepCopy(cslDate);
						if(cslDate["date-parts"] && typeof cslDate["date-parts"] === "object"
							&& cslDate["date-parts"] !== null
							&& typeof cslDate["date-parts"][0] === "object"
							&& cslDate["date-parts"][0] !== null) {
							if(cslDate["date-parts"][0][0]) newDate.year = cslDate["date-parts"][0][0];
							if(cslDate["date-parts"][0][1]) newDate.month = cslDate["date-parts"][0][1];
							if(cslDate["date-parts"][0][2]) newDate.day = cslDate["date-parts"][0][2];
						}

						if(newDate.year) {
							if(variable === "accessed") {
								// Need to convert to SQL
								var date = Zotero.Utilities.lpad(newDate.year, "0", 4);
								if(newDate.month) {
									date += "-"+Zotero.Utilities.lpad(newDate.month, "0", 2);
									if(newDate.day) {
										date += "-"+Zotero.Utilities.lpad(newDate.day, "0", 2);
									}
								}
							} else {
								if(newDate.month) newDate.month--;
								date = Zotero.Date.formatDate(newDate);
								if(newDate.season) {
									date = newDate.season+" "+date;
								}
							}
						}
					}

					if(isZoteroItem) {
						item.setField(fieldID, date);
					} else {
						item[field] = date;
					}
				}
			}
		}
	},

	/**
	 * Given API JSON for an item, return the best single first creator, regardless of creator order
	 *
	 * Note that this is just a single creator, not the firstCreator field return from the
	 * Zotero.Item::firstCreator property or Zotero.Items.getFirstCreatorFromData()
	 *
	 * @return {Object|false} - Creator in API JSON format, or false
	 */
	getFirstCreatorFromItemJSON: function (json) {
		var primaryCreatorType = Zotero.CreatorTypes.getName(
			Zotero.CreatorTypes.getPrimaryIDForType(
				Zotero.ItemTypes.getID(json.itemType)
			)
		);
		let firstCreator = json.creators.find(creator => {
			return creator.creatorType == primaryCreatorType || creator.creatorType == 'author';
		});
		if (!firstCreator) {
			firstCreator = json.creators.find(creator => creator.creatorType == 'editor');
		}
		if (!firstCreator) {
			return false;
		}
		return firstCreator;
	},

	/**
	* Taken from citeproc-js. Extracts particles (e.g. de, von, etc.) from family name and given name.
	* 
	* Copyright (c) 2009-2019 Frank Bennett
	*	This program is free software: you can redistribute it and/or
	*	modify it under EITHER
	*
	*	 * the terms of the Common Public Attribution License (CPAL) as
	*		published by the Open Source Initiative, either version 1 of
	*		the CPAL, or (at your option) any later version; OR
	*
	*	 * the terms of the GNU Affero General Public License (AGPL)
	*		as published by the Free Software Foundation, either version
	*		3 of the AGPL, or (at your option) any later version.
	*
	*	This program is distributed in the hope that it will be useful,
	*	but WITHOUT ANY WARRANTY; without even the implied warranty of
	*	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
	*	Affero General Public License for more details.
	*
	*	You should have received copies of the Common Public Attribution
	*	License and of the GNU Affero General Public License along with
	*	this program.  If not, see <https://opensource.org/licenses/> or
	*	<http://www.gnu.org/licenses/> respectively.
	*/
	parseParticles: function (nameObj) {
		function splitParticles(nameValue, firstNameFlag, caseOverride) {
			// Parse particles out from name fields.
			// * nameValue (string) is the field content to be parsed.
			// * firstNameFlag (boolean) parse trailing particles
			//	 (default is to parse leading particles)
			// * caseOverride (boolean) include all but one word in particle set
			//	 (default is to include only words with lowercase first char)
			//   [caseOverride is not used in this application]
			// Returns an array with:
			// * (boolean) flag indicating whether a particle was found
			// * (string) the name after removal of particles
			// * (array) the list of particles found
			var origNameValue = nameValue;
			nameValue = caseOverride ? nameValue.toLowerCase() : nameValue;
			var particleList = [];
			var rex;
			var hasParticle;
			if (firstNameFlag) {
				nameValue = nameValue.split("").reverse().join("");
				rex = Utilities_Item.PARTICLE_GIVEN_REGEXP;
			} else {
				rex = Utilities_Item.PARTICLE_FAMILY_REGEXP;
			}
			var m = nameValue.match(rex);
			while (m) {
				var m1 = firstNameFlag ? m[1].split("").reverse().join("") : m[1];
				var firstChar = m ? m1 : false;
				var firstChar = firstChar ? m1.replace(/^[-\'\u02bb\u2019\s]*(.).*$/, "$1") : false;
				hasParticle = firstChar ? firstChar.toUpperCase() !== firstChar : false;
				if (!hasParticle) {
					break;
				}
				if (firstNameFlag) {
					particleList.push(origNameValue.slice(m1.length * -1));
					origNameValue = origNameValue.slice(0,m1.length * -1);
				} else {
					particleList.push(origNameValue.slice(0,m1.length));
					origNameValue = origNameValue.slice(m1.length);
				}
				//particleList.push(m1);
				nameValue = m[2];
				m = nameValue.match(rex);
			}
			if (firstNameFlag) {
				nameValue = nameValue.split("").reverse().join("");
				particleList.reverse();
				for (var i=1,ilen=particleList.length;i<ilen;i++) {
					if (particleList[i].slice(0, 1) == " ") {
						particleList[i-1] += " ";
					}
				}
				for (var i=0,ilen=particleList.length;i<ilen;i++) {
					if (particleList[i].slice(0, 1) == " ") {
						particleList[i] = particleList[i].slice(1);
					}
				}
				nameValue = origNameValue.slice(0, nameValue.length);
			} else {
				nameValue = origNameValue.slice(nameValue.length * -1);
			}
			return [hasParticle, nameValue, particleList];
		}
		function trimLast(str) {
			var lastChar = str.slice(-1);
			str = str.trim();
			if (lastChar === " " && ["\'", "\u2019"].indexOf(str.slice(-1)) > -1) {
				str += " ";
			}
			return str;
		}
		function parseSuffix(nameObj) {
			if (!nameObj.suffix && nameObj.given) {
				var m = nameObj.given.match(/(\s*,!*\s*)/);
				if (m) {
					var idx = nameObj.given.indexOf(m[1]);
					var possible_suffix = nameObj.given.slice(idx + m[1].length);
					var possible_comma = nameObj.given.slice(idx, idx + m[1].length).replace(/\s*/g, "");
					if (possible_suffix.replace(/\./g, "") === 'et al' && !nameObj["dropping-particle"]) {
						// This hack covers the case where "et al." is explicitly used in the
						// authorship information of the work.
						nameObj["dropping-particle"] = possible_suffix;
						nameObj["comma-dropping-particle"] = ",";
					} else {
						if (possible_comma.length === 2) {
							nameObj["comma-suffix"] = true;
						}
						nameObj.suffix = possible_suffix;
					}
					nameObj.given = nameObj.given.slice(0, idx);
				}
			}
		}
		// Extract and set non-dropping particle(s) from family name field
		var res = splitParticles(nameObj.family);
		var lastNameValue = res[1];
		var lastParticleList = res[2];
		nameObj.family = lastNameValue;
		var nonDroppingParticle = trimLast(lastParticleList.join(""));
		if (nonDroppingParticle) {
			nameObj['non-dropping-particle'] = nonDroppingParticle;
		}
		// Split off suffix first of all
		parseSuffix(nameObj);
		// Extract and set dropping particle(s) from given name field
		var res = splitParticles(nameObj.given, true);
		var firstNameValue = res[1];
		var firstParticleList = res[2];
		nameObj.given = firstNameValue;
		var droppingParticle = firstParticleList.join("").trim();
		if (droppingParticle) {
			nameObj['dropping-particle'] = droppingParticle;
		}
	},

	/**
	 * Return first line (or first MAX_LENGTH characters) of note content
	 *
	 * @param {String} text
	 * @param {Object} [options]
	 * @param {Boolean} [options.stopAtLineBreak] - Stop at <br/> instead of converting to space
	 * @return {String}
	 */
	noteToTitle: function (text, options = {}) {
		var MAX_TITLE_LENGTH = 120;
		var origText = text;
		text = text.trim();
		// Add line breaks after block elements
		text = text.replace(/(<\/(h\d|p|div)+>)/g, '$1\n');
		if (options.stopAtLineBreak) {
			text = text.replace(/<br\s*\/?>/g, '\n');
		}
		else {
			text = text.replace(/<br\s*\/?>/g, ' ');
		}
		text = Zotero.Utilities.unescapeHTML(text);

		// If first line is just an opening HTML tag, remove it
		//
		// Example:
		//
		// <blockquote>
		// <p>Foo</p>
		// </blockquote>
		if (/^<[^>\n]+[^\/]>\n/.test(origText)) {
			text = text.trim();
		}

		var t = text.substring(0, MAX_TITLE_LENGTH);
		var ln = t.indexOf("\n");
		if (ln > -1 && ln < MAX_TITLE_LENGTH) {
			t = t.substring(0, ln);
		}
		return t;
	},

	/**
	 * Preprocess Zotero item extra field for passing to citeproc-js for extra CSL properties
	 * @param extra
	 * @returns {String|string|void|*}
	 */
	extraToCSL: function (extra) {
		return extra.replace(/^([A-Za-z \-]+)(:\s*.+)/gm, function (_, field, value) {
			var originalField = field;
			field = field.toLowerCase().replace(/ /g, '-');
			// Fields from https://aurimasv.github.io/z2csl/typeMap.xml
			switch (field) {
				// Standard fields
			case 'abstract':
			case 'accessed':
			case 'annote':
			case 'archive':
			case 'archive-place':
			case 'author':
			case 'authority':
			case 'call-number':
			case 'chapter-number':
			case 'citation-label':
			case 'citation-number':
			case 'collection-editor':
			case 'collection-number':
			case 'collection-title':
			case 'composer':
			case 'container':
			case 'container-author':
			case 'container-title':
			case 'container-title-short':
			case 'dimensions':
			case 'director':
			case 'edition':
			case 'editor':
			case 'editorial-director':
			case 'event':
			case 'event-date':
			case 'event-place':
			case 'first-reference-note-number':
			case 'genre':
			case 'illustrator':
			case 'interviewer':
			case 'issue':
			case 'issued':
			case 'jurisdiction':
			case 'keyword':
			case 'language':
			case 'locator':
			case 'medium':
			case 'note':
			case 'number':
			case 'number-of-pages':
			case 'number-of-volumes':
			case 'original-author':
			case 'original-date':
			case 'original-publisher':
			case 'original-publisher-place':
			case 'original-title':
			case 'page':
			case 'page-first':
			case 'publisher':
			case 'publisher-place':
			case 'recipient':
			case 'references':
			case 'reviewed-author':
			case 'reviewed-title':
			case 'scale':
			case 'section':
			case 'source':
			case 'status':
			case 'submitted':
			case 'title':
			case 'title-short':
			case 'translator':
			case 'type':
			case 'version':
			case 'volume':
			case 'year-suffix':
				break;

				// Uppercase fields
			case 'doi':
			case 'isbn':
			case 'issn':
			case 'pmcid':
			case 'pmid':
			case 'url':
				field = field.toUpperCase();
				break;

				// Weirdo
			case 'archive-location':
				field = 'archive_location';
				break;

			default:
				// See if this is a Zotero field written out (e.g., "Publication Title"), and if so
				// convert to its associated CSL field
				var zoteroField = originalField.replace(/ ([A-Z])/, '$1');
				// If second character is lowercase (so not an acronym), lowercase first letter too
				if (zoteroField[1] && zoteroField[1] == zoteroField[1].toLowerCase()) {
					zoteroField = zoteroField[0].toLowerCase() + zoteroField.substr(1);
				}
				if (Zotero.Schema.CSL_FIELD_MAPPINGS_REVERSE[zoteroField]) {
					field = Zotero.Schema.CSL_FIELD_MAPPINGS_REVERSE[zoteroField];
				}
				// Don't change other lines
				else {
					field = originalField;
				}
			}
			return field + value;
		});
	},

	/**
	 * Converts an item from toArray() format to an array of items in
	 * the content=json format used by the server
	 *
	 * (for origin see: https://github.com/zotero/zotero/blob/56f9f043/chrome/content/zotero/xpcom/utilities.js#L1526-L1526)
	 *
	 */
	itemToAPIJSON: function(item) {
		var newItem = {
				key: Zotero.Utilities.generateObjectKey(),
				version: 0
			},
			newItems = [newItem];

		var typeID = Zotero.ItemTypes.getID(item.itemType);
		if(!typeID) {
			Zotero.debug(`itemToAPIJSON: Invalid itemType ${item.itemType}; using webpage`);
			item.itemType = "webpage";
			typeID = Zotero.ItemTypes.getID(item.itemType);
		}

		var accessDateFieldID = Zotero.ItemFields.getID('accessDate');

		var fieldID, itemFieldID;
		for(var field in item) {
			if(field === "complete" || field === "itemID" || field === "attachments"
				|| field === "seeAlso") continue;

			var val = item[field];

			if(field === "itemType") {
				newItem[field] = val;
			} else if(field === "creators") {
				// normalize creators
				var n = val.length;
				var newCreators = newItem.creators = [];
				for(var j=0; j<n; j++) {
					var creator = val[j];

					if(!creator.firstName && !creator.lastName) {
						Zotero.debug("itemToAPIJSON: Silently dropping empty creator");
						continue;
					}

					// Single-field mode
					if (!creator.firstName || (creator.fieldMode && creator.fieldMode == 1)) {
						var newCreator = {
							name: creator.lastName
						};
					}
					// Two-field mode
					else {
						var newCreator = {
							firstName: creator.firstName,
							lastName: creator.lastName
						};
					}

					// ensure creatorType is present and valid
					if(creator.creatorType) {
						if(Zotero.CreatorTypes.getID(creator.creatorType)) {
							newCreator.creatorType = creator.creatorType;
						} else {
							Zotero.debug(`itemToAPIJSON: Invalid creator type ${creator.creatorType}; `
								+ "falling back to author");
						}
					}
					if(!newCreator.creatorType) newCreator.creatorType = "author";

					newCreators.push(newCreator);
				}
			} else if(field === "tags") {
				// normalize tags
				var n = val.length;
				var newTags = newItem.tags = [];
				for(var j=0; j<n; j++) {
					var tag = val[j];
					if(typeof tag === "object") {
						if(tag.tag) {
							tag = tag.tag;
						} else if(tag.name) {
							tag = tag.name;
						} else {
							Zotero.debug("itemToAPIJSON: Discarded invalid tag");
							continue;
						}
					} else if(tag === "") {
						continue;
					}
					newTags.push({"tag":tag.toString(), "type":1});
				}
			} else if(field === "notes") {
				// normalize notes
				var n = val.length;
				for(var j=0; j<n; j++) {
					var note = val[j];
					if(typeof note === "object") {
						if(!note.note) {
							Zotero.debug("itemToAPIJSON: Discarded invalid note");
							continue;
						}
						note = note.note;
					}
					newItems.push({
						itemType: "note",
						parentItem: newItem.key,
						note: note.toString()
					});
				}
			} else if((fieldID = Zotero.ItemFields.getID(field))) {
				// if content is not a string, either stringify it or delete it
				if(typeof val !== "string") {
					if(val || val === 0) {
						val = val.toString();
					} else {
						continue;
					}
				}

				// map from base field if possible
				if((itemFieldID = Zotero.ItemFields.getFieldIDFromTypeAndBase(typeID, fieldID))) {
					let fieldName = Zotero.ItemFields.getName(itemFieldID);
					// Only map if item field does not exist
					if(fieldName !== field && !newItem[fieldName]) newItem[fieldName] = val;
					continue;	// already know this is valid
				}

				// if field is valid for this type, set field
				if(Zotero.ItemFields.isValidForType(fieldID, typeID)) {
					// Convert access date placeholder to current time
					if (fieldID == accessDateFieldID && val == "CURRENT_TIMESTAMP") {
						val = Zotero.Date.dateToISO(new Date());
					}

					newItem[field] = val;
				} else {
					Zotero.debug(`itemToAPIJSON: Discarded field ${field}: `
						+ `field not valid for type ${item.itemType}`, 3);
				}
			} else {
				Zotero.debug(`itemToAPIJSON: Discarded unknown field ${field}`, 3);
			}
		}

		return newItems;
	},

	/**
	 * Converts a current Zotero Item to a format that export translators written for Zotero versions pre-4.0.26
	 * See https://github.com/zotero/translation-server/issues/73
	 * @param {Object} item
	 * @returns {Object}
	 */
	itemToLegacyExportFormat: function(item) {
		item.uniqueFields = {};

		// Map base fields
		for (let field in item) {
			try {
				var baseField = Zotero.ItemFields.getName(
					Zotero.ItemFields.getBaseIDFromTypeAndField(item.itemType, field)
				);
			} catch (e) {
				continue;
			}

			if (!baseField || baseField == field) {
				item.uniqueFields[field] = item[field];
			} else {
				item[baseField] = item[field];
				item.uniqueFields[baseField] = item[field];
			}
		}

		// Meaningless local item ID, but some older export translators depend on it
		item.itemID = Zotero.Utilities.randomString(6);
		item.key = Zotero.Utilities.randomString(6); // CSV translator exports this

		// "version" is expected to be a field for "computerProgram", which is now
		// called "versionNumber"
		delete item.version;
		if (item.versionNumber) {
			item.version = item.uniqueFields.version = item.versionNumber;
			delete item.versionNumber;
		}

		// Creators
		if (item.creators) {
			for (let i=0; i<item.creators.length; i++) {
				let creator = item.creators[i];

				if (creator.name) {
					creator.fieldMode = 1;
					creator.lastName = creator.name;
					delete creator.name;
				}

				// Old format used to supply creatorID (the database ID), but no
				// translator ever used it
			}
		}
		else {
			item.creators = [];
		}

		item.sourceItemKey = item.parentItem;

		// Tags
		if (item.tags) {
			for (let i = 0; i < item.tags.length; i++) {
				if (!item.tags[i].type) {
					item.tags[i].type = 0;
				}
				// No translator ever used "primary", "fields", or "linkedItems" objects
			}
		}
		else {
			item.tags = [];
		}

		// seeAlso was always present, but it was always an empty array.
		// Zotero RDF translator pretended to use it
		item.seeAlso = [];

		if (item.contentType) {
			item.mimeType = item.uniqueFields.mimeType = item.contentType;
		}

		if (item.note) {
			item.uniqueFields.note = item.note;
		}

		return item;
	},

	/**
	 * Compare two call numbers. Handles Dewey and LC specially,
	 * compares numbers as numbers, uses string comparison for everything else.
	 *
	 * @param {String} fieldA
	 * @param {String} fieldB
	 * @returns {Number} Negative if A < B, 0 if A == B, positive if A > B
	 */
	compareCallNumbers: function (fieldA, fieldB) {
		function compareStringArrays(a, b) {
			let i;
			for (i = 0; i < a.length && i < b.length; i++) {
				if (a[i] < b[i]) {
					return -1;
				}
				else if (a[i] > b[i]) {
					return 1;
				}
			}
			return (i < a.length) ? 1 : (i < b.length) ? -1 : 0;
		}

		let onlyNumbersRe = /^\d*$/;
		let deweyRe = /^(\d{3})(?:\.(\d+))?(?:\/([a-zA-Z]{3}))?$/;
		let lcWithClassificationRe = /^[a-zA-Z]{1,3}\d+($|(?=\s*[.\d]))/;

		if (onlyNumbersRe.test(fieldA) && onlyNumbersRe.test(fieldB)) {
			return parseInt(fieldA) - parseInt(fieldB);
		}

		let splitA = fieldA.toLowerCase().replace(/\s/g, '').match(deweyRe);
		let splitB = fieldB.toLowerCase().replace(/\s/g, '').match(deweyRe);
		if (splitA && splitB) {
			// Looks like Dewey Decimal, so we'll compare by parts
			splitA.shift();
			splitB.shift();
			return compareStringArrays(splitA, splitB);
		}
		
		let classificationA = fieldA.match(lcWithClassificationRe);
		let classificationB = fieldB.match(lcWithClassificationRe);
		if (classificationA && classificationB) {
			// Looks like a LC call number, so we'll first compare
			// by classification field using locale collation
			let classificationComp = Zotero.localeCompare(
				classificationA[0].replace(/[\s.]/g, ''),
				classificationB[0].replace(/[\s.]/g, '')
			);

			if (classificationComp == 0) {
				// If they match, we'll compare the rest using
				// basic string comparison
				fieldA = fieldA.substring(classificationA[0].length).replace(/[\s.]+/g, ' ');
				fieldB = fieldB.substring(classificationB[0].length).replace(/[\s.]+/g, ' ');
				return compareStringArrays(fieldA.split(' '), fieldB.split(' '));
			}
			else {
				return classificationComp;
			}
		}

		return (fieldA > fieldB) ? 1 : (fieldA < fieldB) ? -1 : 0;
	}
};

{
	module.exports = Utilities_Item;
}

})();
}(utilities_item));

var Utilities_Item = utilities_item.exports;

var schema = {exports: {}};

/*
	***** BEGIN LICENSE BLOCK *****
	
	Copyright © 2021 Corporation for Digital Scholarship
                     Vienna, Virginia, USA
					http://zotero.org
	
	This file is part of Zotero.
	
	Zotero is free software: you can redistribute it and/or modify
	it under the terms of the GNU Affero General Public License as published by
	the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.
	
	Zotero is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU Affero General Public License for more details.

	You should have received a copy of the GNU Affero General Public License
	along with Zotero.  If not, see <http://www.gnu.org/licenses/>.
	
	***** END LICENSE BLOCK *****
*/

(function (module) {
const Schema = {
	/**
	 * This must be called before translation
	 * @param data - Zotero schema from https://github.com/zotero/zotero-schema or
	 * 		https://api.zotero.org/schema
	 */
	init(data) {
		if (typeof data == 'string') {
			data = JSON.parse(data);
		}
		// CSL type/field mappings used by Utilities.Item.itemFromCSLJSON()
		Zotero.Schema.CSL_TYPE_MAPPINGS = {};
		Zotero.Schema.CSL_TYPE_MAPPINGS_REVERSE = {};
		for (let cslType in data.csl.types) {
			for (let zoteroType of data.csl.types[cslType]) {
				Zotero.Schema.CSL_TYPE_MAPPINGS[zoteroType] = cslType;
			}
			Zotero.Schema.CSL_TYPE_MAPPINGS_REVERSE[cslType] = [...data.csl.types[cslType]];
		}
		Zotero.Schema.CSL_TEXT_MAPPINGS = data.csl.fields.text;
		Zotero.Schema.CSL_DATE_MAPPINGS = data.csl.fields.date;
		Zotero.Schema.CSL_NAME_MAPPINGS = data.csl.names;
		Zotero.Schema.CSL_FIELD_MAPPINGS_REVERSE = {};
		for (let cslField in data.csl.fields.text) {
			for (let zoteroField of data.csl.fields.text[cslField]) {
				Zotero.Schema.CSL_FIELD_MAPPINGS_REVERSE[zoteroField] = cslField;
			}
		}
		for (let cslField in data.csl.fields.date) {
			let zoteroField = data.csl.fields.date[cslField];
			Zotero.Schema.CSL_FIELD_MAPPINGS_REVERSE[zoteroField] = cslField;
		}
	}
};

{
	module.exports = Schema;
}
}(schema));

var Schema = schema.exports;

var cachedTypes = {exports: {}};

/*
    ***** BEGIN LICENSE BLOCK *****
    
    Copyright © 2011 Center for History and New Media
                     George Mason University, Fairfax, Virginia, USA
                     http://zotero.org
    
    This file is part of Zotero.
    
    Zotero is free software: you can redistribute it and/or modify
    it under the terms of the GNU Affero General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    
    Zotero is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Affero General Public License for more details.
    
    You should have received a copy of the GNU Affero General Public License
    along with Zotero.  If not, see <http://www.gnu.org/licenses/>.
    
    ***** END LICENSE BLOCK *****
*/

(function (module) {
/**
 * Emulates very small parts of cachedTypes.js and itemFields.js APIs for use with connector
 */

(function() {

var TypeSchema;
if (typeof ZOTERO_TYPE_SCHEMA != 'undefined') {
	TypeSchema = ZOTERO_TYPE_SCHEMA;
}

var CachedTypes = new function() {
	const schemaTypes = ["itemTypes", "creatorTypes", "fields"];
	var typeData = {};
	var itemTypes, creatorTypes, fields;

	this.setTypeSchema = function(typeSchema) {
		TypeSchema = typeSchema;
		typeData = {};

		// attach IDs and make referenceable by either ID or name
		for (let i = 0; i < schemaTypes.length; i++) {
			let schemaType = schemaTypes[i];
			typeData[schemaType] = Zotero.Utilities.deepCopy(TypeSchema[schemaType]);
			for (let id in TypeSchema[schemaType]) {
				let entry = typeData[schemaType][id];
				entry.unshift(parseInt(id, 10));
				typeData[schemaType][entry[1]/* name */] = entry;
			}
		}

		itemTypes = typeData.itemTypes;
		creatorTypes = typeData.creatorTypes;
		fields = typeData.fields;
	};
	
	if (TypeSchema) {
		this.setTypeSchema(TypeSchema);
	}

	class Types {
		constructor(schemeType) {
			this.schemeType = schemeType;
		}

		get type() {
			return typeData[this.schemeType];
		}

		getID(idOrName) {
			var type = this.type[idOrName];
			return (type ? type[0]/* id */ : false);
		}

		getName(idOrName) {
			var type = this.type[idOrName];
			return (type ? type[1]/* name */ : false);
		}

		getLocalizedString(idOrName) {
			var type = this.type[idOrName];
			return (type ? type[2]/* localizedString */ : false);
		}
	}

	this.ItemTypes = new (class extends Types {
		constructor() {
			super("itemTypes");
		}
	})();

	this.CreatorTypes = new (class extends Types {
		constructor() {
			super("creatorTypes");
		}
		
		getTypesForItemType(idOrName) {
			var itemType = itemTypes[idOrName];
			if(!itemType) return false;
			
			var itemCreatorTypes = itemType[3]; // creatorTypes
			if (!itemCreatorTypes
					// TEMP: 'note' and 'attachment' have an array containing false
					|| (itemCreatorTypes.length == 1 && !itemCreatorTypes[0])) {
				return [];
			}
			var n = itemCreatorTypes.length;
			var outputTypes = new Array(n);
			
			for(var i=0; i<n; i++) {
				var creatorType = creatorTypes[itemCreatorTypes[i]];
				outputTypes[i] = {"id":creatorType[0]/* id */,
					"name":creatorType[1]/* name */};
			}
			return outputTypes;
		};
		
		getPrimaryIDForType(idOrName) {
			var itemType = itemTypes[idOrName];
			if(!itemType) return false;
			return itemType[3]/* creatorTypes */[0];
		};
		
		isValidForItemType(creatorTypeID, itemTypeID) {
			let itemType = itemTypes[itemTypeID];
			return itemType[3]/* creatorTypes */.includes(creatorTypeID);
		};
	})();
	
	this.ItemFields = new (class extends Types {
		constructor() {
			super("fields");
		}
		
		isValidForType(fieldIdOrName, typeIdOrName) {
			var field = fields[fieldIdOrName], itemType = itemTypes[typeIdOrName];
			
			// mimics itemFields.js
			if(!field || !itemType) return false;
			
				   /* fields */        /* id */
			return itemType[4].indexOf(field[0]) !== -1;
		};
		
		isBaseField(fieldID) {
			return fields[fieldID][2];
		};
		
		getFieldIDFromTypeAndBase(typeIdOrName, fieldIdOrName) {
			var baseField = fields[fieldIdOrName], itemType = itemTypes[typeIdOrName];
			
			if(!baseField || !itemType) return false;
			
			// get as ID
			baseField = baseField[0]/* id */;
			
			// loop through base fields for item type
			var baseFields = itemType[5];
			for(var i in baseFields) {
				if(baseFields[i] === baseField) {
					return i;
				}
			}
			
			return false;
		};
		
		getBaseIDFromTypeAndField(typeIdOrName, fieldIdOrName) {
			var field = fields[fieldIdOrName], itemType = itemTypes[typeIdOrName];
			if(!field || !itemType) {
				throw new Error("Invalid field or type ID");
			}
			
			var baseField = itemType[5]/* baseFields */[field[0]/* id */];
			return baseField ? baseField : false;
		};
		
		getItemTypeFields(typeIdOrName) {
			return itemTypes[typeIdOrName][4]/* fields */.slice();
		};
	})();
};
{
	module.exports = CachedTypes;
}
})();
}(cachedTypes));

var CachedTypes = cachedTypes.exports;

var zoteroTypeSchemaData = {exports: {}};

(function (module) {
var ZOTERO_TYPE_SCHEMA = {"itemTypes":{"1":["annotation","Annotation",[false],[],{},"treeitem@2x.png"],"2":["artwork","Artwork",[1,2],[1,2,3,5,6,7,8,9,10,11,12,13,14,15,16],{"3":4},"treeitem-artwork@2x.png"],"3":["attachment","Attachment",[false],[1,14,13],{},"treeitem@2x.png"],"4":["audioRecording","Audio Recording",[3,4,2,5],[1,2,17,18,19,20,21,22,6,24,7,25,8,9,10,11,12,13,14,15,16],{"17":4,"22":23},"treeitem-audioRecording@2x.png"],"5":["bill","Bill",[6,2,7],[1,2,26,28,29,30,31,33,34,35,6,7,13,14,8,15,16],{"26":27,"29":19,"31":32},"treeitem-bill@2x.png"],"6":["blogPost","Blog Post",[8,9,2],[1,2,36,38,6,13,14,7,8,15,16],{"36":37,"38":39},"treeitem-blogPost@2x.png"],"7":["book","Book",[8,2,10,12,11],[1,2,40,41,19,20,42,21,23,6,43,7,25,8,13,14,9,10,11,12,15,16],{},"treeitem-book@2x.png"],"8":["bookSection","Book Section",[8,13,2,10,12,11],[1,2,44,40,41,19,20,42,21,23,6,32,7,25,8,13,14,9,10,11,12,15,16],{"44":37},"treeitem-bookSection@2x.png"],"9":["case","Case",[8,2,14],[45,2,46,47,48,49,50,51,35,7,8,13,14,15,16],{"45":1,"47":6,"48":27,"50":19,"51":32},"treeitem-case@2x.png"],"10":["computerProgram","Software",[15,2],[1,2,18,52,6,53,21,54,55,25,8,13,15,9,10,11,12,14,16],{"54":23},"treeitem-computerProgram@2x.png"],"11":["conferencePaper","Conference Paper",[8,2,10,12,11],[1,2,6,56,57,21,23,19,32,40,7,58,25,8,13,14,9,10,11,12,15,16],{"56":37},"treeitem-conferencePaper@2x.png"],"12":["dictionaryEntry","Dictionary Entry",[8,2,10,12,11],[1,2,59,40,41,19,20,42,21,23,6,32,7,25,8,13,14,9,10,11,12,15,16],{"59":37},"treeitem-dictionaryEntry@2x.png"],"13":["document","Document",[8,2,10,16,11],[1,2,23,6,7,8,13,14,9,10,11,12,15,16],{},"treeitem@2x.png"],"14":["email","E-mail",[8,2,17],[60,2,6,8,13,14,7,15,16],{"60":1},"treeitem-email@2x.png"],"15":["encyclopediaArticle","Encyclopedia Article",[8,2,10,12,11],[1,2,61,40,41,19,20,42,21,23,6,32,25,8,13,14,7,9,10,11,12,15,16],{"61":37},"treeitem-encyclopediaArticle@2x.png"],"16":["film","Film",[18,2,20,19],[1,2,62,6,63,64,24,7,8,13,14,9,10,11,12,15,16],{"62":23,"63":39,"64":4},"treeitem-film@2x.png"],"17":["forumPost","Forum Post",[8,2],[1,2,65,66,6,7,8,13,14,15,16],{"65":37,"66":39},"treeitem-forumPost@2x.png"],"18":["hearing","Hearing",[2],[1,2,67,21,23,20,68,32,33,34,35,6,7,8,13,14,15,16],{"68":27},"treeitem-hearing@2x.png"],"19":["instantMessage","Instant Message",[8,2,17],[1,2,6,7,8,13,14,15,16],{},"treeitem-instantMessage@2x.png"],"20":["interview","Interview",[21,2,22,11],[1,2,6,69,7,8,13,14,9,10,11,12,15,16],{"69":4},"treeitem-interview@2x.png"],"21":["journalArticle","Journal Article",[8,2,10,16,11],[1,2,37,19,70,32,6,40,18,71,72,7,58,73,8,13,14,9,10,11,12,15,16],{},"treeitem-journalArticle@2x.png"],"22":["letter","Letter",[8,2,17],[1,2,74,6,7,8,13,14,9,10,11,12,15,16],{"74":39},"treeitem-letter@2x.png"],"23":["magazineArticle","Magazine Article",[8,2,16,11],[1,2,37,19,70,6,32,7,73,8,13,14,9,10,11,12,15,16],{},"treeitem-magazineArticle@2x.png"],"24":["manuscript","Manuscript",[8,2,11],[1,2,75,21,6,43,7,8,13,14,9,10,11,12,15,16],{"75":39},"treeitem-manuscript@2x.png"],"25":["map","Map",[23,2,12],[1,2,76,77,18,42,21,23,6,7,25,8,13,14,9,10,11,12,15,16],{"76":39},"treeitem-map.png"],"26":["newspaperArticle","Newspaper Article",[8,2,16,11],[1,2,37,21,42,6,30,32,7,8,73,13,14,9,10,11,12,15,16],{},"treeitem-newspaperArticle@2x.png"],"27":["note","Note",[false],[],{},"treeitem-note@2x.png"],"28":["patent","Patent",[24,25,2],[1,2,21,78,79,80,81,82,32,83,84,85,86,87,7,8,13,14,15,16],{"81":27,"85":6},"treeitem-patent@2x.png"],"29":["podcast","Podcast",[26,2,27],[1,2,18,88,89,24,13,14,7,8,15,16],{"88":27,"89":4},"treeitem-podcast.png"],"30":["preprint","Preprint",[8,2,10,16,11],[1,2,63,90,91,21,6,40,41,58,92,13,14,9,10,8,7,11,12,15,16],{"63":39,"90":23},"treeitem-preprint@2x.png"],"31":["presentation","Presentation",[28,2],[1,2,93,6,21,94,13,14,7,8,15,16],{"93":39},"treeitem-presentation@2x.png"],"32":["radioBroadcast","Radio Broadcast",[18,29,2,27,20,19],[1,2,95,88,17,21,96,6,24,7,8,13,14,9,10,11,12,15,16],{"17":4,"88":27,"95":37,"96":23},"treeitem-radioBroadcast.png"],"33":["report","Report",[8,2,12,11],[1,2,97,98,18,21,99,6,32,7,8,13,14,9,10,11,12,15,16],{"97":27,"98":39,"99":23},"treeitem-report@2x.png"],"34":["statute","Statute",[8,2],[100,2,28,101,102,103,32,30,34,35,7,8,13,14,15,16],{"100":1,"102":27,"103":6},"treeitem-statute@2x.png"],"35":["thesis","Thesis",[8,2],[1,2,104,105,21,6,43,7,8,13,14,9,10,11,12,15,16],{"104":39,"105":23},"treeitem-thesis@2x.png"],"36":["tvBroadcast","TV Broadcast",[18,29,2,27,20,19],[1,2,95,88,64,21,96,6,24,7,8,13,14,9,10,11,12,15,16],{"64":4,"88":27,"95":37,"96":23},"treeitem-tvBroadcast.png"],"37":["videoRecording","Video Recording",[18,29,2,20,19],[1,2,64,18,19,20,21,106,6,24,7,25,8,13,14,9,10,11,12,15,16],{"64":4,"106":23},"treeitem-videoRecording.png"],"38":["webpage","Web Page",[8,2,11],[1,2,107,38,6,8,13,14,7,15,16],{"38":39,"107":37},"treeitem-webpage@2x.png"]},"creatorTypes":{"1":["artist","Artist"],"2":["contributor","Contributor"],"3":["performer","Performer"],"4":["composer","Composer"],"5":["wordsBy","Words By"],"6":["sponsor","Sponsor"],"7":["cosponsor","Cosponsor"],"8":["author","Author"],"9":["commenter","Commenter"],"10":["editor","Editor"],"11":["translator","Translator"],"12":["seriesEditor","Series Editor"],"13":["bookAuthor","Book Author"],"14":["counsel","Counsel"],"15":["programmer","Programmer"],"16":["reviewedAuthor","Reviewed Author"],"17":["recipient","Recipient"],"18":["director","Director"],"19":["scriptwriter","Scriptwriter"],"20":["producer","Producer"],"21":["interviewee","Interview With"],"22":["interviewer","Interviewer"],"23":["cartographer","Cartographer"],"24":["inventor","Inventor"],"25":["attorneyAgent","Attorney/Agent"],"26":["podcaster","Podcaster"],"27":["guest","Guest"],"28":["presenter","Presenter"],"29":["castMember","Cast Member"]},"fields":{"1":["title","title",true],"2":["abstractNote","abstractNote",true],"3":["artworkMedium","artworkMedium",false],"4":["medium","medium",true],"5":["artworkSize","artworkSize",true],"6":["date","date",true],"7":["language","language",true],"8":["shortTitle","shortTitle",true],"9":["archive","archive",true],"10":["archiveLocation","archiveLocation",true],"11":["libraryCatalog","libraryCatalog",true],"12":["callNumber","callNumber",true],"13":["url","url",true],"14":["accessDate","accessDate",true],"15":["rights","rights",true],"16":["extra","extra",true],"17":["audioRecordingFormat","audioRecordingFormat",false],"18":["seriesTitle","seriesTitle",true],"19":["volume","volume",true],"20":["numberOfVolumes","numberOfVolumes",true],"21":["place","place",true],"22":["label","label",false],"23":["publisher","publisher",true],"24":["runningTime","runningTime",true],"25":["ISBN","ISBN",true],"26":["billNumber","billNumber",false],"27":["number","number",true],"28":["code","code",true],"29":["codeVolume","codeVolume",false],"30":["section","section",true],"31":["codePages","codePages",false],"32":["pages","pages",true],"33":["legislativeBody","legislativeBody",true],"34":["session","session",true],"35":["history","history",true],"36":["blogTitle","blogTitle",false],"37":["publicationTitle","publicationTitle",true],"38":["websiteType","websiteType",false],"39":["type","type",true],"40":["series","series",true],"41":["seriesNumber","seriesNumber",true],"42":["edition","edition",true],"43":["numPages","numPages",true],"44":["bookTitle","bookTitle",false],"45":["caseName","caseName",false],"46":["court","court",true],"47":["dateDecided","dateDecided",false],"48":["docketNumber","docketNumber",false],"49":["reporter","reporter",true],"50":["reporterVolume","reporterVolume",false],"51":["firstPage","firstPage",false],"52":["versionNumber","versionNumber",true],"53":["system","system",true],"54":["company","company",false],"55":["programmingLanguage","programmingLanguage",true],"56":["proceedingsTitle","proceedingsTitle",false],"57":["conferenceName","conferenceName",true],"58":["DOI","DOI",true],"59":["dictionaryTitle","dictionaryTitle",false],"60":["subject","subject",false],"61":["encyclopediaTitle","encyclopediaTitle",false],"62":["distributor","distributor",false],"63":["genre","genre",false],"64":["videoRecordingFormat","videoRecordingFormat",false],"65":["forumTitle","forumTitle",false],"66":["postType","postType",false],"67":["committee","committee",true],"68":["documentNumber","documentNumber",false],"69":["interviewMedium","interviewMedium",false],"70":["issue","issue",true],"71":["seriesText","seriesText",true],"72":["journalAbbreviation","journalAbbreviation",true],"73":["ISSN","ISSN",true],"74":["letterType","letterType",false],"75":["manuscriptType","manuscriptType",false],"76":["mapType","mapType",false],"77":["scale","scale",true],"78":["country","country",true],"79":["assignee","assignee",true],"80":["issuingAuthority","issuingAuthority",true],"81":["patentNumber","patentNumber",false],"82":["filingDate","filingDate",true],"83":["applicationNumber","applicationNumber",true],"84":["priorityNumbers","priorityNumbers",true],"85":["issueDate","issueDate",false],"86":["references","references",true],"87":["legalStatus","legalStatus",true],"88":["episodeNumber","episodeNumber",false],"89":["audioFileType","audioFileType",false],"90":["repository","repository",false],"91":["archiveID","archiveID",true],"92":["citationKey","citationKey",true],"93":["presentationType","presentationType",false],"94":["meetingName","meetingName",true],"95":["programTitle","programTitle",false],"96":["network","network",false],"97":["reportNumber","reportNumber",false],"98":["reportType","reportType",false],"99":["institution","institution",false],"100":["nameOfAct","nameOfAct",false],"101":["codeNumber","codeNumber",true],"102":["publicLawNumber","publicLawNumber",false],"103":["dateEnacted","dateEnacted",false],"104":["thesisType","thesisType",false],"105":["university","university",false],"106":["studio","studio",false],"107":["websiteTitle","websiteTitle",false]}};

{
	module.exports = ZOTERO_TYPE_SCHEMA;
}
}(zoteroTypeSchemaData));

var ZOTERO_TYPE_SCHEMA$1 = zoteroTypeSchemaData.exports;

var date = {exports: {}};

/*
    ***** BEGIN LICENSE BLOCK *****
    
    Copyright © 2009 Center for History and New Media
                     George Mason University, Fairfax, Virginia, USA
                     http://zotero.org
    
    This file is part of Zotero.
    
    Zotero is free software: you can redistribute it and/or modify
    it under the terms of the GNU Affero General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    
    Zotero is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Affero General Public License for more details.
    
    You should have received a copy of the GNU Affero General Public License
    along with Zotero.  If not, see <http://www.gnu.org/licenses/>.
    
    ***** END LICENSE BLOCK *****
*/

(function (module) {
(function() {

var Utilities_Date = new function(){
	this.isSQLDate = isSQLDate;
	this.isSQLDateTime = isSQLDateTime;
	this.sqlHasYear = sqlHasYear;
	this.sqlHasMonth = sqlHasMonth;
	this.sqlHasDay = sqlHasDay;
	this.getUnixTimestamp = getUnixTimestamp;
	this.toUnixTimestamp = toUnixTimestamp;
	this.getFileDateString = getFileDateString;
	this.getFileTimeString = getFileTimeString;
	this.getLocaleDateOrder = getLocaleDateOrder;

	var _localeDateOrder = null;
	var _months;
	var _monthsWithEnglish;

	/**
	 * Initializes localized months for strToDate month parsing
	 * @param dateFormatsJSON {Object} the JSON from resource/dateFormats.json
	 */
	this.init = function (dateFormatsJSON) {
		if ((Zotero.isFx || Zotero.isElectron) && !dateFormatsJSON) {
			dateFormatsJSON = Zotero.File.getResource('resource://zotero/schema/dateFormats.json');
		}
		if (!dateFormatsJSON) {
			throw new Error("Zotero.Date.init() must be called with dateFormats.json");
		}
		if (typeof dateFormatsJSON == 'string') {
			dateFormatsJSON = JSON.parse(dateFormatsJSON);
		}

		var locale = Zotero.locale;
		var english = locale.startsWith('en');
		// If no exact match, try first two characters ('de')
		if (!dateFormatsJSON[locale]) {
			locale = locale.substr(0, 2);
		}
		// Try first two characters repeated ('de-DE')
		if (!dateFormatsJSON[locale]) {
			locale = locale + "-" + locale.toUpperCase();
		}
		// Look for another locale with same first two characters
		if (!dateFormatsJSON[locale]) {
			let sameLang = Object.keys(dateFormatsJSON).filter(l => l.startsWith(locale.substr(0, 2)));
			if (sameLang.length) {
				locale = sameLang[0];
			}
		}
		// If all else fails, use English
		if (!dateFormatsJSON[locale]) {
			locale = 'en-US';
			english = true;
		}
		_months = dateFormatsJSON[locale];

		// Add English versions if not already added
		if (english) {
			_monthsWithEnglish = _months;
		}
		else {
			_monthsWithEnglish = {};
			for (let key in _months) {
				_monthsWithEnglish[key] = _months[key].concat(dateFormatsJSON['en-US'][key]);
			}
		}
		
		let months = _monthsWithEnglish.short.map(m => m.toLowerCase())
			.concat(_monthsWithEnglish.long.map(m => m.toLowerCase()));
		// TODO: Switch back to native RegExp in Fx102 when Unicode property escapes are supported
		_monthRe = Zotero.Utilities.XRegExp("(.*)(?:^|[^\\p{L}])(" + months.join("|") + ")[^ ]*(?: (.*)$|$)", "iu");
	};


	/**
	 * @param {Boolean} [withEnglish = false] - Include English months
	 * @return {Object} - Object with 'short' and 'long' arrays
	 */
	this.getMonths = function (withEnglish) {
		if (withEnglish) {
			if (_monthsWithEnglish) return _monthsWithEnglish;
		}
		else {
			if (_months) return _months;
		}

		throw new Error("Zotero.Date: Zotero.Date.init() not called with resource/dateFormats.json");
	};

	/**
	 * Convert an SQL date in the form '2006-06-13 11:03:05' into a JS Date object
	 *
	 * Can also accept just the date part (e.g. '2006-06-13')
	 **/
	this.sqlToDate = function (sqldate, isUTC) {
		try {
			if (!this.isSQLDate(sqldate)
				&& !this.isSQLDateTime(sqldate)
				&& !this.isSQLDateTimeWithoutSeconds(sqldate)) {
				throw new Error("Invalid date");
			}

			var datetime = sqldate.split(' ');
			var dateparts = datetime[0].split('-');
			if (datetime[1]){
				var timeparts = datetime[1].split(':');
			}
			else {
				timeparts = [false, false, false];
			}

			// Invalid date part
			if (dateparts.length==1){
				throw new Error("Invalid date part");
			}
			// Allow missing seconds
			if (timeparts.length == 2) {
				timeparts[2] = '00';
			}

			if (isUTC){
				return new Date(Date.UTC(dateparts[0], dateparts[1]-1, dateparts[2],
					timeparts[0], timeparts[1], timeparts[2]));
			}

			return new Date(dateparts[0], dateparts[1]-1, dateparts[2],
				timeparts[0], timeparts[1], timeparts[2]);
		}
		catch (e){
			Zotero.debug(sqldate + ' is not a valid SQL date', 2);
			return false;
		}
	};


	/**
	 * Convert a JS Date object to an SQL date in the form '2006-06-13 11:03:05'
	 *
	 * If _toUTC_ is true, creates a UTC date
	 **/
	this.dateToSQL = function (date, toUTC) {
		try {
			if (toUTC){
				var year = date.getUTCFullYear();
				var month = date.getUTCMonth();
				var day = date.getUTCDate();
				var hours = date.getUTCHours();
				var minutes = date.getUTCMinutes();
				var seconds = date.getUTCSeconds();
			}
			else {
				var year = date.getFullYear();
				var month = date.getMonth();
				var day = date.getDate();
				var hours = date.getHours();
				var minutes = date.getMinutes();
				var seconds = date.getSeconds();
			}

			year = Zotero.Utilities.lpad(year, '0', 4);
			month = Zotero.Utilities.lpad(month + 1, '0', 2);
			day = Zotero.Utilities.lpad(day, '0', 2);
			hours = Zotero.Utilities.lpad(hours, '0', 2);
			minutes = Zotero.Utilities.lpad(minutes, '0', 2);
			seconds = Zotero.Utilities.lpad(seconds, '0', 2);

			return year + '-' + month + '-' + day + ' '
				+ hours + ':' + minutes + ':' + seconds;
		}
		catch (e){
			Zotero.debug(date + ' is not a valid JS date', 2);
			return '';
		}
	};


	/**
	 * Convert a JS Date object to an ISO 8601 UTC date/time
	 *
	 * @param	{Date}		date		JS Date object
	 * @return	{String}				ISO 8601 UTC date/time
	 *									e.g. 2008-08-15T20:00:00Z
	 */
	this.dateToISO = function (date) {
		var year = date.getUTCFullYear();
		var month = date.getUTCMonth();
		var day = date.getUTCDate();
		var hours = date.getUTCHours();
		var minutes = date.getUTCMinutes();
		var seconds = date.getUTCSeconds();

		year = Zotero.Utilities.lpad(year, '0', 4);
		month = Zotero.Utilities.lpad(month + 1, '0', 2);
		day = Zotero.Utilities.lpad(day, '0', 2);
		hours = Zotero.Utilities.lpad(hours, '0', 2);
		minutes = Zotero.Utilities.lpad(minutes, '0', 2);
		seconds = Zotero.Utilities.lpad(seconds, '0', 2);

		return year + '-' + month + '-' + day + 'T'
			+ hours + ':' + minutes + ':' + seconds + 'Z';
	};


	var _re8601 = /^([0-9]{4})(-([0-9]{2})(-([0-9]{2})(T([0-9]{2}):([0-9]{2})(:([0-9]{2})(\.([0-9]+))?)?(Z|(([-+])([0-9]{2}):([0-9]{2})))?)?)?)?$/;

	/**
	 * @return {Boolean} - True if string is an ISO 8601 date, false if not
	 */
	this.isISODate = function (str) {
		return _re8601.test(str);
	};

	/**
	 * Convert an ISO 8601–formatted date/time to a JS Date
	 *
	 * @param	{String}		isoDate		ISO 8601 date
	 * @return {Date|False} - JS Date, or false if not a valid date
	 */
	this.isoToDate = function (isoDate) {
		var d = isoDate.match(_re8601);
		if (!d) return false;
		return new Date(isoDate);
	};


	this.isoToSQL = function (isoDate) {
		return Utilities_Date.dateToSQL(Utilities_Date.isoToDate(isoDate), true); // no 'this' for translator sandbox
	};


	/*
	 * converts a string to an object containing:
	 *    day: integer form of the day
	 *    month: integer form of the month (indexed from 0, not 1)
	 *    year: 4 digit year (or, year + BC/AD/etc.)
	 *    part: anything that does not fall under any of the above categories
	 *          (e.g., "Summer," etc.)
	 *
	 * Note: the returned object is *not* a JS Date object
	 */
	var _slashRe = /^(.*?)\b([0-9]{1,4})(?:([\-\/\.\u5e74])([0-9]{1,2}))?(?:([\-\/\.\u6708])([0-9]{1,4}))?((?:\b|[^0-9]).*?)$/;
	var _yearRe = /^(.*?)\b((?:circa |around |about |c\.? ?)?[0-9]{1,4}(?: ?B\.? ?C\.?(?: ?E\.?)?| ?C\.? ?E\.?| ?A\.? ?D\.?)|[0-9]{3,4})\b(.*?)$/i;
	var _monthRe = null;
	var _dayRe = null;

	this.strToDate = function (string) {
		var date = {
			order: ''
		};

		if (typeof string == 'string' || typeof string == 'number') {
			string = Zotero.Utilities.trimInternal(string.toString());
		}

		// skip empty things
		if(!string) {
			return date;
		}

		var parts = [];

		// first, directly inspect the string
		var m = _slashRe.exec(string);
		if(m &&
			((!m[5] || !m[3]) || m[3] == m[5] || (m[3] == "\u5e74" && m[5] == "\u6708")) &&	// require sane separators
			((m[2] && m[4] && m[6]) || (!m[1] && !m[7]))) {						// require that either all parts are found,
			// or else this is the entire date field
			// figure out date based on parts
			if(m[2].length == 3 || m[2].length == 4 || m[3] == "\u5e74") {
				// ISO 8601 style date (big endian)
				date.year = m[2];
				date.month = m[4];
				date.day = m[6];
				date.order += m[2] ? 'y' : '';
				date.order += m[4] ? 'm' : '';
				date.order += m[6] ? 'd' : '';
			} else if(m[2] && !m[4] && m[6]) {
				date.month = m[2];
				date.year = m[6];
				date.order += m[2] ? 'm' : '';
				date.order += m[6] ? 'y' : '';
			} else {
				// local style date (middle or little endian)
				var country = Zotero.locale ? Zotero.locale.substr(3) : "US";
				if(country == "US" ||	// The United States
					country == "FM" ||	// The Federated States of Micronesia
					country == "PW" ||	// Palau
					country == "PH") {	// The Philippines
					date.month = m[2];
					date.day = m[4];
					date.order += m[2] ? 'm' : '';
					date.order += m[4] ? 'd' : '';
				} else {
					date.month = m[4];
					date.day = m[2];
					date.order += m[2] ? 'd' : '';
					date.order += m[4] ? 'm' : '';
				}
				date.year = m[6];
				if (m[6] !== undefined) {
					date.order += 'y';
				}
			}

			var longYear = date.year && date.year.toString().length > 2;
			if(date.year) date.year = parseInt(date.year, 10);
			if(date.day) date.day = parseInt(date.day, 10);
			if(date.month) {
				date.month = parseInt(date.month, 10);

				if(date.month > 12) {
					// swap day and month
					var tmp = date.day;
					date.day = date.month;
					date.month = tmp;
					date.order = date.order.replace('m', 'D')
						.replace('d', 'M')
						.replace('D', 'd')
						.replace('M', 'm');
				}
			}

			if((!date.month || date.month <= 12) && (!date.day || date.day <= 31)) {
				// Parse pre-100 years with leading zeroes (001, 0001, 012, 0012, 0123, but not 08)
				if (date.year && date.year < 100 && !longYear) {
					var today = new Date();
					var year = today.getFullYear();
					var twoDigitYear = year % 100;
					var century = year - twoDigitYear;

					if(date.year <= twoDigitYear) {
						// assume this date is from our century
						date.year = century + date.year;
					} else {
						// assume this date is from the previous century
						date.year = century - 100 + date.year;
					}
				}

				if(date.month) date.month--;		// subtract one for JS style
				else delete date.month;

				//Zotero.debug("DATE: retrieved with algorithms: "+JSON.stringify(date));

				parts.push(
					{ part: m[1], before: true },
					{ part: m[7] }
				);
			} else {
				// give up; we failed the sanity check
				Zotero.debug("DATE: algorithms failed sanity check");
				var date = {
					order: ''
				};
				parts.push({ part: string });
			}
		} else {
			//Zotero.debug("DATE: could not apply algorithms");
			parts.push({ part: string });
		}

		// couldn't find something with the algorithms; use regexp
		// YEAR
		if(!date.year) {
			for (var i in parts) {
				var m = _yearRe.exec(parts[i].part);
				if (m) {
					date.year = m[2];
					date.order = _insertDateOrderPart(date.order, 'y', parts[i]);
					parts.splice(
						i, 1,
						{ part: m[1], before: true },
						{ part: m[3] }
					);
					//Zotero.debug("DATE: got year (" + date.year + ", " + JSON.stringify(parts) + ")");
					break;
				}
			}
		}

		// MONTH
		if(date.month === undefined) {
			// compile month regular expression
			let months = Utilities_Date.getMonths(true); // no 'this' for translator sandbox
			months = months.short.map(m => m.toLowerCase())
				.concat(months.long.map(m => m.toLowerCase()));
			for (var i in parts) {
				var m = _monthRe.exec(parts[i].part);
				if (m) {
					// Modulo 12 in case we have multiple languages
					date.month = months.indexOf(m[2].toLowerCase()) % 12;
					date.order = _insertDateOrderPart(date.order, 'm', parts[i]);
					parts.splice(
						i, 1,
						{ part: m[1], before: "m" },
						{ part: m[3], after: "m" }
					);
					//Zotero.debug("DATE: got month (" + date.month + ", " + JSON.stringify(parts) + ")");
					break;
				}
			}
		}

		// DAY
		if(!date.day) {
			// compile day regular expression
			if(!_dayRe) {
				var daySuffixes = Zotero.isClient ? Zotero.getString("date.daySuffixes").replace(/, ?/g, "|") : "";
				_dayRe = new RegExp("\\b([0-9]{1,2})(?:"+daySuffixes+")?\\b(.*)", "i");
			}

			for (var i in parts) {
				var m = _dayRe.exec(parts[i].part);
				if (m) {
					var day = parseInt(m[1], 10);
					// Sanity check
					if (day <= 31) {
						date.day = day;
						date.order = _insertDateOrderPart(date.order, 'd', parts[i]);
						if(m.index > 0) {
							var part = parts[i].part.substr(0, m.index);
							if(m[2]) {
								part += " " + m[2];							}
						} else {
							var part = m[2];
						}
						parts.splice(
							i, 1,
							{ part: part }
						);
						//Zotero.debug("DATE: got day (" + date.day + ", " + JSON.stringify(parts) + ")");
						break;
					}
				}
			}
		}

		// Concatenate date parts
		date.part = '';
		for (var i in parts) {
			date.part += parts[i].part + ' ';
		}

		// clean up date part
		if(date.part) {
			date.part = date.part.replace(/^[^A-Za-z0-9]+|[^A-Za-z0-9]+$/g, "");
		}

		if(date.part === "" || date.part == undefined) {
			delete date.part;
		}

		//make sure year is always a string
		if(date.year || date.year === 0) date.year += '';

		return date;
	};

	this.isHTTPDate = function(str) {
		var dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
		var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep",
			"Oct", "Nov", "Dec"];
		str = str.trim();
		var temp = str.split(',');
		if (temp.length > 1) {
			var dayOfWeek = temp[0];
			if(dayNames.indexOf(dayOfWeek) == -1) {
				return false;
			}

			str = temp[1].trim();
		}
		temp = str.split(' ');
		temp = temp.filter((t) => ! t.match(/^\s*$/));
		if (temp.length < 5) {
			return false;
		}
		if (!temp[0].trim().match(/[0-3]\d/)) {
			return false;
		}
		if (monthNames.indexOf(temp[1].trim()) == -1) {
			return false;
		}
		if (!temp[2].trim().match(/\d\d\d\d/)) {
			return false;
		}
		temp.splice(0, 3);
		var time = temp[0].trim().split(':');
		if (time.length < 2) {
			return false;
		}
		for (let t of time) {
			if (!t.match(/\d\d/)) {
				return false;
			}
		}
		temp.splice(0, 1);
		var zone = temp.join(' ').trim();
		return !!zone.match(/([+-]\d\d\d\d|UTC?|GMT|EST|EDT|CST|CDT|MST|MDT|PST|PDT)/)
	};


	function _insertDateOrderPart(dateOrder, part, partOrder) {
		if (!dateOrder) {
			return part;
		}
		if (partOrder.before === true) {
			return part + dateOrder;
		}
		if (partOrder.after === true) {
			return dateOrder + part;
		}
		if (partOrder.before) {
			var pos = dateOrder.indexOf(partOrder.before);
			if (pos == -1) {
				return dateOrder;
			}
			return dateOrder.replace(new RegExp("(" + partOrder.before + ")"), part + '$1');
		}
		if (partOrder.after) {
			var pos = dateOrder.indexOf(partOrder.after);
			if (pos == -1) {
				return dateOrder + part;
			}
			return dateOrder.replace(new RegExp("(" + partOrder.after + ")"), '$1' + part);
		}
		return dateOrder + part;
	}



	/**
	 * does pretty formatting of a date object returned by strToDate()
	 *
	 * @param {Object} date A date object, as returned from strToDate()
	 * @param {Boolean} shortFormat Whether to return a short (12/1/95) date
	 * @return A formatted date string
	 * @type String
	 **/
	this.formatDate = function (date, shortFormat) {
		if(shortFormat) {
			var localeDateOrder = getLocaleDateOrder();
			var string = localeDateOrder[0]+"/"+localeDateOrder[1]+"/"+localeDateOrder[2];
			return string.replace("y", (date.year !== undefined ? date.year : "00"))
				.replace("m", (date.month !== undefined ? 1+date.month : "0"))
				.replace("d", (date.day !== undefined ? date.day : "0"));
		} else {
			var string = "";

			if(date.part) {
				string += date.part+" ";
			}

			var months = Utilities_Date.getMonths().long; // no 'this' for translator sandbox
			if(date.month != undefined && months[date.month]) {
				// get short month strings from CSL interpreter
				string += months[date.month];
				if(date.day) {
					string += " "+date.day+", ";
				} else {
					string += " ";
				}
			}

			if(date.year) {
				string += date.year;
			}
		}

		return string;
	};

	this.strToISO = function (str) {
		var date = this.strToDate(str);

		if(date.year) {
			var dateString = Zotero.Utilities.lpad(date.year, "0", 4);
			if (parseInt(date.month) == date.month) {
				dateString += "-"+Zotero.Utilities.lpad(date.month+1, "0", 2);
				if(date.day) {
					dateString += "-"+Zotero.Utilities.lpad(date.day, "0", 2);
				}
			}
			return dateString;
		}
		return false;
	};


	this.sqlToISO8601 = function (sqlDate) {
		var date = sqlDate.substr(0, 10);
		var matches = date.match(/^([0-9]{4})\-([0-9]{2})\-([0-9]{2})/);
		if (!matches) {
			return false;
		}
		date = matches[1];
		// Drop parts for reduced precision
		if (matches[2] !== "00") {
			date += "-" + matches[2];
			if (matches[3] !== "00") {
				date += "-" + matches[3];
			}
		}
		var time = sqlDate.substr(11);
		// TODO: validate times
		if (time) {
			date += "T" + time + "Z";
		}
		return date;
	};

	this.strToMultipart = function (str) {
		if (!str){
			return '';
		}

		var parts = this.strToDate(str);

		// FIXME: Until we have a better BCE date solution,
		// remove year value if not between 1 and 9999
		if (parts.year) {
			var year = parts.year + '';
			if (!year.match(/^[0-9]{1,4}$/)) {
				delete parts.year;
			}
		}

		parts.month = typeof parts.month != "undefined" ? parts.month + 1 : '';

		var multi = (parts.year ? Zotero.Utilities.lpad(parts.year, '0', 4) : '0000') + '-'
			+ Zotero.Utilities.lpad(parts.month, '0', 2) + '-'
			+ (parts.day ? Zotero.Utilities.lpad(parts.day, '0', 2) : '00')
			+ ' '
			+ str;
		return multi;
	};

	// Regexes for multipart and SQL dates
	// Allow zeroes in multipart dates
	// TODO: Allow negative multipart in DB and here with \-?
	var _multipartRE = /^[0-9]{4}\-(0[0-9]|10|11|12)\-(0[0-9]|[1-2][0-9]|30|31) /;
	var _sqldateRE = /^\-?[0-9]{4}\-(0[1-9]|10|11|12)\-(0[1-9]|[1-2][0-9]|30|31)$/;
	var _sqldateWithZeroesRE = /^\-?[0-9]{4}\-(0[0-9]|10|11|12)\-(0[0-9]|[1-2][0-9]|30|31)$/;
	var _sqldatetimeRE = /^\-?[0-9]{4}\-(0[1-9]|10|11|12)\-(0[1-9]|[1-2][0-9]|30|31) ([0-1][0-9]|[2][0-3]):([0-5][0-9]):([0-5][0-9])$/;
	var _sqlDateTimeWithoutSecondsRE = /^\-?[0-9]{4}\-(0[1-9]|10|11|12)\-(0[1-9]|[1-2][0-9]|30|31) ([0-1][0-9]|[2][0-3]):([0-5][0-9])$/;

	/**
	 * Tests if a string is a multipart date string
	 * e.g. '2006-11-03 November 3rd, 2006'
	 */
	this.isMultipart = function (str) {
		if (this.isSQLDateTime(str) || this.isSQLDateTimeWithoutSeconds(str)) {
			return false;
		}
		return _multipartRE.test(str);
	};


	/**
	 * Returns the SQL part of a multipart date string
	 * (e.g. '2006-11-03 November 3rd, 2006' returns '2006-11-03')
	 */
	this.multipartToSQL = function (multi) {
		if (!multi){
			return '';
		}

		if (!this.isMultipart(multi)) {
			return '0000-00-00';
		}

		return multi.substr(0, 10);
	};


	/**
	 * Returns the user part of a multipart date string
	 * (e.g. '2006-11-03 November 3rd, 2006' returns 'November 3rd, 2006')
	 */
	this.multipartToStr = function (multi) {
		if (!multi){
			return '';
		}

		if (!this.isMultipart(multi)) {
			return multi;
		}

		return multi.substr(11);
	};


	/**
	 * Convert 'yesterday'/'today'/'tomorrow' to SQL date, or else return original string
	 *
	 * @param {String} str
	 * @return {String}
	 */
	this.parseDescriptiveString = function (str) {
		// Parse 'yesterday'/'today'/'tomorrow' and convert to dates,
		// since it doesn't make sense for those to be actual metadata values
		var lc = str.toLowerCase().trim();
		if (lc == 'yesterday' || lc == Zotero.getString('date.yesterday')) {
			str = Utilities_Date.dateToSQL(new Date(new Date().getTime() - 86400000)).substr(0, 10);
		}
		else if (lc == 'today' || lc == Zotero.getString('date.today')) {
			str = Utilities_Date.dateToSQL(new Date()).substr(0, 10);
		}
		else if (lc == 'tomorrow' || lc == Zotero.getString('date.tomorrow')) {
			str = Utilities_Date.dateToSQL(new Date(new Date().getTime() + 86400000)).substr(0, 10);
		}
		return str;
	};


	function isSQLDate(str, allowZeroes) {
		if (allowZeroes) {
			return _sqldateWithZeroesRE.test(str);
		}
		return _sqldateRE.test(str);
	}


	function isSQLDateTime(str){
		return _sqldatetimeRE.test(str);
	}


	this.isSQLDateTimeWithoutSeconds = function (str) {
		return _sqlDateTimeWithoutSecondsRE.test(str);
	};


	function sqlHasYear(sqldate){
		return isSQLDate(sqldate, true) && sqldate.substr(0,4)!='0000';
	}


	function sqlHasMonth(sqldate){
		return isSQLDate(sqldate, true) && sqldate.substr(5,2)!='00';
	}


	function sqlHasDay(sqldate){
		return isSQLDate(sqldate, true) && sqldate.substr(8,2)!='00';
	}


	function getUnixTimestamp() {
		return Math.round(Date.now() / 1000);
	}


	function toUnixTimestamp(date) {
		if (date === null || typeof date != 'object' ||
			date.constructor.name != 'Date') {
			throw new Error(`'${date}' is not a valid date`);
		}
		return Math.round(date.getTime() / 1000);
	}


	/**
	 * Convert a JS Date to a relative date (e.g., "5 minutes ago")
	 *
	 * Adapted from http://snipplr.com/view/10290/javascript-parse-relative-date/
	 *
	 * @param	{Date}	date
	 * @return	{String}
	 */
	this.toRelativeDate = function (date) {
		var now = new Date();
		var timeSince = now.getTime() - date;
		var inSeconds = timeSince / 1000;
		var inMinutes = timeSince / 1000 / 60;
		var inHours = timeSince / 1000 / 60 / 60;
		var inDays = timeSince / 1000 / 60 / 60 / 24;
		var inYears = timeSince / 1000 / 60 / 60 / 24 / 365;

		var n;

		// in seconds
		if (Math.round(inSeconds) == 1) {
			var key = "secondsAgo";
		}
		else if (inMinutes < 1.01) {
			var key = "secondsAgo";
			n = Math.round(inSeconds);
		}

		// in minutes
		else if (Math.round(inMinutes) == 1) {
			var key = "minutesAgo";
		}
		else if (inHours < 1.01) {
			var key = "minutesAgo";
			n = Math.round(inMinutes);
		}

		// in hours
		else if (Math.round(inHours) == 1) {
			var key = "hoursAgo";
		}
		else if (inDays < 1.01) {
			var key = "hoursAgo";
			n = Math.round(inHours);
		}

		// in days
		else if (Math.round(inDays) == 1) {
			var key = "daysAgo";
		}
		else if (inYears < 1.01) {
			var key = "daysAgo";
			n = Math.round(inDays);
		}

		// in years
		else if (Math.round(inYears) == 1) {
			var key = "yearsAgo";
		}
		else {
			var key = "yearsAgo";
			var n = Math.round(inYears);
		}

		return Zotero.getString("date.relative." + key + "." + (n ? "multiple" : "one"), n);
	};


	this.toFriendlyDate = function (date) {
		// 6:14:36 PM
		if (isToday(date)) {
			return date.toLocaleString(false, { hour: 'numeric', minute: 'numeric' })
		}
		// 'Thursday'
		if (isThisWeek(date)) {
			return date.toLocaleString(false, { weekday: 'long' });
		}
		return date.toLocaleDateString(false, { year: '2-digit', month: 'numeric', day: 'numeric' });
	};


	function isToday(date) {
		var d = new Date();
		return d.getDate() == date.getDate()
			&& d.getMonth() == d.getMonth()
			&& d.getFullYear() == d.getFullYear();
	}


	function isThisWeek(date) {
		var d = new Date();
		return d.getFullYear() == date.getFullYear() && getWeekNumber(d) == getWeekNumber(date);
	}


	// https://stackoverflow.com/a/27125580
	function getWeekNumber(date) {
		let onejan = new Date(date.getFullYear(), 0, 1);
		return Math.ceil((((date.getTime() - onejan.getTime()) / 86400000) + onejan.getDay() + 1) / 7);
	}


	function getFileDateString(file){
		var date = new Date();
		date.setTime(file.lastModifiedTime);
		return date.toLocaleDateString();
	}


	function getFileTimeString(file){
		var date = new Date();
		date.setTime(file.lastModifiedTime);
		return date.toLocaleTimeString();
	}

	/**
	 * Get the order of the date components based on the current locale
	 *
	 * Returns a string with y, m, and d (e.g. 'ymd', 'mdy')
	 */
	function getLocaleDateOrder(){
		if (!_localeDateOrder) {
			switch (Zotero.locale ? Zotero.locale.substr(3) : "US") {
				// middle-endian
			case 'US': // The United States
			case 'BZ': // Belize
			case 'FM': // The Federated States of Micronesia
			case 'PA': // Panama
			case 'PH':	// The Philippines
			case 'PW':	// Palau
			case 'ZW': // Zimbabwe
				_localeDateOrder = 'mdy';
				break;

				// big-endian
			case 'fa': // Persian
			case 'AL': // Albania
			case 'CA': // Canada
			case 'CN': // China
			case 'HU': // Hungary
			case 'JP': // Japan
			case 'KE': // Kenya
			case 'KR': // Korea
			case 'LT': // Lithuania
			case 'LV': // Latvia
			case 'MN': // Mongolia
			case 'SE': // Sweden
			case 'TW': // Taiwan
			case 'ZA': // South Africa
				_localeDateOrder = 'ymd';
				break;

				// little-endian
			default:
				_localeDateOrder = 'dmy';
			}
		}
		return _localeDateOrder;
	}
};

{
	module.exports = Utilities_Date;
}

})();
}(date));

var Utilities_Date = date.exports;

var utilities = {exports: {}};

var xregexpAll = {exports: {}};

(function (module, exports) {
(function(f){{module.exports=f();}})(function(){return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof commonjsRequire=="function"&&commonjsRequire;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r);}return n[o].exports}var i=typeof commonjsRequire=="function"&&commonjsRequire;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/*!
 * XRegExp.build 3.2.0
 * <xregexp.com>
 * Steven Levithan (c) 2012-2017 MIT License
 * Inspired by Lea Verou's RegExp.create <lea.verou.me>
 */

module.exports = function(XRegExp) {

    var REGEX_DATA = 'xregexp';
    var subParts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
    var parts = XRegExp.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, subParts], 'g', {
        conjunction: 'or'
    });

    /**
     * Strips a leading `^` and trailing unescaped `$`, if both are present.
     *
     * @private
     * @param {String} pattern Pattern to process.
     * @returns {String} Pattern with edge anchors removed.
     */
    function deanchor(pattern) {
        // Allow any number of empty noncapturing groups before/after anchors, because regexes
        // built/generated by XRegExp sometimes include them
        var leadingAnchor = /^(?:\(\?:\))*\^/;
        var trailingAnchor = /\$(?:\(\?:\))*$/;

        if (
            leadingAnchor.test(pattern) &&
            trailingAnchor.test(pattern) &&
            // Ensure that the trailing `$` isn't escaped
            trailingAnchor.test(pattern.replace(/\\[\s\S]/g, ''))
        ) {
            return pattern.replace(leadingAnchor, '').replace(trailingAnchor, '');
        }

        return pattern;
    }

    /**
     * Converts the provided value to an XRegExp. Native RegExp flags are not preserved.
     *
     * @private
     * @param {String|RegExp} value Value to convert.
     * @param {Boolean} [addFlagX] Whether to apply the `x` flag in cases when `value` is not
     *   already a regex generated by XRegExp
     * @returns {RegExp} XRegExp object with XRegExp syntax applied.
     */
    function asXRegExp(value, addFlagX) {
        var flags = addFlagX ? 'x' : '';
        return XRegExp.isRegExp(value) ?
            (value[REGEX_DATA] && value[REGEX_DATA].captureNames ?
                // Don't recompile, to preserve capture names
                value :
                // Recompile as XRegExp
                XRegExp(value.source, flags)
            ) :
            // Compile string as XRegExp
            XRegExp(value, flags);
    }

    /**
     * Builds regexes using named subpatterns, for readability and pattern reuse. Backreferences in
     * the outer pattern and provided subpatterns are automatically renumbered to work correctly.
     * Native flags used by provided subpatterns are ignored in favor of the `flags` argument.
     *
     * @memberOf XRegExp
     * @param {String} pattern XRegExp pattern using `{{name}}` for embedded subpatterns. Allows
     *   `({{name}})` as shorthand for `(?<name>{{name}})`. Patterns cannot be embedded within
     *   character classes.
     * @param {Object} subs Lookup object for named subpatterns. Values can be strings or regexes. A
     *   leading `^` and trailing unescaped `$` are stripped from subpatterns, if both are present.
     * @param {String} [flags] Any combination of XRegExp flags.
     * @returns {RegExp} Regex with interpolated subpatterns.
     * @example
     *
     * var time = XRegExp.build('(?x)^ {{hours}} ({{minutes}}) $', {
     *   hours: XRegExp.build('{{h12}} : | {{h24}}', {
     *     h12: /1[0-2]|0?[1-9]/,
     *     h24: /2[0-3]|[01][0-9]/
     *   }, 'x'),
     *   minutes: /^[0-5][0-9]$/
     * });
     * time.test('10:59'); // -> true
     * XRegExp.exec('10:59', time).minutes; // -> '59'
     */
    XRegExp.build = function(pattern, subs, flags) {
        flags = flags || '';
        // Used with `asXRegExp` calls for `pattern` and subpatterns in `subs`, to work around how
        // some browsers convert `RegExp('\n')` to a regex that contains the literal characters `\`
        // and `n`. See more details at <https://github.com/slevithan/xregexp/pull/163>.
        var addFlagX = flags.indexOf('x') > -1;
        var inlineFlags = /^\(\?([\w$]+)\)/.exec(pattern);
        // Add flags within a leading mode modifier to the overall pattern's flags
        if (inlineFlags) {
            flags = XRegExp._clipDuplicates(flags + inlineFlags[1]);
        }

        var data = {};
        for (var p in subs) {
            if (subs.hasOwnProperty(p)) {
                // Passing to XRegExp enables extended syntax and ensures independent validity,
                // lest an unescaped `(`, `)`, `[`, or trailing `\` breaks the `(?:)` wrapper. For
                // subpatterns provided as native regexes, it dies on octals and adds the property
                // used to hold extended regex instance data, for simplicity.
                var sub = asXRegExp(subs[p], addFlagX);
                data[p] = {
                    // Deanchoring allows embedding independently useful anchored regexes. If you
                    // really need to keep your anchors, double them (i.e., `^^...$$`).
                    pattern: deanchor(sub.source),
                    names: sub[REGEX_DATA].captureNames || []
                };
            }
        }

        // Passing to XRegExp dies on octals and ensures the outer pattern is independently valid;
        // helps keep this simple. Named captures will be put back.
        var patternAsRegex = asXRegExp(pattern, addFlagX);

        // 'Caps' is short for 'captures'
        var numCaps = 0;
        var numPriorCaps;
        var numOuterCaps = 0;
        var outerCapsMap = [0];
        var outerCapNames = patternAsRegex[REGEX_DATA].captureNames || [];
        var output = patternAsRegex.source.replace(parts, function($0, $1, $2, $3, $4) {
            var subName = $1 || $2;
            var capName;
            var intro;
            var localCapIndex;
            // Named subpattern
            if (subName) {
                if (!data.hasOwnProperty(subName)) {
                    throw new ReferenceError('Undefined property ' + $0);
                }
                // Named subpattern was wrapped in a capturing group
                if ($1) {
                    capName = outerCapNames[numOuterCaps];
                    outerCapsMap[++numOuterCaps] = ++numCaps;
                    // If it's a named group, preserve the name. Otherwise, use the subpattern name
                    // as the capture name
                    intro = '(?<' + (capName || subName) + '>';
                } else {
                    intro = '(?:';
                }
                numPriorCaps = numCaps;
                return intro + data[subName].pattern.replace(subParts, function(match, paren, backref) {
                    // Capturing group
                    if (paren) {
                        capName = data[subName].names[numCaps - numPriorCaps];
                        ++numCaps;
                        // If the current capture has a name, preserve the name
                        if (capName) {
                            return '(?<' + capName + '>';
                        }
                    // Backreference
                    } else if (backref) {
                        localCapIndex = +backref - 1;
                        // Rewrite the backreference
                        return data[subName].names[localCapIndex] ?
                            // Need to preserve the backreference name in case using flag `n`
                            '\\k<' + data[subName].names[localCapIndex] + '>' :
                            '\\' + (+backref + numPriorCaps);
                    }
                    return match;
                }) + ')';
            }
            // Capturing group
            if ($3) {
                capName = outerCapNames[numOuterCaps];
                outerCapsMap[++numOuterCaps] = ++numCaps;
                // If the current capture has a name, preserve the name
                if (capName) {
                    return '(?<' + capName + '>';
                }
            // Backreference
            } else if ($4) {
                localCapIndex = +$4 - 1;
                // Rewrite the backreference
                return outerCapNames[localCapIndex] ?
                    // Need to preserve the backreference name in case using flag `n`
                    '\\k<' + outerCapNames[localCapIndex] + '>' :
                    '\\' + outerCapsMap[+$4];
            }
            return $0;
        });

        return XRegExp(output, flags);
    };

};

},{}],2:[function(require,module,exports){
/*!
 * XRegExp.matchRecursive 3.2.0
 * <xregexp.com>
 * Steven Levithan (c) 2009-2017 MIT License
 */

module.exports = function(XRegExp) {

    /**
     * Returns a match detail object composed of the provided values.
     *
     * @private
     */
    function row(name, value, start, end) {
        return {
            name: name,
            value: value,
            start: start,
            end: end
        };
    }

    /**
     * Returns an array of match strings between outermost left and right delimiters, or an array of
     * objects with detailed match parts and position data. An error is thrown if delimiters are
     * unbalanced within the data.
     *
     * @memberOf XRegExp
     * @param {String} str String to search.
     * @param {String} left Left delimiter as an XRegExp pattern.
     * @param {String} right Right delimiter as an XRegExp pattern.
     * @param {String} [flags] Any native or XRegExp flags, used for the left and right delimiters.
     * @param {Object} [options] Lets you specify `valueNames` and `escapeChar` options.
     * @returns {Array} Array of matches, or an empty array.
     * @example
     *
     * // Basic usage
     * var str = '(t((e))s)t()(ing)';
     * XRegExp.matchRecursive(str, '\\(', '\\)', 'g');
     * // -> ['t((e))s', '', 'ing']
     *
     * // Extended information mode with valueNames
     * str = 'Here is <div> <div>an</div></div> example';
     * XRegExp.matchRecursive(str, '<div\\s*>', '</div>', 'gi', {
     *   valueNames: ['between', 'left', 'match', 'right']
     * });
     * // -> [
     * // {name: 'between', value: 'Here is ',       start: 0,  end: 8},
     * // {name: 'left',    value: '<div>',          start: 8,  end: 13},
     * // {name: 'match',   value: ' <div>an</div>', start: 13, end: 27},
     * // {name: 'right',   value: '</div>',         start: 27, end: 33},
     * // {name: 'between', value: ' example',       start: 33, end: 41}
     * // ]
     *
     * // Omitting unneeded parts with null valueNames, and using escapeChar
     * str = '...{1}.\\{{function(x,y){return {y:x}}}';
     * XRegExp.matchRecursive(str, '{', '}', 'g', {
     *   valueNames: ['literal', null, 'value', null],
     *   escapeChar: '\\'
     * });
     * // -> [
     * // {name: 'literal', value: '...',  start: 0, end: 3},
     * // {name: 'value',   value: '1',    start: 4, end: 5},
     * // {name: 'literal', value: '.\\{', start: 6, end: 9},
     * // {name: 'value',   value: 'function(x,y){return {y:x}}', start: 10, end: 37}
     * // ]
     *
     * // Sticky mode via flag y
     * str = '<1><<<2>>><3>4<5>';
     * XRegExp.matchRecursive(str, '<', '>', 'gy');
     * // -> ['1', '<<2>>', '3']
     */
    XRegExp.matchRecursive = function(str, left, right, flags, options) {
        flags = flags || '';
        options = options || {};
        var global = flags.indexOf('g') > -1;
        var sticky = flags.indexOf('y') > -1;
        // Flag `y` is controlled internally
        var basicFlags = flags.replace(/y/g, '');
        var escapeChar = options.escapeChar;
        var vN = options.valueNames;
        var output = [];
        var openTokens = 0;
        var delimStart = 0;
        var delimEnd = 0;
        var lastOuterEnd = 0;
        var outerStart;
        var innerStart;
        var leftMatch;
        var rightMatch;
        var esc;
        left = XRegExp(left, basicFlags);
        right = XRegExp(right, basicFlags);

        if (escapeChar) {
            if (escapeChar.length > 1) {
                throw new Error('Cannot use more than one escape character');
            }
            escapeChar = XRegExp.escape(escapeChar);
            // Example of concatenated `esc` regex:
            // `escapeChar`: '%'
            // `left`: '<'
            // `right`: '>'
            // Regex is: /(?:%[\S\s]|(?:(?!<|>)[^%])+)+/
            esc = new RegExp(
                '(?:' + escapeChar + '[\\S\\s]|(?:(?!' +
                    // Using `XRegExp.union` safely rewrites backreferences in `left` and `right`.
                    // Intentionally not passing `basicFlags` to `XRegExp.union` since any syntax
                    // transformation resulting from those flags was already applied to `left` and
                    // `right` when they were passed through the XRegExp constructor above.
                    XRegExp.union([left, right], '', {conjunction: 'or'}).source +
                    ')[^' + escapeChar + '])+)+',
                // Flags `gy` not needed here
                flags.replace(/[^imu]+/g, '')
            );
        }

        while (true) {
            // If using an escape character, advance to the delimiter's next starting position,
            // skipping any escaped characters in between
            if (escapeChar) {
                delimEnd += (XRegExp.exec(str, esc, delimEnd, 'sticky') || [''])[0].length;
            }
            leftMatch = XRegExp.exec(str, left, delimEnd);
            rightMatch = XRegExp.exec(str, right, delimEnd);
            // Keep the leftmost match only
            if (leftMatch && rightMatch) {
                if (leftMatch.index <= rightMatch.index) {
                    rightMatch = null;
                } else {
                    leftMatch = null;
                }
            }
            // Paths (LM: leftMatch, RM: rightMatch, OT: openTokens):
            // LM | RM | OT | Result
            // 1  | 0  | 1  | loop
            // 1  | 0  | 0  | loop
            // 0  | 1  | 1  | loop
            // 0  | 1  | 0  | throw
            // 0  | 0  | 1  | throw
            // 0  | 0  | 0  | break
            // The paths above don't include the sticky mode special case. The loop ends after the
            // first completed match if not `global`.
            if (leftMatch || rightMatch) {
                delimStart = (leftMatch || rightMatch).index;
                delimEnd = delimStart + (leftMatch || rightMatch)[0].length;
            } else if (!openTokens) {
                break;
            }
            if (sticky && !openTokens && delimStart > lastOuterEnd) {
                break;
            }
            if (leftMatch) {
                if (!openTokens) {
                    outerStart = delimStart;
                    innerStart = delimEnd;
                }
                ++openTokens;
            } else if (rightMatch && openTokens) {
                if (!--openTokens) {
                    if (vN) {
                        if (vN[0] && outerStart > lastOuterEnd) {
                            output.push(row(vN[0], str.slice(lastOuterEnd, outerStart), lastOuterEnd, outerStart));
                        }
                        if (vN[1]) {
                            output.push(row(vN[1], str.slice(outerStart, innerStart), outerStart, innerStart));
                        }
                        if (vN[2]) {
                            output.push(row(vN[2], str.slice(innerStart, delimStart), innerStart, delimStart));
                        }
                        if (vN[3]) {
                            output.push(row(vN[3], str.slice(delimStart, delimEnd), delimStart, delimEnd));
                        }
                    } else {
                        output.push(str.slice(innerStart, delimStart));
                    }
                    lastOuterEnd = delimEnd;
                    if (!global) {
                        break;
                    }
                }
            } else {
                throw new Error('Unbalanced delimiter found in string');
            }
            // If the delimiter matched an empty string, avoid an infinite loop
            if (delimStart === delimEnd) {
                ++delimEnd;
            }
        }

        if (global && !sticky && vN && vN[0] && str.length > lastOuterEnd) {
            output.push(row(vN[0], str.slice(lastOuterEnd), lastOuterEnd, str.length));
        }

        return output;
    };

};

},{}],3:[function(require,module,exports){
/*!
 * XRegExp Unicode Base 3.2.0
 * <xregexp.com>
 * Steven Levithan (c) 2008-2017 MIT License
 */

module.exports = function(XRegExp) {

    /**
     * Adds base support for Unicode matching:
     * - Adds syntax `\p{..}` for matching Unicode tokens. Tokens can be inverted using `\P{..}` or
     *   `\p{^..}`. Token names ignore case, spaces, hyphens, and underscores. You can omit the
     *   braces for token names that are a single letter (e.g. `\pL` or `PL`).
     * - Adds flag A (astral), which enables 21-bit Unicode support.
     * - Adds the `XRegExp.addUnicodeData` method used by other addons to provide character data.
     *
     * Unicode Base relies on externally provided Unicode character data. Official addons are
     * available to provide data for Unicode categories, scripts, blocks, and properties.
     *
     * @requires XRegExp
     */

    // ==--------------------------==
    // Private stuff
    // ==--------------------------==

    // Storage for Unicode data
    var unicode = {};

    // Reuse utils
    var dec = XRegExp._dec;
    var hex = XRegExp._hex;
    var pad4 = XRegExp._pad4;

    // Generates a token lookup name: lowercase, with hyphens, spaces, and underscores removed
    function normalize(name) {
        return name.replace(/[- _]+/g, '').toLowerCase();
    }

    // Gets the decimal code of a literal code unit, \xHH, \uHHHH, or a backslash-escaped literal
    function charCode(chr) {
        var esc = /^\\[xu](.+)/.exec(chr);
        return esc ?
            dec(esc[1]) :
            chr.charCodeAt(chr.charAt(0) === '\\' ? 1 : 0);
    }

    // Inverts a list of ordered BMP characters and ranges
    function invertBmp(range) {
        var output = '';
        var lastEnd = -1;

        XRegExp.forEach(
            range,
            /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/,
            function(m) {
                var start = charCode(m[1]);
                if (start > (lastEnd + 1)) {
                    output += '\\u' + pad4(hex(lastEnd + 1));
                    if (start > (lastEnd + 2)) {
                        output += '-\\u' + pad4(hex(start - 1));
                    }
                }
                lastEnd = charCode(m[2] || m[1]);
            }
        );

        if (lastEnd < 0xFFFF) {
            output += '\\u' + pad4(hex(lastEnd + 1));
            if (lastEnd < 0xFFFE) {
                output += '-\\uFFFF';
            }
        }

        return output;
    }

    // Generates an inverted BMP range on first use
    function cacheInvertedBmp(slug) {
        var prop = 'b!';
        return (
            unicode[slug][prop] ||
            (unicode[slug][prop] = invertBmp(unicode[slug].bmp))
        );
    }

    // Combines and optionally negates BMP and astral data
    function buildAstral(slug, isNegated) {
        var item = unicode[slug];
        var combined = '';

        if (item.bmp && !item.isBmpLast) {
            combined = '[' + item.bmp + ']' + (item.astral ? '|' : '');
        }
        if (item.astral) {
            combined += item.astral;
        }
        if (item.isBmpLast && item.bmp) {
            combined += (item.astral ? '|' : '') + '[' + item.bmp + ']';
        }

        // Astral Unicode tokens always match a code point, never a code unit
        return isNegated ?
            '(?:(?!' + combined + ')(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\0-\uFFFF]))' :
            '(?:' + combined + ')';
    }

    // Builds a complete astral pattern on first use
    function cacheAstral(slug, isNegated) {
        var prop = isNegated ? 'a!' : 'a=';
        return (
            unicode[slug][prop] ||
            (unicode[slug][prop] = buildAstral(slug, isNegated))
        );
    }

    // ==--------------------------==
    // Core functionality
    // ==--------------------------==

    /*
     * Add astral mode (flag A) and Unicode token syntax: `\p{..}`, `\P{..}`, `\p{^..}`, `\pC`.
     */
    XRegExp.addToken(
        // Use `*` instead of `+` to avoid capturing `^` as the token name in `\p{^}`
        /\\([pP])(?:{(\^?)([^}]*)}|([A-Za-z]))/,
        function(match, scope, flags) {
            var ERR_DOUBLE_NEG = 'Invalid double negation ';
            var ERR_UNKNOWN_NAME = 'Unknown Unicode token ';
            var ERR_UNKNOWN_REF = 'Unicode token missing data ';
            var ERR_ASTRAL_ONLY = 'Astral mode required for Unicode token ';
            var ERR_ASTRAL_IN_CLASS = 'Astral mode does not support Unicode tokens within character classes';
            // Negated via \P{..} or \p{^..}
            var isNegated = match[1] === 'P' || !!match[2];
            // Switch from BMP (0-FFFF) to astral (0-10FFFF) mode via flag A
            var isAstralMode = flags.indexOf('A') > -1;
            // Token lookup name. Check `[4]` first to avoid passing `undefined` via `\p{}`
            var slug = normalize(match[4] || match[3]);
            // Token data object
            var item = unicode[slug];

            if (match[1] === 'P' && match[2]) {
                throw new SyntaxError(ERR_DOUBLE_NEG + match[0]);
            }
            if (!unicode.hasOwnProperty(slug)) {
                throw new SyntaxError(ERR_UNKNOWN_NAME + match[0]);
            }

            // Switch to the negated form of the referenced Unicode token
            if (item.inverseOf) {
                slug = normalize(item.inverseOf);
                if (!unicode.hasOwnProperty(slug)) {
                    throw new ReferenceError(ERR_UNKNOWN_REF + match[0] + ' -> ' + item.inverseOf);
                }
                item = unicode[slug];
                isNegated = !isNegated;
            }

            if (!(item.bmp || isAstralMode)) {
                throw new SyntaxError(ERR_ASTRAL_ONLY + match[0]);
            }
            if (isAstralMode) {
                if (scope === 'class') {
                    throw new SyntaxError(ERR_ASTRAL_IN_CLASS);
                }

                return cacheAstral(slug, isNegated);
            }

            return scope === 'class' ?
                (isNegated ? cacheInvertedBmp(slug) : item.bmp) :
                (isNegated ? '[^' : '[') + item.bmp + ']';
        },
        {
            scope: 'all',
            optionalFlags: 'A',
            leadChar: '\\'
        }
    );

    /**
     * Adds to the list of Unicode tokens that XRegExp regexes can match via `\p` or `\P`.
     *
     * @memberOf XRegExp
     * @param {Array} data Objects with named character ranges. Each object may have properties
     *   `name`, `alias`, `isBmpLast`, `inverseOf`, `bmp`, and `astral`. All but `name` are
     *   optional, although one of `bmp` or `astral` is required (unless `inverseOf` is set). If
     *   `astral` is absent, the `bmp` data is used for BMP and astral modes. If `bmp` is absent,
     *   the name errors in BMP mode but works in astral mode. If both `bmp` and `astral` are
     *   provided, the `bmp` data only is used in BMP mode, and the combination of `bmp` and
     *   `astral` data is used in astral mode. `isBmpLast` is needed when a token matches orphan
     *   high surrogates *and* uses surrogate pairs to match astral code points. The `bmp` and
     *   `astral` data should be a combination of literal characters and `\xHH` or `\uHHHH` escape
     *   sequences, with hyphens to create ranges. Any regex metacharacters in the data should be
     *   escaped, apart from range-creating hyphens. The `astral` data can additionally use
     *   character classes and alternation, and should use surrogate pairs to represent astral code
     *   points. `inverseOf` can be used to avoid duplicating character data if a Unicode token is
     *   defined as the exact inverse of another token.
     * @example
     *
     * // Basic use
     * XRegExp.addUnicodeData([{
     *   name: 'XDigit',
     *   alias: 'Hexadecimal',
     *   bmp: '0-9A-Fa-f'
     * }]);
     * XRegExp('\\p{XDigit}:\\p{Hexadecimal}+').test('0:3D'); // -> true
     */
    XRegExp.addUnicodeData = function(data) {
        var ERR_NO_NAME = 'Unicode token requires name';
        var ERR_NO_DATA = 'Unicode token has no character data ';
        var item;

        for (var i = 0; i < data.length; ++i) {
            item = data[i];
            if (!item.name) {
                throw new Error(ERR_NO_NAME);
            }
            if (!(item.inverseOf || item.bmp || item.astral)) {
                throw new Error(ERR_NO_DATA + item.name);
            }
            unicode[normalize(item.name)] = item;
            if (item.alias) {
                unicode[normalize(item.alias)] = item;
            }
        }

        // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and
        // flags might now produce different results
        XRegExp.cache.flush('patterns');
    };

    /**
     * @ignore
     *
     * Return a reference to the internal Unicode definition structure for the given Unicode
     * Property if the given name is a legal Unicode Property for use in XRegExp `\p` or `\P` regex
     * constructs.
     *
     * @memberOf XRegExp
     * @param {String} name Name by which the Unicode Property may be recognized (case-insensitive),
     *   e.g. `'N'` or `'Number'`. The given name is matched against all registered Unicode
     *   Properties and Property Aliases.
     * @returns {Object} Reference to definition structure when the name matches a Unicode Property.
     *
     * @note
     * For more info on Unicode Properties, see also http://unicode.org/reports/tr18/#Categories.
     *
     * @note
     * This method is *not* part of the officially documented API and may change or be removed in
     * the future. It is meant for userland code that wishes to reuse the (large) internal Unicode
     * structures set up by XRegExp.
     */
    XRegExp._getUnicodeProperty = function(name) {
        var slug = normalize(name);
        return unicode[slug];
    };

};

},{}],4:[function(require,module,exports){
/*!
 * XRegExp Unicode Blocks 3.2.0
 * <xregexp.com>
 * Steven Levithan (c) 2010-2017 MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */

module.exports = function(XRegExp) {

    /**
     * Adds support for all Unicode blocks. Block names use the prefix 'In'. E.g.,
     * `\p{InBasicLatin}`. Token names are case insensitive, and any spaces, hyphens, and
     * underscores are ignored.
     *
     * Uses Unicode 9.0.0.
     *
     * @requires XRegExp, Unicode Base
     */

    if (!XRegExp.addUnicodeData) {
        throw new ReferenceError('Unicode Base must be loaded before Unicode Blocks');
    }

    XRegExp.addUnicodeData([
        {
            name: 'InAdlam',
            astral: '\uD83A[\uDD00-\uDD5F]'
        },
        {
            name: 'InAegean_Numbers',
            astral: '\uD800[\uDD00-\uDD3F]'
        },
        {
            name: 'InAhom',
            astral: '\uD805[\uDF00-\uDF3F]'
        },
        {
            name: 'InAlchemical_Symbols',
            astral: '\uD83D[\uDF00-\uDF7F]'
        },
        {
            name: 'InAlphabetic_Presentation_Forms',
            bmp: '\uFB00-\uFB4F'
        },
        {
            name: 'InAnatolian_Hieroglyphs',
            astral: '\uD811[\uDC00-\uDE7F]'
        },
        {
            name: 'InAncient_Greek_Musical_Notation',
            astral: '\uD834[\uDE00-\uDE4F]'
        },
        {
            name: 'InAncient_Greek_Numbers',
            astral: '\uD800[\uDD40-\uDD8F]'
        },
        {
            name: 'InAncient_Symbols',
            astral: '\uD800[\uDD90-\uDDCF]'
        },
        {
            name: 'InArabic',
            bmp: '\u0600-\u06FF'
        },
        {
            name: 'InArabic_Extended_A',
            bmp: '\u08A0-\u08FF'
        },
        {
            name: 'InArabic_Mathematical_Alphabetic_Symbols',
            astral: '\uD83B[\uDE00-\uDEFF]'
        },
        {
            name: 'InArabic_Presentation_Forms_A',
            bmp: '\uFB50-\uFDFF'
        },
        {
            name: 'InArabic_Presentation_Forms_B',
            bmp: '\uFE70-\uFEFF'
        },
        {
            name: 'InArabic_Supplement',
            bmp: '\u0750-\u077F'
        },
        {
            name: 'InArmenian',
            bmp: '\u0530-\u058F'
        },
        {
            name: 'InArrows',
            bmp: '\u2190-\u21FF'
        },
        {
            name: 'InAvestan',
            astral: '\uD802[\uDF00-\uDF3F]'
        },
        {
            name: 'InBalinese',
            bmp: '\u1B00-\u1B7F'
        },
        {
            name: 'InBamum',
            bmp: '\uA6A0-\uA6FF'
        },
        {
            name: 'InBamum_Supplement',
            astral: '\uD81A[\uDC00-\uDE3F]'
        },
        {
            name: 'InBasic_Latin',
            bmp: '\0-\x7F'
        },
        {
            name: 'InBassa_Vah',
            astral: '\uD81A[\uDED0-\uDEFF]'
        },
        {
            name: 'InBatak',
            bmp: '\u1BC0-\u1BFF'
        },
        {
            name: 'InBengali',
            bmp: '\u0980-\u09FF'
        },
        {
            name: 'InBhaiksuki',
            astral: '\uD807[\uDC00-\uDC6F]'
        },
        {
            name: 'InBlock_Elements',
            bmp: '\u2580-\u259F'
        },
        {
            name: 'InBopomofo',
            bmp: '\u3100-\u312F'
        },
        {
            name: 'InBopomofo_Extended',
            bmp: '\u31A0-\u31BF'
        },
        {
            name: 'InBox_Drawing',
            bmp: '\u2500-\u257F'
        },
        {
            name: 'InBrahmi',
            astral: '\uD804[\uDC00-\uDC7F]'
        },
        {
            name: 'InBraille_Patterns',
            bmp: '\u2800-\u28FF'
        },
        {
            name: 'InBuginese',
            bmp: '\u1A00-\u1A1F'
        },
        {
            name: 'InBuhid',
            bmp: '\u1740-\u175F'
        },
        {
            name: 'InByzantine_Musical_Symbols',
            astral: '\uD834[\uDC00-\uDCFF]'
        },
        {
            name: 'InCJK_Compatibility',
            bmp: '\u3300-\u33FF'
        },
        {
            name: 'InCJK_Compatibility_Forms',
            bmp: '\uFE30-\uFE4F'
        },
        {
            name: 'InCJK_Compatibility_Ideographs',
            bmp: '\uF900-\uFAFF'
        },
        {
            name: 'InCJK_Compatibility_Ideographs_Supplement',
            astral: '\uD87E[\uDC00-\uDE1F]'
        },
        {
            name: 'InCJK_Radicals_Supplement',
            bmp: '\u2E80-\u2EFF'
        },
        {
            name: 'InCJK_Strokes',
            bmp: '\u31C0-\u31EF'
        },
        {
            name: 'InCJK_Symbols_and_Punctuation',
            bmp: '\u3000-\u303F'
        },
        {
            name: 'InCJK_Unified_Ideographs',
            bmp: '\u4E00-\u9FFF'
        },
        {
            name: 'InCJK_Unified_Ideographs_Extension_A',
            bmp: '\u3400-\u4DBF'
        },
        {
            name: 'InCJK_Unified_Ideographs_Extension_B',
            astral: '[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF]'
        },
        {
            name: 'InCJK_Unified_Ideographs_Extension_C',
            astral: '\uD869[\uDF00-\uDFFF]|[\uD86A-\uD86C][\uDC00-\uDFFF]|\uD86D[\uDC00-\uDF3F]'
        },
        {
            name: 'InCJK_Unified_Ideographs_Extension_D',
            astral: '\uD86D[\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1F]'
        },
        {
            name: 'InCJK_Unified_Ideographs_Extension_E',
            astral: '\uD86E[\uDC20-\uDFFF]|[\uD86F-\uD872][\uDC00-\uDFFF]|\uD873[\uDC00-\uDEAF]'
        },
        {
            name: 'InCarian',
            astral: '\uD800[\uDEA0-\uDEDF]'
        },
        {
            name: 'InCaucasian_Albanian',
            astral: '\uD801[\uDD30-\uDD6F]'
        },
        {
            name: 'InChakma',
            astral: '\uD804[\uDD00-\uDD4F]'
        },
        {
            name: 'InCham',
            bmp: '\uAA00-\uAA5F'
        },
        {
            name: 'InCherokee',
            bmp: '\u13A0-\u13FF'
        },
        {
            name: 'InCherokee_Supplement',
            bmp: '\uAB70-\uABBF'
        },
        {
            name: 'InCombining_Diacritical_Marks',
            bmp: '\u0300-\u036F'
        },
        {
            name: 'InCombining_Diacritical_Marks_Extended',
            bmp: '\u1AB0-\u1AFF'
        },
        {
            name: 'InCombining_Diacritical_Marks_Supplement',
            bmp: '\u1DC0-\u1DFF'
        },
        {
            name: 'InCombining_Diacritical_Marks_for_Symbols',
            bmp: '\u20D0-\u20FF'
        },
        {
            name: 'InCombining_Half_Marks',
            bmp: '\uFE20-\uFE2F'
        },
        {
            name: 'InCommon_Indic_Number_Forms',
            bmp: '\uA830-\uA83F'
        },
        {
            name: 'InControl_Pictures',
            bmp: '\u2400-\u243F'
        },
        {
            name: 'InCoptic',
            bmp: '\u2C80-\u2CFF'
        },
        {
            name: 'InCoptic_Epact_Numbers',
            astral: '\uD800[\uDEE0-\uDEFF]'
        },
        {
            name: 'InCounting_Rod_Numerals',
            astral: '\uD834[\uDF60-\uDF7F]'
        },
        {
            name: 'InCuneiform',
            astral: '\uD808[\uDC00-\uDFFF]'
        },
        {
            name: 'InCuneiform_Numbers_and_Punctuation',
            astral: '\uD809[\uDC00-\uDC7F]'
        },
        {
            name: 'InCurrency_Symbols',
            bmp: '\u20A0-\u20CF'
        },
        {
            name: 'InCypriot_Syllabary',
            astral: '\uD802[\uDC00-\uDC3F]'
        },
        {
            name: 'InCyrillic',
            bmp: '\u0400-\u04FF'
        },
        {
            name: 'InCyrillic_Extended_A',
            bmp: '\u2DE0-\u2DFF'
        },
        {
            name: 'InCyrillic_Extended_B',
            bmp: '\uA640-\uA69F'
        },
        {
            name: 'InCyrillic_Extended_C',
            bmp: '\u1C80-\u1C8F'
        },
        {
            name: 'InCyrillic_Supplement',
            bmp: '\u0500-\u052F'
        },
        {
            name: 'InDeseret',
            astral: '\uD801[\uDC00-\uDC4F]'
        },
        {
            name: 'InDevanagari',
            bmp: '\u0900-\u097F'
        },
        {
            name: 'InDevanagari_Extended',
            bmp: '\uA8E0-\uA8FF'
        },
        {
            name: 'InDingbats',
            bmp: '\u2700-\u27BF'
        },
        {
            name: 'InDomino_Tiles',
            astral: '\uD83C[\uDC30-\uDC9F]'
        },
        {
            name: 'InDuployan',
            astral: '\uD82F[\uDC00-\uDC9F]'
        },
        {
            name: 'InEarly_Dynastic_Cuneiform',
            astral: '\uD809[\uDC80-\uDD4F]'
        },
        {
            name: 'InEgyptian_Hieroglyphs',
            astral: '\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F]'
        },
        {
            name: 'InElbasan',
            astral: '\uD801[\uDD00-\uDD2F]'
        },
        {
            name: 'InEmoticons',
            astral: '\uD83D[\uDE00-\uDE4F]'
        },
        {
            name: 'InEnclosed_Alphanumeric_Supplement',
            astral: '\uD83C[\uDD00-\uDDFF]'
        },
        {
            name: 'InEnclosed_Alphanumerics',
            bmp: '\u2460-\u24FF'
        },
        {
            name: 'InEnclosed_CJK_Letters_and_Months',
            bmp: '\u3200-\u32FF'
        },
        {
            name: 'InEnclosed_Ideographic_Supplement',
            astral: '\uD83C[\uDE00-\uDEFF]'
        },
        {
            name: 'InEthiopic',
            bmp: '\u1200-\u137F'
        },
        {
            name: 'InEthiopic_Extended',
            bmp: '\u2D80-\u2DDF'
        },
        {
            name: 'InEthiopic_Extended_A',
            bmp: '\uAB00-\uAB2F'
        },
        {
            name: 'InEthiopic_Supplement',
            bmp: '\u1380-\u139F'
        },
        {
            name: 'InGeneral_Punctuation',
            bmp: '\u2000-\u206F'
        },
        {
            name: 'InGeometric_Shapes',
            bmp: '\u25A0-\u25FF'
        },
        {
            name: 'InGeometric_Shapes_Extended',
            astral: '\uD83D[\uDF80-\uDFFF]'
        },
        {
            name: 'InGeorgian',
            bmp: '\u10A0-\u10FF'
        },
        {
            name: 'InGeorgian_Supplement',
            bmp: '\u2D00-\u2D2F'
        },
        {
            name: 'InGlagolitic',
            bmp: '\u2C00-\u2C5F'
        },
        {
            name: 'InGlagolitic_Supplement',
            astral: '\uD838[\uDC00-\uDC2F]'
        },
        {
            name: 'InGothic',
            astral: '\uD800[\uDF30-\uDF4F]'
        },
        {
            name: 'InGrantha',
            astral: '\uD804[\uDF00-\uDF7F]'
        },
        {
            name: 'InGreek_Extended',
            bmp: '\u1F00-\u1FFF'
        },
        {
            name: 'InGreek_and_Coptic',
            bmp: '\u0370-\u03FF'
        },
        {
            name: 'InGujarati',
            bmp: '\u0A80-\u0AFF'
        },
        {
            name: 'InGurmukhi',
            bmp: '\u0A00-\u0A7F'
        },
        {
            name: 'InHalfwidth_and_Fullwidth_Forms',
            bmp: '\uFF00-\uFFEF'
        },
        {
            name: 'InHangul_Compatibility_Jamo',
            bmp: '\u3130-\u318F'
        },
        {
            name: 'InHangul_Jamo',
            bmp: '\u1100-\u11FF'
        },
        {
            name: 'InHangul_Jamo_Extended_A',
            bmp: '\uA960-\uA97F'
        },
        {
            name: 'InHangul_Jamo_Extended_B',
            bmp: '\uD7B0-\uD7FF'
        },
        {
            name: 'InHangul_Syllables',
            bmp: '\uAC00-\uD7AF'
        },
        {
            name: 'InHanunoo',
            bmp: '\u1720-\u173F'
        },
        {
            name: 'InHatran',
            astral: '\uD802[\uDCE0-\uDCFF]'
        },
        {
            name: 'InHebrew',
            bmp: '\u0590-\u05FF'
        },
        {
            name: 'InHigh_Private_Use_Surrogates',
            bmp: '\uDB80-\uDBFF'
        },
        {
            name: 'InHigh_Surrogates',
            bmp: '\uD800-\uDB7F'
        },
        {
            name: 'InHiragana',
            bmp: '\u3040-\u309F'
        },
        {
            name: 'InIPA_Extensions',
            bmp: '\u0250-\u02AF'
        },
        {
            name: 'InIdeographic_Description_Characters',
            bmp: '\u2FF0-\u2FFF'
        },
        {
            name: 'InIdeographic_Symbols_and_Punctuation',
            astral: '\uD81B[\uDFE0-\uDFFF]'
        },
        {
            name: 'InImperial_Aramaic',
            astral: '\uD802[\uDC40-\uDC5F]'
        },
        {
            name: 'InInscriptional_Pahlavi',
            astral: '\uD802[\uDF60-\uDF7F]'
        },
        {
            name: 'InInscriptional_Parthian',
            astral: '\uD802[\uDF40-\uDF5F]'
        },
        {
            name: 'InJavanese',
            bmp: '\uA980-\uA9DF'
        },
        {
            name: 'InKaithi',
            astral: '\uD804[\uDC80-\uDCCF]'
        },
        {
            name: 'InKana_Supplement',
            astral: '\uD82C[\uDC00-\uDCFF]'
        },
        {
            name: 'InKanbun',
            bmp: '\u3190-\u319F'
        },
        {
            name: 'InKangxi_Radicals',
            bmp: '\u2F00-\u2FDF'
        },
        {
            name: 'InKannada',
            bmp: '\u0C80-\u0CFF'
        },
        {
            name: 'InKatakana',
            bmp: '\u30A0-\u30FF'
        },
        {
            name: 'InKatakana_Phonetic_Extensions',
            bmp: '\u31F0-\u31FF'
        },
        {
            name: 'InKayah_Li',
            bmp: '\uA900-\uA92F'
        },
        {
            name: 'InKharoshthi',
            astral: '\uD802[\uDE00-\uDE5F]'
        },
        {
            name: 'InKhmer',
            bmp: '\u1780-\u17FF'
        },
        {
            name: 'InKhmer_Symbols',
            bmp: '\u19E0-\u19FF'
        },
        {
            name: 'InKhojki',
            astral: '\uD804[\uDE00-\uDE4F]'
        },
        {
            name: 'InKhudawadi',
            astral: '\uD804[\uDEB0-\uDEFF]'
        },
        {
            name: 'InLao',
            bmp: '\u0E80-\u0EFF'
        },
        {
            name: 'InLatin_Extended_Additional',
            bmp: '\u1E00-\u1EFF'
        },
        {
            name: 'InLatin_Extended_A',
            bmp: '\u0100-\u017F'
        },
        {
            name: 'InLatin_Extended_B',
            bmp: '\u0180-\u024F'
        },
        {
            name: 'InLatin_Extended_C',
            bmp: '\u2C60-\u2C7F'
        },
        {
            name: 'InLatin_Extended_D',
            bmp: '\uA720-\uA7FF'
        },
        {
            name: 'InLatin_Extended_E',
            bmp: '\uAB30-\uAB6F'
        },
        {
            name: 'InLatin_1_Supplement',
            bmp: '\x80-\xFF'
        },
        {
            name: 'InLepcha',
            bmp: '\u1C00-\u1C4F'
        },
        {
            name: 'InLetterlike_Symbols',
            bmp: '\u2100-\u214F'
        },
        {
            name: 'InLimbu',
            bmp: '\u1900-\u194F'
        },
        {
            name: 'InLinear_A',
            astral: '\uD801[\uDE00-\uDF7F]'
        },
        {
            name: 'InLinear_B_Ideograms',
            astral: '\uD800[\uDC80-\uDCFF]'
        },
        {
            name: 'InLinear_B_Syllabary',
            astral: '\uD800[\uDC00-\uDC7F]'
        },
        {
            name: 'InLisu',
            bmp: '\uA4D0-\uA4FF'
        },
        {
            name: 'InLow_Surrogates',
            bmp: '\uDC00-\uDFFF'
        },
        {
            name: 'InLycian',
            astral: '\uD800[\uDE80-\uDE9F]'
        },
        {
            name: 'InLydian',
            astral: '\uD802[\uDD20-\uDD3F]'
        },
        {
            name: 'InMahajani',
            astral: '\uD804[\uDD50-\uDD7F]'
        },
        {
            name: 'InMahjong_Tiles',
            astral: '\uD83C[\uDC00-\uDC2F]'
        },
        {
            name: 'InMalayalam',
            bmp: '\u0D00-\u0D7F'
        },
        {
            name: 'InMandaic',
            bmp: '\u0840-\u085F'
        },
        {
            name: 'InManichaean',
            astral: '\uD802[\uDEC0-\uDEFF]'
        },
        {
            name: 'InMarchen',
            astral: '\uD807[\uDC70-\uDCBF]'
        },
        {
            name: 'InMathematical_Alphanumeric_Symbols',
            astral: '\uD835[\uDC00-\uDFFF]'
        },
        {
            name: 'InMathematical_Operators',
            bmp: '\u2200-\u22FF'
        },
        {
            name: 'InMeetei_Mayek',
            bmp: '\uABC0-\uABFF'
        },
        {
            name: 'InMeetei_Mayek_Extensions',
            bmp: '\uAAE0-\uAAFF'
        },
        {
            name: 'InMende_Kikakui',
            astral: '\uD83A[\uDC00-\uDCDF]'
        },
        {
            name: 'InMeroitic_Cursive',
            astral: '\uD802[\uDDA0-\uDDFF]'
        },
        {
            name: 'InMeroitic_Hieroglyphs',
            astral: '\uD802[\uDD80-\uDD9F]'
        },
        {
            name: 'InMiao',
            astral: '\uD81B[\uDF00-\uDF9F]'
        },
        {
            name: 'InMiscellaneous_Mathematical_Symbols_A',
            bmp: '\u27C0-\u27EF'
        },
        {
            name: 'InMiscellaneous_Mathematical_Symbols_B',
            bmp: '\u2980-\u29FF'
        },
        {
            name: 'InMiscellaneous_Symbols',
            bmp: '\u2600-\u26FF'
        },
        {
            name: 'InMiscellaneous_Symbols_and_Arrows',
            bmp: '\u2B00-\u2BFF'
        },
        {
            name: 'InMiscellaneous_Symbols_and_Pictographs',
            astral: '\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF]'
        },
        {
            name: 'InMiscellaneous_Technical',
            bmp: '\u2300-\u23FF'
        },
        {
            name: 'InModi',
            astral: '\uD805[\uDE00-\uDE5F]'
        },
        {
            name: 'InModifier_Tone_Letters',
            bmp: '\uA700-\uA71F'
        },
        {
            name: 'InMongolian',
            bmp: '\u1800-\u18AF'
        },
        {
            name: 'InMongolian_Supplement',
            astral: '\uD805[\uDE60-\uDE7F]'
        },
        {
            name: 'InMro',
            astral: '\uD81A[\uDE40-\uDE6F]'
        },
        {
            name: 'InMultani',
            astral: '\uD804[\uDE80-\uDEAF]'
        },
        {
            name: 'InMusical_Symbols',
            astral: '\uD834[\uDD00-\uDDFF]'
        },
        {
            name: 'InMyanmar',
            bmp: '\u1000-\u109F'
        },
        {
            name: 'InMyanmar_Extended_A',
            bmp: '\uAA60-\uAA7F'
        },
        {
            name: 'InMyanmar_Extended_B',
            bmp: '\uA9E0-\uA9FF'
        },
        {
            name: 'InNKo',
            bmp: '\u07C0-\u07FF'
        },
        {
            name: 'InNabataean',
            astral: '\uD802[\uDC80-\uDCAF]'
        },
        {
            name: 'InNew_Tai_Lue',
            bmp: '\u1980-\u19DF'
        },
        {
            name: 'InNewa',
            astral: '\uD805[\uDC00-\uDC7F]'
        },
        {
            name: 'InNumber_Forms',
            bmp: '\u2150-\u218F'
        },
        {
            name: 'InOgham',
            bmp: '\u1680-\u169F'
        },
        {
            name: 'InOl_Chiki',
            bmp: '\u1C50-\u1C7F'
        },
        {
            name: 'InOld_Hungarian',
            astral: '\uD803[\uDC80-\uDCFF]'
        },
        {
            name: 'InOld_Italic',
            astral: '\uD800[\uDF00-\uDF2F]'
        },
        {
            name: 'InOld_North_Arabian',
            astral: '\uD802[\uDE80-\uDE9F]'
        },
        {
            name: 'InOld_Permic',
            astral: '\uD800[\uDF50-\uDF7F]'
        },
        {
            name: 'InOld_Persian',
            astral: '\uD800[\uDFA0-\uDFDF]'
        },
        {
            name: 'InOld_South_Arabian',
            astral: '\uD802[\uDE60-\uDE7F]'
        },
        {
            name: 'InOld_Turkic',
            astral: '\uD803[\uDC00-\uDC4F]'
        },
        {
            name: 'InOptical_Character_Recognition',
            bmp: '\u2440-\u245F'
        },
        {
            name: 'InOriya',
            bmp: '\u0B00-\u0B7F'
        },
        {
            name: 'InOrnamental_Dingbats',
            astral: '\uD83D[\uDE50-\uDE7F]'
        },
        {
            name: 'InOsage',
            astral: '\uD801[\uDCB0-\uDCFF]'
        },
        {
            name: 'InOsmanya',
            astral: '\uD801[\uDC80-\uDCAF]'
        },
        {
            name: 'InPahawh_Hmong',
            astral: '\uD81A[\uDF00-\uDF8F]'
        },
        {
            name: 'InPalmyrene',
            astral: '\uD802[\uDC60-\uDC7F]'
        },
        {
            name: 'InPau_Cin_Hau',
            astral: '\uD806[\uDEC0-\uDEFF]'
        },
        {
            name: 'InPhags_pa',
            bmp: '\uA840-\uA87F'
        },
        {
            name: 'InPhaistos_Disc',
            astral: '\uD800[\uDDD0-\uDDFF]'
        },
        {
            name: 'InPhoenician',
            astral: '\uD802[\uDD00-\uDD1F]'
        },
        {
            name: 'InPhonetic_Extensions',
            bmp: '\u1D00-\u1D7F'
        },
        {
            name: 'InPhonetic_Extensions_Supplement',
            bmp: '\u1D80-\u1DBF'
        },
        {
            name: 'InPlaying_Cards',
            astral: '\uD83C[\uDCA0-\uDCFF]'
        },
        {
            name: 'InPrivate_Use_Area',
            bmp: '\uE000-\uF8FF'
        },
        {
            name: 'InPsalter_Pahlavi',
            astral: '\uD802[\uDF80-\uDFAF]'
        },
        {
            name: 'InRejang',
            bmp: '\uA930-\uA95F'
        },
        {
            name: 'InRumi_Numeral_Symbols',
            astral: '\uD803[\uDE60-\uDE7F]'
        },
        {
            name: 'InRunic',
            bmp: '\u16A0-\u16FF'
        },
        {
            name: 'InSamaritan',
            bmp: '\u0800-\u083F'
        },
        {
            name: 'InSaurashtra',
            bmp: '\uA880-\uA8DF'
        },
        {
            name: 'InSharada',
            astral: '\uD804[\uDD80-\uDDDF]'
        },
        {
            name: 'InShavian',
            astral: '\uD801[\uDC50-\uDC7F]'
        },
        {
            name: 'InShorthand_Format_Controls',
            astral: '\uD82F[\uDCA0-\uDCAF]'
        },
        {
            name: 'InSiddham',
            astral: '\uD805[\uDD80-\uDDFF]'
        },
        {
            name: 'InSinhala',
            bmp: '\u0D80-\u0DFF'
        },
        {
            name: 'InSinhala_Archaic_Numbers',
            astral: '\uD804[\uDDE0-\uDDFF]'
        },
        {
            name: 'InSmall_Form_Variants',
            bmp: '\uFE50-\uFE6F'
        },
        {
            name: 'InSora_Sompeng',
            astral: '\uD804[\uDCD0-\uDCFF]'
        },
        {
            name: 'InSpacing_Modifier_Letters',
            bmp: '\u02B0-\u02FF'
        },
        {
            name: 'InSpecials',
            bmp: '\uFFF0-\uFFFF'
        },
        {
            name: 'InSundanese',
            bmp: '\u1B80-\u1BBF'
        },
        {
            name: 'InSundanese_Supplement',
            bmp: '\u1CC0-\u1CCF'
        },
        {
            name: 'InSuperscripts_and_Subscripts',
            bmp: '\u2070-\u209F'
        },
        {
            name: 'InSupplemental_Arrows_A',
            bmp: '\u27F0-\u27FF'
        },
        {
            name: 'InSupplemental_Arrows_B',
            bmp: '\u2900-\u297F'
        },
        {
            name: 'InSupplemental_Arrows_C',
            astral: '\uD83E[\uDC00-\uDCFF]'
        },
        {
            name: 'InSupplemental_Mathematical_Operators',
            bmp: '\u2A00-\u2AFF'
        },
        {
            name: 'InSupplemental_Punctuation',
            bmp: '\u2E00-\u2E7F'
        },
        {
            name: 'InSupplemental_Symbols_and_Pictographs',
            astral: '\uD83E[\uDD00-\uDDFF]'
        },
        {
            name: 'InSupplementary_Private_Use_Area_A',
            astral: '[\uDB80-\uDBBF][\uDC00-\uDFFF]'
        },
        {
            name: 'InSupplementary_Private_Use_Area_B',
            astral: '[\uDBC0-\uDBFF][\uDC00-\uDFFF]'
        },
        {
            name: 'InSutton_SignWriting',
            astral: '\uD836[\uDC00-\uDEAF]'
        },
        {
            name: 'InSyloti_Nagri',
            bmp: '\uA800-\uA82F'
        },
        {
            name: 'InSyriac',
            bmp: '\u0700-\u074F'
        },
        {
            name: 'InTagalog',
            bmp: '\u1700-\u171F'
        },
        {
            name: 'InTagbanwa',
            bmp: '\u1760-\u177F'
        },
        {
            name: 'InTags',
            astral: '\uDB40[\uDC00-\uDC7F]'
        },
        {
            name: 'InTai_Le',
            bmp: '\u1950-\u197F'
        },
        {
            name: 'InTai_Tham',
            bmp: '\u1A20-\u1AAF'
        },
        {
            name: 'InTai_Viet',
            bmp: '\uAA80-\uAADF'
        },
        {
            name: 'InTai_Xuan_Jing_Symbols',
            astral: '\uD834[\uDF00-\uDF5F]'
        },
        {
            name: 'InTakri',
            astral: '\uD805[\uDE80-\uDECF]'
        },
        {
            name: 'InTamil',
            bmp: '\u0B80-\u0BFF'
        },
        {
            name: 'InTangut',
            astral: '[\uD81C-\uD821][\uDC00-\uDFFF]'
        },
        {
            name: 'InTangut_Components',
            astral: '\uD822[\uDC00-\uDEFF]'
        },
        {
            name: 'InTelugu',
            bmp: '\u0C00-\u0C7F'
        },
        {
            name: 'InThaana',
            bmp: '\u0780-\u07BF'
        },
        {
            name: 'InThai',
            bmp: '\u0E00-\u0E7F'
        },
        {
            name: 'InTibetan',
            bmp: '\u0F00-\u0FFF'
        },
        {
            name: 'InTifinagh',
            bmp: '\u2D30-\u2D7F'
        },
        {
            name: 'InTirhuta',
            astral: '\uD805[\uDC80-\uDCDF]'
        },
        {
            name: 'InTransport_and_Map_Symbols',
            astral: '\uD83D[\uDE80-\uDEFF]'
        },
        {
            name: 'InUgaritic',
            astral: '\uD800[\uDF80-\uDF9F]'
        },
        {
            name: 'InUnified_Canadian_Aboriginal_Syllabics',
            bmp: '\u1400-\u167F'
        },
        {
            name: 'InUnified_Canadian_Aboriginal_Syllabics_Extended',
            bmp: '\u18B0-\u18FF'
        },
        {
            name: 'InVai',
            bmp: '\uA500-\uA63F'
        },
        {
            name: 'InVariation_Selectors',
            bmp: '\uFE00-\uFE0F'
        },
        {
            name: 'InVariation_Selectors_Supplement',
            astral: '\uDB40[\uDD00-\uDDEF]'
        },
        {
            name: 'InVedic_Extensions',
            bmp: '\u1CD0-\u1CFF'
        },
        {
            name: 'InVertical_Forms',
            bmp: '\uFE10-\uFE1F'
        },
        {
            name: 'InWarang_Citi',
            astral: '\uD806[\uDCA0-\uDCFF]'
        },
        {
            name: 'InYi_Radicals',
            bmp: '\uA490-\uA4CF'
        },
        {
            name: 'InYi_Syllables',
            bmp: '\uA000-\uA48F'
        },
        {
            name: 'InYijing_Hexagram_Symbols',
            bmp: '\u4DC0-\u4DFF'
        }
    ]);

};

},{}],5:[function(require,module,exports){
/*!
 * XRegExp Unicode Categories 3.2.0
 * <xregexp.com>
 * Steven Levithan (c) 2010-2017 MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */

module.exports = function(XRegExp) {

    /**
     * Adds support for Unicode's general categories. E.g., `\p{Lu}` or `\p{Uppercase Letter}`. See
     * category descriptions in UAX #44 <http://unicode.org/reports/tr44/#GC_Values_Table>. Token
     * names are case insensitive, and any spaces, hyphens, and underscores are ignored.
     *
     * Uses Unicode 9.0.0.
     *
     * @requires XRegExp, Unicode Base
     */

    if (!XRegExp.addUnicodeData) {
        throw new ReferenceError('Unicode Base must be loaded before Unicode Categories');
    }

    XRegExp.addUnicodeData([
        {
            name: 'C',
            alias: 'Other',
            isBmpLast: true,
            bmp: '\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08B5\u08BE-\u08D3\u08E2\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0AFA-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D00\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D50-\u0D53\u0D64\u0D65\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180E\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C89-\u1CBF\u1CC8-\u1CCF\u1CF7\u1CFA-\u1CFF\u1DF6-\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BF-\u20CF\u20F1-\u20FF\u218C-\u218F\u23FF\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E45-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FD6-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C6-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF',
            astral: '\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2F\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCBD\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5A\uDC5C\uDC5E-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD823-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83F\uD874-\uD87D\uD87F-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFDF\uDFE1-\uDFFF]|\uD821[\uDFED-\uDFFF]|\uD822[\uDEF3-\uDFFF]|\uD82C[\uDC02-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA0-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD73-\uDD7A\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4B-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDDAD-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF]|\uD83D[\uDED3-\uDEDF\uDEED-\uDEEF\uDEF7-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDD0F\uDD1F\uDD28-\uDD2F\uDD31\uDD32\uDD3F\uDD4C-\uDD4F\uDD5F-\uDD7F\uDD92-\uDDBF\uDDC1-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]'
        },
        {
            name: 'Cc',
            alias: 'Control',
            bmp: '\0-\x1F\x7F-\x9F'
        },
        {
            name: 'Cf',
            alias: 'Format',
            bmp: '\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB',
            astral: '\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]'
        },
        {
            name: 'Cn',
            alias: 'Unassigned',
            bmp: '\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u0560\u0588\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u05FF\u061D\u070E\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08B5\u08BE-\u08D3\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0AFA-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D00\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D50-\u0D53\u0D64\u0D65\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1ABF-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C89-\u1CBF\u1CC8-\u1CCF\u1CF7\u1CFA-\u1CFF\u1DF6-\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u2065\u2072\u2073\u208F\u209D-\u209F\u20BF-\u20CF\u20F1-\u20FF\u218C-\u218F\u23FF\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2B97\u2BBA-\u2BBC\u2BC9\u2BD2-\u2BEB\u2BF0-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E45-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FD6-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7AF\uA7B8-\uA7F6\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C6-\uA8CD\uA8DA-\uA8DF\uA8FE\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB66-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD\uFEFE\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFF8\uFFFE\uFFFF',
            astral: '\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9C-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2F\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE34-\uDE37\uDE3B-\uDE3E\uDE48-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD00-\uDE5F\uDE7F-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD44-\uDD4F\uDD77-\uDD7F\uDDCE\uDDCF\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF3B\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5A\uDC5C\uDC5E-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEB8-\uDEBF\uDECA-\uDEFF\uDF1A-\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD806[\uDC00-\uDC9F\uDCF3-\uDCFE\uDD00-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD823-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83F\uD874-\uD87D\uD87F-\uDB3F\uDB41-\uDB7F][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDEFF\uDF45-\uDF4F\uDF7F-\uDF8E\uDFA0-\uDFDF\uDFE1-\uDFFF]|\uD821[\uDFED-\uDFFF]|\uD822[\uDEF3-\uDFFF]|\uD82C[\uDC02-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDDE9-\uDDFF\uDE46-\uDEFF\uDF57-\uDF5F\uDF72-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4B-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD6F\uDDAD-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDEFF]|\uD83D[\uDED3-\uDEDF\uDEED-\uDEEF\uDEF7-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDD0F\uDD1F\uDD28-\uDD2F\uDD31\uDD32\uDD3F\uDD4C-\uDD4F\uDD5F-\uDD7F\uDD92-\uDDBF\uDDC1-\uDFFF]|\uD869[\uDED7-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uDB40[\uDC00\uDC02-\uDC1F\uDC80-\uDCFF\uDDF0-\uDFFF]|[\uDBBF\uDBFF][\uDFFE\uDFFF]'
        },
        {
            name: 'Co',
            alias: 'Private_Use',
            bmp: '\uE000-\uF8FF',
            astral: '[\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uDBBF\uDBFF][\uDC00-\uDFFD]'
        },
        {
            name: 'Cs',
            alias: 'Surrogate',
            bmp: '\uD800-\uDFFF'
        },
        {
            name: 'L',
            alias: 'Letter',
            bmp: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
            astral: '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]'
        },
        {
            name: 'Ll',
            alias: 'Lowercase_Letter',
            bmp: 'a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A',
            astral: '\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]'
        },
        {
            name: 'Lm',
            alias: 'Modifier_Letter',
            bmp: '\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5\u06E6\u07F4\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C\uA69D\uA717-\uA71F\uA770\uA788\uA7F8\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3\uAAF4\uAB5C-\uAB5F\uFF70\uFF9E\uFF9F',
            astral: '\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0]'
        },
        {
            name: 'Lo',
            alias: 'Other_Letter',
            bmp: '\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E45\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
            astral: '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]'
        },
        {
            name: 'Lt',
            alias: 'Titlecase_Letter',
            bmp: '\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC'
        },
        {
            name: 'Lu',
            alias: 'Uppercase_Letter',
            bmp: 'A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A',
            astral: '\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]'
        },
        {
            name: 'M',
            alias: 'Mark',
            bmp: '\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F',
            astral: '\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC7F-\uDC82\uDCB0-\uDCBA\uDD00-\uDD02\uDD27-\uDD34\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDCA-\uDDCC\uDE2C-\uDE37\uDE3E\uDEDF-\uDEEA\uDF00-\uDF03\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF51-\uDF7E\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]'
        },
        {
            name: 'Mc',
            alias: 'Spacing_Mark',
            bmp: '\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BE-\u09C0\u09C7\u09C8\u09CB\u09CC\u09D7\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B3E\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0B57\u0BBE\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD7\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0-\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0CD5\u0CD6\u0D02\u0D03\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D57\u0D82\u0D83\u0DCF-\u0DD1\u0DD8-\u0DDF\u0DF2\u0DF3\u0F3E\u0F3F\u0F7F\u102B\u102C\u1031\u1038\u103B\u103C\u1056\u1057\u1062-\u1064\u1067-\u106D\u1083\u1084\u1087-\u108C\u108F\u109A-\u109C\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A61\u1A63\u1A64\u1A6D-\u1A72\u1B04\u1B35\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF2\u1CF3\u302E\u302F\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BD-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAA7B\uAA7D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC',
            astral: '\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3E\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB0-\uDCB2\uDCB9\uDCBB-\uDCBE\uDCC1\uDDAF-\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF20\uDF21\uDF26]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4]|\uD81B[\uDF51-\uDF7E]|\uD834[\uDD65\uDD66\uDD6D-\uDD72]'
        },
        {
            name: 'Me',
            alias: 'Enclosing_Mark',
            bmp: '\u0488\u0489\u1ABE\u20DD-\u20E0\u20E2-\u20E4\uA670-\uA672'
        },
        {
            name: 'Mn',
            alias: 'Nonspacing_Mark',
            bmp: '\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D01\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F',
            astral: '\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDCA-\uDDCC\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF8F-\uDF92]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]'
        },
        {
            name: 'N',
            alias: 'Number',
            bmp: '0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19',
            astral: '\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2]|\uD807[\uDC50-\uDC6C]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83C[\uDD00-\uDD0C]'
        },
        {
            name: 'Nd',
            alias: 'Decimal_Number',
            bmp: '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19',
            astral: '\uD801[\uDCA0-\uDCA9]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9]|\uD807[\uDC50-\uDC59]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59]|\uD835[\uDFCE-\uDFFF]|\uD83A[\uDD50-\uDD59]'
        },
        {
            name: 'Nl',
            alias: 'Letter_Number',
            bmp: '\u16EE-\u16F0\u2160-\u2182\u2185-\u2188\u3007\u3021-\u3029\u3038-\u303A\uA6E6-\uA6EF',
            astral: '\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]|\uD809[\uDC00-\uDC6E]'
        },
        {
            name: 'No',
            alias: 'Other_Number',
            bmp: '\xB2\xB3\xB9\xBC-\xBE\u09F4-\u09F9\u0B72-\u0B77\u0BF0-\u0BF2\u0C78-\u0C7E\u0D58-\u0D5E\u0D70-\u0D78\u0F2A-\u0F33\u1369-\u137C\u17F0-\u17F9\u19DA\u2070\u2074-\u2079\u2080-\u2089\u2150-\u215F\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA830-\uA835',
            astral: '\uD800[\uDD07-\uDD33\uDD75-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE47\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E]|\uD804[\uDC52-\uDC65\uDDE1-\uDDF4]|\uD805[\uDF3A\uDF3B]|\uD806[\uDCEA-\uDCF2]|\uD807[\uDC5A-\uDC6C]|\uD81A[\uDF5B-\uDF61]|\uD834[\uDF60-\uDF71]|\uD83A[\uDCC7-\uDCCF]|\uD83C[\uDD00-\uDD0C]'
        },
        {
            name: 'P',
            alias: 'Punctuation',
            bmp: '\x21-\x23\x25-\\x2A\x2C-\x2F\x3A\x3B\\x3F\x40\\x5B-\\x5D\x5F\\x7B\x7D\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E44\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65',
            astral: '\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]'
        },
        {
            name: 'Pc',
            alias: 'Connector_Punctuation',
            bmp: '\x5F\u203F\u2040\u2054\uFE33\uFE34\uFE4D-\uFE4F\uFF3F'
        },
        {
            name: 'Pd',
            alias: 'Dash_Punctuation',
            bmp: '\\x2D\u058A\u05BE\u1400\u1806\u2010-\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D'
        },
        {
            name: 'Pe',
            alias: 'Close_Punctuation',
            bmp: '\\x29\\x5D\x7D\u0F3B\u0F3D\u169C\u2046\u207E\u208E\u2309\u230B\u232A\u2769\u276B\u276D\u276F\u2771\u2773\u2775\u27C6\u27E7\u27E9\u27EB\u27ED\u27EF\u2984\u2986\u2988\u298A\u298C\u298E\u2990\u2992\u2994\u2996\u2998\u29D9\u29DB\u29FD\u2E23\u2E25\u2E27\u2E29\u3009\u300B\u300D\u300F\u3011\u3015\u3017\u3019\u301B\u301E\u301F\uFD3E\uFE18\uFE36\uFE38\uFE3A\uFE3C\uFE3E\uFE40\uFE42\uFE44\uFE48\uFE5A\uFE5C\uFE5E\uFF09\uFF3D\uFF5D\uFF60\uFF63'
        },
        {
            name: 'Pf',
            alias: 'Final_Punctuation',
            bmp: '\xBB\u2019\u201D\u203A\u2E03\u2E05\u2E0A\u2E0D\u2E1D\u2E21'
        },
        {
            name: 'Pi',
            alias: 'Initial_Punctuation',
            bmp: '\xAB\u2018\u201B\u201C\u201F\u2039\u2E02\u2E04\u2E09\u2E0C\u2E1C\u2E20'
        },
        {
            name: 'Po',
            alias: 'Other_Punctuation',
            bmp: '\x21-\x23\x25-\x27\\x2A\x2C\\x2E\x2F\x3A\x3B\\x3F\x40\\x5C\xA1\xA7\xB6\xB7\xBF\u037E\u0387\u055A-\u055F\u0589\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u166D\u166E\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u1805\u1807-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2016\u2017\u2020-\u2027\u2030-\u2038\u203B-\u203E\u2041-\u2043\u2047-\u2051\u2053\u2055-\u205E\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00\u2E01\u2E06-\u2E08\u2E0B\u2E0E-\u2E16\u2E18\u2E19\u2E1B\u2E1E\u2E1F\u2E2A-\u2E2E\u2E30-\u2E39\u2E3C-\u2E3F\u2E41\u2E43\u2E44\u3001-\u3003\u303D\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFE10-\uFE16\uFE19\uFE30\uFE45\uFE46\uFE49-\uFE4C\uFE50-\uFE52\uFE54-\uFE57\uFE5F-\uFE61\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF07\uFF0A\uFF0C\uFF0E\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3C\uFF61\uFF64\uFF65',
            astral: '\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]'
        },
        {
            name: 'Ps',
            alias: 'Open_Punctuation',
            bmp: '\\x28\\x5B\\x7B\u0F3A\u0F3C\u169B\u201A\u201E\u2045\u207D\u208D\u2308\u230A\u2329\u2768\u276A\u276C\u276E\u2770\u2772\u2774\u27C5\u27E6\u27E8\u27EA\u27EC\u27EE\u2983\u2985\u2987\u2989\u298B\u298D\u298F\u2991\u2993\u2995\u2997\u29D8\u29DA\u29FC\u2E22\u2E24\u2E26\u2E28\u2E42\u3008\u300A\u300C\u300E\u3010\u3014\u3016\u3018\u301A\u301D\uFD3F\uFE17\uFE35\uFE37\uFE39\uFE3B\uFE3D\uFE3F\uFE41\uFE43\uFE47\uFE59\uFE5B\uFE5D\uFF08\uFF3B\uFF5B\uFF5F\uFF62'
        },
        {
            name: 'S',
            alias: 'Symbol',
            bmp: '\\x24\\x2B\x3C-\x3E\\x5E\x60\\x7C\x7E\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BE\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u23FE\u2400-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD',
            astral: '\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD83B[\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED2\uDEE0-\uDEEC\uDEF0-\uDEF6\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3E\uDD40-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0]'
        },
        {
            name: 'Sc',
            alias: 'Currency_Symbol',
            bmp: '\\x24\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BE\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6'
        },
        {
            name: 'Sk',
            alias: 'Modifier_Symbol',
            bmp: '\\x5E\x60\xA8\xAF\xB4\xB8\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u309B\u309C\uA700-\uA716\uA720\uA721\uA789\uA78A\uAB5B\uFBB2-\uFBC1\uFF3E\uFF40\uFFE3',
            astral: '\uD83C[\uDFFB-\uDFFF]'
        },
        {
            name: 'Sm',
            alias: 'Math_Symbol',
            bmp: '\\x2B\x3C-\x3E\\x7C\x7E\xAC\xB1\xD7\xF7\u03F6\u0606-\u0608\u2044\u2052\u207A-\u207C\u208A-\u208C\u2118\u2140-\u2144\u214B\u2190-\u2194\u219A\u219B\u21A0\u21A3\u21A6\u21AE\u21CE\u21CF\u21D2\u21D4\u21F4-\u22FF\u2320\u2321\u237C\u239B-\u23B3\u23DC-\u23E1\u25B7\u25C1\u25F8-\u25FF\u266F\u27C0-\u27C4\u27C7-\u27E5\u27F0-\u27FF\u2900-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2AFF\u2B30-\u2B44\u2B47-\u2B4C\uFB29\uFE62\uFE64-\uFE66\uFF0B\uFF1C-\uFF1E\uFF5C\uFF5E\uFFE2\uFFE9-\uFFEC',
            astral: '\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD83B[\uDEF0\uDEF1]'
        },
        {
            name: 'So',
            alias: 'Other_Symbol',
            bmp: '\xA6\xA9\xAE\xB0\u0482\u058D\u058E\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09FA\u0B70\u0BF3-\u0BF8\u0BFA\u0C7F\u0D4F\u0D79\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116\u2117\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u214A\u214C\u214D\u214F\u218A\u218B\u2195-\u2199\u219C-\u219F\u21A1\u21A2\u21A4\u21A5\u21A7-\u21AD\u21AF-\u21CD\u21D0\u21D1\u21D3\u21D5-\u21F3\u2300-\u2307\u230C-\u231F\u2322-\u2328\u232B-\u237B\u237D-\u239A\u23B4-\u23DB\u23E2-\u23FE\u2400-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u25B6\u25B8-\u25C0\u25C2-\u25F7\u2600-\u266E\u2670-\u2767\u2794-\u27BF\u2800-\u28FF\u2B00-\u2B2F\u2B45\u2B46\u2B4D-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2CE5-\u2CEA\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u32FE\u3300-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA828-\uA82B\uA836\uA837\uA839\uAA77-\uAA79\uFDFD\uFFE4\uFFE8\uFFED\uFFEE\uFFFC\uFFFD',
            astral: '\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9B\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFA]|\uD83D[\uDC00-\uDED2\uDEE0-\uDEEC\uDEF0-\uDEF6\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3E\uDD40-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0]'
        },
        {
            name: 'Z',
            alias: 'Separator',
            bmp: '\x20\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000'
        },
        {
            name: 'Zl',
            alias: 'Line_Separator',
            bmp: '\u2028'
        },
        {
            name: 'Zp',
            alias: 'Paragraph_Separator',
            bmp: '\u2029'
        },
        {
            name: 'Zs',
            alias: 'Space_Separator',
            bmp: '\x20\xA0\u1680\u2000-\u200A\u202F\u205F\u3000'
        }
    ]);

};

},{}],6:[function(require,module,exports){
/*!
 * XRegExp Unicode Properties 3.2.0
 * <xregexp.com>
 * Steven Levithan (c) 2012-2017 MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */

module.exports = function(XRegExp) {

    /**
     * Adds properties to meet the UTS #18 Level 1 RL1.2 requirements for Unicode regex support. See
     * <http://unicode.org/reports/tr18/#RL1.2>. Following are definitions of these properties from
     * UAX #44 <http://unicode.org/reports/tr44/>:
     *
     * - Alphabetic
     *   Characters with the Alphabetic property. Generated from: Lowercase + Uppercase + Lt + Lm +
     *   Lo + Nl + Other_Alphabetic.
     *
     * - Default_Ignorable_Code_Point
     *   For programmatic determination of default ignorable code points. New characters that should
     *   be ignored in rendering (unless explicitly supported) will be assigned in these ranges,
     *   permitting programs to correctly handle the default rendering of such characters when not
     *   otherwise supported.
     *
     * - Lowercase
     *   Characters with the Lowercase property. Generated from: Ll + Other_Lowercase.
     *
     * - Noncharacter_Code_Point
     *   Code points permanently reserved for internal use.
     *
     * - Uppercase
     *   Characters with the Uppercase property. Generated from: Lu + Other_Uppercase.
     *
     * - White_Space
     *   Spaces, separator characters and other control characters which should be treated by
     *   programming languages as "white space" for the purpose of parsing elements.
     *
     * The properties ASCII, Any, and Assigned are also included but are not defined in UAX #44. UTS
     * #18 RL1.2 additionally requires support for Unicode scripts and general categories. These are
     * included in XRegExp's Unicode Categories and Unicode Scripts addons.
     *
     * Token names are case insensitive, and any spaces, hyphens, and underscores are ignored.
     *
     * Uses Unicode 9.0.0.
     *
     * @requires XRegExp, Unicode Base
     */

    if (!XRegExp.addUnicodeData) {
        throw new ReferenceError('Unicode Base must be loaded before Unicode Properties');
    }

    var unicodeData = [
        {
            name: 'ASCII',
            bmp: '\0-\x7F'
        },
        {
            name: 'Alphabetic',
            bmp: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0345\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05B0-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0657\u0659-\u065F\u066E-\u06D3\u06D5-\u06DC\u06E1-\u06E8\u06ED-\u06EF\u06FA-\u06FC\u06FF\u0710-\u073F\u074D-\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0817\u081A-\u082C\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08DF\u08E3-\u08E9\u08F0-\u093B\u093D-\u094C\u094E-\u0950\u0955-\u0963\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD-\u09C4\u09C7\u09C8\u09CB\u09CC\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09F0\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3E-\u0A42\u0A47\u0A48\u0A4B\u0A4C\u0A51\u0A59-\u0A5C\u0A5E\u0A70-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD-\u0AC5\u0AC7-\u0AC9\u0ACB\u0ACC\u0AD0\u0AE0-\u0AE3\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D-\u0B44\u0B47\u0B48\u0B4B\u0B4C\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4C\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCC\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E46\u0E4D\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0ECD\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F71-\u0F81\u0F88-\u0F97\u0F99-\u0FBC\u1000-\u1036\u1038\u103B-\u103F\u1050-\u1062\u1065-\u1068\u106E-\u1086\u108E\u109C\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1713\u1720-\u1733\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17B3\u17B6-\u17C8\u17D7\u17DC\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u1938\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A1B\u1A20-\u1A5E\u1A61-\u1A74\u1AA7\u1B00-\u1B33\u1B35-\u1B43\u1B45-\u1B4B\u1B80-\u1BA9\u1BAC-\u1BAF\u1BBA-\u1BE5\u1BE7-\u1BF1\u1C00-\u1C35\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1D00-\u1DBF\u1DE7-\u1DF4\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA674-\uA67B\uA67F-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA827\uA840-\uA873\uA880-\uA8C3\uA8C5\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA92A\uA930-\uA952\uA960-\uA97C\uA980-\uA9B2\uA9B4-\uA9BF\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA60-\uAA76\uAA7A\uAA7E-\uAABE\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF5\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
            astral: '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC45\uDC82-\uDCB8\uDCD0-\uDCE8\uDD00-\uDD32\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD805[\uDC00-\uDC41\uDC43-\uDC45\uDC47-\uDC4A\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE80-\uDEB5\uDF00-\uDF19\uDF1D-\uDF2A]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC3E\uDC40\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF36\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD47]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]'
        },
        {
            name: 'Any',
            isBmpLast: true,
            bmp: '\0-\uFFFF',
            astral: '[\uD800-\uDBFF][\uDC00-\uDFFF]'
        },
        {
            name: 'Default_Ignorable_Code_Point',
            bmp: '\xAD\u034F\u061C\u115F\u1160\u17B4\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8',
            astral: '\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|[\uDB40-\uDB43][\uDC00-\uDFFF]'
        },
        {
            name: 'Lowercase',
            bmp: 'a-z\xAA\xB5\xBA\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02B8\u02C0\u02C1\u02E0-\u02E4\u0345\u0371\u0373\u0377\u037A-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1DBF\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u2071\u207F\u2090-\u209C\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2170-\u217F\u2184\u24D0-\u24E9\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7D\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B-\uA69D\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7F8-\uA7FA\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A',
            astral: '\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]'
        },
        {
            name: 'Noncharacter_Code_Point',
            bmp: '\uFDD0-\uFDEF\uFFFE\uFFFF',
            astral: '[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]'
        },
        {
            name: 'Uppercase',
            bmp: 'A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2160-\u216F\u2183\u24B6-\u24CF\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A',
            astral: '\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]'
        },
        {
            name: 'White_Space',
            bmp: '\x09-\x0D\x20\x85\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000'
        }
    ];

    // Add non-generated data
    unicodeData.push({
        name: 'Assigned',
        // Since this is defined as the inverse of Unicode category Cn (Unassigned), the Unicode
        // Categories addon is required to use this property
        inverseOf: 'Cn'
    });

    XRegExp.addUnicodeData(unicodeData);

};

},{}],7:[function(require,module,exports){
/*!
 * XRegExp Unicode Scripts 3.2.0
 * <xregexp.com>
 * Steven Levithan (c) 2010-2017 MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */

module.exports = function(XRegExp) {

    /**
     * Adds support for all Unicode scripts. E.g., `\p{Latin}`. Token names are case insensitive,
     * and any spaces, hyphens, and underscores are ignored.
     *
     * Uses Unicode 9.0.0.
     *
     * @requires XRegExp, Unicode Base
     */

    if (!XRegExp.addUnicodeData) {
        throw new ReferenceError('Unicode Base must be loaded before Unicode Scripts');
    }

    XRegExp.addUnicodeData([
        {
            name: 'Adlam',
            astral: '\uD83A[\uDD00-\uDD4A\uDD50-\uDD59\uDD5E\uDD5F]'
        },
        {
            name: 'Ahom',
            astral: '\uD805[\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF3F]'
        },
        {
            name: 'Anatolian_Hieroglyphs',
            astral: '\uD811[\uDC00-\uDE46]'
        },
        {
            name: 'Arabic',
            bmp: '\u0600-\u0604\u0606-\u060B\u060D-\u061A\u061E\u0620-\u063F\u0641-\u064A\u0656-\u066F\u0671-\u06DC\u06DE-\u06FF\u0750-\u077F\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u08FF\uFB50-\uFBC1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFD\uFE70-\uFE74\uFE76-\uFEFC',
            astral: '\uD803[\uDE60-\uDE7E]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]'
        },
        {
            name: 'Armenian',
            bmp: '\u0531-\u0556\u0559-\u055F\u0561-\u0587\u058A\u058D-\u058F\uFB13-\uFB17'
        },
        {
            name: 'Avestan',
            astral: '\uD802[\uDF00-\uDF35\uDF39-\uDF3F]'
        },
        {
            name: 'Balinese',
            bmp: '\u1B00-\u1B4B\u1B50-\u1B7C'
        },
        {
            name: 'Bamum',
            bmp: '\uA6A0-\uA6F7',
            astral: '\uD81A[\uDC00-\uDE38]'
        },
        {
            name: 'Bassa_Vah',
            astral: '\uD81A[\uDED0-\uDEED\uDEF0-\uDEF5]'
        },
        {
            name: 'Batak',
            bmp: '\u1BC0-\u1BF3\u1BFC-\u1BFF'
        },
        {
            name: 'Bengali',
            bmp: '\u0980-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09FB'
        },
        {
            name: 'Bhaiksuki',
            astral: '\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC45\uDC50-\uDC6C]'
        },
        {
            name: 'Bopomofo',
            bmp: '\u02EA\u02EB\u3105-\u312D\u31A0-\u31BA'
        },
        {
            name: 'Brahmi',
            astral: '\uD804[\uDC00-\uDC4D\uDC52-\uDC6F\uDC7F]'
        },
        {
            name: 'Braille',
            bmp: '\u2800-\u28FF'
        },
        {
            name: 'Buginese',
            bmp: '\u1A00-\u1A1B\u1A1E\u1A1F'
        },
        {
            name: 'Buhid',
            bmp: '\u1740-\u1753'
        },
        {
            name: 'Canadian_Aboriginal',
            bmp: '\u1400-\u167F\u18B0-\u18F5'
        },
        {
            name: 'Carian',
            astral: '\uD800[\uDEA0-\uDED0]'
        },
        {
            name: 'Caucasian_Albanian',
            astral: '\uD801[\uDD30-\uDD63\uDD6F]'
        },
        {
            name: 'Chakma',
            astral: '\uD804[\uDD00-\uDD34\uDD36-\uDD43]'
        },
        {
            name: 'Cham',
            bmp: '\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F'
        },
        {
            name: 'Cherokee',
            bmp: '\u13A0-\u13F5\u13F8-\u13FD\uAB70-\uABBF'
        },
        {
            name: 'Common',
            bmp: '\0-\x40\\x5B-\x60\\x7B-\xA9\xAB-\xB9\xBB-\xBF\xD7\xF7\u02B9-\u02DF\u02E5-\u02E9\u02EC-\u02FF\u0374\u037E\u0385\u0387\u0589\u0605\u060C\u061B\u061C\u061F\u0640\u06DD\u08E2\u0964\u0965\u0E3F\u0FD5-\u0FD8\u10FB\u16EB-\u16ED\u1735\u1736\u1802\u1803\u1805\u1CD3\u1CE1\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u2000-\u200B\u200E-\u2064\u2066-\u2070\u2074-\u207E\u2080-\u208E\u20A0-\u20BE\u2100-\u2125\u2127-\u2129\u212C-\u2131\u2133-\u214D\u214F-\u215F\u2189-\u218B\u2190-\u23FE\u2400-\u2426\u2440-\u244A\u2460-\u27FF\u2900-\u2B73\u2B76-\u2B95\u2B98-\u2BB9\u2BBD-\u2BC8\u2BCA-\u2BD1\u2BEC-\u2BEF\u2E00-\u2E44\u2FF0-\u2FFB\u3000-\u3004\u3006\u3008-\u3020\u3030-\u3037\u303C-\u303F\u309B\u309C\u30A0\u30FB\u30FC\u3190-\u319F\u31C0-\u31E3\u3220-\u325F\u327F-\u32CF\u3358-\u33FF\u4DC0-\u4DFF\uA700-\uA721\uA788-\uA78A\uA830-\uA839\uA92E\uA9CF\uAB5B\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFEFF\uFF01-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFF70\uFF9E\uFF9F\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFF9-\uFFFD',
            astral: '\uD800[\uDD00-\uDD02\uDD07-\uDD33\uDD37-\uDD3F\uDD90-\uDD9B\uDDD0-\uDDFC\uDEE1-\uDEFB]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD66\uDD6A-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDF00-\uDF56\uDF60-\uDF71]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDFCB\uDFCE-\uDFFF]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD00-\uDD0C\uDD10-\uDD2E\uDD30-\uDD6B\uDD70-\uDDAC\uDDE6-\uDDFF\uDE01\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED2\uDEE0-\uDEEC\uDEF0-\uDEF6\uDF00-\uDF73\uDF80-\uDFD4]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3E\uDD40-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0]|\uDB40[\uDC01\uDC20-\uDC7F]'
        },
        {
            name: 'Coptic',
            bmp: '\u03E2-\u03EF\u2C80-\u2CF3\u2CF9-\u2CFF'
        },
        {
            name: 'Cuneiform',
            astral: '\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC70-\uDC74\uDC80-\uDD43]'
        },
        {
            name: 'Cypriot',
            astral: '\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F]'
        },
        {
            name: 'Cyrillic',
            bmp: '\u0400-\u0484\u0487-\u052F\u1C80-\u1C88\u1D2B\u1D78\u2DE0-\u2DFF\uA640-\uA69F\uFE2E\uFE2F'
        },
        {
            name: 'Deseret',
            astral: '\uD801[\uDC00-\uDC4F]'
        },
        {
            name: 'Devanagari',
            bmp: '\u0900-\u0950\u0953-\u0963\u0966-\u097F\uA8E0-\uA8FD'
        },
        {
            name: 'Duployan',
            astral: '\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]'
        },
        {
            name: 'Egyptian_Hieroglyphs',
            astral: '\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]'
        },
        {
            name: 'Elbasan',
            astral: '\uD801[\uDD00-\uDD27]'
        },
        {
            name: 'Ethiopic',
            bmp: '\u1200-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u137C\u1380-\u1399\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E'
        },
        {
            name: 'Georgian',
            bmp: '\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u10FF\u2D00-\u2D25\u2D27\u2D2D'
        },
        {
            name: 'Glagolitic',
            bmp: '\u2C00-\u2C2E\u2C30-\u2C5E',
            astral: '\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]'
        },
        {
            name: 'Gothic',
            astral: '\uD800[\uDF30-\uDF4A]'
        },
        {
            name: 'Grantha',
            astral: '\uD804[\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]'
        },
        {
            name: 'Greek',
            bmp: '\u0370-\u0373\u0375-\u0377\u037A-\u037D\u037F\u0384\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03E1\u03F0-\u03FF\u1D26-\u1D2A\u1D5D-\u1D61\u1D66-\u1D6A\u1DBF\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FC4\u1FC6-\u1FD3\u1FD6-\u1FDB\u1FDD-\u1FEF\u1FF2-\u1FF4\u1FF6-\u1FFE\u2126\uAB65',
            astral: '\uD800[\uDD40-\uDD8E\uDDA0]|\uD834[\uDE00-\uDE45]'
        },
        {
            name: 'Gujarati',
            bmp: '\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AF1\u0AF9'
        },
        {
            name: 'Gurmukhi',
            bmp: '\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75'
        },
        {
            name: 'Han',
            bmp: '\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FD5\uF900-\uFA6D\uFA70-\uFAD9',
            astral: '[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]'
        },
        {
            name: 'Hangul',
            bmp: '\u1100-\u11FF\u302E\u302F\u3131-\u318E\u3200-\u321E\u3260-\u327E\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC'
        },
        {
            name: 'Hanunoo',
            bmp: '\u1720-\u1734'
        },
        {
            name: 'Hatran',
            astral: '\uD802[\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDCFF]'
        },
        {
            name: 'Hebrew',
            bmp: '\u0591-\u05C7\u05D0-\u05EA\u05F0-\u05F4\uFB1D-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFB4F'
        },
        {
            name: 'Hiragana',
            bmp: '\u3041-\u3096\u309D-\u309F',
            astral: '\uD82C\uDC01|\uD83C\uDE00'
        },
        {
            name: 'Imperial_Aramaic',
            astral: '\uD802[\uDC40-\uDC55\uDC57-\uDC5F]'
        },
        {
            name: 'Inherited',
            bmp: '\u0300-\u036F\u0485\u0486\u064B-\u0655\u0670\u0951\u0952\u1AB0-\u1ABE\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u200C\u200D\u20D0-\u20F0\u302A-\u302D\u3099\u309A\uFE00-\uFE0F\uFE20-\uFE2D',
            astral: '\uD800[\uDDFD\uDEE0]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uDB40[\uDD00-\uDDEF]'
        },
        {
            name: 'Inscriptional_Pahlavi',
            astral: '\uD802[\uDF60-\uDF72\uDF78-\uDF7F]'
        },
        {
            name: 'Inscriptional_Parthian',
            astral: '\uD802[\uDF40-\uDF55\uDF58-\uDF5F]'
        },
        {
            name: 'Javanese',
            bmp: '\uA980-\uA9CD\uA9D0-\uA9D9\uA9DE\uA9DF'
        },
        {
            name: 'Kaithi',
            astral: '\uD804[\uDC80-\uDCC1]'
        },
        {
            name: 'Kannada',
            bmp: '\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2'
        },
        {
            name: 'Katakana',
            bmp: '\u30A1-\u30FA\u30FD-\u30FF\u31F0-\u31FF\u32D0-\u32FE\u3300-\u3357\uFF66-\uFF6F\uFF71-\uFF9D',
            astral: '\uD82C\uDC00'
        },
        {
            name: 'Kayah_Li',
            bmp: '\uA900-\uA92D\uA92F'
        },
        {
            name: 'Kharoshthi',
            astral: '\uD802[\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F-\uDE47\uDE50-\uDE58]'
        },
        {
            name: 'Khmer',
            bmp: '\u1780-\u17DD\u17E0-\u17E9\u17F0-\u17F9\u19E0-\u19FF'
        },
        {
            name: 'Khojki',
            astral: '\uD804[\uDE00-\uDE11\uDE13-\uDE3E]'
        },
        {
            name: 'Khudawadi',
            astral: '\uD804[\uDEB0-\uDEEA\uDEF0-\uDEF9]'
        },
        {
            name: 'Lao',
            bmp: '\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF'
        },
        {
            name: 'Latin',
            bmp: 'A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A'
        },
        {
            name: 'Lepcha',
            bmp: '\u1C00-\u1C37\u1C3B-\u1C49\u1C4D-\u1C4F'
        },
        {
            name: 'Limbu',
            bmp: '\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1940\u1944-\u194F'
        },
        {
            name: 'Linear_A',
            astral: '\uD801[\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]'
        },
        {
            name: 'Linear_B',
            astral: '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA]'
        },
        {
            name: 'Lisu',
            bmp: '\uA4D0-\uA4FF'
        },
        {
            name: 'Lycian',
            astral: '\uD800[\uDE80-\uDE9C]'
        },
        {
            name: 'Lydian',
            astral: '\uD802[\uDD20-\uDD39\uDD3F]'
        },
        {
            name: 'Mahajani',
            astral: '\uD804[\uDD50-\uDD76]'
        },
        {
            name: 'Malayalam',
            bmp: '\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4F\u0D54-\u0D63\u0D66-\u0D7F'
        },
        {
            name: 'Mandaic',
            bmp: '\u0840-\u085B\u085E'
        },
        {
            name: 'Manichaean',
            astral: '\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6]'
        },
        {
            name: 'Marchen',
            astral: '\uD807[\uDC70-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]'
        },
        {
            name: 'Meetei_Mayek',
            bmp: '\uAAE0-\uAAF6\uABC0-\uABED\uABF0-\uABF9'
        },
        {
            name: 'Mende_Kikakui',
            astral: '\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6]'
        },
        {
            name: 'Meroitic_Cursive',
            astral: '\uD802[\uDDA0-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDDFF]'
        },
        {
            name: 'Meroitic_Hieroglyphs',
            astral: '\uD802[\uDD80-\uDD9F]'
        },
        {
            name: 'Miao',
            astral: '\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F]'
        },
        {
            name: 'Modi',
            astral: '\uD805[\uDE00-\uDE44\uDE50-\uDE59]'
        },
        {
            name: 'Mongolian',
            bmp: '\u1800\u1801\u1804\u1806-\u180E\u1810-\u1819\u1820-\u1877\u1880-\u18AA',
            astral: '\uD805[\uDE60-\uDE6C]'
        },
        {
            name: 'Mro',
            astral: '\uD81A[\uDE40-\uDE5E\uDE60-\uDE69\uDE6E\uDE6F]'
        },
        {
            name: 'Multani',
            astral: '\uD804[\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9]'
        },
        {
            name: 'Myanmar',
            bmp: '\u1000-\u109F\uA9E0-\uA9FE\uAA60-\uAA7F'
        },
        {
            name: 'Nabataean',
            astral: '\uD802[\uDC80-\uDC9E\uDCA7-\uDCAF]'
        },
        {
            name: 'New_Tai_Lue',
            bmp: '\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u19DE\u19DF'
        },
        {
            name: 'Newa',
            astral: '\uD805[\uDC00-\uDC59\uDC5B\uDC5D]'
        },
        {
            name: 'Nko',
            bmp: '\u07C0-\u07FA'
        },
        {
            name: 'Ogham',
            bmp: '\u1680-\u169C'
        },
        {
            name: 'Ol_Chiki',
            bmp: '\u1C50-\u1C7F'
        },
        {
            name: 'Old_Hungarian',
            astral: '\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDCFF]'
        },
        {
            name: 'Old_Italic',
            astral: '\uD800[\uDF00-\uDF23]'
        },
        {
            name: 'Old_North_Arabian',
            astral: '\uD802[\uDE80-\uDE9F]'
        },
        {
            name: 'Old_Permic',
            astral: '\uD800[\uDF50-\uDF7A]'
        },
        {
            name: 'Old_Persian',
            astral: '\uD800[\uDFA0-\uDFC3\uDFC8-\uDFD5]'
        },
        {
            name: 'Old_South_Arabian',
            astral: '\uD802[\uDE60-\uDE7F]'
        },
        {
            name: 'Old_Turkic',
            astral: '\uD803[\uDC00-\uDC48]'
        },
        {
            name: 'Oriya',
            bmp: '\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B77'
        },
        {
            name: 'Osage',
            astral: '\uD801[\uDCB0-\uDCD3\uDCD8-\uDCFB]'
        },
        {
            name: 'Osmanya',
            astral: '\uD801[\uDC80-\uDC9D\uDCA0-\uDCA9]'
        },
        {
            name: 'Pahawh_Hmong',
            astral: '\uD81A[\uDF00-\uDF45\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]'
        },
        {
            name: 'Palmyrene',
            astral: '\uD802[\uDC60-\uDC7F]'
        },
        {
            name: 'Pau_Cin_Hau',
            astral: '\uD806[\uDEC0-\uDEF8]'
        },
        {
            name: 'Phags_Pa',
            bmp: '\uA840-\uA877'
        },
        {
            name: 'Phoenician',
            astral: '\uD802[\uDD00-\uDD1B\uDD1F]'
        },
        {
            name: 'Psalter_Pahlavi',
            astral: '\uD802[\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]'
        },
        {
            name: 'Rejang',
            bmp: '\uA930-\uA953\uA95F'
        },
        {
            name: 'Runic',
            bmp: '\u16A0-\u16EA\u16EE-\u16F8'
        },
        {
            name: 'Samaritan',
            bmp: '\u0800-\u082D\u0830-\u083E'
        },
        {
            name: 'Saurashtra',
            bmp: '\uA880-\uA8C5\uA8CE-\uA8D9'
        },
        {
            name: 'Sharada',
            astral: '\uD804[\uDD80-\uDDCD\uDDD0-\uDDDF]'
        },
        {
            name: 'Shavian',
            astral: '\uD801[\uDC50-\uDC7F]'
        },
        {
            name: 'Siddham',
            astral: '\uD805[\uDD80-\uDDB5\uDDB8-\uDDDD]'
        },
        {
            name: 'SignWriting',
            astral: '\uD836[\uDC00-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]'
        },
        {
            name: 'Sinhala',
            bmp: '\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2-\u0DF4',
            astral: '\uD804[\uDDE1-\uDDF4]'
        },
        {
            name: 'Sora_Sompeng',
            astral: '\uD804[\uDCD0-\uDCE8\uDCF0-\uDCF9]'
        },
        {
            name: 'Sundanese',
            bmp: '\u1B80-\u1BBF\u1CC0-\u1CC7'
        },
        {
            name: 'Syloti_Nagri',
            bmp: '\uA800-\uA82B'
        },
        {
            name: 'Syriac',
            bmp: '\u0700-\u070D\u070F-\u074A\u074D-\u074F'
        },
        {
            name: 'Tagalog',
            bmp: '\u1700-\u170C\u170E-\u1714'
        },
        {
            name: 'Tagbanwa',
            bmp: '\u1760-\u176C\u176E-\u1770\u1772\u1773'
        },
        {
            name: 'Tai_Le',
            bmp: '\u1950-\u196D\u1970-\u1974'
        },
        {
            name: 'Tai_Tham',
            bmp: '\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA0-\u1AAD'
        },
        {
            name: 'Tai_Viet',
            bmp: '\uAA80-\uAAC2\uAADB-\uAADF'
        },
        {
            name: 'Takri',
            astral: '\uD805[\uDE80-\uDEB7\uDEC0-\uDEC9]'
        },
        {
            name: 'Tamil',
            bmp: '\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BFA'
        },
        {
            name: 'Tangut',
            astral: '\uD81B\uDFE0|[\uD81C-\uD820][\uDC00-\uDFFF]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]'
        },
        {
            name: 'Telugu',
            bmp: '\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C78-\u0C7F'
        },
        {
            name: 'Thaana',
            bmp: '\u0780-\u07B1'
        },
        {
            name: 'Thai',
            bmp: '\u0E01-\u0E3A\u0E40-\u0E5B'
        },
        {
            name: 'Tibetan',
            bmp: '\u0F00-\u0F47\u0F49-\u0F6C\u0F71-\u0F97\u0F99-\u0FBC\u0FBE-\u0FCC\u0FCE-\u0FD4\u0FD9\u0FDA'
        },
        {
            name: 'Tifinagh',
            bmp: '\u2D30-\u2D67\u2D6F\u2D70\u2D7F'
        },
        {
            name: 'Tirhuta',
            astral: '\uD805[\uDC80-\uDCC7\uDCD0-\uDCD9]'
        },
        {
            name: 'Ugaritic',
            astral: '\uD800[\uDF80-\uDF9D\uDF9F]'
        },
        {
            name: 'Vai',
            bmp: '\uA500-\uA62B'
        },
        {
            name: 'Warang_Citi',
            astral: '\uD806[\uDCA0-\uDCF2\uDCFF]'
        },
        {
            name: 'Yi',
            bmp: '\uA000-\uA48C\uA490-\uA4C6'
        }
    ]);

};

},{}],8:[function(require,module,exports){
var XRegExp = require('./xregexp');

require('./addons/build')(XRegExp);
require('./addons/matchrecursive')(XRegExp);
require('./addons/unicode-base')(XRegExp);
require('./addons/unicode-blocks')(XRegExp);
require('./addons/unicode-categories')(XRegExp);
require('./addons/unicode-properties')(XRegExp);
require('./addons/unicode-scripts')(XRegExp);

module.exports = XRegExp;

},{"./addons/build":1,"./addons/matchrecursive":2,"./addons/unicode-base":3,"./addons/unicode-blocks":4,"./addons/unicode-categories":5,"./addons/unicode-properties":6,"./addons/unicode-scripts":7,"./xregexp":9}],9:[function(require,module,exports){

/**
 * XRegExp provides augmented, extensible regular expressions. You get additional regex syntax and
 * flags, beyond what browsers support natively. XRegExp is also a regex utility belt with tools to
 * make your client-side grepping simpler and more powerful, while freeing you from related
 * cross-browser inconsistencies.
 */

// ==--------------------------==
// Private stuff
// ==--------------------------==

// Property name used for extended regex instance data
var REGEX_DATA = 'xregexp';
// Optional features that can be installed and uninstalled
var features = {
    astral: false,
    natives: false
};
// Native methods to use and restore ('native' is an ES3 reserved keyword)
var nativ = {
    exec: RegExp.prototype.exec,
    test: RegExp.prototype.test,
    match: String.prototype.match,
    replace: String.prototype.replace,
    split: String.prototype.split
};
// Storage for fixed/extended native methods
var fixed = {};
// Storage for regexes cached by `XRegExp.cache`
var regexCache = {};
// Storage for pattern details cached by the `XRegExp` constructor
var patternCache = {};
// Storage for regex syntax tokens added internally or by `XRegExp.addToken`
var tokens = [];
// Token scopes
var defaultScope = 'default';
var classScope = 'class';
// Regexes that match native regex syntax, including octals
var nativeTokens = {
    // Any native multicharacter token in default scope, or any single character
    'default': /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
    // Any native multicharacter token in character class scope, or any single character
    'class': /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
};
// Any backreference or dollar-prefixed character in replacement strings
var replacementToken = /\$(?:{([\w$]+)}|(\d\d?|[\s\S]))/g;
// Check for correct `exec` handling of nonparticipating capturing groups
var correctExecNpcg = nativ.exec.call(/()??/, '')[1] === undefined;
// Check for ES6 `flags` prop support
var hasFlagsProp = /x/.flags !== undefined;
// Shortcut to `Object.prototype.toString`
var toString = {}.toString;

function hasNativeFlag(flag) {
    // Can't check based on the presence of properties/getters since browsers might support such
    // properties even when they don't support the corresponding flag in regex construction (tested
    // in Chrome 48, where `'unicode' in /x/` is true but trying to construct a regex with flag `u`
    // throws an error)
    var isSupported = true;
    try {
        // Can't use regex literals for testing even in a `try` because regex literals with
        // unsupported flags cause a compilation error in IE
        new RegExp('', flag);
    } catch (exception) {
        isSupported = false;
    }
    return isSupported;
}
// Check for ES6 `u` flag support
var hasNativeU = hasNativeFlag('u');
// Check for ES6 `y` flag support
var hasNativeY = hasNativeFlag('y');
// Tracker for known flags, including addon flags
var registeredFlags = {
    g: true,
    i: true,
    m: true,
    u: hasNativeU,
    y: hasNativeY
};

/**
 * Attaches extended data and `XRegExp.prototype` properties to a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to augment.
 * @param {Array} captureNames Array with capture names, or `null`.
 * @param {String} xSource XRegExp pattern used to generate `regex`, or `null` if N/A.
 * @param {String} xFlags XRegExp flags used to generate `regex`, or `null` if N/A.
 * @param {Boolean} [isInternalOnly=false] Whether the regex will be used only for internal
 *   operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *   skipping some operations like attaching `XRegExp.prototype` properties.
 * @returns {RegExp} Augmented regex.
 */
function augment(regex, captureNames, xSource, xFlags, isInternalOnly) {
    var p;

    regex[REGEX_DATA] = {
        captureNames: captureNames
    };

    if (isInternalOnly) {
        return regex;
    }

    // Can't auto-inherit these since the XRegExp constructor returns a nonprimitive value
    if (regex.__proto__) {
        regex.__proto__ = XRegExp.prototype;
    } else {
        for (p in XRegExp.prototype) {
            // An `XRegExp.prototype.hasOwnProperty(p)` check wouldn't be worth it here, since this
            // is performance sensitive, and enumerable `Object.prototype` or `RegExp.prototype`
            // extensions exist on `regex.prototype` anyway
            regex[p] = XRegExp.prototype[p];
        }
    }

    regex[REGEX_DATA].source = xSource;
    // Emulate the ES6 `flags` prop by ensuring flags are in alphabetical order
    regex[REGEX_DATA].flags = xFlags ? xFlags.split('').sort().join('') : xFlags;

    return regex;
}

/**
 * Removes any duplicate characters from the provided string.
 *
 * @private
 * @param {String} str String to remove duplicate characters from.
 * @returns {String} String with any duplicate characters removed.
 */
function clipDuplicates(str) {
    return nativ.replace.call(str, /([\s\S])(?=[\s\S]*\1)/g, '');
}

/**
 * Copies a regex object while preserving extended data and augmenting with `XRegExp.prototype`
 * properties. The copy has a fresh `lastIndex` property (set to zero). Allows adding and removing
 * flags g and y while copying the regex.
 *
 * @private
 * @param {RegExp} regex Regex to copy.
 * @param {Object} [options] Options object with optional properties:
 *   - `addG` {Boolean} Add flag g while copying the regex.
 *   - `addY` {Boolean} Add flag y while copying the regex.
 *   - `removeG` {Boolean} Remove flag g while copying the regex.
 *   - `removeY` {Boolean} Remove flag y while copying the regex.
 *   - `isInternalOnly` {Boolean} Whether the copied regex will be used only for internal
 *     operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *     skipping some operations like attaching `XRegExp.prototype` properties.
 *   - `source` {String} Overrides `<regex>.source`, for special cases.
 * @returns {RegExp} Copy of the provided regex, possibly with modified flags.
 */
function copyRegex(regex, options) {
    if (!XRegExp.isRegExp(regex)) {
        throw new TypeError('Type RegExp expected');
    }

    var xData = regex[REGEX_DATA] || {};
    var flags = getNativeFlags(regex);
    var flagsToAdd = '';
    var flagsToRemove = '';
    var xregexpSource = null;
    var xregexpFlags = null;

    options = options || {};

    if (options.removeG) {flagsToRemove += 'g';}
    if (options.removeY) {flagsToRemove += 'y';}
    if (flagsToRemove) {
        flags = nativ.replace.call(flags, new RegExp('[' + flagsToRemove + ']+', 'g'), '');
    }

    if (options.addG) {flagsToAdd += 'g';}
    if (options.addY) {flagsToAdd += 'y';}
    if (flagsToAdd) {
        flags = clipDuplicates(flags + flagsToAdd);
    }

    if (!options.isInternalOnly) {
        if (xData.source !== undefined) {
            xregexpSource = xData.source;
        }
        // null or undefined; don't want to add to `flags` if the previous value was null, since
        // that indicates we're not tracking original precompilation flags
        if (xData.flags != null) {
            // Flags are only added for non-internal regexes by `XRegExp.globalize`. Flags are never
            // removed for non-internal regexes, so don't need to handle it
            xregexpFlags = flagsToAdd ? clipDuplicates(xData.flags + flagsToAdd) : xData.flags;
        }
    }

    // Augment with `XRegExp.prototype` properties, but use the native `RegExp` constructor to avoid
    // searching for special tokens. That would be wrong for regexes constructed by `RegExp`, and
    // unnecessary for regexes constructed by `XRegExp` because the regex has already undergone the
    // translation to native regex syntax
    regex = augment(
        new RegExp(options.source || regex.source, flags),
        hasNamedCapture(regex) ? xData.captureNames.slice(0) : null,
        xregexpSource,
        xregexpFlags,
        options.isInternalOnly
    );

    return regex;
}

/**
 * Converts hexadecimal to decimal.
 *
 * @private
 * @param {String} hex
 * @returns {Number}
 */
function dec(hex) {
    return parseInt(hex, 16);
}

/**
 * Returns a pattern that can be used in a native RegExp in place of an ignorable token such as an
 * inline comment or whitespace with flag x. This is used directly as a token handler function
 * passed to `XRegExp.addToken`.
 *
 * @private
 * @param {String} match Match arg of `XRegExp.addToken` handler
 * @param {String} scope Scope arg of `XRegExp.addToken` handler
 * @param {String} flags Flags arg of `XRegExp.addToken` handler
 * @returns {String} Either '' or '(?:)', depending on which is needed in the context of the match.
 */
function getContextualTokenSeparator(match, scope, flags) {
    if (
        // No need to separate tokens if at the beginning or end of a group
        match.input.charAt(match.index - 1) === '(' ||
        match.input.charAt(match.index + match[0].length) === ')' ||
        // Avoid separating tokens when the following token is a quantifier
        isPatternNext(match.input, match.index + match[0].length, flags, '[?*+]|{\\d+(?:,\\d*)?}')
    ) {
        return '';
    }
    // Keep tokens separated. This avoids e.g. inadvertedly changing `\1 1` or `\1(?#)1` to `\11`.
    // This also ensures all tokens remain as discrete atoms, e.g. it avoids converting the syntax
    // error `(? :` into `(?:`.
    return '(?:)';
}

/**
 * Returns native `RegExp` flags used by a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {String} Native flags in use.
 */
function getNativeFlags(regex) {
    return hasFlagsProp ?
        regex.flags :
        // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or concatenation
        // with an empty string) allows this to continue working predictably when
        // `XRegExp.proptotype.toString` is overridden
        nativ.exec.call(/\/([a-z]*)$/i, RegExp.prototype.toString.call(regex))[1];
}

/**
 * Determines whether a regex has extended instance data used to track capture names.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {Boolean} Whether the regex uses named capture.
 */
function hasNamedCapture(regex) {
    return !!(regex[REGEX_DATA] && regex[REGEX_DATA].captureNames);
}

/**
 * Converts decimal to hexadecimal.
 *
 * @private
 * @param {Number|String} dec
 * @returns {String}
 */
function hex(dec) {
    return parseInt(dec, 10).toString(16);
}

/**
 * Returns the first index at which a given value can be found in an array.
 *
 * @private
 * @param {Array} array Array to search.
 * @param {*} value Value to locate in the array.
 * @returns {Number} Zero-based index at which the item is found, or -1.
 */
function indexOf(array, value) {
    var len = array.length;
    var i;

    for (i = 0; i < len; ++i) {
        if (array[i] === value) {
            return i;
        }
    }

    return -1;
}

/**
 * Checks whether the next nonignorable token after the specified position matches the
 * `needlePattern`
 *
 * @private
 * @param {String} pattern Pattern to search within.
 * @param {Number} pos Index in `pattern` to search at.
 * @param {String} flags Flags used by the pattern.
 * @param {String} needlePattern Pattern to match the next token against.
 * @returns {Boolean} Whether the next nonignorable token matches `needlePattern`
 */
function isPatternNext(pattern, pos, flags, needlePattern) {
    var inlineCommentPattern = '\\(\\?#[^)]*\\)';
    var lineCommentPattern = '#[^#\\n]*';
    var patternsToIgnore = flags.indexOf('x') > -1 ?
        // Ignore any leading whitespace, line comments, and inline comments
        ['\\s', lineCommentPattern, inlineCommentPattern] :
        // Ignore any leading inline comments
        [inlineCommentPattern];
    return nativ.test.call(
        new RegExp('^(?:' + patternsToIgnore.join('|') + ')*(?:' + needlePattern + ')'),
        pattern.slice(pos)
    );
}

/**
 * Determines whether a value is of the specified type, by resolving its internal [[Class]].
 *
 * @private
 * @param {*} value Object to check.
 * @param {String} type Type to check for, in TitleCase.
 * @returns {Boolean} Whether the object matches the type.
 */
function isType(value, type) {
    return toString.call(value) === '[object ' + type + ']';
}

/**
 * Adds leading zeros if shorter than four characters. Used for fixed-length hexadecimal values.
 *
 * @private
 * @param {String} str
 * @returns {String}
 */
function pad4(str) {
    while (str.length < 4) {
        str = '0' + str;
    }
    return str;
}

/**
 * Checks for flag-related errors, and strips/applies flags in a leading mode modifier. Offloads
 * the flag preparation logic from the `XRegExp` constructor.
 *
 * @private
 * @param {String} pattern Regex pattern, possibly with a leading mode modifier.
 * @param {String} flags Any combination of flags.
 * @returns {Object} Object with properties `pattern` and `flags`.
 */
function prepareFlags(pattern, flags) {
    var i;

    // Recent browsers throw on duplicate flags, so copy this behavior for nonnative flags
    if (clipDuplicates(flags) !== flags) {
        throw new SyntaxError('Invalid duplicate regex flag ' + flags);
    }

    // Strip and apply a leading mode modifier with any combination of flags except g or y
    pattern = nativ.replace.call(pattern, /^\(\?([\w$]+)\)/, function($0, $1) {
        if (nativ.test.call(/[gy]/, $1)) {
            throw new SyntaxError('Cannot use flag g or y in mode modifier ' + $0);
        }
        // Allow duplicate flags within the mode modifier
        flags = clipDuplicates(flags + $1);
        return '';
    });

    // Throw on unknown native or nonnative flags
    for (i = 0; i < flags.length; ++i) {
        if (!registeredFlags[flags.charAt(i)]) {
            throw new SyntaxError('Unknown regex flag ' + flags.charAt(i));
        }
    }

    return {
        pattern: pattern,
        flags: flags
    };
}

/**
 * Prepares an options object from the given value.
 *
 * @private
 * @param {String|Object} value Value to convert to an options object.
 * @returns {Object} Options object.
 */
function prepareOptions(value) {
    var options = {};

    if (isType(value, 'String')) {
        XRegExp.forEach(value, /[^\s,]+/, function(match) {
            options[match] = true;
        });

        return options;
    }

    return value;
}

/**
 * Registers a flag so it doesn't throw an 'unknown flag' error.
 *
 * @private
 * @param {String} flag Single-character flag to register.
 */
function registerFlag(flag) {
    if (!/^[\w$]$/.test(flag)) {
        throw new Error('Flag must be a single character A-Za-z0-9_$');
    }

    registeredFlags[flag] = true;
}

/**
 * Runs built-in and custom regex syntax tokens in reverse insertion order at the specified
 * position, until a match is found.
 *
 * @private
 * @param {String} pattern Original pattern from which an XRegExp object is being built.
 * @param {String} flags Flags being used to construct the regex.
 * @param {Number} pos Position to search for tokens within `pattern`.
 * @param {Number} scope Regex scope to apply: 'default' or 'class'.
 * @param {Object} context Context object to use for token handler functions.
 * @returns {Object} Object with properties `matchLength`, `output`, and `reparse`; or `null`.
 */
function runTokens(pattern, flags, pos, scope, context) {
    var i = tokens.length;
    var leadChar = pattern.charAt(pos);
    var result = null;
    var match;
    var t;

    // Run in reverse insertion order
    while (i--) {
        t = tokens[i];
        if (
            (t.leadChar && t.leadChar !== leadChar) ||
            (t.scope !== scope && t.scope !== 'all') ||
            (t.flag && flags.indexOf(t.flag) === -1)
        ) {
            continue;
        }

        match = XRegExp.exec(pattern, t.regex, pos, 'sticky');
        if (match) {
            result = {
                matchLength: match[0].length,
                output: t.handler.call(context, match, scope, flags),
                reparse: t.reparse
            };
            // Finished with token tests
            break;
        }
    }

    return result;
}

/**
 * Enables or disables implicit astral mode opt-in. When enabled, flag A is automatically added to
 * all new regexes created by XRegExp. This causes an error to be thrown when creating regexes if
 * the Unicode Base addon is not available, since flag A is registered by that addon.
 *
 * @private
 * @param {Boolean} on `true` to enable; `false` to disable.
 */
function setAstral(on) {
    features.astral = on;
}

/**
 * Enables or disables native method overrides.
 *
 * @private
 * @param {Boolean} on `true` to enable; `false` to disable.
 */
function setNatives(on) {
    RegExp.prototype.exec = (on ? fixed : nativ).exec;
    RegExp.prototype.test = (on ? fixed : nativ).test;
    String.prototype.match = (on ? fixed : nativ).match;
    String.prototype.replace = (on ? fixed : nativ).replace;
    String.prototype.split = (on ? fixed : nativ).split;

    features.natives = on;
}

/**
 * Returns the object, or throws an error if it is `null` or `undefined`. This is used to follow
 * the ES5 abstract operation `ToObject`.
 *
 * @private
 * @param {*} value Object to check and return.
 * @returns {*} The provided object.
 */
function toObject(value) {
    // null or undefined
    if (value == null) {
        throw new TypeError('Cannot convert null or undefined to object');
    }

    return value;
}

// ==--------------------------==
// Constructor
// ==--------------------------==

/**
 * Creates an extended regular expression object for matching text with a pattern. Differs from a
 * native regular expression in that additional syntax and flags are supported. The returned object
 * is in fact a native `RegExp` and works with all native methods.
 *
 * @class XRegExp
 * @constructor
 * @param {String|RegExp} pattern Regex pattern string, or an existing regex object to copy.
 * @param {String} [flags] Any combination of flags.
 *   Native flags:
 *     - `g` - global
 *     - `i` - ignore case
 *     - `m` - multiline anchors
 *     - `u` - unicode (ES6)
 *     - `y` - sticky (Firefox 3+, ES6)
 *   Additional XRegExp flags:
 *     - `n` - explicit capture
 *     - `s` - dot matches all (aka singleline)
 *     - `x` - free-spacing and line comments (aka extended)
 *     - `A` - astral (requires the Unicode Base addon)
 *   Flags cannot be provided when constructing one `RegExp` from another.
 * @returns {RegExp} Extended regular expression object.
 * @example
 *
 * // With named capture and flag x
 * XRegExp('(?<year>  [0-9]{4} ) -?  # year  \n\
 *          (?<month> [0-9]{2} ) -?  # month \n\
 *          (?<day>   [0-9]{2} )     # day   ', 'x');
 *
 * // Providing a regex object copies it. Native regexes are recompiled using native (not XRegExp)
 * // syntax. Copies maintain extended data, are augmented with `XRegExp.prototype` properties, and
 * // have fresh `lastIndex` properties (set to zero).
 * XRegExp(/regex/);
 */
function XRegExp(pattern, flags) {
    if (XRegExp.isRegExp(pattern)) {
        if (flags !== undefined) {
            throw new TypeError('Cannot supply flags when copying a RegExp');
        }
        return copyRegex(pattern);
    }

    // Copy the argument behavior of `RegExp`
    pattern = pattern === undefined ? '' : String(pattern);
    flags = flags === undefined ? '' : String(flags);

    if (XRegExp.isInstalled('astral') && flags.indexOf('A') === -1) {
        // This causes an error to be thrown if the Unicode Base addon is not available
        flags += 'A';
    }

    if (!patternCache[pattern]) {
        patternCache[pattern] = {};
    }

    if (!patternCache[pattern][flags]) {
        var context = {
            hasNamedCapture: false,
            captureNames: []
        };
        var scope = defaultScope;
        var output = '';
        var pos = 0;
        var result;

        // Check for flag-related errors, and strip/apply flags in a leading mode modifier
        var applied = prepareFlags(pattern, flags);
        var appliedPattern = applied.pattern;
        var appliedFlags = applied.flags;

        // Use XRegExp's tokens to translate the pattern to a native regex pattern.
        // `appliedPattern.length` may change on each iteration if tokens use `reparse`
        while (pos < appliedPattern.length) {
            do {
                // Check for custom tokens at the current position
                result = runTokens(appliedPattern, appliedFlags, pos, scope, context);
                // If the matched token used the `reparse` option, splice its output into the
                // pattern before running tokens again at the same position
                if (result && result.reparse) {
                    appliedPattern = appliedPattern.slice(0, pos) +
                        result.output +
                        appliedPattern.slice(pos + result.matchLength);
                }
            } while (result && result.reparse);

            if (result) {
                output += result.output;
                pos += (result.matchLength || 1);
            } else {
                // Get the native token at the current position
                var token = XRegExp.exec(appliedPattern, nativeTokens[scope], pos, 'sticky')[0];
                output += token;
                pos += token.length;
                if (token === '[' && scope === defaultScope) {
                    scope = classScope;
                } else if (token === ']' && scope === classScope) {
                    scope = defaultScope;
                }
            }
        }

        patternCache[pattern][flags] = {
            // Use basic cleanup to collapse repeated empty groups like `(?:)(?:)` to `(?:)`. Empty
            // groups are sometimes inserted during regex transpilation in order to keep tokens
            // separated. However, more than one empty group in a row is never needed.
            pattern: nativ.replace.call(output, /(?:\(\?:\))+/g, '(?:)'),
            // Strip all but native flags
            flags: nativ.replace.call(appliedFlags, /[^gimuy]+/g, ''),
            // `context.captureNames` has an item for each capturing group, even if unnamed
            captures: context.hasNamedCapture ? context.captureNames : null
        };
    }

    var generated = patternCache[pattern][flags];
    return augment(
        new RegExp(generated.pattern, generated.flags),
        generated.captures,
        pattern,
        flags
    );
}

// Add `RegExp.prototype` to the prototype chain
XRegExp.prototype = new RegExp();

// ==--------------------------==
// Public properties
// ==--------------------------==

/**
 * The XRegExp version number as a string containing three dot-separated parts. For example,
 * '2.0.0-beta-3'.
 *
 * @static
 * @memberOf XRegExp
 * @type String
 */
XRegExp.version = '3.2.0';

// ==--------------------------==
// Public methods
// ==--------------------------==

// Intentionally undocumented; used in tests and addons
XRegExp._clipDuplicates = clipDuplicates;
XRegExp._hasNativeFlag = hasNativeFlag;
XRegExp._dec = dec;
XRegExp._hex = hex;
XRegExp._pad4 = pad4;

/**
 * Extends XRegExp syntax and allows custom flags. This is used internally and can be used to
 * create XRegExp addons. If more than one token can match the same string, the last added wins.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex object that matches the new token.
 * @param {Function} handler Function that returns a new pattern string (using native regex syntax)
 *   to replace the matched token within all future XRegExp regexes. Has access to persistent
 *   properties of the regex being built, through `this`. Invoked with three arguments:
 *   - The match array, with named backreference properties.
 *   - The regex scope where the match was found: 'default' or 'class'.
 *   - The flags used by the regex, including any flags in a leading mode modifier.
 *   The handler function becomes part of the XRegExp construction process, so be careful not to
 *   construct XRegExps within the function or you will trigger infinite recursion.
 * @param {Object} [options] Options object with optional properties:
 *   - `scope` {String} Scope where the token applies: 'default', 'class', or 'all'.
 *   - `flag` {String} Single-character flag that triggers the token. This also registers the
 *     flag, which prevents XRegExp from throwing an 'unknown flag' error when the flag is used.
 *   - `optionalFlags` {String} Any custom flags checked for within the token `handler` that are
 *     not required to trigger the token. This registers the flags, to prevent XRegExp from
 *     throwing an 'unknown flag' error when any of the flags are used.
 *   - `reparse` {Boolean} Whether the `handler` function's output should not be treated as
 *     final, and instead be reparseable by other tokens (including the current token). Allows
 *     token chaining or deferring.
 *   - `leadChar` {String} Single character that occurs at the beginning of any successful match
 *     of the token (not always applicable). This doesn't change the behavior of the token unless
 *     you provide an erroneous value. However, providing it can increase the token's performance
 *     since the token can be skipped at any positions where this character doesn't appear.
 * @example
 *
 * // Basic usage: Add \a for the ALERT control code
 * XRegExp.addToken(
 *   /\\a/,
 *   function() {return '\\x07';},
 *   {scope: 'all'}
 * );
 * XRegExp('\\a[\\a-\\n]+').test('\x07\n\x07'); // -> true
 *
 * // Add the U (ungreedy) flag from PCRE and RE2, which reverses greedy and lazy quantifiers.
 * // Since `scope` is not specified, it uses 'default' (i.e., transformations apply outside of
 * // character classes only)
 * XRegExp.addToken(
 *   /([?*+]|{\d+(?:,\d*)?})(\??)/,
 *   function(match) {return match[1] + (match[2] ? '' : '?');},
 *   {flag: 'U'}
 * );
 * XRegExp('a+', 'U').exec('aaa')[0]; // -> 'a'
 * XRegExp('a+?', 'U').exec('aaa')[0]; // -> 'aaa'
 */
XRegExp.addToken = function(regex, handler, options) {
    options = options || {};
    var optionalFlags = options.optionalFlags;
    var i;

    if (options.flag) {
        registerFlag(options.flag);
    }

    if (optionalFlags) {
        optionalFlags = nativ.split.call(optionalFlags, '');
        for (i = 0; i < optionalFlags.length; ++i) {
            registerFlag(optionalFlags[i]);
        }
    }

    // Add to the private list of syntax tokens
    tokens.push({
        regex: copyRegex(regex, {
            addG: true,
            addY: hasNativeY,
            isInternalOnly: true
        }),
        handler: handler,
        scope: options.scope || defaultScope,
        flag: options.flag,
        reparse: options.reparse,
        leadChar: options.leadChar
    });

    // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and flags
    // might now produce different results
    XRegExp.cache.flush('patterns');
};

/**
 * Caches and returns the result of calling `XRegExp(pattern, flags)`. On any subsequent call with
 * the same pattern and flag combination, the cached copy of the regex is returned.
 *
 * @memberOf XRegExp
 * @param {String} pattern Regex pattern string.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @returns {RegExp} Cached XRegExp object.
 * @example
 *
 * while (match = XRegExp.cache('.', 'gs').exec(str)) {
 *   // The regex is compiled once only
 * }
 */
XRegExp.cache = function(pattern, flags) {
    if (!regexCache[pattern]) {
        regexCache[pattern] = {};
    }
    return regexCache[pattern][flags] || (
        regexCache[pattern][flags] = XRegExp(pattern, flags)
    );
};

// Intentionally undocumented; used in tests
XRegExp.cache.flush = function(cacheName) {
    if (cacheName === 'patterns') {
        // Flush the pattern cache used by the `XRegExp` constructor
        patternCache = {};
    } else {
        // Flush the regex cache populated by `XRegExp.cache`
        regexCache = {};
    }
};

/**
 * Escapes any regular expression metacharacters, for use when matching literal strings. The result
 * can safely be used at any point within a regex that uses any flags.
 *
 * @memberOf XRegExp
 * @param {String} str String to escape.
 * @returns {String} String with regex metacharacters escaped.
 * @example
 *
 * XRegExp.escape('Escaped? <.>');
 * // -> 'Escaped\?\ <\.>'
 */
XRegExp.escape = function(str) {
    return nativ.replace.call(toObject(str), /[-\[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

/**
 * Executes a regex search in a specified string. Returns a match array or `null`. If the provided
 * regex uses named capture, named backreference properties are included on the match array.
 * Optional `pos` and `sticky` arguments specify the search start position, and whether the match
 * must start at the specified position only. The `lastIndex` property of the provided regex is not
 * used, but is updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.exec` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {Array} Match array with named backreference properties, or `null`.
 * @example
 *
 * // Basic use, with named backreference
 * var match = XRegExp.exec('U+2620', XRegExp('U\\+(?<hex>[0-9A-F]{4})'));
 * match.hex; // -> '2620'
 *
 * // With pos and sticky, in a loop
 * var pos = 2, result = [], match;
 * while (match = XRegExp.exec('<1><2><3><4>5<6>', /<(\d)>/, pos, 'sticky')) {
 *   result.push(match[1]);
 *   pos = match.index + match[0].length;
 * }
 * // result -> ['2', '3', '4']
 */
XRegExp.exec = function(str, regex, pos, sticky) {
    var cacheKey = 'g';
    var addY = false;
    var fakeY = false;
    var match;
    var r2;

    addY = hasNativeY && !!(sticky || (regex.sticky && sticky !== false));
    if (addY) {
        cacheKey += 'y';
    } else if (sticky) {
        // Simulate sticky matching by appending an empty capture to the original regex. The
        // resulting regex will succeed no matter what at the current index (set with `lastIndex`),
        // and will not search the rest of the subject string. We'll know that the original regex
        // has failed if that last capture is `''` rather than `undefined` (i.e., if that last
        // capture participated in the match).
        fakeY = true;
        cacheKey += 'FakeY';
    }

    regex[REGEX_DATA] = regex[REGEX_DATA] || {};

    // Shares cached copies with `XRegExp.match`/`replace`
    r2 = regex[REGEX_DATA][cacheKey] || (
        regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
            addG: true,
            addY: addY,
            source: fakeY ? regex.source + '|()' : undefined,
            removeY: sticky === false,
            isInternalOnly: true
        })
    );

    pos = pos || 0;
    r2.lastIndex = pos;

    // Fixed `exec` required for `lastIndex` fix, named backreferences, etc.
    match = fixed.exec.call(r2, str);

    // Get rid of the capture added by the pseudo-sticky matcher if needed. An empty string means
    // the original regexp failed (see above).
    if (fakeY && match && match.pop() === '') {
        match = null;
    }

    if (regex.global) {
        regex.lastIndex = match ? r2.lastIndex : 0;
    }

    return match;
};

/**
 * Executes a provided function once per regex match. Searches always start at the beginning of the
 * string and continue until the end, regardless of the state of the regex's `global` property and
 * initial `lastIndex`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Function} callback Function to execute for each match. Invoked with four arguments:
 *   - The match array, with named backreference properties.
 *   - The zero-based match index.
 *   - The string being traversed.
 *   - The regex object being used to traverse the string.
 * @example
 *
 * // Extracts every other digit from a string
 * var evens = [];
 * XRegExp.forEach('1a2345', /\d/, function(match, i) {
 *   if (i % 2) evens.push(+match[0]);
 * });
 * // evens -> [2, 4]
 */
XRegExp.forEach = function(str, regex, callback) {
    var pos = 0;
    var i = -1;
    var match;

    while ((match = XRegExp.exec(str, regex, pos))) {
        // Because `regex` is provided to `callback`, the function could use the deprecated/
        // nonstandard `RegExp.prototype.compile` to mutate the regex. However, since `XRegExp.exec`
        // doesn't use `lastIndex` to set the search position, this can't lead to an infinite loop,
        // at least. Actually, because of the way `XRegExp.exec` caches globalized versions of
        // regexes, mutating the regex will not have any effect on the iteration or matched strings,
        // which is a nice side effect that brings extra safety.
        callback(match, ++i, str, regex);

        pos = match.index + (match[0].length || 1);
    }
};

/**
 * Copies a regex object and adds flag `g`. The copy maintains extended data, is augmented with
 * `XRegExp.prototype` properties, and has a fresh `lastIndex` property (set to zero). Native
 * regexes are not recompiled using XRegExp syntax.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex to globalize.
 * @returns {RegExp} Copy of the provided regex with flag `g` added.
 * @example
 *
 * var globalCopy = XRegExp.globalize(/regex/);
 * globalCopy.global; // -> true
 */
XRegExp.globalize = function(regex) {
    return copyRegex(regex, {addG: true});
};

/**
 * Installs optional features according to the specified options. Can be undone using
 * `XRegExp.uninstall`.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.install({
 *   // Enables support for astral code points in Unicode addons (implicitly sets flag A)
 *   astral: true,
 *
 *   // DEPRECATED: Overrides native regex methods with fixed/extended versions
 *   natives: true
 * });
 *
 * // With an options string
 * XRegExp.install('astral natives');
 */
XRegExp.install = function(options) {
    options = prepareOptions(options);

    if (!features.astral && options.astral) {
        setAstral(true);
    }

    if (!features.natives && options.natives) {
        setNatives(true);
    }
};

/**
 * Checks whether an individual optional feature is installed.
 *
 * @memberOf XRegExp
 * @param {String} feature Name of the feature to check. One of:
 *   - `astral`
 *   - `natives`
 * @returns {Boolean} Whether the feature is installed.
 * @example
 *
 * XRegExp.isInstalled('astral');
 */
XRegExp.isInstalled = function(feature) {
    return !!(features[feature]);
};

/**
 * Returns `true` if an object is a regex; `false` if it isn't. This works correctly for regexes
 * created in another frame, when `instanceof` and `constructor` checks would fail.
 *
 * @memberOf XRegExp
 * @param {*} value Object to check.
 * @returns {Boolean} Whether the object is a `RegExp` object.
 * @example
 *
 * XRegExp.isRegExp('string'); // -> false
 * XRegExp.isRegExp(/regex/i); // -> true
 * XRegExp.isRegExp(RegExp('^', 'm')); // -> true
 * XRegExp.isRegExp(XRegExp('(?s).')); // -> true
 */
XRegExp.isRegExp = function(value) {
    return toString.call(value) === '[object RegExp]';
    //return isType(value, 'RegExp');
};

/**
 * Returns the first matched string, or in global mode, an array containing all matched strings.
 * This is essentially a more convenient re-implementation of `String.prototype.match` that gives
 * the result types you actually want (string instead of `exec`-style array in match-first mode,
 * and an empty array instead of `null` when no matches are found in match-all mode). It also lets
 * you override flag g and ignore `lastIndex`, and fixes browser bugs.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {String} [scope='one'] Use 'one' to return the first match as a string. Use 'all' to
 *   return an array of all matched strings. If not explicitly specified and `regex` uses flag g,
 *   `scope` is 'all'.
 * @returns {String|Array} In match-first mode: First match as a string, or `null`. In match-all
 *   mode: Array of all matched strings, or an empty array.
 * @example
 *
 * // Match first
 * XRegExp.match('abc', /\w/); // -> 'a'
 * XRegExp.match('abc', /\w/g, 'one'); // -> 'a'
 * XRegExp.match('abc', /x/g, 'one'); // -> null
 *
 * // Match all
 * XRegExp.match('abc', /\w/g); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /\w/, 'all'); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /x/, 'all'); // -> []
 */
XRegExp.match = function(str, regex, scope) {
    var global = (regex.global && scope !== 'one') || scope === 'all';
    var cacheKey = ((global ? 'g' : '') + (regex.sticky ? 'y' : '')) || 'noGY';
    var result;
    var r2;

    regex[REGEX_DATA] = regex[REGEX_DATA] || {};

    // Shares cached copies with `XRegExp.exec`/`replace`
    r2 = regex[REGEX_DATA][cacheKey] || (
        regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
            addG: !!global,
            removeG: scope === 'one',
            isInternalOnly: true
        })
    );

    result = nativ.match.call(toObject(str), r2);

    if (regex.global) {
        regex.lastIndex = (
            (scope === 'one' && result) ?
                // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
                (result.index + result[0].length) : 0
        );
    }

    return global ? (result || []) : (result && result[0]);
};

/**
 * Retrieves the matches from searching a string using a chain of regexes that successively search
 * within previous matches. The provided `chain` array can contain regexes and or objects with
 * `regex` and `backref` properties. When a backreference is specified, the named or numbered
 * backreference is passed forward to the next regex or returned.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} chain Regexes that each search for matches within preceding results.
 * @returns {Array} Matches by the last regex in the chain, or an empty array.
 * @example
 *
 * // Basic usage; matches numbers within <b> tags
 * XRegExp.matchChain('1 <b>2</b> 3 <b>4 a 56</b>', [
 *   XRegExp('(?is)<b>.*?</b>'),
 *   /\d+/
 * ]);
 * // -> ['2', '4', '56']
 *
 * // Passing forward and returning specific backreferences
 * html = '<a href="http://xregexp.com/api/">XRegExp</a>\
 *         <a href="http://www.google.com/">Google</a>';
 * XRegExp.matchChain(html, [
 *   {regex: /<a href="([^"]+)">/i, backref: 1},
 *   {regex: XRegExp('(?i)^https?://(?<domain>[^/?#]+)'), backref: 'domain'}
 * ]);
 * // -> ['xregexp.com', 'www.google.com']
 */
XRegExp.matchChain = function(str, chain) {
    return (function recurseChain(values, level) {
        var item = chain[level].regex ? chain[level] : {regex: chain[level]};
        var matches = [];

        function addMatch(match) {
            if (item.backref) {
                // Safari 4.0.5 (but not 5.0.5+) inappropriately uses sparse arrays to hold the
                // `undefined`s for backreferences to nonparticipating capturing groups. In such
                // cases, a `hasOwnProperty` or `in` check on its own would inappropriately throw
                // the exception, so also check if the backreference is a number that is within the
                // bounds of the array.
                if (!(match.hasOwnProperty(item.backref) || +item.backref < match.length)) {
                    throw new ReferenceError('Backreference to undefined group: ' + item.backref);
                }

                matches.push(match[item.backref] || '');
            } else {
                matches.push(match[0]);
            }
        }

        for (var i = 0; i < values.length; ++i) {
            XRegExp.forEach(values[i], item.regex, addMatch);
        }

        return ((level === chain.length - 1) || !matches.length) ?
            matches :
            recurseChain(matches, level + 1);
    }([str], 0));
};

/**
 * Returns a new string with one or all matches of a pattern replaced. The pattern can be a string
 * or regex, and the replacement can be a string or a function to be called for each match. To
 * perform a global search and replace, use the optional `scope` argument or include flag g if using
 * a regex. Replacement strings can use `${n}` for named and numbered backreferences. Replacement
 * functions can use named backreferences via `arguments[0].name`. Also fixes browser bugs compared
 * to the native `String.prototype.replace` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 *   Replacement strings can include special replacement syntax:
 *     - $$ - Inserts a literal $ character.
 *     - $&, $0 - Inserts the matched substring.
 *     - $` - Inserts the string that precedes the matched substring (left context).
 *     - $' - Inserts the string that follows the matched substring (right context).
 *     - $n, $nn - Where n/nn are digits referencing an existent capturing group, inserts
 *       backreference n/nn.
 *     - ${n} - Where n is a name or any number of digits that reference an existent capturing
 *       group, inserts backreference n.
 *   Replacement functions are invoked with three or more arguments:
 *     - The matched substring (corresponds to $& above). Named backreferences are accessible as
 *       properties of this first argument.
 *     - 0..n arguments, one for each backreference (corresponding to $1, $2, etc. above).
 *     - The zero-based index of the match within the total search string.
 *     - The total string being searched.
 * @param {String} [scope='one'] Use 'one' to replace the first match only, or 'all'. If not
 *   explicitly specified and using a regex with flag g, `scope` is 'all'.
 * @returns {String} New string with one or all matches replaced.
 * @example
 *
 * // Regex search, using named backreferences in replacement string
 * var name = XRegExp('(?<first>\\w+) (?<last>\\w+)');
 * XRegExp.replace('John Smith', name, '${last}, ${first}');
 * // -> 'Smith, John'
 *
 * // Regex search, using named backreferences in replacement function
 * XRegExp.replace('John Smith', name, function(match) {
 *   return match.last + ', ' + match.first;
 * });
 * // -> 'Smith, John'
 *
 * // String search, with replace-all
 * XRegExp.replace('RegExp builds RegExps', 'RegExp', 'XRegExp', 'all');
 * // -> 'XRegExp builds XRegExps'
 */
XRegExp.replace = function(str, search, replacement, scope) {
    var isRegex = XRegExp.isRegExp(search);
    var global = (search.global && scope !== 'one') || scope === 'all';
    var cacheKey = ((global ? 'g' : '') + (search.sticky ? 'y' : '')) || 'noGY';
    var s2 = search;
    var result;

    if (isRegex) {
        search[REGEX_DATA] = search[REGEX_DATA] || {};

        // Shares cached copies with `XRegExp.exec`/`match`. Since a copy is used, `search`'s
        // `lastIndex` isn't updated *during* replacement iterations
        s2 = search[REGEX_DATA][cacheKey] || (
            search[REGEX_DATA][cacheKey] = copyRegex(search, {
                addG: !!global,
                removeG: scope === 'one',
                isInternalOnly: true
            })
        );
    } else if (global) {
        s2 = new RegExp(XRegExp.escape(String(search)), 'g');
    }

    // Fixed `replace` required for named backreferences, etc.
    result = fixed.replace.call(toObject(str), s2, replacement);

    if (isRegex && search.global) {
        // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
        search.lastIndex = 0;
    }

    return result;
};

/**
 * Performs batch processing of string replacements. Used like `XRegExp.replace`, but accepts an
 * array of replacement details. Later replacements operate on the output of earlier replacements.
 * Replacement details are accepted as an array with a regex or string to search for, the
 * replacement string or function, and an optional scope of 'one' or 'all'. Uses the XRegExp
 * replacement text syntax, which supports named backreference properties via `${name}`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} replacements Array of replacement detail arrays.
 * @returns {String} New string with all replacements.
 * @example
 *
 * str = XRegExp.replaceEach(str, [
 *   [XRegExp('(?<name>a)'), 'z${name}'],
 *   [/b/gi, 'y'],
 *   [/c/g, 'x', 'one'], // scope 'one' overrides /g
 *   [/d/, 'w', 'all'],  // scope 'all' overrides lack of /g
 *   ['e', 'v', 'all'],  // scope 'all' allows replace-all for strings
 *   [/f/g, function($0) {
 *     return $0.toUpperCase();
 *   }]
 * ]);
 */
XRegExp.replaceEach = function(str, replacements) {
    var i;
    var r;

    for (i = 0; i < replacements.length; ++i) {
        r = replacements[i];
        str = XRegExp.replace(str, r[0], r[1], r[2]);
    }

    return str;
};

/**
 * Splits a string into an array of strings using a regex or string separator. Matches of the
 * separator are not included in the result array. However, if `separator` is a regex that contains
 * capturing groups, backreferences are spliced into the result each time `separator` is matched.
 * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
 * cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to split.
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 * @example
 *
 * // Basic use
 * XRegExp.split('a b c', ' ');
 * // -> ['a', 'b', 'c']
 *
 * // With limit
 * XRegExp.split('a b c', ' ', 2);
 * // -> ['a', 'b']
 *
 * // Backreferences in result array
 * XRegExp.split('..word1..', /([a-z]+)(\d+)/i);
 * // -> ['..', 'word', '1', '..']
 */
XRegExp.split = function(str, separator, limit) {
    return fixed.split.call(toObject(str), separator, limit);
};

/**
 * Executes a regex search in a specified string. Returns `true` or `false`. Optional `pos` and
 * `sticky` arguments specify the search start position, and whether the match must start at the
 * specified position only. The `lastIndex` property of the provided regex is not used, but is
 * updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.test` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {Boolean} Whether the regex matched the provided value.
 * @example
 *
 * // Basic use
 * XRegExp.test('abc', /c/); // -> true
 *
 * // With pos and sticky
 * XRegExp.test('abc', /c/, 0, 'sticky'); // -> false
 * XRegExp.test('abc', /c/, 2, 'sticky'); // -> true
 */
XRegExp.test = function(str, regex, pos, sticky) {
    // Do this the easy way :-)
    return !!XRegExp.exec(str, regex, pos, sticky);
};

/**
 * Uninstalls optional features according to the specified options. All optional features start out
 * uninstalled, so this is used to undo the actions of `XRegExp.install`.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.uninstall({
 *   // Disables support for astral code points in Unicode addons
 *   astral: true,
 *
 *   // DEPRECATED: Restores native regex methods
 *   natives: true
 * });
 *
 * // With an options string
 * XRegExp.uninstall('astral natives');
 */
XRegExp.uninstall = function(options) {
    options = prepareOptions(options);

    if (features.astral && options.astral) {
        setAstral(false);
    }

    if (features.natives && options.natives) {
        setNatives(false);
    }
};

/**
 * Returns an XRegExp object that is the union of the given patterns. Patterns can be provided as
 * regex objects or strings. Metacharacters are escaped in patterns provided as strings.
 * Backreferences in provided regex objects are automatically renumbered to work correctly within
 * the larger combined pattern. Native flags used by provided regexes are ignored in favor of the
 * `flags` argument.
 *
 * @memberOf XRegExp
 * @param {Array} patterns Regexes and strings to combine.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @param {Object} [options] Options object with optional properties:
 *   - `conjunction` {String} Type of conjunction to use: 'or' (default) or 'none'.
 * @returns {RegExp} Union of the provided regexes and strings.
 * @example
 *
 * XRegExp.union(['a+b*c', /(dogs)\1/, /(cats)\1/], 'i');
 * // -> /a\+b\*c|(dogs)\1|(cats)\2/i
 *
 * XRegExp.union([/man/, /bear/, /pig/], 'i', {conjunction: 'none'});
 * // -> /manbearpig/i
 */
XRegExp.union = function(patterns, flags, options) {
    options = options || {};
    var conjunction = options.conjunction || 'or';
    var numCaptures = 0;
    var numPriorCaptures;
    var captureNames;

    function rewrite(match, paren, backref) {
        var name = captureNames[numCaptures - numPriorCaptures];

        // Capturing group
        if (paren) {
            ++numCaptures;
            // If the current capture has a name, preserve the name
            if (name) {
                return '(?<' + name + '>';
            }
        // Backreference
        } else if (backref) {
            // Rewrite the backreference
            return '\\' + (+backref + numPriorCaptures);
        }

        return match;
    }

    if (!(isType(patterns, 'Array') && patterns.length)) {
        throw new TypeError('Must provide a nonempty array of patterns to merge');
    }

    var parts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
    var output = [];
    var pattern;
    for (var i = 0; i < patterns.length; ++i) {
        pattern = patterns[i];

        if (XRegExp.isRegExp(pattern)) {
            numPriorCaptures = numCaptures;
            captureNames = (pattern[REGEX_DATA] && pattern[REGEX_DATA].captureNames) || [];

            // Rewrite backreferences. Passing to XRegExp dies on octals and ensures patterns are
            // independently valid; helps keep this simple. Named captures are put back
            output.push(nativ.replace.call(XRegExp(pattern.source).source, parts, rewrite));
        } else {
            output.push(XRegExp.escape(pattern));
        }
    }

    var separator = conjunction === 'none' ? '' : '|';
    return XRegExp(output.join(separator), flags);
};

// ==--------------------------==
// Fixed/extended native methods
// ==--------------------------==

/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `RegExp.prototype.exec`. Calling `XRegExp.install('natives')` uses this to
 * override the native method. Use via `XRegExp.exec` without overriding natives.
 *
 * @memberOf RegExp
 * @param {String} str String to search.
 * @returns {Array} Match array with named backreference properties, or `null`.
 */
fixed.exec = function(str) {
    var origLastIndex = this.lastIndex;
    var match = nativ.exec.apply(this, arguments);
    var name;
    var r2;
    var i;

    if (match) {
        // Fix browsers whose `exec` methods don't return `undefined` for nonparticipating capturing
        // groups. This fixes IE 5.5-8, but not IE 9's quirks mode or emulation of older IEs. IE 9
        // in standards mode follows the spec.
        if (!correctExecNpcg && match.length > 1 && indexOf(match, '') > -1) {
            r2 = copyRegex(this, {
                removeG: true,
                isInternalOnly: true
            });
            // Using `str.slice(match.index)` rather than `match[0]` in case lookahead allowed
            // matching due to characters outside the match
            nativ.replace.call(String(str).slice(match.index), r2, function() {
                var len = arguments.length;
                var i;
                // Skip index 0 and the last 2
                for (i = 1; i < len - 2; ++i) {
                    if (arguments[i] === undefined) {
                        match[i] = undefined;
                    }
                }
            });
        }

        // Attach named capture properties
        if (this[REGEX_DATA] && this[REGEX_DATA].captureNames) {
            // Skip index 0
            for (i = 1; i < match.length; ++i) {
                name = this[REGEX_DATA].captureNames[i - 1];
                if (name) {
                    match[name] = match[i];
                }
            }
        }

        // Fix browsers that increment `lastIndex` after zero-length matches
        if (this.global && !match[0].length && (this.lastIndex > match.index)) {
            this.lastIndex = match.index;
        }
    }

    if (!this.global) {
        // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
        this.lastIndex = origLastIndex;
    }

    return match;
};

/**
 * Fixes browser bugs in the native `RegExp.prototype.test`. Calling `XRegExp.install('natives')`
 * uses this to override the native method.
 *
 * @memberOf RegExp
 * @param {String} str String to search.
 * @returns {Boolean} Whether the regex matched the provided value.
 */
fixed.test = function(str) {
    // Do this the easy way :-)
    return !!fixed.exec.call(this, str);
};

/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `String.prototype.match`. Calling `XRegExp.install('natives')` uses this to
 * override the native method.
 *
 * @memberOf String
 * @param {RegExp|*} regex Regex to search with. If not a regex object, it is passed to `RegExp`.
 * @returns {Array} If `regex` uses flag g, an array of match strings or `null`. Without flag g,
 *   the result of calling `regex.exec(this)`.
 */
fixed.match = function(regex) {
    var result;

    if (!XRegExp.isRegExp(regex)) {
        // Use the native `RegExp` rather than `XRegExp`
        regex = new RegExp(regex);
    } else if (regex.global) {
        result = nativ.match.apply(this, arguments);
        // Fixes IE bug
        regex.lastIndex = 0;

        return result;
    }

    return fixed.exec.call(regex, toObject(this));
};

/**
 * Adds support for `${n}` tokens for named and numbered backreferences in replacement text, and
 * provides named backreferences to replacement functions as `arguments[0].name`. Also fixes browser
 * bugs in replacement text syntax when performing a replacement using a nonregex search value, and
 * the value of a replacement regex's `lastIndex` property during replacement iterations and upon
 * completion. Calling `XRegExp.install('natives')` uses this to override the native method. Note
 * that this doesn't support SpiderMonkey's proprietary third (`flags`) argument. Use via
 * `XRegExp.replace` without overriding natives.
 *
 * @memberOf String
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 * @returns {String} New string with one or all matches replaced.
 */
fixed.replace = function(search, replacement) {
    var isRegex = XRegExp.isRegExp(search);
    var origLastIndex;
    var captureNames;
    var result;

    if (isRegex) {
        if (search[REGEX_DATA]) {
            captureNames = search[REGEX_DATA].captureNames;
        }
        // Only needed if `search` is nonglobal
        origLastIndex = search.lastIndex;
    } else {
        search += ''; // Type-convert
    }

    // Don't use `typeof`; some older browsers return 'function' for regex objects
    if (isType(replacement, 'Function')) {
        // Stringifying `this` fixes a bug in IE < 9 where the last argument in replacement
        // functions isn't type-converted to a string
        result = nativ.replace.call(String(this), search, function() {
            var args = arguments;
            var i;
            if (captureNames) {
                // Change the `arguments[0]` string primitive to a `String` object that can store
                // properties. This really does need to use `String` as a constructor
                args[0] = new String(args[0]);
                // Store named backreferences on the first argument
                for (i = 0; i < captureNames.length; ++i) {
                    if (captureNames[i]) {
                        args[0][captureNames[i]] = args[i + 1];
                    }
                }
            }
            // Update `lastIndex` before calling `replacement`. Fixes IE, Chrome, Firefox, Safari
            // bug (last tested IE 9, Chrome 17, Firefox 11, Safari 5.1)
            if (isRegex && search.global) {
                search.lastIndex = args[args.length - 2] + args[0].length;
            }
            // ES6 specs the context for replacement functions as `undefined`
            return replacement.apply(undefined, args);
        });
    } else {
        // Ensure that the last value of `args` will be a string when given nonstring `this`,
        // while still throwing on null or undefined context
        result = nativ.replace.call(this == null ? this : String(this), search, function() {
            // Keep this function's `arguments` available through closure
            var args = arguments;
            return nativ.replace.call(String(replacement), replacementToken, function($0, $1, $2) {
                var n;
                // Named or numbered backreference with curly braces
                if ($1) {
                    // XRegExp behavior for `${n}`:
                    // 1. Backreference to numbered capture, if `n` is an integer. Use `0` for the
                    //    entire match. Any number of leading zeros may be used.
                    // 2. Backreference to named capture `n`, if it exists and is not an integer
                    //    overridden by numbered capture. In practice, this does not overlap with
                    //    numbered capture since XRegExp does not allow named capture to use a bare
                    //    integer as the name.
                    // 3. If the name or number does not refer to an existing capturing group, it's
                    //    an error.
                    n = +$1; // Type-convert; drop leading zeros
                    if (n <= args.length - 3) {
                        return args[n] || '';
                    }
                    // Groups with the same name is an error, else would need `lastIndexOf`
                    n = captureNames ? indexOf(captureNames, $1) : -1;
                    if (n < 0) {
                        throw new SyntaxError('Backreference to undefined group ' + $0);
                    }
                    return args[n + 1] || '';
                }
                // Else, special variable or numbered backreference without curly braces
                if ($2 === '$') { // $$
                    return '$';
                }
                if ($2 === '&' || +$2 === 0) { // $&, $0 (not followed by 1-9), $00
                    return args[0];
                }
                if ($2 === '`') { // $` (left context)
                    return args[args.length - 1].slice(0, args[args.length - 2]);
                }
                if ($2 === "'") { // $' (right context)
                    return args[args.length - 1].slice(args[args.length - 2] + args[0].length);
                }
                // Else, numbered backreference without curly braces
                $2 = +$2; // Type-convert; drop leading zero
                // XRegExp behavior for `$n` and `$nn`:
                // - Backrefs end after 1 or 2 digits. Use `${..}` for more digits.
                // - `$1` is an error if no capturing groups.
                // - `$10` is an error if less than 10 capturing groups. Use `${1}0` instead.
                // - `$01` is `$1` if at least one capturing group, else it's an error.
                // - `$0` (not followed by 1-9) and `$00` are the entire match.
                // Native behavior, for comparison:
                // - Backrefs end after 1 or 2 digits. Cannot reference capturing group 100+.
                // - `$1` is a literal `$1` if no capturing groups.
                // - `$10` is `$1` followed by a literal `0` if less than 10 capturing groups.
                // - `$01` is `$1` if at least one capturing group, else it's a literal `$01`.
                // - `$0` is a literal `$0`.
                if (!isNaN($2)) {
                    if ($2 > args.length - 3) {
                        throw new SyntaxError('Backreference to undefined group ' + $0);
                    }
                    return args[$2] || '';
                }
                // `$` followed by an unsupported char is an error, unlike native JS
                throw new SyntaxError('Invalid token ' + $0);
            });
        });
    }

    if (isRegex) {
        if (search.global) {
            // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
            search.lastIndex = 0;
        } else {
            // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
            search.lastIndex = origLastIndex;
        }
    }

    return result;
};

/**
 * Fixes browser bugs in the native `String.prototype.split`. Calling `XRegExp.install('natives')`
 * uses this to override the native method. Use via `XRegExp.split` without overriding natives.
 *
 * @memberOf String
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 */
fixed.split = function(separator, limit) {
    if (!XRegExp.isRegExp(separator)) {
        // Browsers handle nonregex split correctly, so use the faster native method
        return nativ.split.apply(this, arguments);
    }

    var str = String(this);
    var output = [];
    var origLastIndex = separator.lastIndex;
    var lastLastIndex = 0;
    var lastLength;

    // Values for `limit`, per the spec:
    // If undefined: pow(2,32) - 1
    // If 0, Infinity, or NaN: 0
    // If positive number: limit = floor(limit); if (limit >= pow(2,32)) limit -= pow(2,32);
    // If negative number: pow(2,32) - floor(abs(limit))
    // If other: Type-convert, then use the above rules
    // This line fails in very strange ways for some values of `limit` in Opera 10.5-10.63, unless
    // Opera Dragonfly is open (go figure). It works in at least Opera 9.5-10.1 and 11+
    limit = (limit === undefined ? -1 : limit) >>> 0;

    XRegExp.forEach(str, separator, function(match) {
        // This condition is not the same as `if (match[0].length)`
        if ((match.index + match[0].length) > lastLastIndex) {
            output.push(str.slice(lastLastIndex, match.index));
            if (match.length > 1 && match.index < str.length) {
                Array.prototype.push.apply(output, match.slice(1));
            }
            lastLength = match[0].length;
            lastLastIndex = match.index + lastLength;
        }
    });

    if (lastLastIndex === str.length) {
        if (!nativ.test.call(separator, '') || lastLength) {
            output.push('');
        }
    } else {
        output.push(str.slice(lastLastIndex));
    }

    separator.lastIndex = origLastIndex;
    return output.length > limit ? output.slice(0, limit) : output;
};

// ==--------------------------==
// Built-in syntax/flag tokens
// ==--------------------------==

/*
 * Letter escapes that natively match literal characters: `\a`, `\A`, etc. These should be
 * SyntaxErrors but are allowed in web reality. XRegExp makes them errors for cross-browser
 * consistency and to reserve their syntax, but lets them be superseded by addons.
 */
XRegExp.addToken(
    /\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/,
    function(match, scope) {
        // \B is allowed in default scope only
        if (match[1] === 'B' && scope === defaultScope) {
            return match[0];
        }
        throw new SyntaxError('Invalid escape ' + match[0]);
    },
    {
        scope: 'all',
        leadChar: '\\'
    }
);

/*
 * Unicode code point escape with curly braces: `\u{N..}`. `N..` is any one or more digit
 * hexadecimal number from 0-10FFFF, and can include leading zeros. Requires the native ES6 `u` flag
 * to support code points greater than U+FFFF. Avoids converting code points above U+FFFF to
 * surrogate pairs (which could be done without flag `u`), since that could lead to broken behavior
 * if you follow a `\u{N..}` token that references a code point above U+FFFF with a quantifier, or
 * if you use the same in a character class.
 */
XRegExp.addToken(
    /\\u{([\dA-Fa-f]+)}/,
    function(match, scope, flags) {
        var code = dec(match[1]);
        if (code > 0x10FFFF) {
            throw new SyntaxError('Invalid Unicode code point ' + match[0]);
        }
        if (code <= 0xFFFF) {
            // Converting to \uNNNN avoids needing to escape the literal character and keep it
            // separate from preceding tokens
            return '\\u' + pad4(hex(code));
        }
        // If `code` is between 0xFFFF and 0x10FFFF, require and defer to native handling
        if (hasNativeU && flags.indexOf('u') > -1) {
            return match[0];
        }
        throw new SyntaxError('Cannot use Unicode code point above \\u{FFFF} without flag u');
    },
    {
        scope: 'all',
        leadChar: '\\'
    }
);

/*
 * Empty character class: `[]` or `[^]`. This fixes a critical cross-browser syntax inconsistency.
 * Unless this is standardized (per the ES spec), regex syntax can't be accurately parsed because
 * character class endings can't be determined.
 */
XRegExp.addToken(
    /\[(\^?)\]/,
    function(match) {
        // For cross-browser compatibility with ES3, convert [] to \b\B and [^] to [\s\S].
        // (?!) should work like \b\B, but is unreliable in some versions of Firefox
        return match[1] ? '[\\s\\S]' : '\\b\\B';
    },
    {leadChar: '['}
);

/*
 * Comment pattern: `(?# )`. Inline comments are an alternative to the line comments allowed in
 * free-spacing mode (flag x).
 */
XRegExp.addToken(
    /\(\?#[^)]*\)/,
    getContextualTokenSeparator,
    {leadChar: '('}
);

/*
 * Whitespace and line comments, in free-spacing mode (aka extended mode, flag x) only.
 */
XRegExp.addToken(
    /\s+|#[^\n]*\n?/,
    getContextualTokenSeparator,
    {flag: 'x'}
);

/*
 * Dot, in dotall mode (aka singleline mode, flag s) only.
 */
XRegExp.addToken(
    /\./,
    function() {
        return '[\\s\\S]';
    },
    {
        flag: 's',
        leadChar: '.'
    }
);

/*
 * Named backreference: `\k<name>`. Backreference names can use the characters A-Z, a-z, 0-9, _,
 * and $ only. Also allows numbered backreferences as `\k<n>`.
 */
XRegExp.addToken(
    /\\k<([\w$]+)>/,
    function(match) {
        // Groups with the same name is an error, else would need `lastIndexOf`
        var index = isNaN(match[1]) ? (indexOf(this.captureNames, match[1]) + 1) : +match[1];
        var endIndex = match.index + match[0].length;
        if (!index || index > this.captureNames.length) {
            throw new SyntaxError('Backreference to undefined group ' + match[0]);
        }
        // Keep backreferences separate from subsequent literal numbers. This avoids e.g.
        // inadvertedly changing `(?<n>)\k<n>1` to `()\11`.
        return '\\' + index + (
            endIndex === match.input.length || isNaN(match.input.charAt(endIndex)) ?
                '' : '(?:)'
        );
    },
    {leadChar: '\\'}
);

/*
 * Numbered backreference or octal, plus any following digits: `\0`, `\11`, etc. Octals except `\0`
 * not followed by 0-9 and backreferences to unopened capture groups throw an error. Other matches
 * are returned unaltered. IE < 9 doesn't support backreferences above `\99` in regex syntax.
 */
XRegExp.addToken(
    /\\(\d+)/,
    function(match, scope) {
        if (
            !(
                scope === defaultScope &&
                /^[1-9]/.test(match[1]) &&
                +match[1] <= this.captureNames.length
            ) &&
            match[1] !== '0'
        ) {
            throw new SyntaxError('Cannot use octal escape or backreference to undefined group ' +
                match[0]);
        }
        return match[0];
    },
    {
        scope: 'all',
        leadChar: '\\'
    }
);

/*
 * Named capturing group; match the opening delimiter only: `(?<name>`. Capture names can use the
 * characters A-Z, a-z, 0-9, _, and $ only. Names can't be integers. Supports Python-style
 * `(?P<name>` as an alternate syntax to avoid issues in some older versions of Opera which natively
 * supported the Python-style syntax. Otherwise, XRegExp might treat numbered backreferences to
 * Python-style named capture as octals.
 */
XRegExp.addToken(
    /\(\?P?<([\w$]+)>/,
    function(match) {
        // Disallow bare integers as names because named backreferences are added to match arrays
        // and therefore numeric properties may lead to incorrect lookups
        if (!isNaN(match[1])) {
            throw new SyntaxError('Cannot use integer as capture name ' + match[0]);
        }
        if (match[1] === 'length' || match[1] === '__proto__') {
            throw new SyntaxError('Cannot use reserved word as capture name ' + match[0]);
        }
        if (indexOf(this.captureNames, match[1]) > -1) {
            throw new SyntaxError('Cannot use same name for multiple groups ' + match[0]);
        }
        this.captureNames.push(match[1]);
        this.hasNamedCapture = true;
        return '(';
    },
    {leadChar: '('}
);

/*
 * Capturing group; match the opening parenthesis only. Required for support of named capturing
 * groups. Also adds explicit capture mode (flag n).
 */
XRegExp.addToken(
    /\((?!\?)/,
    function(match, scope, flags) {
        if (flags.indexOf('n') > -1) {
            return '(?:';
        }
        this.captureNames.push(null);
        return '(';
    },
    {
        optionalFlags: 'n',
        leadChar: '('
    }
);

module.exports = XRegExp;

},{}]},{},[8])(8)
});
}(xregexpAll));

/*
    ***** BEGIN LICENSE BLOCK *****
    
    Copyright © 2009 Center for History and New Media
                     George Mason University, Fairfax, Virginia, USA
                     http://zotero.org
    
    This file is part of Zotero.
    
    Zotero is free software: you can redistribute it and/or modify
    it under the terms of the GNU Affero General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    
    Zotero is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Affero General Public License for more details.
    
    You should have received a copy of the GNU Affero General Public License
    along with Zotero.  If not, see <http://www.gnu.org/licenses/>.
    
	
	Utilities based in part on code taken from Piggy Bank 2.1.1 (BSD-licensed)
	
    ***** END LICENSE BLOCK *****
*/

(function (module) {
(function() {

function movedToUtilitiesInternal(fnName) {
	return function () {
		if (Zotero.Utilities && Zotero.Utilities.Internal) {
			Zotero.debug(`Zotero.Utilities.${fnName}() is deprecated -- use Zotero.Utilities.Internal.${fnName}() instead`);
			return Zotero.Utilities.Internal[fnName].apply(Zotero.Utilities.Internal, arguments);
		} else {
			throw new Error(`Zotero.Utilities.${fnName}() is only available in the zotero-client codebase`)
		}
	}
}

/**
 * @class Functions for text manipulation and other miscellaneous purposes
 */
var Utilities = {
	/**
	 * Returns a function which will execute `fn` with provided arguments after `delay` milliseconds and not more
	 * than once, if called multiple times. See
	 * http://stackoverflow.com/questions/24004791/can-someone-explain-the-debounce-function-in-javascript
	 * @param fn {Function} function to debounce
	 * @param delay {Integer} number of milliseconds to delay the function execution
	 * @returns {Function}
	 */
	debounce: function(fn, delay=500) {
		var timer = null;
		return function () {
			let args = arguments;
			clearTimeout(timer);
			timer = setTimeout(function () {
				fn.apply(this, args);
			}.bind(this), delay);
		};
	},

	/**
	 *  Creates and returns a new, throttled version of the
	 *  passed function, that, when invoked repeatedly,
	 *  will only actually call the original function at most
	 *  once per every wait milliseconds
	 *
	 *  By default, throttle will execute the function as soon
	 *  as you call it for the first time, and, if you call it
	 *  again any number of times during the wait period, as soon
	 *  as that period is over. If you'd like to disable the
	 *  leading-edge call, pass {leading: false}, and if you'd
	 *  like to disable the execution on the trailing-edge,
	 *  pass {trailing: false}. See
	 *  https://underscorejs.org/#throttle
	 *  https://github.com/jashkenas/underscore/blob/master/underscore.js
	 *  (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 *  Underscore may be freely distributed under the MIT license.
	 *
	 *  @param {Function} func Function to throttle
	 *  @param {Integer} wait Wait period in milliseconds
	 *  @param {Boolean} [options.leading] Call at the beginning of the wait period
	 *  @param {Boolean} [options.trailing] Call at the end of the wait period
	 */
	throttle: function (func, wait, options) {
		var context, args, result;
		var timeout = null;
		var previous = 0;
		if (!options) options = {};
		var later = function () {
			previous = options.leading === false ? 0 : Date.now();
			timeout = null;
			result = func.apply(context, args);
			if (!timeout) context = args = null;
		};
		return function () {
			var now = Date.now();
			if (!previous && options.leading === false) previous = now;
			var remaining = wait - (now - previous);
			context = this;
			args = arguments;
			if (remaining <= 0 || remaining > wait) {
				if (timeout) {
					clearTimeout(timeout);
					timeout = null;
				}
				previous = now;
				result = func.apply(context, args);
				if (!timeout) context = args = null;
			}
			else if (!timeout && options.trailing !== false) {
				timeout = setTimeout(later, remaining);
			}
			return result;
		};
	},

	/**
	 * Fixes author name capitalization.
	 * Currently for all uppercase names only
	 *
	 * JOHN -> John
	 * GUTIÉRREZ-ALBILLA -> Gutiérrez-Albilla
	 * O'NEAL -> O'Neal
	 *
	 * @param {String} string Uppercase author name
	 * @return {String} Title-cased author name
	 */
	capitalizeName: function (string) {
		if (typeof string === "string" && string.toUpperCase() === string) {
			string = Utilities.XRegExp.replace(
				string.toLowerCase(),
				Utilities.XRegExp('(^|[^\\pL])\\pL', 'g'),
				m => m.toUpperCase()
			);
		}
		return string;
	},

	/**
	 * Cleans extraneous punctuation off a creator name and parse into first and last name
	 *
	 * @param {String} author Creator string
	 * @param {String} type Creator type string (e.g., "author" or "editor")
	 * @param {Boolean} useComma Whether the creator string is in inverted (Last, First) format
	 * @return {Object} firstName, lastName, and creatorType
	 */
	cleanAuthor: function(author, type, useComma) {
		var allCaps = 'A-Z' +
			'\u0400-\u042f';		//cyrilic

		var allCapsRe = new RegExp('^[' + allCaps + ']+$');
		var initialRe = new RegExp('^-?[' + allCaps + ']$');

		if(typeof(author) != "string") {
			throw new Error("cleanAuthor: author must be a string");
		}

		author = author.replace(/^[\s\u00A0\.\,\/\[\]\:]+/, '')
			.replace(/[\s\u00A0\.\,\/\[\]\:]+$/, '')
			.replace(/[\s\u00A0]+/, ' ');

		if(useComma) {
			// Add spaces between periods
			author = author.replace(/\.([^ ])/, ". $1");

			var splitNames = author.split(/[,،] ?/);
			if(splitNames.length > 1) {
				var lastName = splitNames[0];
				var firstName = splitNames[1];
			} else {
				var lastName = author;
			}
		} else {
			// Don't parse "Firstname Lastname [Country]" as "[Country], Firstname Lastname"
			var spaceIndex = author.length;
			do {
				spaceIndex = author.lastIndexOf(" ", spaceIndex-1);
				var lastName = author.substring(spaceIndex + 1);
				var firstName = author.substring(0, spaceIndex);
			} while (!Utilities.XRegExp('\\pL').test(lastName[0]) && spaceIndex > 0)
		}

		if(firstName && allCapsRe.test(firstName) &&
			firstName.length < 4 &&
			(firstName.length == 1 || lastName.toUpperCase() != lastName)) {
			// first name is probably initials
			var newFirstName = "";
			for(var i=0; i<firstName.length; i++) {
				newFirstName += " "+firstName[i]+".";
			}
			firstName = newFirstName.substr(1);
		}

		//add periods after all the initials
		if(firstName) {
			var names = firstName.replace(/^[\s\.]+/,'')
				.replace(/[\s\,]+$/,'')
				//remove spaces surronding any dashes
				.replace(/\s*([\u002D\u00AD\u2010-\u2015\u2212\u2E3A\u2E3B])\s*/,'-')
				.split(/(?:[\s\.]+|(?=-))/);
			var newFirstName = '';
			for(var i=0, n=names.length; i<n; i++) {
				newFirstName += names[i];
				if(initialRe.test(names[i])) newFirstName += '.';
				newFirstName += ' ';
			}
			firstName = newFirstName.replace(/ -/g,'-').trim();
		}

		return {firstName:firstName, lastName:lastName, creatorType:type};
	},

	/**
	 * Removes leading and trailing whitespace from a string
	 * @type String
	 */
	trim: function(/**String*/ s) {
		if (typeof(s) != "string") {
			throw new Error("trim: argument must be a string");
		}

		s = s.replace(/^\s+/, "");
		return s.replace(/\s+$/, "");
	},

	/**
	 * Cleans whitespace off a string and replaces multiple spaces with one
	 * @type String
	 */
	trimInternal: function(/**String*/ s) {
		if (typeof(s) != "string") {
			throw new Error("trimInternal: argument must be a string");
		}

		s = s.replace(/[\xA0\r\n\s]+/g, " ");
		return this.trim(s);
	},

	/**
	 * Cleans any non-word non-parenthesis characters off the ends of a string
	 * @type String
	 */
	superCleanString: function(/**String*/ x) {
		if(typeof(x) != "string") {
			throw new Error("superCleanString: argument must be a string");
		}

		var x = x.replace(/^[\x00-\x27\x29-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F\s]+/, "");
		return x.replace(/[\x00-\x28\x2A-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F\s]+$/, "");
	},

	isHTTPURL: function (url, allowNoScheme = false) {
		// From https://stackoverflow.com/a/3809435
		var noSchemeRE = /^[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
		return /^https?:\/\//.test(url)
			|| (allowNoScheme && !url.startsWith('mailto:') && noSchemeRE.test(url));
	},

	/**
	 * Cleans a http url string
	 * @param url {String}
	 * @params tryHttp {Boolean} Attempt prepending 'http://' to the url
	 * @returns {String}
	 */
	cleanURL: function(url, tryHttp=false) {
		url = url.trim();
		if (!url) return false;

		try {
			return Services.io.newURI(url, null, null).spec; // Valid URI if succeeds
		} catch (e) {
			if (e instanceof Components.Exception
				&& e.result == Components.results.NS_ERROR_MALFORMED_URI
			) {
				if (tryHttp && /\w\.\w/.test(url)) {
					// Assume it's a URL missing "http://" part
					try {
						return Services.io.newURI('http://' + url, null, null).spec;
					} catch (e) {}
				}

				Zotero.debug('cleanURL: Invalid URI: ' + url, 2);
				return false;
			}
			throw e;
		}
	},

	/**
	 * Eliminates HTML tags, replacing &lt;br&gt;s with newlines
	 * @type String
	 */
	cleanTags: function(/**String*/ x) {
		if(typeof(x) != "string") {
			throw new Error("cleanTags: argument must be a string");
		}

		x = x.replace(/<br[^>]*>/gi, "\n");
		x = x.replace(/<\/p>/gi, "\n\n");
		return x.replace(/<[^>]+>/g, "");
	},

	extractIdentifiers: function (text) {
		var identifiers = [];
		var foundIDs = new Set(); // keep track of identifiers to avoid duplicates

		// First look for DOIs
		var ids = text.split(/[\s\u00A0]+/); // whitespace + non-breaking space
		var doi;
		for (let id of ids) {
			if ((doi = Zotero.Utilities.cleanDOI(id)) && !foundIDs.has(doi)) {
				identifiers.push({
					DOI: doi
				});
				foundIDs.add(doi);
			}
		}

		// Then try ISBNs
		if (!identifiers.length) {
			// First try replacing dashes
			let ids = text.replace(/[\u002D\u00AD\u2010-\u2015\u2212]+/g, "") // hyphens and dashes
				.toUpperCase();
			let ISBN_RE = /(?:\D|^)(97[89]\d{10}|\d{9}[\dX])(?!\d)/g;
			let isbn;
			while (isbn = ISBN_RE.exec(ids)) {
				isbn = Zotero.Utilities.cleanISBN(isbn[1]);
				if (isbn && !foundIDs.has(isbn)) {
					identifiers.push({
						ISBN: isbn
					});
					foundIDs.add(isbn);
				}
			}

			// Next try spaces
			if (!identifiers.length) {
				ids = ids.replace(/[ \u00A0]+/g, ""); // space + non-breaking space
				while (isbn = ISBN_RE.exec(ids)) {
					isbn = Zotero.Utilities.cleanISBN(isbn[1]);
					if(isbn && !foundIDs.has(isbn)) {
						identifiers.push({
							ISBN: isbn
						});
						foundIDs.add(isbn);
					}
				}
			}
		}

		// Next try arXiv
		if (!identifiers.length) {
			// arXiv identifiers are extracted without version number
			// i.e. 0706.0044v1 is extracted as 0706.0044,
			// because arXiv OAI API doesn't allow to access individual versions
			let arXiv_RE = /((?:[^A-Za-z]|^)([\-A-Za-z\.]+\/\d{7})(?:(v[0-9]+)|)(?!\d))|((?:\D|^)(\d{4}\.\d{4,5})(?:(v[0-9]+)|)(?!\d))/g;
			let m;
			while ((m = arXiv_RE.exec(text))) {
				let arXiv = m[2] || m[5];
				if (arXiv && !foundIDs.has(arXiv)) {
					identifiers.push({arXiv: arXiv});
					foundIDs.add(arXiv);
				}
			}
		}

		// Next, try ADS Bibcodes
		if (!identifiers.length) {
			// regex as in the ADS Bibcode translator
			let adsBibcode_RE = /\b(\d{4}\D\S{13}[A-Z.:])\b/g;
			let adsBibcode;
			while ((adsBibcode = adsBibcode_RE.exec(text)) && !foundIDs.has(adsBibcode)) {
				identifiers.push({
					adsBibcode: adsBibcode[1]
				});
				foundIDs.add(adsBibcode);
			}
		}

		// Finally, try PMID
		if (!identifiers.length) {
			// PMID; right now, the longest PMIDs are 8 digits, so it doesn't seem like we'll
			// need to discriminate for a fairly long time
			let PMID_RE = /(^|\s|,|:)(\d{1,9})(?=\s|,|$)/g;
			let pmid;
			while ((pmid = PMID_RE.exec(text)) && !foundIDs.has(pmid)) {
				identifiers.push({
					PMID: pmid[2]
				});
				foundIDs.add(pmid);
			}
		}

		return identifiers;
	},	

	/**
	 * Strip info:doi prefix and any suffixes from a DOI
	 * @type String
	 */
	cleanDOI: function(/**String**/ x) {
		if(typeof(x) != "string") {
			throw new Error("cleanDOI: argument must be a string");
		}

		var doi = x.match(/10(?:\.[0-9]{4,})?\/[^\s]*[^\s\.,]/);
		return doi ? doi[0] : null;
	},

	/**
	 * Clean and validate ISBN.
	 * Return isbn if valid, otherwise return false
	 * @param {String} isbn
	 * @param {Boolean} [dontValidate=false] Do not validate check digit
	 * @return {String|Boolean} Valid ISBN or false
	 */
	cleanISBN: function(isbnStr, dontValidate) {
		isbnStr = isbnStr.toUpperCase()
			.replace(/[\x2D\xAD\u2010-\u2015\u2043\u2212]+/g, ''); // Ignore dashes
		var isbnRE = /\b(?:97[89]\s*(?:\d\s*){9}\d|(?:\d\s*){9}[\dX])\b/g,
			isbnMatch;
		while(isbnMatch = isbnRE.exec(isbnStr)) {
			var isbn = isbnMatch[0].replace(/\s+/g, '');

			if (dontValidate) {
				return isbn;
			}

			if(isbn.length == 10) {
				// Verify ISBN-10 checksum
				var sum = 0;
				for (var i = 0; i < 9; i++) {
					sum += isbn[i] * (10-i);
				}
				//check digit might be 'X'
				sum += (isbn[9] == 'X')? 10 : isbn[9]*1;

				if (sum % 11 == 0) return isbn;
			} else {
				// Verify ISBN 13 checksum
				var sum = 0;
				for (var i = 0; i < 12; i+=2) sum += isbn[i]*1;	//to make sure it's int
				for (var i = 1; i < 12; i+=2) sum += isbn[i]*3;
				sum += isbn[12]*1; //add the check digit

				if (sum % 10 == 0 ) return isbn;
			}

			isbnRE.lastIndex = isbnMatch.index + 1; // Retry the same spot + 1
		}

		return false;
	},

	/*
	 * Convert ISBN 10 to ISBN 13
	 * @param {String} isbn ISBN 10 or ISBN 13
	 *   cleanISBN
	 * @return {String} ISBN-13
	 */
	toISBN13: function(isbnStr) {
		var isbn;
		if (!(isbn = Utilities.cleanISBN(isbnStr, true))) {
			throw new Error('ISBN not found in "' + isbnStr + '"');
		}

		if (isbn.length == 13) {
			isbn = isbn.substr(0,12); // Strip off check digit and re-calculate it
		} else {
			isbn = '978' + isbn.substr(0,9);
		}

		var sum = 0;
		for (var i = 0; i < 12; i++) {
			sum += isbn[i] * (i%2 ? 3 : 1);
		}

		var checkDigit = 10 - (sum % 10);
		if (checkDigit == 10) checkDigit = 0;

		return isbn + checkDigit;
	},

	/**
	 * Clean and validate ISSN.
	 * Return issn if valid, otherwise return false
	 */
	cleanISSN: function(/**String*/ issnStr) {
		issnStr = issnStr.toUpperCase()
			.replace(/[\x2D\xAD\u2010-\u2015\u2043\u2212]+/g, ''); // Ignore dashes
		var issnRE = /\b(?:\d\s*){7}[\dX]\b/g,
			issnMatch;
		while (issnMatch = issnRE.exec(issnStr)) {
			var issn = issnMatch[0].replace(/\s+/g, '');

			// Verify ISSN checksum
			var sum = 0;
			for (var i = 0; i < 7; i++) {
				sum += issn[i] * (8-i);
			}
			//check digit might be 'X'
			sum += (issn[7] == 'X')? 10 : issn[7]*1;

			if (sum % 11 == 0) {
				return issn.substring(0,4) + '-' + issn.substring(4);
			}

			issnRE.lastIndex = issnMatch.index + 1; // Retry same spot + 1
		}

		return false;
	},

	/**
	 * Convert plain text to HTML by replacing special characters and replacing newlines with BRs or
	 * P tags
	 * @param {String} str Plain text string
	 * @param {Boolean} singleNewlineIsParagraph Whether single newlines should be considered as
	 *     paragraphs. If true, each newline is replaced with a P tag. If false, double newlines
	 *     are replaced with P tags, while single newlines are replaced with BR tags.
	 * @type String
	 */
	text2html: function (/**String**/ str, /**Boolean**/ singleNewlineIsParagraph) {
		str = Utilities.htmlSpecialChars(str);

		// \n => <p>
		if (singleNewlineIsParagraph) {
			str = '<p>'
				+ str.replace(/\n/g, '</p><p>')
					.replace(/  /g, '&nbsp; ')
				+ '</p>';
		}
		// \n\n => <p>, \n => <br/>
		else {
			str = '<p>'
				+ str.replace(/\n\n/g, '</p><p>')
					.replace(/\n/g, '<br/>')
					.replace(/  /g, '&nbsp; ')
				+ '</p>';
		}
		return str.replace(/<p>\s*<\/p>/g, '<p>&nbsp;</p>');
	},

	/**
	 * Encode special XML/HTML characters
	 * Certain entities can be inserted manually:
	 *   <ZOTEROBREAK/> => <br/>
	 *   <ZOTEROHELLIP/> => &#8230;
	 *
	 * @param {String} str
	 * @return {String}
	 */
	htmlSpecialChars: function(str) {
		if (str && typeof str != 'string') {
			Zotero.debug('#htmlSpecialChars: non-string arguments are deprecated. Update your code',
				1, undefined, true);
			str = str.toString();
		}

		if (!str) return '';

		return str
			.replace(/&/g, '&amp;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&apos;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/&lt;ZOTERO([^\/]+)\/&gt;/g, function (str, p1, offset, s) {
				switch (p1) {
				case 'BREAK':
					return '<br/>';
				case 'HELLIP':
					return '&#8230;';
				default:
					return p1;
				}
			});
	},

	/**
	 * Decodes HTML entities within a string, returning plain text
	 * @type String
	 */
	"unescapeHTML":new function() {
		var node;

		return function(/**String*/ str) {
			// If no tags, no need to unescape
			if(str.indexOf("<") === -1 && str.indexOf("&") === -1) return str;

			if(Zotero.isFx && !Zotero.isBookmarklet) {
				// Create a node and use the textContent property to do unescaping where
				// possible, because this approach preserves line endings in the HTML
				if(node === undefined) {
					node = Utilities.Internal.getDOMDocument().createElement("div");
				}

				node.innerHTML = str;
				return node.textContent.replace(/ {2,}/g, " ");
			} else {
				if(!node) node = document.createElement("div");
				node.innerHTML = str;
				return ("textContent" in node ? node.textContent : node.innerText).replace(/ {2,}/g, " ");
			}
		};
	},

	/**
	 * Wrap URLs and DOIs in <a href=""> links in plain text
	 *
	 * Ignore URLs preceded by '>', just in case there are already links
	 * @type String
	 */
	autoLink: function (/**String**/ str) {
		// "http://www.google.com."
		// "http://www.google.com. "
		// "<http://www.google.com>" (and other characters, with or without a space after)
		str = str.replace(/([^>])(https?:\/\/[^\s]+)([\."'>:\]\)](\s|$))/g, '$1<a href="$2">$2</a>$3');
		// "http://www.google.com"
		// "http://www.google.com "
		str = str.replace(/([^">])(https?:\/\/[^\s]+)(\s|$)/g, '$1<a href="$2">$2</a>$3');

		// DOI
		str = str.replace(/(doi:[ ]*)(10\.[^\s]+[0-9a-zA-Z])/g, '$1<a href="http://dx.doi.org/$2">$2</a>');
		return str;
	},

	/**
	 * Parses a text string for HTML/XUL markup and returns an array of parts. Currently only finds
	 * HTML links (&lt;a&gt; tags)
	 *
	 * @return {Array} An array of objects with the following form:<br>
	 * <pre>   {
	 *         type: 'text'|'link',
	 *         text: "text content",
	 *         [ attributes: { key1: val [ , key2: val, ...] }
	 *    }</pre>
	 */
	parseMarkup: function(/**String*/ str) {
		var parts = [];
		var splits = str.split(/(<a [^>]+>[^<]*<\/a>)/);

		for(var i=0; i<splits.length; i++) {
			// Link
			if (splits[i].indexOf('<a ') == 0) {
				var matches = splits[i].match(/<a ([^>]+)>([^<]*)<\/a>/);
				if (matches) {
					// Attribute pairs
					var attributes = {};
					var pairs = matches[1].match(/([^ =]+)="([^"]+")/g);
					for(var j=0; j<pairs.length; j++) {
						var keyVal = pairs[j].split(/=/);
						attributes[keyVal[0]] = keyVal[1].substr(1, keyVal[1].length - 2);
					}

					parts.push({
						type: 'link',
						text: matches[2],
						attributes: attributes
					});
					continue;
				}
			}

			parts.push({
				type: 'text',
				text: splits[i]
			});
		}

		return parts;
	},

	/**
	 * Calculates the Levenshtein distance between two strings
	 * @type Number
	 */
	levenshtein: function (/**String*/ a, /**String**/ b) {
		var aLen = a.length;
		var bLen = b.length;

		var arr = new Array(aLen+1);
		var i, j, cost;

		for (i = 0; i <= aLen; i++) {
			arr[i] = new Array(bLen);
			arr[i][0] = i;
		}

		for (j = 0; j <= bLen; j++) {
			arr[0][j] = j;
		}

		for (i = 1; i <= aLen; i++) {
			for (j = 1; j <= bLen; j++) {
				cost = (a[i-1] == b[j-1]) ? 0 : 1;
				arr[i][j] = Math.min(arr[i-1][j] + 1, Math.min(arr[i][j-1] + 1, arr[i-1][j-1] + cost));
			}
		}

		return arr[aLen][bLen];
	},

	/**
	 * Test if an object is empty
	 *
	 * @param {Object} obj
	 * @type Boolean
	 */
	isEmpty: function (obj) {
		for (var i in obj) {
			return false;
		}
		return true;
	},

	/**
	 * Compares an array with another and returns an array with
	 *	the values from array1 that don't exist in array2
	 *
	 * @param	{Array}		array1
	 * @param	{Array}		array2
	 * @param	{Boolean}	useIndex		If true, return an array containing just
	 *										the index of array2's elements;
	 *										otherwise return the values
	 */
	arrayDiff: function(array1, array2, useIndex) {
		if (!Array.isArray(array1)) {
			throw new Error("array1 is not an array (" + array1 + ")");
		}
		if (!Array.isArray(array2)) {
			throw new Error("array2 is not an array (" + array2 + ")");
		}

		var val, pos, vals = [];
		for (var i=0; i<array1.length; i++) {
			val = array1[i];
			pos = array2.indexOf(val);
			if (pos == -1) {
				vals.push(useIndex ? pos : val);
			}
		}
		return vals;
	},


	/**
	 * Determine whether two arrays are identical
	 *
	 * Modified from http://stackoverflow.com/a/14853974
	 *
	 * @return {Boolean}
	 */
	arrayEquals: function (array1, array2) {
		// If either array is a falsy value, return
		if (!array1 || !array2)
			return false;

		// Compare lengths - can save a lot of time
		if (array1.length != array2.length)
			return false;

		for (var i = 0, l=array1.length; i < l; i++) {
			// Check if we have nested arrays
			if (array1[i] instanceof Array && array2[i] instanceof Array) {
				// Recurse into the nested arrays
				if (!this.arrayEquals(array1[i], array2[i])) {
					return false;
				}
			}
			else if (array1[i] != array2[i]) {
				// Warning - two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}
		return true;
	},


	/**
	 * Return new array with values shuffled
	 *
	 * From http://stackoverflow.com/a/6274398
	 *
	 * @param {Array} arr
	 * @return {Array}
	 */
	arrayShuffle: function (array) {
		var counter = array.length, temp, index;

		// While there are elements in the array
		while (counter--) {
			// Pick a random index
			index = (Math.random() * counter) | 0;

			// And swap the last element with it
			temp = array[counter];
			array[counter] = array[index];
			array[index] = temp;
		}

		return array;
	},


	/**
	 * Return new array with duplicate values removed
	 *
	 * @param	{Array}		array
	 * @return	{Array}
	 */
	arrayUnique: function (arr) {
		return [...new Set(arr)];
	},

	/**
	 * Generate a random integer between min and max inclusive
	 *
	 * @param	{Integer}	min
	 * @param	{Integer}	max
	 * @return	{Integer}
	 */
	rand: function (min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	},

	/**
	 * Parse a page range
	 *
	 * @param {String} Page range to parse
	 * @return {Integer[]} Start and end pages
	 */
	getPageRange: function(pages) {
		const pageRangeRegexp = /^\s*([0-9]+) ?[-\u2013] ?([0-9]+)\s*$/;

		var pageNumbers;
		var m = pageRangeRegexp.exec(pages);
		if(m) {
			// A page range
			pageNumbers = [m[1], m[2]];
		} else {
			// Assume start and end are the same
			pageNumbers = [pages, pages];
		}
		return pageNumbers;
	},

	/**
	 * Pads a number or other string with a given string on the left
	 *
	 * @param {String} string String to pad
	 * @param {String} pad String to use as padding
	 * @length {Integer} length Length of new padded string
	 * @type String
	 */
	lpad: function(string, pad, length) {
		string = string ? string + '' : '';
		while(string.length < length) {
			string = pad + string;
		}
		return string;
	},

	/**
	 * Shorten and add an ellipsis to a string if necessary
	 *
	 * @param {String}	str
	 * @param {Integer}	len
	 * @param {Boolean} [wordBoundary=false]
	 * @param {Boolean} [countChars=false]
	 */
	ellipsize: function (str, len, wordBoundary = false, countChars) {
		if (!len) {
			throw ("Length not specified in Utilities.ellipsize()");
		}
		if (str.length <= len) {
			return str;
		}
		var origLen = str.length;
		let radius = Math.min(len, 5);
		if (wordBoundary) {
			let min = len - radius;
			// If next character is a space, include that so we stop at len
			if (str.charAt(len).match(/\s/)) {
				radius++;
			}
			// Remove trailing characters and spaces, up to radius
			str = str.substr(0, min) + str.substr(min, radius).replace(/\W*\s\S*$/, "");
		}
		else {
			str = str.substr(0, len);
		}
		return str + '\u2026' + (countChars ? ' (' + origLen + ' chars)' : '');
	},


	/**
	 * Return the proper plural form of a string
	 *
	 * For now, this is only used for debug output in English.
	 *
	 * @param {Integer} num
	 * @param {String[]|String} forms - If an array, an array of plural forms (e.g., ['object', 'objects']);
	 *     currently only the two English forms are supported, for 1 and 0/many. If a single string,
	 *     's' is added automatically for 0/many.
	 * @return {String}
	 */
	pluralize: function (num, forms) {
		if (typeof forms == 'string') {
			forms = [forms, forms + 's'];
		}
		return num == 1 ? forms[0] : forms[1];
	},


	/**
	 * Port of PHP's number_format()
	 *
	 * MIT Licensed
	 *
	 * From http://kevin.vanzonneveld.net
	 * +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	 * +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	 * +     bugfix by: Michael White (http://getsprink.com)
	 * +     bugfix by: Benjamin Lupton
	 * +     bugfix by: Allan Jensen (http://www.winternet.no)
	 * +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	 * +     bugfix by: Howard Yeend
	 * *     example 1: number_format(1234.5678, 2, '.', '');
	 * *     returns 1: 1234.57
	 */
	numberFormat: function (number, decimals, dec_point, thousands_sep) {
		var n = number, c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
		var d = dec_point == undefined ? "." : dec_point;
		var t = thousands_sep == undefined ? "," : thousands_sep, s = n < 0 ? "-" : "";
		var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "", j = (j = i.length) > 3 ? j % 3 : 0;

		return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
	},

	/**
	 * Cleans a title, converting it to title case and replacing " :" with ":"
	 *
	 * @param {String} string
	 * @param {Boolean} force Forces title case conversion, even if the capitalizeTitles pref is off
	 * @type String
	 */
	capitalizeTitle: function(string, force) {
		const skipWords = ["but", "or", "yet", "so", "for", "and", "nor", "a", "an",
			"the", "at", "by", "from", "in", "into", "of", "on", "to", "with", "up",
			"down", "as"];

		// this may only match a single character
		const delimiterRegexp = /([ \/\u002D\u00AD\u2010-\u2015\u2212\u2E3A\u2E3B])/;

		string = this.trimInternal(string);
		string = string.replace(/ : /g, ": ");
		if (Zotero.Prefs && !Zotero.Prefs.get('capitalizeTitles') && !force) return string;
		if (!string) return "";

		// split words
		var words = string.split(delimiterRegexp);
		var isUpperCase = string.toUpperCase() == string;

		var newString = "";
		words[0].length;
		var lastWordIndex = words.length-1;
		var previousWordIndex = -1;
		for(var i=0; i<=lastWordIndex; i++) {
			// only do manipulation if not a delimiter character
			if(words[i].length != 0 && (words[i].length != 1 || !delimiterRegexp.test(words[i]))) {
				words[i].toUpperCase();
				var lowerCaseVariant = words[i].toLowerCase();

				// only use if word does not already possess some capitalization
				if(isUpperCase || words[i] == lowerCaseVariant) {
					if(
						// a skip word
						skipWords.indexOf(lowerCaseVariant.replace(/[^a-zA-Z]+/, "")) != -1
						// not first or last word
						&& i != 0 && i != lastWordIndex
						// does not follow a colon
						&& (previousWordIndex == -1 || words[previousWordIndex][words[previousWordIndex].length-1].search(/[:\?!]/)==-1)
					) {
						words[i] = lowerCaseVariant;
					} else {
						// this is not a skip word or comes after a colon;
						// we must capitalize
						// handle punctuation in the beginning, including multiple, as in "¿Qué pasa?"		
						var punct = words[i].match(/^[\'\"¡¿“‘„«\s]+/);
						punct = punct ? punct[0].length+1 : 1;
						words[i] = words[i].length ? words[i].substr(0, punct).toUpperCase() +
							words[i].substr(punct).toLowerCase() : words[i];
					}
				}

				previousWordIndex = i;
			}

			newString += words[i];
		}

		return newString;
	},

	capitalize: function (str) {
		if (typeof str != 'string') throw new Error("Argument must be a string");
		if (!str) return str; // Empty string
		return str[0].toUpperCase() + str.substr(1);
	},

	/**
	 * Replaces accented characters in a string with ASCII equivalents
	 *
	 * @param {String} str
	 * @param {Boolean} [lowercaseOnly]  Limit conversions to lowercase characters
	 *                                   (for improved performance on lowercase input)
	 * @return {String}
	 *
	 * From http://lehelk.com/2011/05/06/script-to-remove-diacritics/
	 */
	removeDiacritics: function (str, lowercaseOnly) {
		// Short-circuit on the most basic input
		if (/^[a-zA-Z0-9_-]*$/.test(str)) return str;

		var map = this._diacriticsRemovalMap.lowercase;
		for (var i=0, len=map.length; i<len; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}

		if (!lowercaseOnly) {
			var map = this._diacriticsRemovalMap.uppercase;
			for (var i=0, len=map.length; i<len; i++) {
				str = str.replace(map[i].letters, map[i].base);
			}
		}

		return str;
	},

	"_diacriticsRemovalMap": {
		uppercase: [
			{'base':'A', 'letters':/[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g},
			{'base':'AA','letters':/[\uA732]/g},
			{'base':'AE','letters':/[\u00C6\u01FC\u01E2]/g},
			{'base':'AO','letters':/[\uA734]/g},
			{'base':'AU','letters':/[\uA736]/g},
			{'base':'AV','letters':/[\uA738\uA73A]/g},
			{'base':'AY','letters':/[\uA73C]/g},
			{'base':'B', 'letters':/[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g},
			{'base':'C', 'letters':/[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g},
			{'base':'D', 'letters':/[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g},
			{'base':'DZ','letters':/[\u01F1\u01C4]/g},
			{'base':'Dz','letters':/[\u01F2\u01C5]/g},
			{'base':'E', 'letters':/[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g},
			{'base':'F', 'letters':/[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g},
			{'base':'G', 'letters':/[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g},
			{'base':'H', 'letters':/[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g},
			{'base':'I', 'letters':/[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g},
			{'base':'J', 'letters':/[\u004A\u24BF\uFF2A\u0134\u0248]/g},
			{'base':'K', 'letters':/[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g},
			{'base':'L', 'letters':/[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g},
			{'base':'LJ','letters':/[\u01C7]/g},
			{'base':'Lj','letters':/[\u01C8]/g},
			{'base':'M', 'letters':/[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g},
			{'base':'N', 'letters':/[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g},
			{'base':'NJ','letters':/[\u01CA]/g},
			{'base':'Nj','letters':/[\u01CB]/g},
			{'base':'O', 'letters':/[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g},
			{'base':'OE','letters':/[\u0152]/g},
			{'base':'OI','letters':/[\u01A2]/g},
			{'base':'OO','letters':/[\uA74E]/g},
			{'base':'OU','letters':/[\u0222]/g},
			{'base':'P', 'letters':/[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g},
			{'base':'Q', 'letters':/[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g},
			{'base':'R', 'letters':/[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g},
			{'base':'S', 'letters':/[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g},
			{'base':'T', 'letters':/[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g},
			{'base':'TZ','letters':/[\uA728]/g},
			{'base':'U', 'letters':/[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g},
			{'base':'V', 'letters':/[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g},
			{'base':'VY','letters':/[\uA760]/g},
			{'base':'W', 'letters':/[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g},
			{'base':'X', 'letters':/[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g},
			{'base':'Y', 'letters':/[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g},
			{'base':'Z', 'letters':/[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g},
		],

		lowercase: [
			{'base':'a', 'letters':/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g},
			{'base':'aa','letters':/[\uA733]/g},
			{'base':'ae','letters':/[\u00E6\u01FD\u01E3]/g},
			{'base':'ao','letters':/[\uA735]/g},
			{'base':'au','letters':/[\uA737]/g},
			{'base':'av','letters':/[\uA739\uA73B]/g},
			{'base':'ay','letters':/[\uA73D]/g},
			{'base':'b', 'letters':/[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
			{'base':'c', 'letters':/[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
			{'base':'d', 'letters':/[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g},
			{'base':'dz','letters':/[\u01F3\u01C6]/g},
			{'base':'e', 'letters':/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g},
			{'base':'f', 'letters':/[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
			{'base':'g', 'letters':/[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g},
			{'base':'h', 'letters':/[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g},
			{'base':'hv','letters':/[\u0195]/g},
			{'base':'i', 'letters':/[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g},
			{'base':'j', 'letters':/[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
			{'base':'k', 'letters':/[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g},
			{'base':'l', 'letters':/[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g},
			{'base':'lj','letters':/[\u01C9]/g},
			{'base':'m', 'letters':/[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
			{'base':'n', 'letters':/[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g},
			{'base':'nj','letters':/[\u01CC]/g},
			{'base':'o', 'letters':/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g},
			{'base':'oe','letters':/[\u0153]/g},
			{'base':'oi','letters':/[\u01A3]/g},
			{'base':'ou','letters':/[\u0223]/g},
			{'base':'oo','letters':/[\uA74F]/g},
			{'base':'p','letters':/[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
			{'base':'q','letters':/[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
			{'base':'r','letters':/[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g},
			{'base':'s','letters':/[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g},
			{'base':'t','letters':/[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g},
			{'base':'tz','letters':/[\uA729]/g},
			{'base':'u','letters':/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g},
			{'base':'v','letters':/[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
			{'base':'vy','letters':/[\uA761]/g},
			{'base':'w','letters':/[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
			{'base':'x','letters':/[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
			{'base':'y','letters':/[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g},
			{'base':'z','letters':/[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g}
		]
	},

	/**
	 * Performs a deep copy of a JavaScript object
	 * @param {Object} obj
	 * @return {Object}
	 */
	deepCopy: function(obj) {
		var obj2 = (Array.isArray(obj) ? [] : {});
		for(var i in obj) {
			if(!obj.hasOwnProperty(i)) continue;

			if(typeof obj[i] === "object" && obj[i] !== null) {
				obj2[i] = Utilities.deepCopy(obj[i]);
			} else {
				obj2[i] = obj[i];
			}
		}
		return obj2;
	},

	/**
	 * Find valid creator types for a given item type
	 *
	 * @param {String} type Item type
	 * @return {String[]} Creator types
	 */
	getCreatorsForType: function(type) {
		if(type === "attachment" || type === "note") return [];
		var types = Zotero.CreatorTypes.getTypesForItemType(Zotero.ItemTypes.getID(type));
		var cleanTypes = new Array();
		for(var i=0; i<types.length; i++) {
			cleanTypes.push(types[i].name);
		}
		return cleanTypes;
	},

	/**
	 * Determine whether a given field is valid for a given item type
	 *
	 * @param {String} field Field name
	 * @param {String} type Item type
	 * @type Boolean
	 */
	fieldIsValidForType: function(field, type) {
		return Zotero.ItemFields.isValidForType(field, Zotero.ItemTypes.getID(type));
	},

	/**
	 * Gets a creator type name, localized to the current locale
	 *
	 * @param {String} type Creator type
	 * @param {String} Localized creator type
	 * @type Boolean
	 */
	getLocalizedCreatorType: function(type) {
		try {
			return Zotero.CreatorTypes.getLocalizedString(type);
		} catch(e) {
			return false;
		}
	},

	/**
	 * Escapes metacharacters in a literal so that it may be used in a regular expression
	 */
	quotemeta: function(literal) {
		if(typeof literal !== "string") {
			throw new Error("Argument "+literal+" must be a string in Utilities.quotemeta()");
		}
		const metaRegexp = /[-[\]{}()*+?.\\^$|,#\s]/g;
		return literal.replace(metaRegexp, "\\$&");
	},

	/**
	 * Evaluate an XPath
	 *
	 * @param {element|element[]} elements The element(s) to use as the context for the XPath
	 * @param {String} xpath The XPath expression
	 * @param {Object} [namespaces] An object whose keys represent namespace prefixes, and whose
	 *                              values represent their URIs
	 * @return {element[]} DOM elements matching XPath
	 */
	xpath: function(elements, xpath, namespaces) {
		var nsResolver = null;
		if(namespaces) {
			nsResolver = function(prefix) {
				return namespaces[prefix] || null;
			};
		}

		if(!("length" in elements)) elements = [elements];

		var results = [];
		for(var i=0, n=elements.length; i<n; i++) {
			// For some reason, if elements is wrapped by an object
			// Xray, we won't be able to unwrap the DOMWrapper around
			// the element. So waive the object Xray.
			var maybeWrappedEl = elements.wrappedJSObject ? elements.wrappedJSObject[i] : elements[i];

			// Firefox 5 hack, so we will preserve Fx5DOMWrappers
			var isWrapped = Zotero.Translate.DOMWrapper && Zotero.Translate.DOMWrapper.isWrapped(maybeWrappedEl);
			var element = isWrapped ? Zotero.Translate.DOMWrapper.unwrap(maybeWrappedEl) : maybeWrappedEl;

			// We waived the object Xray above, which will waive the
			// DOM Xray, so make sure we have a DOM Xray wrapper.
			if(Zotero.isFx) {
				element = new XPCNativeWrapper(element);
			}

			if(element.ownerDocument) {
				var rootDoc = element.ownerDocument;
			} else if(element.documentElement) {
				var rootDoc = element;
			} else if(Zotero.isIE && element.documentElement === null) {
				// IE: documentElement may be null if there is a parse error. In this
				// case, we don't match anything to mimic what would happen with DOMParser
				continue;
			} else {
				throw new Error("First argument must be either element(s) or document(s) in Utilities.xpath(elements, '"+xpath+"')");
			}

			if(!Zotero.isIE || "evaluate" in rootDoc) {
				try {
					// This may result in a deprecation warning in the console due to
					// https://bugzilla.mozilla.org/show_bug.cgi?id=674437
					var xpathObject = rootDoc.evaluate(xpath, element, nsResolver, 5 /*ORDERED_NODE_ITERATOR_TYPE*/, null);
				} catch(e) {
					// rethrow so that we get a stack
					throw new Error(e.name+": "+e.message);
				}

				var newEl;
				while(newEl = xpathObject.iterateNext()) {
					// Firefox 5 hack
					results.push(isWrapped ? Zotero.Translate.DOMWrapper.wrapIn(newEl, maybeWrappedEl) : newEl);
				}
			} else if("selectNodes" in element) {
				// We use JavaScript-XPath in IE for HTML documents, but with an XML
				// document, we need to use selectNodes
				if(namespaces) {
					var ieNamespaces = [];
					for(var j in namespaces) {
						if(!j) continue;
						ieNamespaces.push('xmlns:'+j+'="'+Utilities.htmlSpecialChars(namespaces[j])+'"');
					}
					rootDoc.setProperty("SelectionNamespaces", ieNamespaces.join(" "));
				}
				var nodes = element.selectNodes(xpath);
				for(var j=0; j<nodes.length; j++) {
					results.push(nodes[j]);
				}
			} else {
				throw new Error("XPath functionality not available");
			}
		}

		return results;
	},

	/**
	 * Generates a string from the content of nodes matching a given XPath
	 *
	 * @param {element} node The node representing the document and context
	 * @param {String} xpath The XPath expression
	 * @param {Object} [namespaces] An object whose keys represent namespace prefixes, and whose
	 *                              values represent their URIs
	 * @param {String} [delimiter] The string with which to join multiple matching nodes
	 * @return {String|null} DOM elements matching XPath, or null if no elements exist
	 */
	xpathText: function(node, xpath, namespaces, delimiter) {
		var elements = Utilities.xpath(node, xpath, namespaces);
		if(!elements.length) return null;

		var strings = new Array(elements.length);
		for(var i=0, n=elements.length; i<n; i++) {
			var el = elements[i];
			if(el.wrappedJSObject) el = el.wrappedJSObject;
			if(Zotero.Translate.DOMWrapper) el = Zotero.Translate.DOMWrapper.unwrap(el);
			strings[i] =
				(el.nodeType === 2 /*ATTRIBUTE_NODE*/ && "value" in el) ? el.value
					: "textContent" in el ? el.textContent
					: "innerText" in el ? el.innerText
						: "text" in el ? el.text
							: el.nodeValue;
		}

		return strings.join(delimiter !== undefined ? delimiter : ", ");
	},


	/**
	 * Generate a random string of length 'len' (defaults to 8)
	 **/
	randomString: function(len, chars) {
		if (!chars) {
			chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
		}
		if (!len) {
			len = 8;
		}
		var randomstring = '';
		for (var i=0; i<len; i++) {
			var rnum = Math.floor(Math.random() * chars.length);
			randomstring += chars.substring(rnum,rnum+1);
		}
		return randomstring;
	},

	/**
	 * PHP var_dump equivalent for JS
	 *
	 * Adapted from http://binnyva.blogspot.com/2005/10/dump-function-javascript-equivalent-of.html
	 */
	varDump: function(obj,level,maxLevel,parentObjects,path) {
		// Simple dump
		var type = typeof obj;
		if (type == 'number' || type == 'undefined' || type == 'boolean' || obj === null) {
			if (!level) {
				// When dumping these directly, make sure to distinguish them from regular
				// strings as output by Zotero.debug (i.e. no quotes)
				return '===>' + obj + '<=== (' + type + ')';
			}
			else {
				return '' + obj;
			}
		}
		else if (type == 'string' || typeof obj.toJSON == 'function') {
			return JSON.stringify(obj, false, '    ');
		}
		else if (type == 'symbol') {
			return obj.toString();
		}
		else if (type == 'function') {
			var funcStr = ('' + obj).trim();
			if (!level) {
				// Dump function contents as well if only dumping function
				return funcStr;
			}

			// Display [native code] label for native functions, but make it one line
			if (/^[^{]+{\s*\[native code\]\s*}$/i.test(funcStr)) {
				return funcStr.replace(/\s*(\[native code\])\s*/i, ' $1 ');
			}

			// For non-native functions, display an ellipsis
			return ('' + obj).replace(/{[\s\S]*}/, '{...}');
		}
		else if (type != 'object') {
			return '<<Unknown type: ' + type + '>> ' + obj;
		}

		// Don't descend into global object cache for data objects
		if (Zotero.isClient && typeof obj == 'object' && obj instanceof Zotero.DataObject) {
			maxLevel = 1;
		}

		// More complex dump with indentation for objects
		if (level === undefined) {
			level = 0;
		}

		if (maxLevel === undefined) {
			maxLevel = 5;
		}

		var objType = Object.prototype.toString.call(obj);

		if (level > maxLevel) {
			return objType + " <<Maximum depth reached>>";
		}

		// The padding given at the beginning of the line.
		var level_padding = "";
		for (var j=0; j<level+1; j++) {
			level_padding += "    ";
		}

		//Special handling for Error or Exception
		var isException = Zotero.isFx && !Zotero.isBookmarklet && obj instanceof Components.interfaces.nsIException;
		var isError = obj instanceof Error;
		if (!isException && !isError && obj.message !== undefined && obj.stack !== undefined) {
			isError = true;
		}

		if (isError || isException) {
			var header = '';
			if (isError) {
				header = (obj.constructor && obj.constructor.name) ? obj.constructor.name : 'Error';
			} else {
				header = (obj.name ? obj.name + ' ' : '') + 'Exception';
			}

			let msg = (obj.message ? ('' + obj.message).replace(/^/gm, level_padding).trim() : '');
			if (obj.stack) {
				let stack = obj.stack.trim().replace(/^(?=.)/gm, level_padding);
				if (Utilities.Internal) {
					stack = Utilities.Internal.filterStack(stack);
				}

				msg += '\n\n';

				// At least with Zotero.HTTP.UnexpectedStatusException, the stack contains "Error:"
				// and the message in addition to the trace. I'm not sure what's causing that
				// (Bluebird?), but fix it here.
				if (stack.startsWith('Error:')) {
					msg += stack.replace('Error: ' + obj.message + '\n', '');
				}
				else {
					msg += stack;
				}
			}

			return header + ': ' + msg;
		}

		// Only dump single level for Node objects (including document)
		if (Zotero.isFx && !Zotero.isBookmarklet) {
			if (Zotero.platformMajorVersion > 60) {
				if (obj instanceof Node || obj instanceof Window) {
					level = maxLevel;
				}
			}
			else if (obj instanceof Components.interfaces.nsIDOMNode
					|| obj instanceof Components.interfaces.nsIDOMWindow) {
				level = maxLevel;
			}
		}

		// Recursion checking
		if(!parentObjects) {
			parentObjects = [obj];
			path = ['ROOT'];
		}

		var dumpedText;
		var rawProps = false;
		var isArray = objType == '[object Array]';
		var dumpKey = key => (typeof key == 'symbol'
			? key.toString()
			: JSON.stringify(key));
		if (isArray) {
			dumpedText = '[';
		}
		else if (objType == '[object Set]') {
			dumpedText = 'Set {';
			obj = Array.from(obj);
		}
		else if (objType == '[object Map]') {
			dumpedText = 'Map {';
			rawProps = true;
			let newObj = {};
			for (let [key, value] of obj.entries()) {
				newObj[dumpKey(key)] = value;
			}
			obj = newObj;
		}
		else if (objType == '[object Object]') {
			dumpedText = '{';
		}
		else {
			dumpedText = objType + ' {';
		}
		for (var prop in obj) {
			dumpedText += '\n' + level_padding
				+ (rawProps ? prop : dumpKey(prop))
				+ ": ";

			try {
				var value = obj[prop];
			} catch(e) {
				dumpedText += "<<Access Denied>>";
				continue;
			}

			// Check for recursion
			if (typeof(value) == 'object') {
				var i = parentObjects.indexOf(value);
				if(i != -1) {
					var parentName = path.slice(0,i+1).join('->');
					dumpedText += "<<Reference to parent object " + parentName + " >>";
					continue;
				}
			}

			try {
				dumpedText += Utilities.varDump(value,level+1,maxLevel,parentObjects.concat([value]),path.concat([prop]));
			} catch(e) {
				dumpedText += "<<Error processing property: " + e.message + " (" + value + ")>>";
			}
		}

		var lastChar = dumpedText.charAt(dumpedText.length - 1);
		if (lastChar != '[' && lastChar != '{') {
			dumpedText += '\n' + level_padding.substr(4);
		}
		dumpedText += isArray ? ']' : '}';

		return dumpedText;
	},

	/**
	 * Adds a string to a given array at a given offset, converted to UTF-8
	 * @param {String} string The string to convert to UTF-8
	 * @param {Array|Uint8Array} array The array to which to add the string
	 * @param {Integer} [offset] Offset at which to add the string
	 */
	stringToUTF8Array: function(string, array, offset) {
		if(!offset) offset = 0;
		var n = string.length;
		for(var i=0; i<n; i++) {
			var val = string.charCodeAt(i);
			if(val >= 128) {
				if(val >= 2048) {
					array[offset] = (val >>> 12) | 224;
					array[offset+1] = ((val >>> 6) & 63) | 128;
					array[offset+2] = (val & 63) | 128;
					offset += 3;
				} else {
					array[offset] = ((val >>> 6) | 192);
					array[offset+1] = (val & 63) | 128;
					offset += 2;
				}
			} else {
				array[offset++] = val;
			}
		}
	},

	/**
	 * Gets the byte length of the UTF-8 representation of a given string
	 * @param {String} string
	 * @return {Integer}
	 */
	getStringByteLength: function(string) {
		var length = 0, n = string.length;
		for(var i=0; i<n; i++) {
			var val = string.charCodeAt(i);
			if(val >= 128) {
				if(val >= 2048) {
					length += 3;
				} else {
					length += 2;
				}
			} else {
				length += 1;
			}
		}
		return length;
	},	

	semverCompare(a, b) {
		a = a.split('.').map(version => isNaN(parseInt(version)) ? version : parseInt(version));
		b = b.split('.').map(version => isNaN(parseInt(version)) ? version : parseInt(version));
		for (let i = 0; i < a.length && i < b.length; i++) {
			if (a[i] < b[i]) return -1;
			else if (a[i] > b[i]) return 1;
		}
		return a.length - b.length; // E.g. 5.0.0 < 5.0.0.1
	},
	
	allowedKeyChars: "23456789ABCDEFGHIJKLMNPQRSTUVWXYZ",

	/**
	 * Generates a valid object key for the server API
	 */
	generateObjectKey: function generateObjectKey() {
		return Zotero.Utilities.randomString(8, Zotero.Utilities.allowedKeyChars);
	},

	/**
	 * Check if an object key is in a valid format
	 */
	isValidObjectKey: function(key) {
		if (!Zotero.Utilities.objectKeyRegExp) {
			Zotero.Utilities.objectKeyRegExp = new RegExp('^[' + Zotero.Utilities.allowedKeyChars + ']{8}$');
		}
		return Zotero.Utilities.objectKeyRegExp.test(key);
	},

	itemTypeExists: function(type) {
		Zotero.debug(`Zotero.Utilities.itemTypeExists() is deprecated -- use Zotero.Utilities.Item.itemTypeExists() instead`);
		return Zotero.Utilities.Item.itemTypeExists(type);
	},
	
	itemToCSLJSON: function(zoteroItem) {
		Zotero.debug(`Zotero.Utilities.itemToCSLJSON() is deprecated -- use Zotero.Utilities.Item.itemToCSLJSON() instead`);
		return Zotero.Utilities.Item.itemToCSLJSON(zoteroItem);
	},
	itemFromCSLJSON: function(item, cslItem) {
		Zotero.debug(`Zotero.Utilities.itemFromCSLJSON() is deprecated -- use Zotero.Utilities.Item.itemFromCSLJSON() instead`);
		return Zotero.Utilities.Item.itemFromCSLJSON(item, cslItem);
	},

	assignProps: movedToUtilitiesInternal("assignProps"),
	parseURL: movedToUtilitiesInternal("parseURL"),
	resolveIntermediateURL: movedToUtilitiesInternal("resolveIntermediateURL"),
	determineAttachmentIcon: movedToUtilitiesInternal('determineAttachmentIcon'),

	/**
	 * Walk the DOM and the contents of JSON data attributes in the HTML representation
	 * of a note, calling visitor functions that might modify it and returning
	 * the resulting HTML.
	 *
	 * Elements are visited in depth-first order. First the element itself is visited,
	 * then its data attributes, then the URIs in its JSON attributes, then its subtree.
	 *
	 * @param {String} note Note HTML
	 * @param {Object} visitors
	 * @param {Function} [visitors.visitContainer]
	 * @param {Function} [visitors.visitAnnotation]
	 * @param {Function} [visitors.visitCitation]
	 * @param {Function} [visitors.visitOtherElement]
	 * @param {Function} [visitors.visitDataAttribute]
	 * @param {Function} [visitors.visitURI] Return a replacement for the passed URI
	 * @return {String} Potentially modified note HTML
	 */
	walkNoteDOM: function (note, visitors) {
		function visit(elem) {
			if (elem.hasAttribute('data-schema-version')) {
				visitors.visitContainer?.(elem);
			}
			else if (elem.hasAttribute('data-annotation')) {
				visitors.visitAnnotation?.(elem);
			}
			else if (elem.hasAttribute('data-citation')) {
				visitors.visitCitation?.(elem);
			}
			else {
				visitors.visitOtherElement?.(elem);
			}

			if (visitors.visitDataAttribute || visitors.visitURI) {
				for (let attr of ['data-citation', 'data-citation-items', 'data-annotation']) {
					if (elem.hasAttribute(attr)) {
						let json;
						try {
							json = JSON.parse(decodeURIComponent(elem.getAttribute(attr)));
						}
						catch (e) {
							continue;
						}

						visitors.visitDataAttribute?.(attr, json);
						if (visitors.visitURI) visitURIs(json);

						elem.setAttribute(attr, JSON.stringify(json));
					}
				}
			}

			for (let child of elem.children) {
				visit(child);
			}
		}

		function visitURIs(json) {
			if (Array.isArray(json)) {
				json.forEach(visitURIs);
			}
			else if (typeof json === 'object') {
				for (let [key, value] of Object.entries(json)) {
					if (key == 'id' || key == 'attachmentURI') {
						json[key] = visitors.visitURI(value);
					}
					else if (key == 'uris') {
						json[key] = value.map(visitors.visitURI);
					}
					else {
						visitURIs(value);
					}
				}
			}
		}

		let wrappedNote = '<div id="note-body">' + note + '</div>';
		let doc;
		{
			let parser;
			try {
				parser = new DOMParser();
			}
			catch {
				// Fx60 defines DOMParser but throws an error when you construct
				// it from this context
				parser = Cc['@mozilla.org/xmlextras/domparser;1'].createInstance(Ci.nsIDOMParser);
			}
			doc = parser.parseFromString(wrappedNote, 'text/html');
		}

		let root = doc.getElementById('note-body');
		for (let child of root.children) {
			visit(child);
		}
		return root.innerHTML;
	},

	// /**
	//  * Provides unicode support and other additional features for regular expressions
	//  * See https://github.com/slevithan/xregexp for usage
	//  */
	XRegExp: typeof XRegExp !== "undefined" ? XRegExp : null
};

if (!Utilities.XRegExp) {
	{
		Utilities.XRegExp = xregexpAll.exports;
	}
}

{
	module.exports = Utilities;
}

})();
}(utilities));

var Utilities = utilities.exports;

var dateFormats = Object.freeze({"en-US":{"short":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"long":["January","February","March","April","May","June","July","August","September","October","November","December"]},"af-ZA":{"short":["Jan","Feb","Mrt","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Des"],"long":["Januarie","Februarie","Maart","April","Mei","Junie","Julie","Augustus","September","Oktober","November","Desember"]},"ar":{"short":["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"],"long":["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"]},"bg-BG":{"short":["Яну","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Ное","Дек"],"long":["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"]},"ca-AD":{"short":["gen","febr","març","abr","maig","juny","jul","ag","set","oct","nov","des"],"long":["gener","febrer","març","abril","maig","juny","juliol","agost","setembre","octubre","novembre","desembre"]},"cs-CZ":{"short":["Led","Úno","Bře","Dub","Kvě","Čvn","Čnc","Srp","Zář","Říj","Lis","Pro"],"long":["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"]},"da-DK":{"short":["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],"long":["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"]},"de":{"short":["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],"long":["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"]},"el-GR":{"short":["Ιαν","Φεβ","Μαρ","Απρ","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ","May"],"long":["January","October","November","December","February","March","April","May","June","July","August","September"]},"en-GB":{"short":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"long":["January","February","March","April","May","June","July","August","September","October","November","December"]},"es-ES":{"short":["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],"long":["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]},"fr-FR":{"short":["jan","fév","mar","avr","mai","juin","juil","aoû","sep","oct","nov","déc"],"long":["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"]},"et-EE":{"short":["jaan","veebr","märts","apr","mai","juun","juul","aug","sept","okt","nov","dets"],"long":["jaanuar","veebruar","märts","aprill","mai","juuni","juuli","august","september","oktoober","november","detsember"]},"eu-ES":{"short":["urt","ots","mar","api","mai","eka","uzt","abu","ira","urr","aza","abe"],"long":["urtarrila","otsaila","martxoa","apirila","maiatza","ekaina","uztaila","abuztua","iraila","urria","azaroa","abendua"]},"fa":{"short":["ژانویه","فوریه","مارس","آوریل","مه","ژوئن","ژوئیه","اوت","سپتامبر","اکتبر","نوامبر","دسامبر"],"long":["ژانویه","فوریه","مارس","آوریل","مه","ژوئن","ژوئیه","اوت","سپتامبر","اکتبر","نوامبر","دسامبر"]},"fi-FI":{"short":["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu"],"long":["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"]},"he-IL":{"short":["ינ'","פב'","מרץ","אפ'","מאי","יוני","יולי","אוג'","ספט'","אוק'","נוב'","דצ'"],"long":["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"]},"hr-HR":{"short":["Sij","Vel","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"],"long":["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"]},"hu-HU":{"short":["Jan.","Febr.","Márc.","Ápr.","Máj.","Jún.","Júl.","Aug.","Szept.","Okt.","Nov.","Dec."],"long":["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"]},"id-ID":{"short":["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"],"long":["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"]},"is-IS":{"short":["Jan","Feb","Mar","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"],"long":["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"]},"it-IT":{"short":["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],"long":["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"]},"ja-JP":{"short":["(1月)","(2月)","(3月)","(4月)","(5月)","(6月)","(7月)","(8月)","(9月)","(10月)","(11月)","(12月)"],"long":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"]},"km":{"short":["មករា","កុម្ភៈ","មីនា","មេសា","ឧសភា","មិថុនា","កក្កដា","សីហា","កញ្ញា","តុលា","វិច្ឆិកា","ធ្នូ"],"long":["មករា","កុម្ភៈ","មីនា","មេសា","ឧសភា","មិថុនា","កក្កដា","សីហា","កញ្ញា","តុលា","វិច្ឆិកា","ធ្នូ"]},"ko-KR":{"short":["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],"long":["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"]},"lt-LT":{"short":["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rgp","Rgs","Spl","Lap","Grd"],"long":["sausio","vasario","kovo","balandžio","gegužės","birželio","liepos","rugpjūčio","rugsėjo","spalio","lapkričio","gruodžio"]},"nb-NO":{"short":["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Des"],"long":["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"]},"nn-NO":{"short":["jan","feb","mar","apr","mai","jun","jul","aug","sep","okt","nov","des"],"long":["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"]},"nl-NL":{"short":["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],"long":["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"]},"pl-PL":{"short":["Sty","Lut","Mar","Kwi","Maj","Cze","Lip","Sie","Wrz","Paź","Lis","Gru"],"long":["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"]},"pt-BR":{"short":["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],"long":["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"]},"pt-PT":{"short":["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],"long":["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"]},"ro-RO":{"short":["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Noi","Dec"],"long":["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"]},"ru-RU":{"short":["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],"long":["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"]},"sk-SK":{"short":["Jan","Feb","Mar","Apr","Máj","Jún","Júl","Aug","Sep","Okt","Nov","Dec"],"long":["Január","Február","Marec","Apríl","Máj","Jún","Júl","August","September","Október","November","December"]},"sl-SI":{"short":["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],"long":["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"]},"sr-RS":{"short":["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],"long":["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"]},"sv-SE":{"short":["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],"long":["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"]},"th-TH":{"short":["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],"long":["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"]},"tr-TR":{"short":["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],"long":["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"]},"uk-UA":{"short":["Січ","Лют","Бер","Кві","Тра","Чер","Лип","Сер","Вер","Жов","Лис","Гру"],"long":["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"]},"vi-VN":{"short":["Thg01","Thg02","Thg03","Thg04","Thg05","Thg06","Thg07","Thg08","Thg09","Thg10","Thg11","Thg12"],"long":["Tháng Một","Tháng Hai","Tháng Ba","Tháng Tư","Tháng Năm","Tháng Sáu","Tháng Bảy","Tháng Tám","Tháng Chín","Tháng Mười","Tháng Mười Một","Tháng Mười Hai"]},"zh-CN":{"short":["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],"long":["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]},"zh-TW":{"short":["1 月","2 月","3 月","4 月","5 月","6 月","7 月","8 月","9 月","10 月","11 月","12 月"],"long":["1 月","2 月","3 月","4 月","5 月","6 月","7 月","8 月","9 月","10 月","11 月","12 月"]}});

var schemaJSON = Object.freeze({"version":20,"itemTypes":[{"itemType":"annotation","fields":[],"creatorTypes":[]},{"itemType":"artwork","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"artworkMedium","baseField":"medium"},{"field":"artworkSize"},{"field":"date"},{"field":"language"},{"field":"shortTitle"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"url"},{"field":"accessDate"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"artist","primary":true},{"creatorType":"contributor"}]},{"itemType":"attachment","fields":[{"field":"title"},{"field":"accessDate"},{"field":"url"}],"creatorTypes":[]},{"itemType":"audioRecording","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"audioRecordingFormat","baseField":"medium"},{"field":"seriesTitle"},{"field":"volume"},{"field":"numberOfVolumes"},{"field":"place"},{"field":"label","baseField":"publisher"},{"field":"date"},{"field":"runningTime"},{"field":"language"},{"field":"ISBN"},{"field":"shortTitle"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"url"},{"field":"accessDate"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"performer","primary":true},{"creatorType":"contributor"},{"creatorType":"composer"},{"creatorType":"wordsBy"}]},{"itemType":"bill","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"billNumber","baseField":"number"},{"field":"code"},{"field":"codeVolume","baseField":"volume"},{"field":"section"},{"field":"codePages","baseField":"pages"},{"field":"legislativeBody"},{"field":"session"},{"field":"history"},{"field":"date"},{"field":"language"},{"field":"url"},{"field":"accessDate"},{"field":"shortTitle"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"sponsor","primary":true},{"creatorType":"cosponsor"},{"creatorType":"contributor"}]},{"itemType":"blogPost","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"blogTitle","baseField":"publicationTitle"},{"field":"websiteType","baseField":"type"},{"field":"date"},{"field":"url"},{"field":"accessDate"},{"field":"language"},{"field":"shortTitle"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"commenter"},{"creatorType":"contributor"}]},{"itemType":"book","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"series"},{"field":"seriesNumber"},{"field":"volume"},{"field":"numberOfVolumes"},{"field":"edition"},{"field":"place"},{"field":"publisher"},{"field":"date"},{"field":"numPages"},{"field":"language"},{"field":"ISBN"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"editor"},{"creatorType":"translator"},{"creatorType":"seriesEditor"}]},{"itemType":"bookSection","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"bookTitle","baseField":"publicationTitle"},{"field":"series"},{"field":"seriesNumber"},{"field":"volume"},{"field":"numberOfVolumes"},{"field":"edition"},{"field":"place"},{"field":"publisher"},{"field":"date"},{"field":"pages"},{"field":"language"},{"field":"ISBN"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"editor"},{"creatorType":"bookAuthor"},{"creatorType":"translator"},{"creatorType":"seriesEditor"}]},{"itemType":"case","fields":[{"field":"caseName","baseField":"title"},{"field":"abstractNote"},{"field":"court"},{"field":"dateDecided","baseField":"date"},{"field":"docketNumber","baseField":"number"},{"field":"reporter"},{"field":"reporterVolume","baseField":"volume"},{"field":"firstPage","baseField":"pages"},{"field":"history"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"counsel"},{"creatorType":"contributor"}]},{"itemType":"computerProgram","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"seriesTitle"},{"field":"versionNumber"},{"field":"date"},{"field":"system"},{"field":"place"},{"field":"company","baseField":"publisher"},{"field":"programmingLanguage"},{"field":"ISBN"},{"field":"shortTitle"},{"field":"url"},{"field":"rights"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"accessDate"},{"field":"extra"}],"creatorTypes":[{"creatorType":"programmer","primary":true},{"creatorType":"contributor"}]},{"itemType":"conferencePaper","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"date"},{"field":"proceedingsTitle","baseField":"publicationTitle"},{"field":"conferenceName"},{"field":"place"},{"field":"publisher"},{"field":"volume"},{"field":"pages"},{"field":"series"},{"field":"language"},{"field":"DOI"},{"field":"ISBN"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"editor"},{"creatorType":"translator"},{"creatorType":"seriesEditor"}]},{"itemType":"dictionaryEntry","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"dictionaryTitle","baseField":"publicationTitle"},{"field":"series"},{"field":"seriesNumber"},{"field":"volume"},{"field":"numberOfVolumes"},{"field":"edition"},{"field":"place"},{"field":"publisher"},{"field":"date"},{"field":"pages"},{"field":"language"},{"field":"ISBN"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"editor"},{"creatorType":"translator"},{"creatorType":"seriesEditor"}]},{"itemType":"document","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"publisher"},{"field":"date"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"editor"},{"creatorType":"translator"},{"creatorType":"reviewedAuthor"}]},{"itemType":"email","fields":[{"field":"subject","baseField":"title"},{"field":"abstractNote"},{"field":"date"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"language"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"recipient"}]},{"itemType":"encyclopediaArticle","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"encyclopediaTitle","baseField":"publicationTitle"},{"field":"series"},{"field":"seriesNumber"},{"field":"volume"},{"field":"numberOfVolumes"},{"field":"edition"},{"field":"place"},{"field":"publisher"},{"field":"date"},{"field":"pages"},{"field":"ISBN"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"language"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"editor"},{"creatorType":"translator"},{"creatorType":"seriesEditor"}]},{"itemType":"film","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"distributor","baseField":"publisher"},{"field":"date"},{"field":"genre","baseField":"type"},{"field":"videoRecordingFormat","baseField":"medium"},{"field":"runningTime"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"director","primary":true},{"creatorType":"contributor"},{"creatorType":"scriptwriter"},{"creatorType":"producer"}]},{"itemType":"forumPost","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"forumTitle","baseField":"publicationTitle"},{"field":"postType","baseField":"type"},{"field":"date"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"}]},{"itemType":"hearing","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"committee"},{"field":"place"},{"field":"publisher"},{"field":"numberOfVolumes"},{"field":"documentNumber","baseField":"number"},{"field":"pages"},{"field":"legislativeBody"},{"field":"session"},{"field":"history"},{"field":"date"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"contributor","primary":true}]},{"itemType":"instantMessage","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"date"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"recipient"}]},{"itemType":"interview","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"date"},{"field":"interviewMedium","baseField":"medium"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"interviewee","primary":true},{"creatorType":"contributor"},{"creatorType":"interviewer"},{"creatorType":"translator"}]},{"itemType":"journalArticle","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"publicationTitle"},{"field":"volume"},{"field":"issue"},{"field":"pages"},{"field":"date"},{"field":"series"},{"field":"seriesTitle"},{"field":"seriesText"},{"field":"journalAbbreviation"},{"field":"language"},{"field":"DOI"},{"field":"ISSN"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"editor"},{"creatorType":"translator"},{"creatorType":"reviewedAuthor"}]},{"itemType":"letter","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"letterType","baseField":"type"},{"field":"date"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"recipient"}]},{"itemType":"magazineArticle","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"publicationTitle"},{"field":"volume"},{"field":"issue"},{"field":"date"},{"field":"pages"},{"field":"language"},{"field":"ISSN"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"translator"},{"creatorType":"reviewedAuthor"}]},{"itemType":"manuscript","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"manuscriptType","baseField":"type"},{"field":"place"},{"field":"date"},{"field":"numPages"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"translator"}]},{"itemType":"map","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"mapType","baseField":"type"},{"field":"scale"},{"field":"seriesTitle"},{"field":"edition"},{"field":"place"},{"field":"publisher"},{"field":"date"},{"field":"language"},{"field":"ISBN"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"cartographer","primary":true},{"creatorType":"contributor"},{"creatorType":"seriesEditor"}]},{"itemType":"newspaperArticle","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"publicationTitle"},{"field":"place"},{"field":"edition"},{"field":"date"},{"field":"section"},{"field":"pages"},{"field":"language"},{"field":"shortTitle"},{"field":"ISSN"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"translator"},{"creatorType":"reviewedAuthor"}]},{"itemType":"note","fields":[],"creatorTypes":[]},{"itemType":"patent","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"place"},{"field":"country"},{"field":"assignee"},{"field":"issuingAuthority"},{"field":"patentNumber","baseField":"number"},{"field":"filingDate"},{"field":"pages"},{"field":"applicationNumber"},{"field":"priorityNumbers"},{"field":"issueDate","baseField":"date"},{"field":"references"},{"field":"legalStatus"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"inventor","primary":true},{"creatorType":"attorneyAgent"},{"creatorType":"contributor"}]},{"itemType":"podcast","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"seriesTitle"},{"field":"episodeNumber","baseField":"number"},{"field":"audioFileType","baseField":"medium"},{"field":"runningTime"},{"field":"url"},{"field":"accessDate"},{"field":"language"},{"field":"shortTitle"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"podcaster","primary":true},{"creatorType":"contributor"},{"creatorType":"guest"}]},{"itemType":"preprint","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"genre","baseField":"type"},{"field":"repository","baseField":"publisher"},{"field":"archiveID","baseField":"number"},{"field":"place"},{"field":"date"},{"field":"series"},{"field":"seriesNumber"},{"field":"DOI"},{"field":"citationKey"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"shortTitle"},{"field":"language"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"editor"},{"creatorType":"translator"},{"creatorType":"reviewedAuthor"}]},{"itemType":"presentation","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"presentationType","baseField":"type"},{"field":"date"},{"field":"place"},{"field":"meetingName"},{"field":"url"},{"field":"accessDate"},{"field":"language"},{"field":"shortTitle"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"presenter","primary":true},{"creatorType":"contributor"}]},{"itemType":"radioBroadcast","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"programTitle","baseField":"publicationTitle"},{"field":"episodeNumber","baseField":"number"},{"field":"audioRecordingFormat","baseField":"medium"},{"field":"place"},{"field":"network","baseField":"publisher"},{"field":"date"},{"field":"runningTime"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"director","primary":true},{"creatorType":"scriptwriter"},{"creatorType":"producer"},{"creatorType":"castMember"},{"creatorType":"contributor"},{"creatorType":"guest"}]},{"itemType":"report","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"reportNumber","baseField":"number"},{"field":"reportType","baseField":"type"},{"field":"seriesTitle"},{"field":"place"},{"field":"institution","baseField":"publisher"},{"field":"date"},{"field":"pages"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"translator"},{"creatorType":"seriesEditor"}]},{"itemType":"statute","fields":[{"field":"nameOfAct","baseField":"title"},{"field":"abstractNote"},{"field":"code"},{"field":"codeNumber"},{"field":"publicLawNumber","baseField":"number"},{"field":"dateEnacted","baseField":"date"},{"field":"pages"},{"field":"section"},{"field":"session"},{"field":"history"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"}]},{"itemType":"thesis","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"thesisType","baseField":"type"},{"field":"university","baseField":"publisher"},{"field":"place"},{"field":"date"},{"field":"numPages"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"}]},{"itemType":"tvBroadcast","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"programTitle","baseField":"publicationTitle"},{"field":"episodeNumber","baseField":"number"},{"field":"videoRecordingFormat","baseField":"medium"},{"field":"place"},{"field":"network","baseField":"publisher"},{"field":"date"},{"field":"runningTime"},{"field":"language"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"director","primary":true},{"creatorType":"scriptwriter"},{"creatorType":"producer"},{"creatorType":"castMember"},{"creatorType":"contributor"},{"creatorType":"guest"}]},{"itemType":"videoRecording","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"videoRecordingFormat","baseField":"medium"},{"field":"seriesTitle"},{"field":"volume"},{"field":"numberOfVolumes"},{"field":"place"},{"field":"studio","baseField":"publisher"},{"field":"date"},{"field":"runningTime"},{"field":"language"},{"field":"ISBN"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"archive"},{"field":"archiveLocation"},{"field":"libraryCatalog"},{"field":"callNumber"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"director","primary":true},{"creatorType":"scriptwriter"},{"creatorType":"producer"},{"creatorType":"castMember"},{"creatorType":"contributor"}]},{"itemType":"webpage","fields":[{"field":"title"},{"field":"abstractNote"},{"field":"websiteTitle","baseField":"publicationTitle"},{"field":"websiteType","baseField":"type"},{"field":"date"},{"field":"shortTitle"},{"field":"url"},{"field":"accessDate"},{"field":"language"},{"field":"rights"},{"field":"extra"}],"creatorTypes":[{"creatorType":"author","primary":true},{"creatorType":"contributor"},{"creatorType":"translator"}]}],"meta":{"fields":{"date":{"type":"date"},"filingDate":{"type":"date"}}},"csl":{"types":{"article":["preprint"],"article-journal":["journalArticle"],"article-magazine":["magazineArticle"],"article-newspaper":["newspaperArticle"],"bill":["bill"],"book":["book"],"broadcast":["podcast","tvBroadcast","radioBroadcast"],"chapter":["bookSection"],"document":["document","attachment","note"],"entry-dictionary":["dictionaryEntry"],"entry-encyclopedia":["encyclopediaArticle"],"graphic":["artwork"],"hearing":["hearing"],"interview":["interview"],"legal_case":["case"],"legislation":["statute"],"manuscript":["manuscript"],"map":["map"],"motion_picture":["film","videoRecording"],"paper-conference":["conferencePaper"],"patent":["patent"],"personal_communication":["letter","email","instantMessage"],"post":["forumPost"],"post-weblog":["blogPost"],"report":["report"],"software":["computerProgram"],"song":["audioRecording"],"speech":["presentation"],"thesis":["thesis"],"webpage":["webpage"]},"fields":{"text":{"abstract":["abstractNote"],"archive":["archive"],"archive_location":["archiveLocation"],"authority":["court","legislativeBody","issuingAuthority"],"call-number":["callNumber","applicationNumber"],"chapter-number":["session"],"collection-number":["seriesNumber"],"collection-title":["seriesTitle","series"],"container-title":["publicationTitle","reporter","code"],"dimensions":["artworkSize","runningTime"],"DOI":["DOI"],"edition":["edition"],"event-place":["place"],"event-title":["meetingName","conferenceName"],"genre":["type","programmingLanguage"],"ISBN":["ISBN"],"ISSN":["ISSN"],"issue":["issue","priorityNumbers"],"journalAbbreviation":["journalAbbreviation"],"language":["language"],"license":["rights"],"medium":["medium","system"],"note":["extra"],"number":["number"],"number-of-pages":["numPages"],"number-of-volumes":["numberOfVolumes"],"page":["pages"],"publisher":["publisher"],"publisher-place":["place"],"references":["history","references"],"scale":["scale"],"section":["section","committee"],"shortTitle":["shortTitle"],"source":["libraryCatalog"],"status":["legalStatus"],"title":["title"],"title-short":["shortTitle"],"URL":["url"],"version":["versionNumber"],"volume":["volume","codeNumber"]},"date":{"accessed":"accessDate","issued":"date","submitted":"filingDate"}},"names":{"author":"author","bookAuthor":"container-author","castMember":"performer","composer":"composer","contributor":"contributor","director":"director","editor":"editor","guest":"guest","interviewer":"interviewer","producer":"producer","recipient":"recipient","reviewedAuthor":"reviewed-author","seriesEditor":"collection-editor","scriptwriter":"script-writer","translator":"translator"}},"locales":{"af-ZA":{"itemTypes":{"annotation":"Annotation","artwork":"Artwork","attachment":"Attachment","audioRecording":"Audio Recording","bill":"Bill","blogPost":"Blog Post","book":"Book","bookSection":"Book Section","case":"Case","computerProgram":"Software","conferencePaper":"Conference Paper","dictionaryEntry":"Dictionary Entry","document":"Document","email":"E-mail","encyclopediaArticle":"Encyclopedia Article","film":"Film","forumPost":"Forum Post","hearing":"Hearing","instantMessage":"Instant Message","interview":"Interview","journalArticle":"Journal Article","letter":"Letter","magazineArticle":"Magazine Article","manuscript":"Manuscript","map":"Map","newspaperArticle":"Newspaper Article","note":"Note","patent":"Patent","podcast":"Podcast","preprint":"Preprint","presentation":"Presentation","radioBroadcast":"Radio Broadcast","report":"Report","statute":"Statute","thesis":"Thesis","tvBroadcast":"TV Broadcast","videoRecording":"Video Recording","webpage":"Web Page"},"fields":{"abstractNote":"Abstract","accessDate":"Gebruik/Toegang verkry","applicationNumber":"Application Number","archive":"Archive","archiveID":"Archive ID","archiveLocation":"Loc. in Archive","artworkMedium":"Medium","artworkSize":"Artwork Size","assignee":"Assignee","audioFileType":"File Type","audioRecordingFormat":"Format","billNumber":"Bill Number","blogTitle":"Blog Title","bookTitle":"Book Title","callNumber":"Telefoonnommer","caseName":"Case Name","citationKey":"Citation Key","code":"Code","codeNumber":"Code Number","codePages":"Code Pages","codeVolume":"Code Volume","committee":"Committee","company":"Company","conferenceName":"Conference Name","country":"Country","court":"Court","date":"Datum","dateAdded":"Datum bygevoeg","dateDecided":"Date Decided","dateEnacted":"Date Enacted","dateModified":"Modified","dictionaryTitle":"Dictionary Title","distributor":"Distributor","docketNumber":"Docket Number","documentNumber":"Document Number","DOI":"DOI","edition":"Edition","encyclopediaTitle":"Encyclopedia Title","episodeNumber":"Episode Number","extra":"Extra","filingDate":"Filing Date","firstPage":"First Page","forumTitle":"Forum/Listserv Title","genre":"Genre","history":"History","institution":"Institution","interviewMedium":"Medium","ISBN":"ISBN","ISSN":"ISSN","issue":"Issue","issueDate":"Issue Date","issuingAuthority":"Issuing Authority","itemType":"Type","journalAbbreviation":"Joernaalafkorting","label":"Label","language":"Language","legalStatus":"Legal Status","legislativeBody":"Legislative Body","letterType":"Type","libraryCatalog":"Biblioteekkatalogus","manuscriptType":"Type","mapType":"Type","meetingName":"Meeting Name","nameOfAct":"Name of Act","network":"Network","number":"Number","numberOfVolumes":"# of Volumes","numPages":"# of Pages","pages":"Pages","patentNumber":"Patent Number","place":"Place","postType":"Post Type","presentationType":"Type","priorityNumbers":"Priority Numbers","proceedingsTitle":"Proceedings Title","programmingLanguage":"Prog. Language","programTitle":"Program Title","publicationTitle":"Publikasie","publicLawNumber":"Public Law Number","publisher":"Uitgewer","references":"References","reporter":"Reporter","reporterVolume":"Reporter Volume","reportNumber":"Report Number","reportType":"Report Type","repository":"Repository","rights":"Regte","runningTime":"Running Time","scale":"Scale","section":"Section","series":"Series","seriesNumber":"Series Number","seriesText":"Series Text","seriesTitle":"Series Title","session":"Session","shortTitle":"Short Title","studio":"Studio","subject":"Subject","system":"System","thesisType":"Type","title":"Title","university":"University","url":"URL","versionNumber":"Version","videoRecordingFormat":"Format","volume":"Volume","websiteTitle":"Website Title","websiteType":"Website Type"},"creatorTypes":{"artist":"Artist","attorneyAgent":"Attorney/Agent","author":"Author","bookAuthor":"Book Author","cartographer":"Cartographer","castMember":"Cast Member","commenter":"Commenter","composer":"Composer","contributor":"Contributor","cosponsor":"Cosponsor","counsel":"Counsel","director":"Director","editor":"Editor","guest":"Guest","interviewee":"Interview With","interviewer":"Interviewer","inventor":"Inventor","performer":"Performer","podcaster":"Podcaster","presenter":"Presenter","producer":"Producer","programmer":"Programmer","recipient":"Recipient","reviewedAuthor":"Reviewed Author","scriptwriter":"Scriptwriter","seriesEditor":"Series Editor","sponsor":"Sponsor","translator":"Translator","wordsBy":"Words By"}},"ar":{"itemTypes":{"annotation":"تعليق","artwork":"عمل فني","attachment":"مرفق","audioRecording":"تسجيل صوتي","bill":"مسودّة قانون","blogPost":"موضوع في مدونة","book":"كتاب","bookSection":"قسم في كتاب","case":"قضية","computerProgram":"Software","conferencePaper":"ورقة عمل في مؤتمر","dictionaryEntry":"كلمة في المعجم","document":"مستند","email":"بريد الكتروني","encyclopediaArticle":"مقالة في موسوعة","film":"فيلم","forumPost":"موضوع في منتدى","hearing":"سماع شهادة","instantMessage":"مراسلة فورية على الانترنت","interview":"مقابلة","journalArticle":"مقالة في دورية","letter":"خطاب","magazineArticle":"مقالة في مجلة","manuscript":"مخطوطة","map":"خريطة","newspaperArticle":"مقالة في جريدة","note":"ملاحظة","patent":"براءة الإختراع","podcast":"تدوينة وسائطية","preprint":"Preprint","presentation":"عرض تقديمي","radioBroadcast":"بث إذاعي","report":"تقرير","statute":"قانون","thesis":"أطروحة","tvBroadcast":"بث تلفزيوني","videoRecording":"تسجيل فيديو","webpage":"صفحة ويب"},"fields":{"abstractNote":"المستخلص","accessDate":"تاريخ الدخول","applicationNumber":"رقم الطلب","archive":"الارشيف","archiveID":"Archive ID","archiveLocation":"الموقع في الأرشيف","artworkMedium":"وسيط العمل الفني","artworkSize":"حجم العمل الفني","assignee":"المخول بالمهمة","audioFileType":"نوع الملف الصوتي","audioRecordingFormat":"صيغة التسجيل الصوتي","billNumber":"رقم مسودّة القانون","blogTitle":"عنوان المدونة","bookTitle":"عنوان الكتاب","callNumber":"رقم الإسترجاع","caseName":"اسم القضية","citationKey":"Citation Key","code":"التشفير","codeNumber":"رقم الرمز","codePages":"صفحات القانون","codeVolume":"مجلد القانون","committee":"اللجنة","company":"الشركة","conferenceName":"اسم المؤتمر","country":"البلد","court":"المحكمة","date":"التاريخ","dateAdded":"تاريخ الإضافة","dateDecided":"تاريخ الحكم","dateEnacted":"تاريخ سن القانون","dateModified":"تاريخ التعديل","dictionaryTitle":"عنوان القاموس","distributor":"الموزع","docketNumber":"رقم القضية","documentNumber":"رقم المستند","DOI":"معرف الكائن الرقمي","edition":"الطبعة","encyclopediaTitle":"عنوان الموسوعة","episodeNumber":"رقم الموضوع","extra":"معلومات إضافية","filingDate":"تاريخ الايداع","firstPage":"الصفحة الأولى","forumTitle":"عنوان المنتدى","genre":"النوع الأدبي","history":"التاريخ","institution":"المؤسسة","interviewMedium":"وسيط المقابلة","ISBN":"تدمك","ISSN":"تدمد","issue":"العدد","issueDate":"تاريخ الإصدار","issuingAuthority":"مسئولية الاصدار","itemType":"نوع العنصر","journalAbbreviation":"اختصار الدورية","label":"علامة","language":"اللغة","legalStatus":"الحالة القانونية","legislativeBody":"الجهة التشريعية","letterType":"نوع الخطاب","libraryCatalog":"فهرس المكتبة","manuscriptType":"نوع المخطوطة","mapType":"نوع الخريطة","meetingName":"اسم الإجتماع","nameOfAct":"اسم القانون","network":"الشبكة","number":"الرقم","numberOfVolumes":"عدد المجلدات","numPages":"عدد الصفحات","pages":"الصفحات","patentNumber":"رقم البرائة","place":"المكان","postType":"نوع الموضوع","presentationType":"نوع العرض التقديمي","priorityNumbers":"ارقام الأولوية","proceedingsTitle":"عنوان ورقة العمل","programmingLanguage":"Prog. Language","programTitle":"عنوان البرنامج","publicationTitle":"عنوان المنشور","publicLawNumber":"رقم القانون العام","publisher":"الناشر","references":"مراجع","reporter":"المراسل","reporterVolume":"مجلد الأحكام","reportNumber":"رقم التقرير","reportType":"نوع التقرير","repository":"Repository","rights":"الحقوق","runningTime":"وقت التشغيل","scale":"مقياس الرسم","section":"القسم","series":"السلسلة","seriesNumber":"رقم السلسلة","seriesText":"نص السلسلة","seriesTitle":"عنوان السلسلة","session":"الجلسة","shortTitle":"العنوان المختصر","studio":"الأستوديو","subject":"الموضوع","system":"النظام","thesisType":"نوع الأطروحة","title":"العنوان","university":"الجامعة","url":"عنوان الموقع","versionNumber":"الإصدارة","videoRecordingFormat":"صيغة التسجيل المرئي","volume":"المجلد","websiteTitle":"اسم موقع الويب","websiteType":"نوع موقع الويب"},"creatorTypes":{"artist":"الفنان","attorneyAgent":"المحامي أو الوكيل","author":"المؤلف","bookAuthor":"مؤلف كتاب","cartographer":"رسام الخريطة","castMember":"عضو طاقم التمثيل","commenter":"المعلق","composer":"الملحن","contributor":"اسم المشارك","cosponsor":"الراعي المشارك","counsel":"المستشار","director":"المخرج","editor":"المحرر","guest":"الضيف","interviewee":"مقابلة مع","interviewer":"المحاور","inventor":"المخترع","performer":"الفنان","podcaster":"المدون","presenter":"المقدم","producer":"المنتج","programmer":"المبرمج","recipient":"المتلقي","reviewedAuthor":"مؤلف مراجع","scriptwriter":"كاتب الحوار","seriesEditor":"محرر السلسلة","sponsor":"الراعي","translator":"المترجم","wordsBy":"من كلمات"}},"bg-BG":{"itemTypes":{"annotation":"Анотация","artwork":"Произведение на изкуството","attachment":"Приложение","audioRecording":"Звукозапис","bill":"Закон","blogPost":"Съобщение в блог","book":"Книга","bookSection":"Глава от книга","case":"Съдебно решение","computerProgram":"Software","conferencePaper":"Публикация от конференция","dictionaryEntry":"Определение в речник","document":"Документ","email":"Електронна поща","encyclopediaArticle":"Статия в енциклопедия","film":"Филм","forumPost":"Съобщение във форум","hearing":"Заседание","instantMessage":"Бързо съобщение","interview":"Интервю","journalArticle":"Статия в научно списание","letter":"Писмо","magazineArticle":"Статия в списание","manuscript":"Ръкопис","map":"Карта","newspaperArticle":"Статия във вестник","note":"Бележка","patent":"Патент","podcast":"Подкаст","preprint":"Preprint","presentation":"Презентация","radioBroadcast":"Радио излъчване","report":"Отчет","statute":"Подзаконов акт","thesis":"Дисертация","tvBroadcast":"Телевизионно излъчване","videoRecording":"Видео","webpage":"Интернет страница"},"fields":{"abstractNote":"Извлечение","accessDate":"Отворен на","applicationNumber":"Номер на молба","archive":"Archive","archiveID":"Archive ID","archiveLocation":"Позиция в архива","artworkMedium":"Медия на произведението:","artworkSize":"Размер на произведението:","assignee":"Изпълнител","audioFileType":"Вид файл","audioRecordingFormat":"Формат","billNumber":"Номер на закон","blogTitle":"Заглавие на блог","bookTitle":"Заглавие на книга","callNumber":"Телефонен номер","caseName":"Име на партида","citationKey":"Citation Key","code":"Кодекс","codeNumber":"Код","codePages":"Страници на законодателство","codeVolume":"Том на законодателство","committee":"Комитет","company":"Компания","conferenceName":"Име на конференцията","country":"Страна","court":"Съд","date":"Дата","dateAdded":"Добавен на:","dateDecided":"Дата на решение","dateEnacted":"Дата на влизане в сила","dateModified":"Променен на:","dictionaryTitle":"Заглавие на речник","distributor":"Дистрибутор","docketNumber":"Номер в регистър","documentNumber":"Номер на документ","DOI":"DOI","edition":"Издание","encyclopediaTitle":"Заглавие на енциклопедия","episodeNumber":"Номер на епизод","extra":"Допълнителни","filingDate":"Дата на архивиране","firstPage":"Първа страница","forumTitle":"Заглавия на форум/listserv","genre":"Жанр","history":"История","institution":"Институция","interviewMedium":"Медия","ISBN":"ISBN","ISSN":"ISSN","issue":"Брой","issueDate":"Дата на издаване","issuingAuthority":"Издаден от","itemType":"Тип","journalAbbreviation":"Съкратено име на списанието","label":"Етикет","language":"Език","legalStatus":"Законов статут","legislativeBody":"Законодателно тяло","letterType":"Вид","libraryCatalog":"Library Catalog","manuscriptType":"Вид","mapType":"Вид","meetingName":"Име на срещата","nameOfAct":"Име на закон","network":"Мрежа","number":"Номер","numberOfVolumes":"Номера на томовете","numPages":"брой страници","pages":"Страници","patentNumber":"Номер на патент","place":"Място","postType":"Вид съобщението","presentationType":"Вид","priorityNumbers":"Приоритетни номера","proceedingsTitle":"Заглавие на протокол","programmingLanguage":"Prog. Language","programTitle":"Заглавие на орграма","publicationTitle":"Издание","publicLawNumber":"Номер на закон","publisher":"Издател","references":"Отпратки","reporter":"Журналист","reporterVolume":"Том на стенограмата","reportNumber":"Номер на отчет","reportType":"Вид отчета","repository":"Repository","rights":"Права","runningTime":"Продължителност","scale":"Скала","section":"Глава","series":"Поредица","seriesNumber":"Номер на поредицата","seriesText":"Текст на поредицата","seriesTitle":"Заглавие на поредицата","session":"Сесия","shortTitle":"Късо заглавие","studio":"Студио","subject":"Тема","system":"Система","thesisType":"Вид","title":"Заглавие","university":"Университет","url":"Адрес","versionNumber":"Version","videoRecordingFormat":"Формат","volume":"Том","websiteTitle":"Заглавие на интернет страница","websiteType":"Вид интернет страницата"},"creatorTypes":{"artist":"Създател","attorneyAgent":"Адвокат/Пълномощтник","author":"Автор","bookAuthor":"Автор на книга","cartographer":"Картограф","castMember":"Член на Трупата","commenter":"Коментатор","composer":"Композитор","contributor":"Сътрудник","cosponsor":"Коспонсор","counsel":"Адвокат","director":"Режисьор","editor":"Редактор","guest":"Гост","interviewee":"Интервю с","interviewer":"Интервюиращ","inventor":"Откривател","performer":"Изпълнител","podcaster":"Автор на подкаст","presenter":"Изнесен от","producer":"Продуцент","programmer":"Програмист","recipient":"Получател","reviewedAuthor":"Рецензиран Автор","scriptwriter":"Сценарист","seriesEditor":"Редактор на Поредицата","sponsor":"Спонсор","translator":"Преводач","wordsBy":"Текст"}},"br":{"itemTypes":{"annotation":"Ennotadur","artwork":"Skeudennadur","attachment":"Pezh-stag","audioRecording":"Enrolladenn aodio","bill":"Raktres/kinnig lezenn","blogPost":"Embannadenn blog","book":"Levr","bookSection":"Chabistr levr","case":"Afer","computerProgram":"Meziant","conferencePaper":"Pennad koñferañs","dictionaryEntry":"Pennger geriadur","document":"Teuliad","email":"Postel","encyclopediaArticle":"Pennad hollouiziegezh","film":"Film","forumPost":"Evezhiadenn forom","hearing":"Odiañs","instantMessage":"Kemennadenn flapva","interview":"Atersadenn","journalArticle":"Pennad kelaouenn","letter":"Lizher","magazineArticle":"Pennad magazin","manuscript":"Dornskrid","map":"Kartenn","newspaperArticle":"Pennad kazetenn","note":"Notenn","patent":"Breved","podcast":"Podskignañ","preprint":"Preprint","presentation":"Kinnigadenn","radioBroadcast":"Abadenn radio","report":"Danevell","statute":"Akta lezennel","thesis":"Tezenn","tvBroadcast":"Abadenn TV","videoRecording":"Enrolladenn video","webpage":"Lec'hienn Web"},"fields":{"abstractNote":"Berradenn","accessDate":"Gwelet d'an/ar/al","applicationNumber":"Niver arload","archive":"Diell","archiveID":"Archive ID","archiveLocation":"Lec'hiadur en diell","artworkMedium":"Harp ar skeudenn","artworkSize":"Ment ar skeudennadur","assignee":"Dilezer","audioFileType":"Doare restr","audioRecordingFormat":"Stumm","billNumber":"Niverenn prezegenn","blogTitle":"Titl blog","bookTitle":"Titl al levr","callNumber":"Niver-envel","caseName":"Anv an afer","citationKey":"Citation Key","code":"Kod","codeNumber":"Niver kod","codePages":"Kod ar pajennoù","codeVolume":"Kod al levrenn","committee":"Komite","company":"Kumpaniezh","conferenceName":"Anv prezegenn","country":"Bro","court":"Lez-varn","date":"Deiziad","dateAdded":"Deiziad ouzhpennañ","dateDecided":"Deiziad an diviz","dateEnacted":"Embannet d'an/ar/al","dateModified":"Deiziad kemmañ","dictionaryTitle":"Titl ar geriadur","distributor":"Dasparzher","docketNumber":"Niver reked","documentNumber":"Niver an teuliad","DOI":"DOI","edition":"Embannadur","encyclopediaTitle":"Titl hollouiziegezh","episodeNumber":"Niver ar rann","extra":"Traoù dibarr","filingDate":"Deiziad leuniadur","firstPage":"Pajenn gentañ","forumTitle":"Titl ar forom/Listserv","genre":"Doare","history":"Istor","institution":"Ensavadur","interviewMedium":"Media","ISBN":"ISBN","ISSN":"ISSN","issue":"Niverenn","issueDate":"Deiziad embann","issuingAuthority":"Aozadur a embann","itemType":"Doare","journalAbbreviation":"Berradur anv kelaouenn","label":"Label","language":"Yezh","legalStatus":"Statudoù lezennel","legislativeBody":"Korf lezennel","letterType":"Doare","libraryCatalog":"Dastumad levraoueg","manuscriptType":"Doare","mapType":"Doare","meetingName":"Anv an emvod","nameOfAct":"Anv an akta","network":"Kenrouedad","number":"Niver","numberOfVolumes":"# a levrennoù","numPages":"# a bajennoù","pages":"Pajennoù","patentNumber":"Niver breved","place":"Lec'h","postType":"Doare embannadenn","presentationType":"Doare","priorityNumbers":"Niver priorelezh","proceedingsTitle":"Titl an aktoù","programmingLanguage":"Yezh brogrammiñ","programTitle":"Titl ar program","publicationTitle":"Embannadenn","publicLawNumber":"Niver ofisiel an akta","publisher":"Embanner","references":"Daveennoù","reporter":"Teskad","reporterVolume":"Levrenn dastumad","reportNumber":"Niver an danevell","reportType":"Doare danevell","repository":"Repository","rights":"Aotreadurioù","runningTime":"Padelezh","scale":"Skeul","section":"Kevrenn","series":"Dastumad","seriesNumber":"Niverenn en dastumad","seriesText":"Testenn an dastumad","seriesTitle":"Titl an dastumad","session":"Dalc'h","shortTitle":"Titl berr","studio":"Studio","subject":"Sujed","system":"Sistem","thesisType":"Doare","title":"Titl","university":"Skol-veur","url":"URL","versionNumber":"Stumm","videoRecordingFormat":"Stumm","volume":"Levrenn","websiteTitle":"Titl al lec'hienn","websiteType":"Doare lec'hienn Web"},"creatorTypes":{"artist":"Arzour","attorneyAgent":"Dileuriad/Ajant","author":"Aozer","bookAuthor":"Aozer al levr","cartographer":"Kartenner","castMember":"Ezel ar c'homedianeta","commenter":"Displeger","composer":"Kompozer","contributor":"Kendaoler","cosponsor":"Ken-tad-paeron","counsel":"Kuzul","director":"Rener","editor":"Embanner","guest":"Den pedet","interviewee":"Aterset gant","interviewer":"Aterser","inventor":"Ijiner","performer":"Jubenner","podcaster":"Podskigner","presenter":"Kinniger","producer":"Produer","programmer":"Programmer","recipient":"Resever","reviewedAuthor":"Aozer niverennet","scriptwriter":"Skriver-skriptoù","seriesEditor":"Embanner heuliadennoù","sponsor":"Sponsor","translator":"Troer","wordsBy":"Gerioù gant"}},"ca-AD":{"itemTypes":{"annotation":"Anotació","artwork":"Peça artística","attachment":"Fitxer adjunt","audioRecording":"Enregistrament d'àudio","bill":"Llei","blogPost":"Entrada de bloc","book":"Llibre","bookSection":"Capítol d'un llibre","case":"Cas","computerProgram":"Programari","conferencePaper":"Text d'una conferència","dictionaryEntry":"Entrada de diccionari","document":"Document","email":"Correu electrònic","encyclopediaArticle":"Article enciclopèdic","film":"Pel·lícula","forumPost":"Comentari en un fòrum","hearing":"Audició","instantMessage":"Missatge instantani","interview":"Entrevista","journalArticle":"Article de revista acadèmica","letter":"Carta","magazineArticle":"Article de revista","manuscript":"Manuscrit","map":"Mapa","newspaperArticle":"Article de premsa","note":"Nota","patent":"Patent","podcast":"Podcast","preprint":"Preprint","presentation":"Presentació","radioBroadcast":"Emissió de ràdio","report":"Informe","statute":"Estatut","thesis":"Tesi","tvBroadcast":"Emissió de televisió","videoRecording":"Enregistrament de vídeo","webpage":"Pàgina web"},"fields":{"abstractNote":"Resum","accessDate":"Últim accés","applicationNumber":"Número d'aplicació","archive":"Arxiu","archiveID":"Archive ID","archiveLocation":"Localització a l'arxiu","artworkMedium":"Mitjà artístic","artworkSize":"Mida","assignee":"Assignatari","audioFileType":"Tipus de fitxer","audioRecordingFormat":"Format","billNumber":"Número de llei","blogTitle":"Títol del blog","bookTitle":"Títol del llibre","callNumber":"Número de catàleg","caseName":"Nom del cas","citationKey":"Citation Key","code":"Codi","codeNumber":"Número del codi","codePages":"Pàgines del codi","codeVolume":"Volum del codi","committee":"Comitè","company":"Empresa","conferenceName":"Títol de la conferència","country":"País","court":"Tribunal","date":"Data","dateAdded":"Afegit","dateDecided":"Data de decisió","dateEnacted":"Data d'aprovació","dateModified":"Modificat","dictionaryTitle":"Títol del diccionari","distributor":"Distribuïdor","docketNumber":"Número d'expedient","documentNumber":"Número de document","DOI":"DOI","edition":"Edició","encyclopediaTitle":"Títol de l'enciclopèdia","episodeNumber":"Número d'episodi","extra":"Extra","filingDate":"Data de presentació","firstPage":"Primera pàgina","forumTitle":"Títol de fòrum/llista","genre":"Gènere","history":"Història","institution":"Institució","interviewMedium":"Mitjà","ISBN":"ISBN","ISSN":"ISSN","issue":"Número","issueDate":"Data d'emissió","issuingAuthority":"Autoritat emissora","itemType":"Tipus","journalAbbreviation":"Abreviatura de la revista","label":"Etiqueta","language":"Llengua","legalStatus":"Estatus jurídic","legislativeBody":"Cos legislatiu","letterType":"Tipus","libraryCatalog":"Catàleg de la biblioteca","manuscriptType":"Tipus","mapType":"Tipus","meetingName":"Nom de la trobada","nameOfAct":"Nom de la llei","network":"Xarxa","number":"Número","numberOfVolumes":"Nre. de volums","numPages":"Nre. de pàgines","pages":"Pàgines","patentNumber":"Número de patent","place":"Lloc","postType":"Tipus d'escrit","presentationType":"Tipus","priorityNumbers":"Números de prioritat","proceedingsTitle":"Títol de la ponència","programmingLanguage":"Llenguatge de prog.","programTitle":"Títol del programa","publicationTitle":"Publicació","publicLawNumber":"Número de dret públic","publisher":"Editorial","references":"Referències","reporter":"Reporter","reporterVolume":"Volum del reporter","reportNumber":"Número d'informe","reportType":"Tipus d'informe","repository":"Repository","rights":"Drets","runningTime":"Durada","scale":"Escala","section":"Secció","series":"Sèrie","seriesNumber":"Número de la sèrie","seriesText":"Text de la sèrie","seriesTitle":"Títol de la sèrie","session":"Sessió","shortTitle":"Títol curt","studio":"Estudi","subject":"Tema","system":"Sistema","thesisType":"Tipus","title":"Títol","university":"Universitat","url":"URL","versionNumber":"Versió","videoRecordingFormat":"Format","volume":"Volum","websiteTitle":"Títol del web","websiteType":"Tipus de pàgina web"},"creatorTypes":{"artist":"Artista","attorneyAgent":"Representant/Agent","author":"Autor","bookAuthor":"Autor del llibre","cartographer":"Cartògraf","castMember":"Membre del repartiment","commenter":"Comentarista","composer":"Compositor","contributor":"Col·laborador","cosponsor":"Copatrocinador","counsel":"Conseller","director":"Director","editor":"Editor","guest":"Convidat","interviewee":"Entrevistat","interviewer":"Entrevistador","inventor":"Inventor","performer":"Intèrpret","podcaster":"Podcaster","presenter":"Presentador","producer":"Productor","programmer":"Programador","recipient":"Receptor","reviewedAuthor":"Autor revisat","scriptwriter":"Guionista","seriesEditor":"Editor de la sèrie","sponsor":"Esponsor","translator":"Traductor","wordsBy":"Lletrista"}},"cs-CZ":{"itemTypes":{"annotation":"Anotace","artwork":"Umělecké dílo","attachment":"Příloha","audioRecording":"Audio nahrávka","bill":"Návrh zákona","blogPost":"Příspěvek v blogu","book":"Kniha","bookSection":"Kapitola knihy","case":"Případ","computerProgram":"Software","conferencePaper":"Konferenční příspěvek","dictionaryEntry":"Záznam ve slovníku","document":"Dokument","email":"E-mail","encyclopediaArticle":"Článek v encyklopedii","film":"Film","forumPost":"Příspěvek ve fóru","hearing":"Slyšení","instantMessage":"Zpráva IM","interview":"Rozhovor","journalArticle":"Článek v časopise","letter":"Dopis","magazineArticle":"Článek v magazínu","manuscript":"Rukopis","map":"Mapa","newspaperArticle":"Článek v novinách","note":"Poznámka","patent":"Patent","podcast":"Podcast","preprint":"Preprint","presentation":"Prezentace","radioBroadcast":"Pořad v rádiu","report":"Zpráva","statute":"Nařízení","thesis":"Vysokoškolská kvalifikační práce","tvBroadcast":"Pořad v TV","videoRecording":"Video nahrávka","webpage":"Webová stránka"},"fields":{"abstractNote":"Abstrakt","accessDate":"Přístup","applicationNumber":"Číslo žádosti","archive":"Archiv","archiveID":"Archive ID","archiveLocation":"Místo v archivu","artworkMedium":"Médium","artworkSize":"Velikost díla","assignee":"Pověřený","audioFileType":"Typ souboru","audioRecordingFormat":"Formát","billNumber":"Číslo zákona","blogTitle":"Název blogu","bookTitle":"Jméno knihy","callNumber":"Signatura","caseName":"Jméno případu","citationKey":"Citation Key","code":"Zákoník","codeNumber":"Kódové číslo","codePages":"Stránky zákoníku","codeVolume":"Ročník zákoníku","committee":"Výbor","company":"Společnost","conferenceName":"Jméno konference","country":"Země","court":"Soud","date":"Datum","dateAdded":"Datum přidání","dateDecided":"Datum rozhodnutí","dateEnacted":"Datum schválení","dateModified":"Upraveno","dictionaryTitle":"Název slovníku","distributor":"Distributor","docketNumber":"Číslo spisu","documentNumber":"Číslo dokumentu","DOI":"DOI","edition":"Vydání","encyclopediaTitle":"Jméno encyklopedie","episodeNumber":"Číslo epizody","extra":"Extra","filingDate":"Datum zápisu","firstPage":"První strana","forumTitle":"Název fóra","genre":"Žánr","history":"Historie","institution":"Instituce","interviewMedium":"Médium","ISBN":"ISBN","ISSN":"ISSN","issue":"Číslo","issueDate":"Datum vydání","issuingAuthority":"Vydávající úřad","itemType":"Typ","journalAbbreviation":"Zkrácený název časopisu","label":"Označení","language":"Jazyk","legalStatus":"Zákonný status","legislativeBody":"Zákonodárný orgán","letterType":"Typ","libraryCatalog":"Katalog knihovny","manuscriptType":"Typ","mapType":"Typ","meetingName":"Název setkání","nameOfAct":"Název zákona","network":"Síť","number":"Číslo","numberOfVolumes":"Počet ročníků","numPages":"# stran","pages":"Rozsah","patentNumber":"Číslo patentů","place":"Místo","postType":"Typ příspěvku","presentationType":"Typ","priorityNumbers":"Číslo priority","proceedingsTitle":"Jméno sborníku","programmingLanguage":"Prog. jazyk","programTitle":"Název programu","publicationTitle":"Publikace","publicLawNumber":"Číslo zákona","publisher":"Vydavatel","references":"Reference","reporter":"Sbírka soudních rozhodnutí","reporterVolume":"Ročník sbírky","reportNumber":"Číslo zprávy","reportType":"Druhy zprávy","repository":"Repository","rights":"Práva","runningTime":"Čas","scale":"Měřítko","section":"Sekce","series":"Série","seriesNumber":"Číslo série","seriesText":"Text série","seriesTitle":"Název série","session":"Zasedání","shortTitle":"Krátký název","studio":"Studio","subject":"Subjekt","system":"Systém","thesisType":"Typ","title":"Název","university":"Univerzita","url":"URL","versionNumber":"Verze","videoRecordingFormat":"Formát","volume":"Ročník","websiteTitle":"Název stránky","websiteType":"Typ webové stránky"},"creatorTypes":{"artist":"Výtvarník","attorneyAgent":"Advokát/zástupce","author":"Autor","bookAuthor":"Autor knihy","cartographer":"Kartograf","castMember":"Člen obsazení","commenter":"Komentátor","composer":"Skladatel","contributor":"Přispěvatel","cosponsor":"Spolusponzor","counsel":"Právní zástupce","director":"Režisér","editor":"Editor","guest":"Host","interviewee":"Rozhovor s","interviewer":"Tazatel","inventor":"Vynálezce","performer":"Účinkující","podcaster":"Autor podcastu","presenter":"Prezentující","producer":"Producent","programmer":"Programátor","recipient":"Příjemce","reviewedAuthor":"Autor revize","scriptwriter":"Scénárista","seriesEditor":"Editor série","sponsor":"Sponzor","translator":"Překladatel","wordsBy":"Texty"}},"da-DK":{"itemTypes":{"annotation":"Annotering","artwork":"Billede/skulptur","attachment":"Vedhæftning","audioRecording":"Lydoptagelse","bill":"Lovforslag","blogPost":"Blog-indlæg","book":"Bog","bookSection":"Bidrag til bog","case":"Retssag/Dom","computerProgram":"Software","conferencePaper":"Konferencebidrag","dictionaryEntry":"Ordbogsopslag","document":"Dokument","email":"E-mail","encyclopediaArticle":"Leksikonartikel","film":"Film","forumPost":"Forum-indlæg","hearing":"Høring","instantMessage":"Besked","interview":"Interview","journalArticle":"Tidsskriftsartikel","letter":"Brev","magazineArticle":"Artikel i blad","manuscript":"Manuskript","map":"Kort","newspaperArticle":"Avisartikel","note":"Note","patent":"Patent","podcast":"Podcast","preprint":"Preprint","presentation":"Præsentation","radioBroadcast":"Radioudsendelse","report":"Rapport","statute":"Lov (vedtaget)","thesis":"Afhandling","tvBroadcast":"TV-udsendelse","videoRecording":"Videooptagelse","webpage":"Web-side"},"fields":{"abstractNote":"Resumé","accessDate":"Set d.","applicationNumber":"Ansøgning nr.","archive":"Samling","archiveID":"Archive ID","archiveLocation":"Placering i samlingen","artworkMedium":"Medium","artworkSize":"Værkets størrelse","assignee":"Ansvarlig","audioFileType":"Filtype","audioRecordingFormat":"Format","billNumber":"Lovforslagets nr.","blogTitle":"Bloggens titel","bookTitle":"Bogens titel","callNumber":"Opstillingssignatur","caseName":"Sagens navn","citationKey":"Citation Key","code":"Lovsamling","codeNumber":"Nummer","codePages":"Sider","codeVolume":"Bind","committee":"Udvalg","company":"Selskab","conferenceName":"Konferencens navn","country":"Land","court":"Domstol","date":"Tidspunkt","dateAdded":"Tilføjet d.","dateDecided":"Dom afsagt d.","dateEnacted":"Vedtaget d.","dateModified":"Ændret d.","dictionaryTitle":"Ordbogens titel","distributor":"Selskab","docketNumber":"Dossier nr.","documentNumber":"Dokument nr.","DOI":"DOI","edition":"Udgave","encyclopediaTitle":"Leksikonets titel","episodeNumber":"Afsnit nr.","extra":"Ekstra","filingDate":"Indlemmet d.","firstPage":"Første side","forumTitle":"Titel på Forum/Listserv","genre":"Genre","history":"Historie","institution":"Institution","interviewMedium":"Medium","ISBN":"ISBN","ISSN":"ISSN","issue":"Nummer","issueDate":"Udstedt d.","issuingAuthority":"Myndighed","itemType":"Type","journalAbbreviation":"Tidsskr.forkort.","label":"Pladeselskab","language":"Sprog","legalStatus":"Juridisk status","legislativeBody":"Lovgivende organ","letterType":"Type","libraryCatalog":"Bibliotekskatalog","manuscriptType":"Type","mapType":"Type","meetingName":"Mødets navn","nameOfAct":"Lovens navn","network":"Station (radio/TV)","number":"Nummer","numberOfVolumes":"Antal bind","numPages":"Antal sider","pages":"Sider","patentNumber":"Patentnummer","place":"Sted","postType":"Type (post)","presentationType":"Type","priorityNumbers":"Prioritetsnumre","proceedingsTitle":"Titel på proceedings","programmingLanguage":"Prog. Language","programTitle":"Programmets titel","publicationTitle":"Publikationens titel","publicLawNumber":"Public Law Number (USA)","publisher":"Udgiver/Forlag","references":"Referencer","reporter":"Referat-samling","reporterVolume":"Referat-bind","reportNumber":"Rapportens nr.","reportType":"Rapporttype","repository":"Repository","rights":"Rettigheder","runningTime":"Længde (tid)","scale":"Skala","section":"Paragraf","series":"Serie","seriesNumber":"Nummer i serien","seriesText":"Serie: suppl. tekst","seriesTitle":"Serietitel","session":"Behandlet","shortTitle":"Forkortet titel","studio":"Studie","subject":"Emne","system":"System","thesisType":"Type","title":"Titel","university":"Universitet","url":"URL","versionNumber":"Version","videoRecordingFormat":"Format","volume":"Bind/Årgang","websiteTitle":"Webstedets titel","websiteType":"Type (websted)"},"creatorTypes":{"artist":"Kunstner/Ophav","attorneyAgent":"Advokat","author":"Forfatter/Ophav","bookAuthor":"Bogens forfatter","cartographer":"Kartograf","castMember":"Medvirkende","commenter":"Kommentator","composer":"Komponist","contributor":"Anden bidragyder","cosponsor":"Medforslagsstiller","counsel":"Advokat","director":"Instruktør/Ophav","editor":"Redaktør","guest":"Gæst","interviewee":"Inverview med","interviewer":"Interviewer","inventor":"Opfinder","performer":"Udøver","podcaster":"Ophav til podcast","presenter":"Forelæser/Ophav","producer":"Producent","programmer":"Programmør","recipient":"Modtager","reviewedAuthor":"Anmeldt forfatter","scriptwriter":"Manuskriptforfatter","seriesEditor":"Seriens redaktør","sponsor":"Forslagsstiller","translator":"Oversætter","wordsBy":"Tekster af"}},"de":{"itemTypes":{"annotation":"Anmerkung","artwork":"Kunstwerk","attachment":"Anhang","audioRecording":"Tonaufnahme","bill":"Gesetzentwurf","blogPost":"Blog-Post","book":"Buch","bookSection":"Buchteil","case":"Fall","computerProgram":"Software","conferencePaper":"Konferenz-Paper","dictionaryEntry":"Wörterbucheintrag","document":"Dokument","email":"E-Mail","encyclopediaArticle":"Enzyklopädieartikel","film":"Film","forumPost":"Foren-Eintrag","hearing":"Anhörung","instantMessage":"Instant-Message","interview":"Interview","journalArticle":"Zeitschriftenartikel","letter":"Brief","magazineArticle":"Magazin-Artikel","manuscript":"Manuskript","map":"Karte","newspaperArticle":"Zeitungsartikel","note":"Notiz","patent":"Patent","podcast":"Podcast","preprint":"Preprint","presentation":"Vortrag","radioBroadcast":"Radiosendung","report":"Bericht","statute":"Gesetz","thesis":"Dissertation","tvBroadcast":"Fernsehsendung","videoRecording":"Videoaufnahme","webpage":"Webseite"},"fields":{"abstractNote":"Zusammenfassung","accessDate":"Heruntergeladen am","applicationNumber":"Bewerbungsnummer","archive":"Archiv","archiveID":"Archiv-ID","archiveLocation":"Standort im Archiv","artworkMedium":"Medium","artworkSize":"Größe des Kunstwerks","assignee":"Abtretungsempfänger","audioFileType":"Dateityp","audioRecordingFormat":"Format","billNumber":"Nummer des Gesetzentwurfs","blogTitle":"Titel des Blogs","bookTitle":"Buchtitel","callNumber":"Signatur","caseName":"Name des Falls","citationKey":"Zitierschlüssel","code":"Code","codeNumber":"Codenummer","codePages":"Seiten des Codes","codeVolume":"Band des Codes","committee":"Ausschuss","company":"Firma","conferenceName":"Name der Konferenz","country":"Land","court":"Gericht","date":"Datum","dateAdded":"Hinzugefügt am","dateDecided":"Beschlussdatum","dateEnacted":"Datum des Inkrafttretens","dateModified":"Geändert am","dictionaryTitle":"Titel des Wörterbuchs","distributor":"Verleih","docketNumber":"Aktenzeichen","documentNumber":"Dokumentennummer","DOI":"DOI","edition":"Auflage","encyclopediaTitle":"Titel der Enzyklopädie","episodeNumber":"Nummer der Folge","extra":"Extra","filingDate":"Datum der Einreichung","firstPage":"Erste Seite","forumTitle":"Titel des Forums/Listservs","genre":"Genre","history":"Geschichte","institution":"Institution","interviewMedium":"Medium","ISBN":"ISBN","ISSN":"ISSN","issue":"Ausgabe","issueDate":"Erscheinungsdatum","issuingAuthority":"Herausgeber","itemType":"Typ","journalAbbreviation":"Zeitschriften-Abkürzung","label":"Label","language":"Sprache","legalStatus":"Rechtsstatus","legislativeBody":"Gesetzgebende Körperschaft","letterType":"Art","libraryCatalog":"Bibliothekskatalog","manuscriptType":"Art","mapType":"Art","meetingName":"Name der Sitzung","nameOfAct":"Name des Erlasses","network":"Netzwerk","number":"Nummer","numberOfVolumes":"# von Bänden","numPages":"Anzahl der Seiten","pages":"Seiten","patentNumber":"Patentnummer","place":"Ort","postType":"Art von Eintrag","presentationType":"Art","priorityNumbers":"Prioritätsnummern","proceedingsTitle":"Titel des Konferenzbandes","programmingLanguage":"Programmiersprache","programTitle":"Name des Programms","publicationTitle":"Publikation","publicLawNumber":"Öffentliche Gesetzesnummer","publisher":"Verlag","references":"Quellenangaben","reporter":"Gesetzessammlung","reporterVolume":"Nummer der Gesetzessammlung","reportNumber":"Nummer des Berichts","reportType":"Art von Bericht","repository":"Repositorium","rights":"Rechte","runningTime":"Laufzeit","scale":"Maßstab","section":"Teil","series":"Reihe","seriesNumber":"Nummer der Reihe","seriesText":"Reihe Text","seriesTitle":"Titel der Reihe","session":"Sitzung","shortTitle":"Kurztitel","studio":"Studio","subject":"Betreff","system":"System","thesisType":"Art","title":"Titel","university":"Universität","url":"URL","versionNumber":"Version","videoRecordingFormat":"Format","volume":"Band","websiteTitle":"Titel der Website","websiteType":"Art der Webseite"},"creatorTypes":{"artist":"Künstler","attorneyAgent":"Anwalt/Agent","author":"Autor","bookAuthor":"Buchautor","cartographer":"Kartograph","castMember":"Ensemble","commenter":"Kommentator","composer":"Komponist","contributor":"Mitarbeiter","cosponsor":"Mitunterzeichner","counsel":"Anwalt","director":"Regisseur","editor":"Herausgeber","guest":"Gast","interviewee":"Interview mit","interviewer":"Interviewer","inventor":"Erfinder","performer":"Darsteller","podcaster":"Podcaster","presenter":"Vortragender","producer":"Produzent","programmer":"Programmierer","recipient":"Empfänger","reviewedAuthor":"Rezensierter Autor","scriptwriter":"Drehbuchautor","seriesEditor":"Hrsg. der Reihe","sponsor":"Sponsor","translator":"Übersetzer","wordsBy":"Text von"}},"el-GR":{"itemTypes":{"annotation":"Annotation","artwork":"Έργο τέχνης","attachment":"Συνημμένο","audioRecording":"Εγγραφή ήχου","bill":"Λογαριασμός","blogPost":"Ανάρτηση","book":"Βιβλίο","bookSection":"Ενότητα Βιβλίου","case":"Υπόθεση","computerProgram":"Λογισμικό","conferencePaper":"Άρθρο Συνεδρίου","dictionaryEntry":"Εισαγωγή λεξικού","document":"Έγγραφο","email":"ηλ. μήνυμα","encyclopediaArticle":"Άρθρο εγκυκλοπαίδειας","film":"Ταινία","forumPost":"Δημοσίευση φόρουμ","hearing":"Ακρόαση","instantMessage":"Άμεσο Μήνυμα","interview":"Συνέντευξη","journalArticle":"Άρθρο Επιστημονικού Περιοδικού","letter":"Επιστολή","magazineArticle":"Άρθρο Περιοδικού","manuscript":"Χειρόγραφο","map":"Χάρτης","newspaperArticle":"Άρθρο Εφημερίδας","note":"Σημείωση","patent":"Ευρεσιτεχνία","podcast":"Podcast","preprint":"Preprint","presentation":"Παρουσίαση","radioBroadcast":"Ραδιοφωνική Μετάδοση","report":"Αναφορά","statute":"Νόμος","thesis":"Διατριβή","tvBroadcast":"Τηλεοπτική Μετάδοση","videoRecording":"Εγγραφή Βίντεο","webpage":"Ιστοσελίδα"},"fields":{"abstractNote":"Περίληψη","accessDate":"Πρόσβαση","applicationNumber":"Application Number","archive":"Αρχείο","archiveID":"Archive ID","archiveLocation":"Τοπ. στο Αρχείο","artworkMedium":"Μέσο","artworkSize":"Μέγεθος έργου τέχνης","assignee":"Assignee","audioFileType":"Τύπος Αρχείου","audioRecordingFormat":"Μορφή","billNumber":"Αριθμός Λογαριασμού","blogTitle":"Blog Title","bookTitle":"Τίτλος Βιβλίου","callNumber":"Αριθμός κλήσης","caseName":"Case Name","citationKey":"Citation Key","code":"Κώδικας","codeNumber":"Code Number","codePages":"Code Pages","codeVolume":"Code Volume","committee":"Επιτροπή","company":"Εταιρία","conferenceName":"Όνομα Συνεδρίου","country":"Χώρα","court":"Δικαστήριο","date":"Ημερομηνία","dateAdded":"Ημερομηνία προσθήκης","dateDecided":"Date Decided","dateEnacted":"Date Enacted","dateModified":"Τροποποιήθηκε","dictionaryTitle":"Τίτλος Λεξικού","distributor":"Διανομέας","docketNumber":"Docket Number","documentNumber":"Document Number","DOI":"DOI","edition":"Έκδοση","encyclopediaTitle":"Τίτλος Εγκυκλοπαίδειας","episodeNumber":"Αριθμός Επεισοδίου","extra":"Επιπλέον","filingDate":"Filing Date","firstPage":"Πρώτη Σελίδα","forumTitle":"Forum/Listserv Title","genre":"Είδος","history":"History","institution":"Ίδρυμα","interviewMedium":"Μέσο","ISBN":"ISBN","ISSN":"ISSN","issue":"Τεύχος","issueDate":"Ημερομηνία Έκδοσης","issuingAuthority":"Issuing Authority","itemType":"Τύπος","journalAbbreviation":"Συντομογραφία περιοδικού","label":"Ετικέτα","language":"Γλώσσα","legalStatus":"Νομική Υπόσταση","legislativeBody":"Νομοθετικό Σώμα","letterType":"Τύπος","libraryCatalog":"Κατάλογος Βιβλιοθήκης","manuscriptType":"Τύπος","mapType":"Τύπος","meetingName":"Όνομα Σύσκεψης","nameOfAct":"Name of Act","network":"Δίκτυο","number":"Αριθμός","numberOfVolumes":"# Τόμων","numPages":"# από Σελίδες","pages":"Σελίδες","patentNumber":"Αριθμός Ευρεσιτεχνίας","place":"Τόπος","postType":"Post Type","presentationType":"Τύπος","priorityNumbers":"Αριθμοί προτεραιότητας","proceedingsTitle":"Proceedings Title","programmingLanguage":"Γλώσσα προγραμ.","programTitle":"Program Title","publicationTitle":"Δημοσίευμα","publicLawNumber":"Public Law Number","publisher":"Εκδότης","references":"Αναφορές","reporter":"Ρεπόρτερ","reporterVolume":"Reporter Volume","reportNumber":"Αριθμός Αναφοράς","reportType":"Τύπος Αναφοράς","repository":"Repository","rights":"Δικαιώματα","runningTime":"Running Time","scale":"Κλίμακα","section":"Ενότητα","series":"Σειρά","seriesNumber":"Αριθμός Σειράς","seriesText":"Series Text","seriesTitle":"Τίτλος Σειράς","session":"Ενότητα","shortTitle":"Short Title","studio":"Στούντιο","subject":"Θέμα","system":"Σύστημα","thesisType":"Τύπος","title":"Τίτλος","university":"Πανεπιστήμιο","url":"URL","versionNumber":"Έκδοση","videoRecordingFormat":"Μορφή","volume":"Τόμος","websiteTitle":"Τίτλος Ιστότοπου","websiteType":"Τύπος Ιστότοπου"},"creatorTypes":{"artist":"Καλλιτέχνης","attorneyAgent":"Attorney/Agent","author":"Συγγραφέας","bookAuthor":"Συγγραφέας Βιβλίου","cartographer":"Χαρτογράφος","castMember":"Μέλος του καστ","commenter":"Σχολιαστής","composer":"Συνθέτης","contributor":"Contributor","cosponsor":"Συντονιστής","counsel":"Counsel","director":"Σκηνοθέτης","editor":"Συντάκτης","guest":"Guest","interviewee":"Συνέντευξη με","interviewer":"Δημοσιογράφος","inventor":"Inventor","performer":"Ερμηνευτής","podcaster":"Podcaster","presenter":"Παρουσιαστής","producer":"Παραγωγός","programmer":"Προγραμματιστής","recipient":"Recipient","reviewedAuthor":"Reviewed Author","scriptwriter":"Scriptwriter","seriesEditor":"Series Editor","sponsor":"Sponsor","translator":"Μετάφραση","wordsBy":"Words By"}},"en-GB":{"itemTypes":{"annotation":"Annotation","artwork":"Artwork","attachment":"Attachment","audioRecording":"Audio Recording","bill":"Bill","blogPost":"Blog Post","book":"Book","bookSection":"Book Section","case":"Case","computerProgram":"Software","conferencePaper":"Conference Paper","dictionaryEntry":"Dictionary Entry","document":"Document","email":"E-mail","encyclopediaArticle":"Encyclopedia Article","film":"Film","forumPost":"Forum Post","hearing":"Hearing","instantMessage":"Instant Message","interview":"Interview","journalArticle":"Journal Article","letter":"Letter","magazineArticle":"Magazine Article","manuscript":"Manuscript","map":"Map","newspaperArticle":"Newspaper Article","note":"Note","patent":"Patent","podcast":"Podcast","preprint":"Preprint","presentation":"Presentation","radioBroadcast":"Radio Broadcast","report":"Report","statute":"Statute","thesis":"Thesis","tvBroadcast":"TV Broadcast","videoRecording":"Video Recording","webpage":"Web Page"},"fields":{"abstractNote":"Abstract","accessDate":"Accessed","applicationNumber":"Application Number","archive":"Archive","archiveID":"Archive ID","archiveLocation":"Loc. in Archive","artworkMedium":"Medium","artworkSize":"Artwork Size","assignee":"Assignee","audioFileType":"File Type","audioRecordingFormat":"Format","billNumber":"Bill Number","blogTitle":"Blog Title","bookTitle":"Book Title","callNumber":"Call Number","caseName":"Case Name","citationKey":"Citation Key","code":"Code","codeNumber":"Code Number","codePages":"Code Pages","codeVolume":"Code Volume","committee":"Committee","company":"Company","conferenceName":"Conference Name","country":"Country","court":"Court","date":"Date","dateAdded":"Date Added","dateDecided":"Date Decided","dateEnacted":"Date Enacted","dateModified":"Modified","dictionaryTitle":"Dictionary Title","distributor":"Distributor","docketNumber":"Docket Number","documentNumber":"Document Number","DOI":"DOI","edition":"Edition","encyclopediaTitle":"Encyclopedia Title","episodeNumber":"Episode Number","extra":"Extra","filingDate":"Filing Date","firstPage":"First Page","forumTitle":"Forum/Listserv Title","genre":"Genre","history":"History","institution":"Institution","interviewMedium":"Medium","ISBN":"ISBN","ISSN":"ISSN","issue":"Issue","issueDate":"Issue Date","issuingAuthority":"Issuing Authority","itemType":"Type","journalAbbreviation":"Journal Abbr","label":"Label","language":"Language","legalStatus":"Legal Status","legislativeBody":"Legislative Body","letterType":"Type","libraryCatalog":"Library Catalogue","manuscriptType":"Type","mapType":"Type","meetingName":"Meeting Name","nameOfAct":"Name of Act","network":"Network","number":"Number","numberOfVolumes":"# of Volumes","numPages":"# of Pages","pages":"Pages","patentNumber":"Patent Number","place":"Place","postType":"Post Type","presentationType":"Type","priorityNumbers":"Priority Numbers","proceedingsTitle":"Proceedings Title","programmingLanguage":"Prog. Language","programTitle":"Program Title","publicationTitle":"Publication","publicLawNumber":"Public Law Number","publisher":"Publisher","references":"References","reporter":"Reporter","reporterVolume":"Reporter Volume","reportNumber":"Report Number","reportType":"Report Type","repository":"Repository","rights":"Rights","runningTime":"Running Time","scale":"Scale","section":"Section","series":"Series","seriesNumber":"Series Number","seriesText":"Series Text","seriesTitle":"Series Title","session":"Session","shortTitle":"Short Title","studio":"Studio","subject":"Subject","system":"System","thesisType":"Type","title":"Title","university":"University","url":"URL","versionNumber":"Version","videoRecordingFormat":"Format","volume":"Volume","websiteTitle":"Website Title","websiteType":"Website Type"},"creatorTypes":{"artist":"Artist","attorneyAgent":"Attorney/Agent","author":"Author","bookAuthor":"Book Author","cartographer":"Cartographer","castMember":"Cast Member","commenter":"Commenter","composer":"Composer","contributor":"Contributor","cosponsor":"Cosponsor","counsel":"Counsel","director":"Director","editor":"Editor","guest":"Guest","interviewee":"Interview With","interviewer":"Interviewer","inventor":"Inventor","performer":"Performer","podcaster":"Podcaster","presenter":"Presenter","producer":"Producer","programmer":"Programmer","recipient":"Recipient","reviewedAuthor":"Reviewed Author","scriptwriter":"Scriptwriter","seriesEditor":"Series Editor","sponsor":"Sponsor","translator":"Translator","wordsBy":"Words By"}},"en-US":{"itemTypes":{"annotation":"Annotation","artwork":"Artwork","attachment":"Attachment","audioRecording":"Audio Recording","bill":"Bill","blogPost":"Blog Post","book":"Book","bookSection":"Book Section","case":"Case","computerProgram":"Software","conferencePaper":"Conference Paper","dictionaryEntry":"Dictionary Entry","document":"Document","email":"E-mail","encyclopediaArticle":"Encyclopedia Article","film":"Film","forumPost":"Forum Post","hearing":"Hearing","instantMessage":"Instant Message","interview":"Interview","journalArticle":"Journal Article","letter":"Letter","magazineArticle":"Magazine Article","manuscript":"Manuscript","map":"Map","newspaperArticle":"Newspaper Article","note":"Note","patent":"Patent","podcast":"Podcast","preprint":"Preprint","presentation":"Presentation","radioBroadcast":"Radio Broadcast","report":"Report","statute":"Statute","thesis":"Thesis","tvBroadcast":"TV Broadcast","videoRecording":"Video Recording","webpage":"Web Page"},"fields":{"abstractNote":"Abstract","accessDate":"Accessed","applicationNumber":"Application Number","archive":"Archive","archiveID":"Archive ID","archiveLocation":"Loc. in Archive","artworkMedium":"Medium","artworkSize":"Artwork Size","assignee":"Assignee","audioFileType":"File Type","audioRecordingFormat":"Format","billNumber":"Bill Number","blogTitle":"Blog Title","bookTitle":"Book Title","callNumber":"Call Number","caseName":"Case Name","citationKey":"Citation Key","code":"Code","codeNumber":"Code Number","codePages":"Code Pages","codeVolume":"Code Volume","committee":"Committee","company":"Company","conferenceName":"Conference Name","country":"Country","court":"Court","date":"Date","dateAdded":"Date Added","dateDecided":"Date Decided","dateEnacted":"Date Enacted","dateModified":"Modified","dictionaryTitle":"Dictionary Title","distributor":"Distributor","docketNumber":"Docket Number","documentNumber":"Document Number","DOI":"DOI","edition":"Edition","encyclopediaTitle":"Encyclopedia Title","episodeNumber":"Episode Number","extra":"Extra","filingDate":"Filing Date","firstPage":"First Page","forumTitle":"Forum/Listserv Title","genre":"Genre","history":"History","institution":"Institution","interviewMedium":"Medium","ISBN":"ISBN","ISSN":"ISSN","issue":"Issue","issueDate":"Issue Date","issuingAuthority":"Issuing Authority","itemType":"Type","journalAbbreviation":"Journal Abbr","label":"Label","language":"Language","legalStatus":"Legal Status","legislativeBody":"Legislative Body","letterType":"Type","libraryCatalog":"Library Catalog","manuscriptType":"Type","mapType":"Type","meetingName":"Meeting Name","nameOfAct":"Name of Act","network":"Network","number":"Number","numberOfVolumes":"# of Volumes","numPages":"# of Pages","pages":"Pages","patentNumber":"Patent Number","place":"Place","postType":"Post Type","presentationType":"Type","priorityNumbers":"Priority Numbers","proceedingsTitle":"Proceedings Title","programmingLanguage":"Prog. Language","programTitle":"Program Title","publicationTitle":"Publication","publicLawNumber":"Public Law Number","publisher":"Publisher","references":"References","reporter":"Reporter","reporterVolume":"Reporter Volume","reportNumber":"Report Number","reportType":"Report Type","repository":"Repository","rights":"Rights","runningTime":"Running Time","scale":"Scale","section":"Section","series":"Series","seriesNumber":"Series Number","seriesText":"Series Text","seriesTitle":"Series Title","session":"Session","shortTitle":"Short Title","studio":"Studio","subject":"Subject","system":"System","thesisType":"Type","title":"Title","university":"University","url":"URL","versionNumber":"Version","videoRecordingFormat":"Format","volume":"Volume","websiteTitle":"Website Title","websiteType":"Website Type"},"creatorTypes":{"artist":"Artist","attorneyAgent":"Attorney/Agent","author":"Author","bookAuthor":"Book Author","cartographer":"Cartographer","castMember":"Cast Member","commenter":"Commenter","composer":"Composer","contributor":"Contributor","cosponsor":"Cosponsor","counsel":"Counsel","director":"Director","editor":"Editor","guest":"Guest","interviewee":"Interview With","interviewer":"Interviewer","inventor":"Inventor","performer":"Performer","podcaster":"Podcaster","presenter":"Presenter","producer":"Producer","programmer":"Programmer","recipient":"Recipient","reviewedAuthor":"Reviewed Author","scriptwriter":"Scriptwriter","seriesEditor":"Series Editor","sponsor":"Sponsor","translator":"Translator","wordsBy":"Words By"}},"es-ES":{"itemTypes":{"annotation":"Anotación","artwork":"Obra de arte","attachment":"Adjunto","audioRecording":"Grabación de sonido","bill":"Propuesta de ley","blogPost":"Entrada de blog","book":"Libro","bookSection":"Sección de un libro","case":"Caso","computerProgram":"Software","conferencePaper":"Artículo en conferencia","dictionaryEntry":"Entrada de diccionario","document":"Documento","email":"Correo electrónico","encyclopediaArticle":"Artículo de enciclopedia","film":"Película","forumPost":"Mensaje en un foro","hearing":"Audiencia","instantMessage":"Mensaje instantáneo","interview":"Entrevista","journalArticle":"Artículo de revista académica","letter":"Carta","magazineArticle":"Artículo de revista","manuscript":"Manuscrito","map":"Mapa","newspaperArticle":"Artículo de periódico","note":"Nota","patent":"Patente","podcast":"Pódcast","preprint":"Preimpresión","presentation":"Presentación","radioBroadcast":"Emisión de radio","report":"Informe","statute":"Estatuto","thesis":"Tesis","tvBroadcast":"Emisión de TV","videoRecording":"Grabación de vídeo","webpage":"Página web"},"fields":{"abstractNote":"Resumen","accessDate":"Accedido","applicationNumber":"Número de solicitud","archive":"Archivo","archiveID":"ID de archivo","archiveLocation":"Posición en archivo","artworkMedium":"Medio","artworkSize":"Tamaño de la obra","assignee":"Responsable","audioFileType":"Tipo de archivo","audioRecordingFormat":"Formato","billNumber":"Número de propuesta de ley","blogTitle":"Título del blog","bookTitle":"Título del libro","callNumber":"Signatura","caseName":"Nombre del caso","citationKey":"Clave de cita","code":"Código","codeNumber":"Número de código","codePages":"Páginas del código","codeVolume":"Volumen del código","committee":"Comité","company":"Compañía","conferenceName":"Nombre de la conferencia","country":"País","court":"Juzgado","date":"Fecha","dateAdded":"Fecha de adición","dateDecided":"Fecha de sentencia","dateEnacted":"Fecha de entrada en vigor","dateModified":"Modificado","dictionaryTitle":"Título del diccionario","distributor":"Distribuidor","docketNumber":"Número de expediente","documentNumber":"Número de documento","DOI":"DOI","edition":"Edición","encyclopediaTitle":"Título de la enciclopedia","episodeNumber":"Número de episodio","extra":"Adicional","filingDate":"Fecha de solicitud","firstPage":"Primera página","forumTitle":"Título de foro o lista de correo","genre":"Género","history":"Historia","institution":"Institución","interviewMedium":"Medio","ISBN":"ISBN","ISSN":"ISSN","issue":"Número","issueDate":"Fecha de publicación","issuingAuthority":"Entidad emisora","itemType":"Tipo","journalAbbreviation":"Abrev. de revista","label":"Etiqueta","language":"Idioma","legalStatus":"Estado legal","legislativeBody":"Cuerpo legislativo","letterType":"Tipo","libraryCatalog":"Catálogo de biblioteca","manuscriptType":"Tipo","mapType":"Tipo","meetingName":"Nombre de la reunión","nameOfAct":"Nombre de la ley","network":"Red","number":"Número","numberOfVolumes":"Número de volúmenes","numPages":"Número de páginas","pages":"Páginas","patentNumber":"Número de patente","place":"Lugar","postType":"Tipo de mensaje","presentationType":"Tipo","priorityNumbers":"Números de prioridad","proceedingsTitle":"Título de las actas","programmingLanguage":"Lenguaje de programación","programTitle":"Título del programa","publicationTitle":"Publicación","publicLawNumber":"Número de ley pública","publisher":"Editorial","references":"Referencias","reporter":"Acta judicial","reporterVolume":"Volumen de las actas","reportNumber":"Número de informe","reportType":"Tipo de informe","repository":"Repositorio","rights":"Derechos","runningTime":"Duración","scale":"Escala","section":"Sección","series":"Serie","seriesNumber":"Número de la serie","seriesText":"Texto de la serie","seriesTitle":"Título de la serie","session":"Sesión","shortTitle":"Título corto","studio":"Estudio","subject":"Asunto","system":"Sistema","thesisType":"Tipo","title":"Título","university":"Universidad","url":"URL","versionNumber":"Versión","videoRecordingFormat":"Formato","volume":"Volumen","websiteTitle":"Título de página web","websiteType":"Tipo de página Web"},"creatorTypes":{"artist":"Artista","attorneyAgent":"Abogado/Representante","author":"Autor","bookAuthor":"Autor del libro","cartographer":"Cartógrafo","castMember":"Miembro del reparto","commenter":"Comentador","composer":"Compositor","contributor":"Contribuidor","cosponsor":"Copatrocinador","counsel":"Consejero","director":"Director","editor":"Editor","guest":"Invitado","interviewee":"Entrevista con","interviewer":"Entrevistador","inventor":"Inventor","performer":"Intérprete","podcaster":"Podcaster","presenter":"Presentador","producer":"Productor","programmer":"Programador","recipient":"Receptor","reviewedAuthor":"Autor revisado","scriptwriter":"Guionista","seriesEditor":"Editor de la serie","sponsor":"Patrocinador","translator":"Traductor","wordsBy":"Palabras de"}},"et-EE":{"itemTypes":{"annotation":"Annotatsioon","artwork":"Kunstiteos","attachment":"Manus","audioRecording":"Helisalvestis","bill":"Arve","blogPost":"Blogipostitus","book":"Raamat","bookSection":"Osa raamatust","case":"Kaasus","computerProgram":"Software","conferencePaper":"Ettekanne","dictionaryEntry":"Kirje sõnaraamatus","document":"Dokument","email":"E-mail","encyclopediaArticle":"Entsüklopeediaartikkel","film":"Film","forumPost":"Foorumi postitus","hearing":"Istung","instantMessage":"Välksõnum","interview":"Intervjuu","journalArticle":"Artikkel","letter":"Kiri","magazineArticle":"Ajakirjaartikkel (mitteakad.)","manuscript":"Käsikiri","map":"Kaart","newspaperArticle":"Ajaleheartikkel","note":"Märkus","patent":"Patent","podcast":"Podcast","preprint":"Preprint","presentation":"Esitlus","radioBroadcast":"Raadiosaade","report":"Raport","statute":"Statuut","thesis":"Väitekiri","tvBroadcast":"Telesaade","videoRecording":"Videosalvestis","webpage":"Veebilehekülg"},"fields":{"abstractNote":"Abstrakt","accessDate":"Vaadatud","applicationNumber":"Taotluse number","archive":"Arhiiv","archiveID":"Archive ID","archiveLocation":"Asukoht arhiivis","artworkMedium":"Kandja","artworkSize":"Kunstiteose suurus","assignee":"Ülesande täitja","audioFileType":"Faili tüüp","audioRecordingFormat":"Formaat","billNumber":"Arvenumber","blogTitle":"Blogi nimi","bookTitle":"Raamatupealkiri","callNumber":"Kohaviit","caseName":"Kaasuse nimi","citationKey":"Citation Key","code":"Koodeks","codeNumber":"Koodeksinumber","codePages":"Koodeksi leheküljed","codeVolume":"Koodeksi köide","committee":"Kommitee","company":"Firma","conferenceName":"Konverentsi nimi","country":"Maa","court":"Kohus","date":"Aeg","dateAdded":"Lisamise aeg","dateDecided":"Otsustamise aeg","dateEnacted":"Jõustumise kuupäev","dateModified":"Muudetud","dictionaryTitle":"Sõnaraamatu pealkiri","distributor":"Levitaja","docketNumber":"Päevakorra number","documentNumber":"Dokumendi number","DOI":"DOI","edition":"Trükk","encyclopediaTitle":"Entsüklopeedia pealkiri","episodeNumber":"Episoodi number","extra":"Lisa","filingDate":"Arhiveerimiskuupäev","firstPage":"Esimene lehekülg","forumTitle":"Foorumi/Listi pealkir","genre":"Žanr","history":"Ajalugu","institution":"Asutus","interviewMedium":"Kandja","ISBN":"ISBN","ISSN":"ISSN","issue":"Väljalase","issueDate":"Väljalaske aeg","issuingAuthority":"Väljaandja","itemType":"Tüüp","journalAbbreviation":"Ajakirja lüh.","label":"Silt","language":"Keel","legalStatus":"Õiguslik seis","legislativeBody":"Seadusandlik keha","letterType":"Tüüp","libraryCatalog":"Raamatukogukataloog","manuscriptType":"Tüüp","mapType":"Tüüp","meetingName":"Kohtumise nimi","nameOfAct":"Akti nimi","network":"Võrk","number":"Number","numberOfVolumes":"# köidet","numPages":"# lk","pages":"Leheküljed","patentNumber":"Patendi number","place":"Koht","postType":"Postituse tüüp","presentationType":"Tüüp","priorityNumbers":"Prioriteedi numbrid","proceedingsTitle":"Toimetise pealkiri","programmingLanguage":"Prog. Language","programTitle":"Programmi nimi","publicationTitle":"Trükis","publicLawNumber":"Avaliku seaduse number(?)","publisher":"Väljaandja","references":"Viited","reporter":"Teavitaja","reporterVolume":"Raporteerija köide(?)","reportNumber":"Raportinumber","reportType":"Raportitüüp","repository":"Repository","rights":"Õigused","runningTime":"Kestvus","scale":"Suurus","section":"Osa","series":"Seeria","seriesNumber":"Seeria number","seriesText":"Seeria tekst","seriesTitle":"Seeria pealkiri","session":"Sessioon","shortTitle":"Lühendatud pealkiri","studio":"Stuudio","subject":"Subjekt","system":"Süsteem","thesisType":"Tüüp","title":"Pealkiri","university":"Ülikool","url":"URL","versionNumber":"Versioon","videoRecordingFormat":"Formaat","volume":"Köide","websiteTitle":"Veebilehekülje pealkiri","websiteType":"Veebilehe tüüp"},"creatorTypes":{"artist":"Kunstnik","attorneyAgent":"Esindaja/Agent","author":"Autor","bookAuthor":"Raamatu autor","cartographer":"Kartograaf","castMember":"Osatäitja","commenter":"Kommentaator","composer":"Helilooja","contributor":"Kaastööline","cosponsor":"Kaas-sponsor","counsel":"Nõustaja","director":"Režissöör","editor":"Toimetaja","guest":"Külaline","interviewee":"Intervjueeritav","interviewer":"Intervjueerija","inventor":"Leiutaja","performer":"Esitaja","podcaster":"Podcaster","presenter":"Esitaja","producer":"Produtsent","programmer":"Programmeerija","recipient":"Saaja","reviewedAuthor":"Arvustatud autor","scriptwriter":"Käsikirja autor","seriesEditor":"Seeria toimetaja","sponsor":"Sponsor","translator":"Tõlkija","wordsBy":"Sõnade autor"}},"eu-ES":{"itemTypes":{"annotation":"Oharpena","artwork":"Artelana","attachment":"Eranskina","audioRecording":"Audio grabaketa","bill":"Lege proiektua","blogPost":"Blog albistea","book":"Liburua","bookSection":"Kapitulua","case":"Kasu legala","computerProgram":"Softwarea","conferencePaper":"Kongresu artikulua","dictionaryEntry":"Hiztegi-sarrera","document":"Dokumentua","email":"E-posta","encyclopediaArticle":"Entziklopedia artikulua","film":"Filma","forumPost":"Foro bateko bidalketa","hearing":"Bista","instantMessage":"Zuzeneko mezua","interview":"Elkarrizketa","journalArticle":"Aldizkaria artikulu","letter":"Gutuna","magazineArticle":"Prentsa artikulua","manuscript":"Eskuizkribua","map":"Mapa","newspaperArticle":"Egunkariko albistea","note":"Oharra","patent":"Patentea","podcast":"Podcasta","preprint":"Imprimatu aurrekoa","presentation":"Aurkezpena","radioBroadcast":"Irrati saioa","report":"Txostena","statute":"Estatutua","thesis":"Tesia","tvBroadcast":"Telebista saioa","videoRecording":"Bideo grabaketa","webpage":"Web-orria"},"fields":{"abstractNote":"Laburpena","accessDate":"Atzipen data","applicationNumber":"Aplikazio zenbakia","archive":"Artxiboa","archiveID":"Artxibo IDa","archiveLocation":"Kokapena artxiboan","artworkMedium":"Hedabidea","artworkSize":"Artelanaren neurriak","assignee":"Nori esleitua","audioFileType":"Fitxategi mota","audioRecordingFormat":"Formatua","billNumber":"Proiektuaren zbk","blogTitle":"Blogaren izenburua","bookTitle":"Liburuaren izenburua","callNumber":"Erref. Zenbakia","caseName":"Kasu izena","citationKey":"Aipu-gakoa","code":"Kodea","codeNumber":"Kode zenbakia","codePages":"Kode orrialdeak","codeVolume":"Kodearen Alea","committee":"Batzordea","company":"Enpresa","conferenceName":"Kongresuaren titulua","country":"Herrialdea","court":"Auzitegia","date":"Data","dateAdded":"Noiz gehitua","dateDecided":"Erabakiaren data","dateEnacted":"Noiz antzeztua","dateModified":"Noiz aldatua","dictionaryTitle":"Hiztegiaren izenburua","distributor":"Banatzailea","docketNumber":"Docket zbk.","documentNumber":"Dokumentu zbk.","DOI":"DOI","edition":"Edizioa","encyclopediaTitle":"Entziklopediaren izenburua","episodeNumber":"Saio zbk.","extra":"Estra","filingDate":"Noiz aurkeztua","firstPage":"Lehen orrialdea","forumTitle":"Forum/Listserv izenburua","genre":"Generoa","history":"Historia","institution":"Instituzioa","interviewMedium":"Komunikabidea","ISBN":"ISBN","ISSN":"ISSN","issue":"Zenbakia","issueDate":"Zenbakiaren data","issuingAuthority":"Agintaritza jaulkitzailea","itemType":"Mota","journalAbbreviation":"Aldizkaria labur.","label":"Disketxea","language":"Hizkuntza","legalStatus":"Egoera legala","legislativeBody":"Erakunde legegintzailea","letterType":"Mota","libraryCatalog":"Liburutegi katalogoa","manuscriptType":"Mota","mapType":"Mota","meetingName":"Bilkuraren titulua","nameOfAct":"Ekitaldiaren izena","network":"Irrati/TB-sare","number":"Zenbakia","numberOfVolumes":"Ale kopurua","numPages":"orr.kopurua","pages":"Orrialdeak","patentNumber":"Patente zenbakia","place":"Tokia","postType":"Posta mota","presentationType":"Mota","priorityNumbers":"Lehentasun zenbakiak","proceedingsTitle":"Proceedings izenburua","programmingLanguage":"Prog. lengoaia","programTitle":"Programaren izenburua","publicationTitle":"Agerkaria","publicLawNumber":"Lege publiko zenbakia","publisher":"Argitaratzailea","references":"Erreferentziak","reporter":"Erreportaria","reporterVolume":"Berriemailearen alea","reportNumber":"Txostenaren zenbakia","reportType":"Txosten mota","repository":"Biltegia","rights":"Eskubideak","runningTime":"Luzapena","scale":"Eskala","section":"Atala","series":"Serie","seriesNumber":"Serie-zenbakia","seriesText":"Serie-testua","seriesTitle":"Serie-izenburua","session":"Saioa","shortTitle":"Izenburu laburra","studio":"Estudioa","subject":"Gaia","system":"Sistema","thesisType":"Mota","title":"Izenburua","university":"Unibertsitatea","url":"URLa","versionNumber":"Bertsioa","videoRecordingFormat":"Formatua","volume":"Alea","websiteTitle":"Webgunearen izenburua","websiteType":"Webgune mota"},"creatorTypes":{"artist":"Artista","attorneyAgent":"Abokatua/Agentea","author":"Autorea","bookAuthor":"Liburuaren autorea","cartographer":"Kartografialaria","castMember":"Aktorea","commenter":"Esataria","composer":"Konposatzailea","contributor":"Kolaboratzaile","cosponsor":"Laguntzailea","counsel":"Kontseilua","director":"Zuzendaria","editor":"Editore","guest":"Gonbidatua","interviewee":"Elkarrizketatua","interviewer":"Elkarrizketatzaile","inventor":"Asmatzailea","performer":"Antzezlea","podcaster":"Podcast egilea","presenter":"Aurkezlea","producer":"Ekoizlea","programmer":"Programatzailea","recipient":"Hartzailea","reviewedAuthor":"Berrikusitako autorea","scriptwriter":"Gidoi-idazle","seriesEditor":"Seriearen editore","sponsor":"Babeslea","translator":"Itzultzaile","wordsBy":"Hitzak"}},"fa":{"itemTypes":{"annotation":"حاشیه‌نویسی","artwork":"اثر هنری","attachment":"پیوست","audioRecording":"صدای ضبط شده","bill":"قانون","blogPost":"پست بلاگ","book":"کتاب","bookSection":"فصل کتاب","case":"پرونده","computerProgram":"Software","conferencePaper":"مقاله کنفرانس","dictionaryEntry":"مدخل لغتنامه","document":"سند","email":"ایمیل","encyclopediaArticle":"مقاله دانشنامه","film":"فیلم","forumPost":"پست فروم","hearing":"استماع","instantMessage":"پیام فوری","interview":"مصاحبه","journalArticle":"مقاله","letter":"نامه","magazineArticle":"مقاله مجله","manuscript":"دست‌نوشته","map":"نقشه","newspaperArticle":"مقاله روزنامه","note":"یادداشت","patent":"ثبت اختراع","podcast":"پادکست","preprint":"Preprint","presentation":"ارائه","radioBroadcast":"برنامه رادیویی","report":"گزارش","statute":"مجسمه","thesis":"پایان‌نامه","tvBroadcast":"برنامه تلویزیونی","videoRecording":"تصویر ضبط شده","webpage":"صفحه وب"},"fields":{"abstractNote":"چکیده","accessDate":"تاریخ دسترسی","applicationNumber":"شماره درخواست","archive":"آرشیو","archiveID":"Archive ID","archiveLocation":"محل در آرشیو","artworkMedium":"رسانه","artworkSize":"اندازه کار هنری","assignee":"نماینده قانونی","audioFileType":"نوع پرونده","audioRecordingFormat":"قالب","billNumber":"Bill Number","blogTitle":"عنوان بلاگ","bookTitle":"عنوان کتاب","callNumber":"شماره فراخوانی","caseName":"نام پرونده","citationKey":"Citation Key","code":"کد","codeNumber":"شماره کد","codePages":"Code Pages","codeVolume":"Code Volume","committee":"کمیته","company":"شرکت","conferenceName":"نام کنفرانس","country":"کشور","court":"دادگاه","date":"تاریخ","dateAdded":"تاریخ افزودن","dateDecided":"Date Decided","dateEnacted":"تاریخ تصویب","dateModified":"تاریخ اصلاح","dictionaryTitle":"عنوان لغتنامه","distributor":"‌توزیع‌کننده","docketNumber":"شماره دفتر","documentNumber":"شماره سند","DOI":"شناسه DOI","edition":"ویرایش","encyclopediaTitle":"عنوان دانشنامه","episodeNumber":"شماره اپیزود","extra":"اطلاعات اضافه","filingDate":"تاریخ بایگانی","firstPage":"صفحه اول","forumTitle":"عنوان انجمن گفتگو","genre":"ژانر","history":"تاریخچه","institution":"موسسه","interviewMedium":"رسانه","ISBN":"شابک","ISSN":"شابن","issue":"شماره","issueDate":"تاریخ شماره","issuingAuthority":"مرجع صادر کننده","itemType":"نوع","journalAbbreviation":"نام مختصر مجله","label":"برچسب","language":"زبان","legalStatus":"وضعیت حقوقی","legislativeBody":"هیات قانون‌گذاری","letterType":"نوع","libraryCatalog":"فهرست کتابخانه","manuscriptType":"نوع","mapType":"نوع","meetingName":"نام نشست","nameOfAct":"نام قانون","network":"شبکه","number":"عدد","numberOfVolumes":"تعداد جلد","numPages":"تعداد صفحه","pages":"صفحات","patentNumber":"شماره ثبت اختراع","place":"مکان","postType":"نوع پست","presentationType":"نوع","priorityNumbers":"شماره‌های اولویت","proceedingsTitle":"عنوان مجموعه مقالات","programmingLanguage":"Prog. Language","programTitle":"عنوان برنامه","publicationTitle":"انتشار","publicLawNumber":"شماره قانون عمومی","publisher":"ناشر","references":"مراجع","reporter":"گزارشگر","reporterVolume":"Reporter Volume","reportNumber":"شماره گزارش","reportType":"نوع گزارش","repository":"Repository","rights":"حقوق","runningTime":"زمان اجرا","scale":"مقیاس","section":"بخش","series":"مجموعه (سری)","seriesNumber":"شماره مجموعه","seriesText":"متن مجموعه","seriesTitle":"عنوان مجموعه","session":"جلسه","shortTitle":"عنوان کوتاه","studio":"استودیو","subject":"موضوع","system":"سامانه","thesisType":"نوع","title":"عنوان","university":"دانشگاه","url":"نشانی وب","versionNumber":"نگارش","videoRecordingFormat":"قالب","volume":"جلد","websiteTitle":"عنوان وب‌گاه","websiteType":"نوع وب‌گاه"},"creatorTypes":{"artist":"هنرمند","attorneyAgent":"وکیل/نماینده","author":"نویسنده","bookAuthor":"نویسنده کتاب","cartographer":"نقشه‌کش","castMember":"عضو گروه","commenter":"مفسر","composer":"آهنگساز","contributor":"پدیدآور","cosponsor":"پشتیبان دوم","counsel":"مشاور","director":"کارگردان","editor":"ویرایشگر","guest":"مهمان","interviewee":"مصاحبه با","interviewer":"مصاحبه‌گر","inventor":"مخترع","performer":"مجری","podcaster":"Podcaster","presenter":"ارائه‌دهنده","producer":"تولیدکننده","programmer":"برنامه‌نویس","recipient":"گیرنده","reviewedAuthor":"Reviewed Author","scriptwriter":"نمایشنامه‌نویس","seriesEditor":"ویرایشگر مجموعه","sponsor":"پشتیبان","translator":"مترجم","wordsBy":"کلام از"}},"fi-FI":{"itemTypes":{"annotation":"Huomautus","artwork":"Taideteos","attachment":"Liite","audioRecording":"Äänite","bill":"Lakiesitys","blogPost":"Blogikirjoitus","book":"Kirja","bookSection":"Kirjan osa","case":"Oikeusjuttu","computerProgram":"Ohjelmisto","conferencePaper":"Konferenssiartikkeli","dictionaryEntry":"Sanakirjan hakusana","document":"Asiakirja","email":"S-posti","encyclopediaArticle":"Tietosanakirja-artikkeli","film":"Filmi","forumPost":"Foorumiviesti","hearing":"Kuuleminen","instantMessage":"Pikaviestimen viesti","interview":"Haastattelu","journalArticle":"Aikakausjulkaisun artikkeli","letter":"Kirje","magazineArticle":"Aikakauslehden artikkeli","manuscript":"Käsikirjoitus","map":"Kartta","newspaperArticle":"Sanomalehden artikkeli","note":"Muistiinpano","patent":"Patentti","podcast":"Podcast","preprint":"Käsikirjoitusversio","presentation":"Esitelmä","radioBroadcast":"Radiolähetys","report":"Raportti","statute":"Säädös","thesis":"Opinnäytetyö","tvBroadcast":"Tv-lähetys","videoRecording":"Videotallenne","webpage":"Web-sivu"},"fields":{"abstractNote":"Tiivistelmä","accessDate":"Luettu","applicationNumber":"Hakemusnumero","archive":"Arkisto","archiveID":"Arkistotunniste (Archive ID)","archiveLocation":"Paik. arkistossa","artworkMedium":"Materiaali","artworkSize":"Teoksen koko","assignee":"Valtuutettu","audioFileType":"Tiedostomuoto","audioRecordingFormat":"Muoto","billNumber":"Lakiesityksen numero","blogTitle":"Blogin nimi","bookTitle":"Kirjan nimi","callNumber":"Hyllypaikka","caseName":"Tapauksen nimi","citationKey":"Viitteen tunniste","code":"Koodi","codeNumber":"Koodinumero","codePages":"Koodin sivut","codeVolume":"Koodisarja","committee":"Komitea","company":"Yritys","conferenceName":"Konferenssin nimi","country":"Maa","court":"Tuomioistuin","date":"Päiväys","dateAdded":"Lisäyspäivä","dateDecided":"Päätöspäivämäärä","dateEnacted":"Täytäntöönpanopäivä","dateModified":"Muokattu","dictionaryTitle":"Sanakirjan otsake","distributor":"Jakelija","docketNumber":"Esityslistan numero","documentNumber":"Asiakirjan numero","DOI":"DOI","edition":"Painos","encyclopediaTitle":"Tietosanakirjan otsake","episodeNumber":"Jakson numero","extra":"Ylim.","filingDate":"Arkistointipäivä","firstPage":"Ensimmäinen sivu","forumTitle":"Foorumin/listan nimi","genre":"Genre","history":"Historia","institution":"Laitos","interviewMedium":"Tallennusväline","ISBN":"ISBN","ISSN":"ISSN","issue":"Numero","issueDate":"Hakupäiväys","issuingAuthority":"Myöntänyt viranomainen","itemType":"Tyyppi","journalAbbreviation":"Julkaisun lyhenne","label":"Otsake","language":"Kieli","legalStatus":"Statustiedot","legislativeBody":"Lainsäätäjä","letterType":"Tyyppi","libraryCatalog":"Kirjastokatalogi","manuscriptType":"Käsikirjoitustyyppi","mapType":"Tyyppi","meetingName":"Tapaamisen nimi","nameOfAct":"Laki","network":"Verkko","number":"Määrä","numberOfVolumes":"Niteiden lkm.","numPages":"Sivumäärä","pages":"Sivut","patentNumber":"Patenttinumero","place":"Paikka","postType":"Tyyppi","presentationType":"Tyyppi","priorityNumbers":"Etuoikeusnumerot","proceedingsTitle":"Konferenssijulkaisun otsikko","programmingLanguage":"Ohjelmointikieli","programTitle":"Ohjelman nimi","publicationTitle":"Julkaisu","publicLawNumber":"Lakinumero","publisher":"Julkaisija","references":"Viittaukset","reporter":"Toimittaja","reporterVolume":"Raporttivuosikerta","reportNumber":"Raportti numero","reportType":"Raportin tyyppi","repository":"Säilö","rights":"Oikeudet","runningTime":"Soittoaika","scale":"Mittakaava","section":"Osio","series":"Sarja","seriesNumber":"Sarjan numero","seriesText":"Sarjan teksti","seriesTitle":"Sarjan nimi","session":"Istunto","shortTitle":"Lyhyt nimi","studio":"Studio","subject":"Aihe","system":"Järjestelmä","thesisType":"Tyyppi","title":"Otsake","university":"Yliopisto","url":"URL","versionNumber":"Versio","videoRecordingFormat":"Muoto","volume":"Vuosikerta","websiteTitle":"Websivu","websiteType":"Web-sivustotyyppi"},"creatorTypes":{"artist":"Taiteilija","attorneyAgent":"Asianajaja/agentti","author":"Tekijä","bookAuthor":"Kirjan tekijä","cartographer":"Kartoittaja","castMember":"Näyttelijä","commenter":"Kommentoija","composer":"Säveltäjä","contributor":"Muu tekijä","cosponsor":"Osasponsori","counsel":"Oikeusavustaja","director":"Ohjaaja","editor":"Toimittaja","guest":"Vieras","interviewee":"Haastattelussa","interviewer":"Haastattelija","inventor":"Keksijä","performer":"Esiintyjä","podcaster":"Podcastin tekijä","presenter":"Esittäjä","producer":"Tuottaja","programmer":"Ohjelmoija","recipient":"Vastaanottaja","reviewedAuthor":"Arvostelun kohde","scriptwriter":"Käsikirjoittaja","seriesEditor":"Sarjan toimittaja","sponsor":"Sponsori","translator":"Kääntäjä","wordsBy":"Sanoittaja"}},"fr-FR":{"itemTypes":{"annotation":"Annotation","artwork":"Illustration","attachment":"Pièce jointe","audioRecording":"Enregistrement audio","bill":"Projet/proposition de loi","blogPost":"Billet de blog","book":"Livre","bookSection":"Chapitre de livre","case":"Affaire","computerProgram":"Logiciel","conferencePaper":"Article de colloque","dictionaryEntry":"Entrée de dictionnaire","document":"Document","email":"Courriel","encyclopediaArticle":"Article d'encyclopédie","film":"Film","forumPost":"Message de forum","hearing":"Audience","instantMessage":"Message instantané","interview":"Interview","journalArticle":"Article de revue","letter":"Lettre","magazineArticle":"Article de magazine","manuscript":"Manuscrit","map":"Carte","newspaperArticle":"Article de journal","note":"Note","patent":"Brevet","podcast":"Balado (Podcast)","preprint":"Prépublication","presentation":"Présentation","radioBroadcast":"Émission de radio","report":"Rapport","statute":"Acte juridique","thesis":"Thèse","tvBroadcast":"Émission de TV","videoRecording":"Enregistrement vidéo","webpage":"Page Web"},"fields":{"abstractNote":"Résumé","accessDate":"Consulté le","applicationNumber":"N° d'application","archive":"Archive","archiveID":"Identifiant dans l'archive","archiveLocation":"Loc. dans l'archive","artworkMedium":"Support de l'illustration","artworkSize":"Taille d'illustration","assignee":"Cessionnaire","audioFileType":"Type de fichier","audioRecordingFormat":"Format","billNumber":"N° de projet","blogTitle":"Titre du blog","bookTitle":"Titre du livre","callNumber":"Cote","caseName":"Nom de l'affaire","citationKey":"Clé de citation","code":"Code","codeNumber":"N° de code","codePages":"Pages de code","codeVolume":"Volume de code","committee":"Commission","company":"Société","conferenceName":"Intitulé du colloque","country":"Pays","court":"Tribunal","date":"Date","dateAdded":"Date d'ajout","dateDecided":"Date de décision","dateEnacted":"Promulgué le","dateModified":"Modifié le","dictionaryTitle":"Titre du dict.","distributor":"Distributeur","docketNumber":"N° de requête","documentNumber":"N° du document","DOI":"DOI","edition":"Édition","encyclopediaTitle":"Titre de l'encycl.","episodeNumber":"N° de l'épisode","extra":"Extra","filingDate":"Date de dépôt","firstPage":"Première page","forumTitle":"Titre du forum/listserv","genre":"Genre","history":"Histoire","institution":"Institution","interviewMedium":"Média","ISBN":"ISBN","ISSN":"ISSN","issue":"Numéro","issueDate":"Date de parution","issuingAuthority":"Autorité émettrice","itemType":"Type","journalAbbreviation":"Abrév. de revue","label":"Label","language":"Langue","legalStatus":"Statut légal","legislativeBody":"Corps législatif","letterType":"Type","libraryCatalog":"Catalogue de bibl.","manuscriptType":"Type","mapType":"Type","meetingName":"Intitulé de la réunion","nameOfAct":"Nom de l'acte","network":"Réseau","number":"Numéro","numberOfVolumes":"Nb de volumes","numPages":"Nb de pages","pages":"Pages","patentNumber":"N° de brevet","place":"Lieu","postType":"Type d'article","presentationType":"Type","priorityNumbers":"Numéros de priorité","proceedingsTitle":"Titre des actes","programmingLanguage":"Langage de programmation","programTitle":"Titre du programme","publicationTitle":"Publication","publicLawNumber":"N° officiel de l'acte","publisher":"Maison d’édition","references":"Références","reporter":"Recueil","reporterVolume":"Volume de recueil","reportNumber":"N° du rapport","reportType":"Type de rapport","repository":"Dépôt","rights":"Autorisations","runningTime":"Durée","scale":"Échelle","section":"Section","series":"Collection","seriesNumber":"N° ds la coll.","seriesText":"Texte de la coll.","seriesTitle":"Titre de la coll.","session":"Session","shortTitle":"Titre abrégé","studio":"Studio","subject":"Sujet","system":"Système","thesisType":"Type","title":"Titre","university":"Université","url":"URL","versionNumber":"Version","videoRecordingFormat":"Format","volume":"Volume","websiteTitle":"Titre du site Web","websiteType":"Type de site Web"},"creatorTypes":{"artist":"Artiste","attorneyAgent":"Mandataire/Agent","author":"Auteur","bookAuthor":"Auteur du livre","cartographer":"Cartographe","castMember":"Membre de la distribution","commenter":"Commentateur","composer":"Compositeur","contributor":"Collaborateur","cosponsor":"Co-parrain","counsel":"Conseiller","director":"Metteur en scène","editor":"Éditeur","guest":"Invité","interviewee":"Interviewé","interviewer":"Reporter","inventor":"Inventeur","performer":"Interprète","podcaster":"Diffuseur","presenter":"Présentateur","producer":"Producteur","programmer":"Programmeur","recipient":"Destinataire","reviewedAuthor":"Auteur recensé","scriptwriter":"Scénariste","seriesEditor":"Directeur de coll.","sponsor":"Auteur","translator":"Traducteur","wordsBy":"Paroles de"}},"gl-ES":{"itemTypes":{"annotation":"Anotación","artwork":"Arte","attachment":"Anexo","audioRecording":"Gravación de son","bill":"Factura","blogPost":"Entrada de blogue","book":"Libro","bookSection":"Sección de libro","case":"Caso","computerProgram":"Software","conferencePaper":"Publicación de congreso","dictionaryEntry":"Entrada de dicionario","document":"Documento","email":"Correo electrónico","encyclopediaArticle":"Artigo enciclopédico","film":"Película","forumPost":"Entrada de foro","hearing":"Audiencia","instantMessage":"Mensaxe instantáneo","interview":"Entrevista","journalArticle":"Artigo de publicación","letter":"Carta","magazineArticle":"Artigo de revista","manuscript":"Manuscrito","map":"Mapa","newspaperArticle":"Artigo de xornal","note":"Nota","patent":"Patente","podcast":"Podcast","preprint":"Preprint","presentation":"Presentación","radioBroadcast":"Emisión de Radio","report":"Informe","statute":"Estatuto","thesis":"Tese","tvBroadcast":"Emisión de TV","videoRecording":"Gravación de vídeo","webpage":"Páxina web"},"fields":{"abstractNote":"Resumen","accessDate":"Consultado","applicationNumber":"Número da solicitude","archive":"Arquivo","archiveID":"Archive ID","archiveLocation":"Loc. no arquivo","artworkMedium":"Mediano","artworkSize":"Tamaño das ilustracións","assignee":"Cesionario","audioFileType":"Tipo de ficheiro","audioRecordingFormat":"Formato","billNumber":"Número da factura","blogTitle":"Título do blogue","bookTitle":"Título do libro","callNumber":"Número de catálogo","caseName":"Número do caso","citationKey":"Citation Key","code":"Código","codeNumber":"Número de código","codePages":"Páxinas de códigos","codeVolume":"Tomo de códigos","committee":"Comité","company":"Compañía","conferenceName":"Nome da congreso","country":"País","court":"Tribunal","date":"Data","dateAdded":"Data de alta","dateDecided":"Data decidida","dateEnacted":"Data de promulgación","dateModified":"Modificado","dictionaryTitle":"Título do dicionario","distributor":"Distribuidor","docketNumber":"Número de expediente","documentNumber":"Número do documento","DOI":"DOI","edition":"Edición","encyclopediaTitle":"Título da enciclopedia","episodeNumber":"Número de episodio","extra":"Extra","filingDate":"Data de entrada en arquivo","firstPage":"Primeira páxina","forumTitle":"Título do foro/Listserv","genre":"Xénero","history":"Historia","institution":"Institución","interviewMedium":"Medio","ISBN":"ISBN","ISSN":"ISSN","issue":"Número","issueDate":"Data do elemento","issuingAuthority":"Autoridade emisora","itemType":"Tipo","journalAbbreviation":"Abreviatura da publicación","label":"Rótulo","language":"Lingua","legalStatus":"Estatuto xurídico","legislativeBody":"Corpo lexislativo","letterType":"Tipo","libraryCatalog":"Catálogo da biblioteca","manuscriptType":"Tipo","mapType":"Tipo","meetingName":"Nome da Reunión","nameOfAct":"Número da acta","network":"Rede","number":"Número","numberOfVolumes":"Nº de tomos","numPages":"Nº de Páxinas","pages":"Páxinas","patentNumber":"Número da patente","place":"Lugar","postType":"Tipo de entrada","presentationType":"Tipo","priorityNumbers":"Números de prioridade","proceedingsTitle":"Título das medidas legais","programmingLanguage":"Ling. de programación","programTitle":"Título do programa","publicationTitle":"Publicación","publicLawNumber":"Número de dereito público","publisher":"Editorial","references":"Referencias","reporter":"Reporteiro","reporterVolume":"Tomo de reporteiros","reportNumber":"Número do informe","reportType":"Tipo de informe","repository":"Repository","rights":"Dereitos","runningTime":"Duración","scale":"Escala","section":"Sección","series":"Serie","seriesNumber":"Número da serie","seriesText":"Texto da serie","seriesTitle":"Título da serie","session":"Sesión","shortTitle":"Título curto","studio":"Estudio","subject":"Asunto","system":"Sistema","thesisType":"Tipo","title":"Título","university":"Universidade","url":"URL","versionNumber":"Versión","videoRecordingFormat":"Formato","volume":"Tomo","websiteTitle":"Título da páxina web","websiteType":"Tipo de páxina web"},"creatorTypes":{"artist":"Artista","attorneyAgent":"Procurador/Axente","author":"Autor","bookAuthor":"Autor do libro","cartographer":"Cartógrafo","castMember":"Membro do elenco","commenter":"Comentarista","composer":"Compositor","contributor":"Colaborador","cosponsor":"Copatrocinador","counsel":"Avogado","director":"Director","editor":"Editor","guest":"Invitado","interviewee":"Entrevista con","interviewer":"Entrevista","inventor":"Inventor","performer":"Intérprete","podcaster":"Fonte do podcast","presenter":"Presentador","producer":"Produtor","programmer":"Programador","recipient":"Receptor","reviewedAuthor":"Autor reseñado","scriptwriter":"Guionista","seriesEditor":"Editor da serie","sponsor":"Patrocinador","translator":"Tradutor","wordsBy":"Guión de"}},"he-IL":{"itemTypes":{"annotation":"הסבר","artwork":"יצירת אומנות","attachment":"קובץ מצורף","audioRecording":"הקלטת שמע","bill":"חשבון","blogPost":"רשומת יומן רשת","book":"ספר","bookSection":"פרק מספר","case":"תיק","computerProgram":"תוכנה","conferencePaper":"Conference Paper","dictionaryEntry":"ערך במילון","document":"מסמך","email":"דוא״ל","encyclopediaArticle":"ערך באנציקלופדיה","film":"סרט","forumPost":"רשומה בפורום","hearing":"שימוע","instantMessage":"הודעה מיידית","interview":"ראיון","journalArticle":"כתבה מכתב עת","letter":"מכתב","magazineArticle":"כתבה ממגזין","manuscript":"כתב־יד","map":"מפה","newspaperArticle":"כתבה מעתון","note":"הערה","patent":"פטנט","podcast":"פודקאסט","preprint":"Preprint","presentation":"מצגת","radioBroadcast":"שידור רדיו","report":"דוח","statute":"Statute","thesis":"תזה","tvBroadcast":"שידור טלוויזיוני","videoRecording":"הקלטת וידאו","webpage":"דף אינטרנט"},"fields":{"abstractNote":"תקציר","accessDate":"Accessed","applicationNumber":"מספר בקשה","archive":"ארכיון","archiveID":"מזהה ארכיון","archiveLocation":"מיקום בארכיון","artworkMedium":"אמצעי","artworkSize":"גודל יצירת האומנות","assignee":"Assignee","audioFileType":"סוג קובץ","audioRecordingFormat":"עיצוב","billNumber":"מס׳ חשבון","blogTitle":"שם בלוג","bookTitle":"שם ספר","callNumber":"Call Number","caseName":"שם התיק","citationKey":"מפתח ציטוט","code":"קוד","codeNumber":"Code Number","codePages":"Code Pages","codeVolume":"Code Volume","committee":"ועדה","company":"חברה","conferenceName":"שם כנס","country":"מדינה","court":"Court","date":"תאריך","dateAdded":"תאריך הוספה","dateDecided":"תאריך החלטה","dateEnacted":"Date Enacted","dateModified":"שונה","dictionaryTitle":"שם מילון","distributor":"מפיץ","docketNumber":"מספרי רשימות תיקי בית משפט","documentNumber":"מספר מסמך","DOI":"DOI","edition":"מהדורה","encyclopediaTitle":"שם אנציקלופדיה","episodeNumber":"מספר פרק","extra":"Extra","filingDate":"תאריך תיוק","firstPage":"עמוד ראשון","forumTitle":"Forum/Listserv Title","genre":"סוגה","history":"היסטוריה","institution":"מוסד","interviewMedium":"אמצעי","ISBN":"מסת״ב","ISSN":"ISSN","issue":"גיליון","issueDate":"תאריך הנפקה","issuingAuthority":"רשות מנפיקה","itemType":"סוג","journalAbbreviation":"קיצורי כתב עת","label":"תווית","language":"שפה","legalStatus":"מצב משפטי","legislativeBody":"גוף מחוקק","letterType":"סוג","libraryCatalog":"קטלוג ספרייה","manuscriptType":"סוג","mapType":"סוג","meetingName":"שם פגישה","nameOfAct":"שם החוק","network":"רשת","number":"מספר","numberOfVolumes":"מס׳ כרכים","numPages":"מס׳ עמודים","pages":"עמודים","patentNumber":"מספר פטנט","place":"מקום","postType":"Post Type","presentationType":"סוג","priorityNumbers":"Priority Numbers","proceedingsTitle":"כותרת תביעה","programmingLanguage":"שפת פיתוח","programTitle":"כותרת תוכנית","publicationTitle":"הוצאה לאור","publicLawNumber":"Public Law Number","publisher":"מו״ל","references":"References","reporter":"Reporter","reporterVolume":"Reporter Volume","reportNumber":"מספר דוח","reportType":"סוג דוח","repository":"מאגר","rights":"זכויות","runningTime":"Running Time","scale":"קנה מידה","section":"מקטע","series":"סדרה","seriesNumber":"מספר סדרה","seriesText":"טקסט סדרה","seriesTitle":"שם סדרה","session":"Session","shortTitle":"כותרת קצרה","studio":"סטודיו","subject":"נושא","system":"מערכת","thesisType":"סוג","title":"כותרת","university":"אוניברסיטה","url":"כתובת","versionNumber":"גרסה","videoRecordingFormat":"עיצוב","volume":"כרך","websiteTitle":"כותרת אתר","websiteType":"סוג אתר"},"creatorTypes":{"artist":"אומן","attorneyAgent":"עורך דין/סוכן","author":"מחבר","bookAuthor":"כותב/ת הספר","cartographer":"קרטוגרף","castMember":"Cast Member","commenter":"מגיב/ה","composer":"מלחין","contributor":"Contributor","cosponsor":"תומך/ת","counsel":"Counsel","director":"במאי","editor":"עורך","guest":"אורח","interviewee":"ראיון עם","interviewer":"מראיין","inventor":"ממציא","performer":"מבצע","podcaster":"שדרן או שדרנית הסכתים","presenter":"מציג","producer":"מפיק","programmer":"מתכנת","recipient":"Recipient","reviewedAuthor":"יוצר/ת סוקר/ת","scriptwriter":"תסריטאי","seriesEditor":"עורך סדרה","sponsor":"נותן חסות","translator":"מתרגם","wordsBy":"מילים מאת"}},"hr-HR":{"itemTypes":{"annotation":"Annotation","artwork":"Artwork","attachment":"Attachment","audioRecording":"Audio Recording","bill":"Bill","blogPost":"Blog Post","book":"Book","bookSection":"Book Section","case":"Case","computerProgram":"Software","conferencePaper":"Conference Paper","dictionaryEntry":"Dictionary Entry","document":"Document","email":"E-mail","encyclopediaArticle":"Encyclopedia Article","film":"Film","forumPost":"Forum Post","hearing":"Hearing","instantMessage":"Instant Message","interview":"Interview","journalArticle":"Journal Article","letter":"Letter","magazineArticle":"Magazine Article","manuscript":"Manuscript","map":"Map","newspaperArticle":"Newspaper Article","note":"Note","patent":"Patent","podcast":"Podcast","preprint":"Preprint","presentation":"Presentation","radioBroadcast":"Radio Broadcast","report":"Report","statute":"Statute","thesis":"Thesis","tvBroadcast":"TV Broadcast","videoRecording":"Video Recording","webpage":"Web Page"},"fields":{"abstractNote":"Abstract","accessDate":"Accessed","applicationNumber":"Application Number","archive":"Archive","archiveID":"Archive ID","archiveLocation":"Loc. in Archive","artworkMedium":"Medium","artworkSize":"Artwork Size","assignee":"Assignee","audioFileType":"File Type","audioRecordingFormat":"Format","billNumber":"Bill Number","blogTitle":"Blog Title","bookTitle":"Book Title","callNumber":"Call Number","caseName":"Case Name","citationKey":"Citation Key","code":"Code","codeNumber":"Code Number","codePages":"Code Pages","codeVolume":"Code Volume","committee":"Committee","company":"Company","conferenceName":"Conference Name","country":"Country","court":"Court","date":"Date","dateAdded":"Date Added","dateDecided":"Date Decided","dateEnacted":"Date Enacted","dateModified":"Modified","dictionaryTitle":"Dictionary Title","distributor":"Distributor","docketNumber":"Docket Number","documentNumber":"Document Number","DOI":"DOI","edition":"Edition","encyclopediaTitle":"Encyclopedia Title","episodeNumber":"Episode Number","extra":"Extra","filingDate":"Filing Date","firstPage":"First Page","forumTitle":"Forum/Listserv Title","genre":"Genre","history":"History","institution":"Institution","interviewMedium":"Medium","ISBN":"ISBN","ISSN":"ISSN","issue":"Issue","issueDate":"Issue Date","issuingAuthority":"Issuing Authority","itemType":"Type","journalAbbreviation":"Journal Abbr","label":"Label","language":"Language","legalStatus":"Legal Status","legislativeBody":"Legislative Body","letterType":"Type","libraryCatalog":"Library Catalog","manuscriptType":"Type","mapType":"Type","meetingName":"Meeting Name","nameOfAct":"Name of Act","network":"Network","number":"Number","numberOfVolumes":"# of Volumes","numPages":"# of Pages","pages":"Pages","patentNumber":"Patent Number","place":"Place","postType":"Post Type","presentationType":"Type","priorityNumbers":"Priority Numbers","proceedingsTitle":"Proceedings Title","programmingLanguage":"Prog. Language","programTitle":"Program Title","publicationTitle":"Publication","publicLawNumber":"Public Law Number","publisher":"Publisher","references":"References","reporter":"Reporter","reporterVolume":"Reporter Volume","reportNumber":"Report Number","reportType":"Report Type","repository":"Repository","rights":"Rights","runningTime":"Running Time","scale":"Scale","section":"Section","series":"Series","seriesNumber":"Series Number","seriesText":"Series Text","seriesTitle":"Series Title","session":"Session","shortTitle":"Short Title","studio":"Studio","subject":"Subject","system":"System","thesisType":"Type","title":"Title","university":"University","url":"URL","versionNumber":"Version","videoRecordingFormat":"Format","volume":"Volume","websiteTitle":"Website Title","websiteType":"Website Type"},"creatorTypes":{"artist":"Artist","attorneyAgent":"Attorney/Agent","author":"Author","bookAuthor":"Book Author","cartographer":"Cartographer","castMember":"Cast Member","commenter":"Commenter","composer":"Composer","contributor":"Contributor","cosponsor":"Cosponsor","counsel":"Counsel","director":"Director","editor":"Editor","guest":"Guest","interviewee":"Interview With","interviewer":"Interviewer","inventor":"Inventor","performer":"Performer","podcaster":"Podcaster","presenter":"Presenter","producer":"Producer","programmer":"Programmer","recipient":"Recipient","reviewedAuthor":"Reviewed Author","scriptwriter":"Scriptwriter","seriesEditor":"Series Editor","sponsor":"Sponsor","translator":"Translator","wordsBy":"Words By"}},"hu-HU":{"itemTypes":{"annotation":"Megjegyzés","artwork":"Műalkotás","attachment":"Csatolmány","audioRecording":"Hangfelvétel","bill":"Törvényjavaslat","blogPost":"Blogbejegyzés","book":"Könyv","bookSection":"Könyvfejezet","case":"Eset","computerProgram":"Szoftver","conferencePaper":"Dolgozat","dictionaryEntry":"Szótár szócikk","document":"Dokumentum","email":"Email","encyclopediaArticle":"Lexikon szócikk","film":"Film","forumPost":"Fórumbejegyzés","hearing":"Meghallgatás","instantMessage":"Azonnali üzenet","interview":"Interjú","journalArticle":"Folyóiratcikk","letter":"Levél","magazineArticle":"Magazincikk","manuscript":"Kézirat","map":"Térkép","newspaperArticle":"Újságcikk","note":"Jegyzet","patent":"Szabadalom","podcast":"Podcast","preprint":"Preprint","presentation":"Előadás","radioBroadcast":"Rádiós program","report":"Jelentés","statute":"Jogszabály","thesis":"Szakdolgozat","tvBroadcast":"Televíziós program","videoRecording":"Videófelvétel","webpage":"Weboldal"},"fields":{"abstractNote":"Kivonat","accessDate":"Hozzáférés","applicationNumber":"Bejelentés száma","archive":"Archívum","archiveID":"Archive ID","archiveLocation":"Pontos lelőhely","artworkMedium":"Műalkotás médiuma","artworkSize":"Műalkotás mérete","assignee":"Felelős","audioFileType":"Fájl típusa","audioRecordingFormat":"Formátum","billNumber":"Törvényjavaslat száma","blogTitle":"Blog címe","bookTitle":"Könyv címe","callNumber":"Raktári jelzet","caseName":"Eset neve","citationKey":"Citation Key","code":"Törvénykönyv","codeNumber":"Törvénykönyv száma","codePages":"Oldalszám","codeVolume":"Kötet","committee":"Bizottság","company":"Cég","conferenceName":"Konferencia címe","country":"Ország","court":"Bíróság","date":"Dátum","dateAdded":"Hozzáadás dátuma","dateDecided":"Döntés dátuma","dateEnacted":"Hatálybalépés dátuma","dateModified":"Módosítás dátuma","dictionaryTitle":"Szótár címe","distributor":"Terjesztő","docketNumber":"Ügyiratszám","documentNumber":"Dokumentum száma","DOI":"DOI","edition":"Kiadás","encyclopediaTitle":"Lexikon címe","episodeNumber":"Epizód száma","extra":"Egyéb","filingDate":"Iktatás időpontja","firstPage":"Első oldal","forumTitle":"Fórum/listserv címe","genre":"Típus","history":"Történet","institution":"Intézmény","interviewMedium":"Médium","ISBN":"ISBN","ISSN":"ISSN","issue":"Szám","issueDate":"Kiadás dátuma","issuingAuthority":"Issuing Authority","itemType":"Típus","journalAbbreviation":"Folyóirat rövid neve","label":"Címke","language":"Nyelv","legalStatus":"Állapot","legislativeBody":"Törvényhozó szerv","letterType":"Típus","libraryCatalog":"Könyvtár Katalógus","manuscriptType":"Típus","mapType":"Típus","meetingName":"Találkozó neve","nameOfAct":"Törvény címe","network":"TV társaság","number":"Sorszám","numberOfVolumes":"Kötetek száma","numPages":"Terjedelem","pages":"Oldalszám","patentNumber":"Szabadalom száma","place":"Hely","postType":"Bejegyzés típusa","presentationType":"Típus","priorityNumbers":"Elsőbbségi sorrend","proceedingsTitle":"Kiadvány címe","programmingLanguage":"Prog. nyelv","programTitle":"Program címe","publicationTitle":"Kiadvány","publicLawNumber":"Törvény száma","publisher":"Kiadó","references":"Hivatkozások","reporter":"Döntvénytár","reporterVolume":"Kötet","reportNumber":"Jelentés száma","reportType":"Jelentés típusa","repository":"Repozitórium","rights":"Jogok","runningTime":"Lejátszási idő","scale":"Arány","section":"Fejezet","series":"Sorozat","seriesNumber":"Sorozatbeli sorszám","seriesText":"Sorozat szövege","seriesTitle":"Sorozat címe","session":"Ülésszak","shortTitle":"Rövid cím","studio":"Stúdió","subject":"Téma","system":"Rendszer","thesisType":"Típus","title":"Cím","university":"Egyetem","url":"URL","versionNumber":"Verzió","videoRecordingFormat":"Formátum","volume":"Kötet","websiteTitle":"Website címe","websiteType":"Weboldal típusa"},"creatorTypes":{"artist":"Művész","attorneyAgent":"Ügyvéd","author":"Szerző","bookAuthor":"Könyv szerzője","cartographer":"Térképész","castMember":"Szereplő","commenter":"Hozzászóló","composer":"Zeneszerző","contributor":"Közreműködő","cosponsor":"Cosponsor","counsel":"Ügyvéd","director":"Rendező","editor":"Szerkesztő","guest":"Vendég","interviewee":"Interjú alanya","interviewer":"Interjú készítője","inventor":"Feltaláló","performer":"Előadó","podcaster":"Podcaster","presenter":"Előadó","producer":"Producer","programmer":"Programozó","recipient":"Alperes","reviewedAuthor":"Recenzált mű szerzője","scriptwriter":"Forgatókönyvíró","seriesEditor":"Sorozatszerkesztő","sponsor":"Benyújtó","translator":"Fordító","wordsBy":"Szövegíró"}},"id-ID":{"itemTypes":{"annotation":"Anotasi","artwork":"Karya Seni","attachment":"Lampiran","audioRecording":"Rekaman Audio","bill":"Tagihan","blogPost":"Pos Blog","book":"Buku","bookSection":"Seksi Buku","case":"Kasus","computerProgram":"Software","conferencePaper":"Dokumen Konferensi","dictionaryEntry":"Entri Kamus","document":"Dokumen","email":"E-mail","encyclopediaArticle":"Artikel Ensiklopedia","film":"Film","forumPost":"Pos Forum","hearing":"Pemeriksaan","instantMessage":"Pesan Instan","interview":"Wawancara","journalArticle":"Artikel Jurnal","letter":"Surat","magazineArticle":"Artikel Majalah","manuscript":"Manuskrip","map":"Peta","newspaperArticle":"Artikel Koran","note":"Catatan","patent":"Paten","podcast":"Podcast","preprint":"Preprint","presentation":"Presentasi","radioBroadcast":"Siaran Radio","report":"Laporan","statute":"Statuta","thesis":"Tesis","tvBroadcast":"Siaran TV","videoRecording":"Rekaman Video","webpage":"Laman Web"},"fields":{"abstractNote":"Abstrak","accessDate":"Diakses","applicationNumber":"Nomor Aplikasi","archive":"Arsip","archiveID":"Archive ID","archiveLocation":"Lokasi di dalam Arsip","artworkMedium":"Media","artworkSize":"Ukuran Karya Seni","assignee":"Penerima","audioFileType":"Jenis Berkas","audioRecordingFormat":"Format","billNumber":"Nomor Tagihan","blogTitle":"Judul Blog","bookTitle":"Judul Buku","callNumber":"Nomor Panggilan","caseName":"Nama Kasus","citationKey":"Citation Key","code":"Kode","codeNumber":"Nomor Kode","codePages":"Halaman Kode","codeVolume":"Volume Kode","committee":"Komite","company":"Perusahaan","conferenceName":"Nama Konferensi","country":"Negara","court":"Pengadilan","date":"Tanggal","dateAdded":"Tanggal Ditambahkan","dateDecided":"Tanggal Diputuskan","dateEnacted":"Tanggal DIundangkan","dateModified":"Dimodifikasi","dictionaryTitle":"Judul Kamus","distributor":"Distributor","docketNumber":"Nomor Acara Pengadilan","documentNumber":"Nomor Dokumen","DOI":"DOI","edition":"Edisi","encyclopediaTitle":"Judul Ensiklopedia","episodeNumber":"Nomor Episode","extra":"Ekstra","filingDate":"Tanggal Pembuatan","firstPage":"Halaman Pertama","forumTitle":"Judul Forum/Listserv","genre":"Genre","history":"RIwayat","institution":"Institusi","interviewMedium":"Media","ISBN":"ISBN","ISSN":"ISSN","issue":"Isu","issueDate":"Tanggal Keluar","issuingAuthority":"Otoritas yang Mengeluarkan","itemType":"Jenis","journalAbbreviation":"Singkatan Jurnal","label":"Label","language":"Bahasa","legalStatus":"Status Legal","legislativeBody":"Badan Legislatif","letterType":"Jenis","libraryCatalog":"Katalog Perpustakaan","manuscriptType":"Jenis","mapType":"Jenis","meetingName":"Nama Pertemuan","nameOfAct":"Nama Putusan","network":"Jaringan","number":"Nomor","numberOfVolumes":"# Volume","numPages":"# halaman","pages":"Halaman","patentNumber":"Nomor Paten","place":"Tempat","postType":"Jenis Pos","presentationType":"Jenis","priorityNumbers":"Nomor Prioritas","proceedingsTitle":"Judul Rapat","programmingLanguage":"Prog. Language","programTitle":"Judul Program","publicationTitle":"Publikasi","publicLawNumber":"Nomor Hukum Publik","publisher":"Penerbit","references":"Referensi","reporter":"Reporter","reporterVolume":"Volume Reporter","reportNumber":"Nomor Laporan","reportType":"Jenis Laporan","repository":"Repository","rights":"Hak","runningTime":"Waktu Berjalan","scale":"Skala","section":"Bagian","series":"Seri","seriesNumber":"Nomor Seri","seriesText":"Teks Seri","seriesTitle":"Judul Seri","session":"Sesi","shortTitle":"Judul Singkat","studio":"Studio","subject":"Subjek","system":"Sistem","thesisType":"Jenis","title":"Judul","university":"Universitas","url":"URL","versionNumber":"Versi","videoRecordingFormat":"Format","volume":"Volume","websiteTitle":"Judul Website","websiteType":"Jenis Website"},"creatorTypes":{"artist":"Seniman","attorneyAgent":"Pengacara/Agen","author":"Penulis","bookAuthor":"Penulis Buku","cartographer":"Pembuat Peta","castMember":"Pemain","commenter":"Pemberi Komentar","composer":"Komposer","contributor":"Kontributor","cosponsor":"Kosponsor","counsel":"Advokat","director":"Direktur","editor":"Editor","guest":"Bintang Tamu","interviewee":"Wawancara dengan","interviewer":"Pewawancara","inventor":"Penemu","performer":"Performer","podcaster":"Podcaster","presenter":"Presenter","producer":"Produser","programmer":"Programer","recipient":"Penerima","reviewedAuthor":"Reviewed Author","scriptwriter":"Penulis Skrip","seriesEditor":"Editor Seri","sponsor":"Sponsor","translator":"Penerjemah","wordsBy":"Teks Oleh"}},"is-IS":{"itemTypes":{"annotation":"Skýring","artwork":"Listaverk","attachment":"Viðhengi","audioRecording":"Hljóðupptaka","bill":"Tilkynning","blogPost":"Bloggfærsla","book":"Bók","bookSection":"Bókarhluti","case":"Mál","computerProgram":"Software","conferencePaper":"Ráðstefnugrein","dictionaryEntry":"Færsla í orðabók","document":"Skjal","email":"Tölvupóstur","encyclopediaArticle":"Færsla í alfræðiriti","film":"Kvikmynd","forumPost":"Færsla á samskiptasvæði","hearing":"Réttarhöld","instantMessage":"Skyndiskilaboð","interview":"Viðtal","journalArticle":"Fræðigrein í tímariti","letter":"Bréf","magazineArticle":"Tímaritsgrein","manuscript":"Handrit","map":"Kort","newspaperArticle":"Grein í dagblaði","note":"Athugasemd","patent":"Einkaleyfi","podcast":"Hljóðvarp","preprint":"Preprint","presentation":"Kynning","radioBroadcast":"Útvarpsútsending","report":"Skýrsla","statute":"Lög","thesis":"Ritgerð","tvBroadcast":"Sjónvarpsútsending","videoRecording":"Myndskeið","webpage":"Vefsíða"},"fields":{"abstractNote":"Ágrip","accessDate":"Sótt","applicationNumber":"Umsókn númer","archive":"Safnvista","archiveID":"Archive ID","archiveLocation":"Staðsetning í safni","artworkMedium":"Miðill","artworkSize":"Stærð verks","assignee":"Málstaki","audioFileType":"Skráartegund","audioRecordingFormat":"Hljóðupptökusnið","billNumber":"Tilkynningarnúmer","blogTitle":"Titill á Bloggi","bookTitle":"Titill bókar","callNumber":"Hillumerking","caseName":"Nafn máls","citationKey":"Citation Key","code":"Kóði","codeNumber":"Kóðanúmer","codePages":"Síður kóða","codeVolume":"Magn kóða","committee":"Nefnd","company":"Fyrirtæki","conferenceName":"Heiti ráðstefnu","country":"Land","court":"Réttur","date":"Dagsetning","dateAdded":"Dagsetning viðbótar","dateDecided":"Dagsetning ákvörðunar","dateEnacted":"Virkjunardagsetning","dateModified":"Breytt","dictionaryTitle":"Nafn orðabókar","distributor":"Dreifingaraðili","docketNumber":"Málsnúmer","documentNumber":"Skjalanúmer","DOI":"DOI","edition":"Útgáfa","encyclopediaTitle":"Nafn alfræðirits","episodeNumber":"Þáttur númer","extra":"Viðbót","filingDate":"Dagsetning skráningar","firstPage":"Fyrsta síða","forumTitle":"Titill samskiptasvæðis/Listserv","genre":"Tegund","history":"Saga","institution":"Stofnun","interviewMedium":"Miðill","ISBN":"ISBN","ISSN":"ISSN","issue":"Hefti","issueDate":"Útgáfudagsetning","issuingAuthority":"Útgefandi","itemType":"Tegund","journalAbbreviation":"Skammstöfun fræðarits","label":"Merki","language":"Tungumál","legalStatus":"Lagaleg staða","legislativeBody":"Lagastofnun","letterType":"Tegund leturs","libraryCatalog":"Færslusafnskrá","manuscriptType":"Tegund ritverks","mapType":"Tegund korts","meetingName":"Heiti fundar","nameOfAct":"Nafn laga","network":"Gagnanet","number":"Númer","numberOfVolumes":"Fjöldi binda","numPages":"# síður","pages":"Blaðsíður","patentNumber":"Einkaleyfi nr.","place":"Staðsetning","postType":"Póstsnið","presentationType":"Tegund","priorityNumbers":"Forgangsnúmer","proceedingsTitle":"Titill málstofu","programmingLanguage":"Prog. Language","programTitle":"Titill forrits","publicationTitle":"Útgáfa","publicLawNumber":"Lög númer","publisher":"Útgefandi","references":"Tilvísanir","reporter":"Blaðamaður","reporterVolume":"Fjöldi blaðamanna","reportNumber":"Skýrslunúmer","reportType":"Tegund skýrslu","repository":"Repository","rights":"Réttindi","runningTime":"Lengd","scale":"Skali","section":"Hluti","series":"Ritröð","seriesNumber":"Númer ritraðar","seriesText":"Nafn eintaks í ritröð","seriesTitle":"Titill ritraðar","session":"Seta","shortTitle":"Stuttur titill","studio":"Stúdíó","subject":"Efni","system":"Kerfi","thesisType":"Tegund","title":"Titill","university":"Háskóli","url":"Slóð","versionNumber":"Útgáfa","videoRecordingFormat":"Upptökusnið","volume":"Bindi","websiteTitle":"Titill vefsíðu","websiteType":"Tegund vefs"},"creatorTypes":{"artist":"Listamaður","attorneyAgent":"Lögfræðingur/fulltrúi","author":"Höfundur","bookAuthor":"Höfundur bókar","cartographer":"Kortagerð","castMember":"Leikari","commenter":"Athugasemdir","composer":"Höfundur","contributor":"Aðili að verki","cosponsor":"Stuðningsþátttakandi","counsel":"Ráðgjöf","director":"Leikstjóri","editor":"Ritstjóri","guest":"Gestur","interviewee":"Viðtal við","interviewer":"Hver tók viðtalið","inventor":"Uppfinningamaður","performer":"Leikari","podcaster":"Hlaðvörpun","presenter":"Kynnandi","producer":"Framleiðandi","programmer":"Forritari","recipient":"Viðtakandi","reviewedAuthor":"Yfirlestrarhöfundur","scriptwriter":"Handritshöfundur","seriesEditor":"Ritstjóri ritraðar","sponsor":"Stuðningsaðili","translator":"Þýðandi","wordsBy":"Textahöfundur"}},"it-IT":{"itemTypes":{"annotation":"Annotazione","artwork":"Opera d'arte","attachment":"Allegato","audioRecording":"Registrazione audio","bill":"Disegno di legge","blogPost":"Messaggio di blog","book":"Libro","bookSection":"Sezione di libro","case":"Sentenza","computerProgram":"Software","conferencePaper":"Atto di convegno","dictionaryEntry":"Voce di dizionario","document":"Documento","email":"E-mail","encyclopediaArticle":"Voce di enciclopedia","film":"Film","forumPost":"Messaggio di forum","hearing":"Udienza","instantMessage":"Messaggio istantaneo","interview":"Intervista","journalArticle":"Articolo di rivista","letter":"Lettera","magazineArticle":"Articolo di rivista generalista","manuscript":"Manoscritto","map":"Mappa","newspaperArticle":"Articolo di giornale","note":"Nota","patent":"Brevetto","podcast":"Podcast","preprint":"Preprint","presentation":"Presentazione","radioBroadcast":"Trasmissione radiofonica","report":"Report","statute":"Legislazione","thesis":"Tesi","tvBroadcast":"Trasmissione televisiva","videoRecording":"Registrazione video","webpage":"Pagina web"},"fields":{"abstractNote":"Abstract","accessDate":"Consultato","applicationNumber":"Numero di applicazione","archive":"Archivio","archiveID":"ID dell'archivio","archiveLocation":"Posizione in archivio","artworkMedium":"Tipologia","artworkSize":"Dimensioni grafiche","assignee":"Assegnatario del brevetto","audioFileType":"Tipo di file","audioRecordingFormat":"Formato","billNumber":"Numero della legge","blogTitle":"Nome del blog","bookTitle":"Titolo del libro","callNumber":"Collocazione","caseName":"Nome del caso","citationKey":"Chiave di citazione","code":"Codice","codeNumber":"Numero di codice","codePages":"Pagine del codice","codeVolume":"Volume del codice","committee":"Commissione","company":"Società","conferenceName":"Nome del convegno","country":"Nazione","court":"Corte","date":"Data","dateAdded":"Data inserimento","dateDecided":"Data della sentenza","dateEnacted":"Data di emanazione","dateModified":"Data ultima modifica","dictionaryTitle":"Titolo dizionario","distributor":"Casa di distribuzione","docketNumber":"Numero di inventario della sentenza","documentNumber":"Numero di documento","DOI":"DOI","edition":"Edizione","encyclopediaTitle":"Titolo enciclopedia","episodeNumber":"Numero di episodio","extra":"Extra","filingDate":"Data di sottomissione","firstPage":"Prima pagina","forumTitle":"Nome del forum o listserv","genre":"Genere","history":"Cronologia","institution":"Istituzione","interviewMedium":"Formato","ISBN":"ISBN","ISSN":"ISSN","issue":"Fascicolo","issueDate":"Data di pubblicazione","issuingAuthority":"Autorità emettente","itemType":"Tipo","journalAbbreviation":"Abbreviazione rivista","label":"Etichetta","language":"Lingua","legalStatus":"Stato legale","legislativeBody":"Corpo legislativo","letterType":"Tipo","libraryCatalog":"Catalogo della biblioteca","manuscriptType":"Tipo","mapType":"Tipo","meetingName":"Nome della riunione","nameOfAct":"Nome dell'atto","network":"Rete","number":"Numero","numberOfVolumes":"Numero di volumi","numPages":"# di Pagine","pages":"Pagine","patentNumber":"Numero di brevetto","place":"Luogo di edizione","postType":"Tipo di messaggio","presentationType":"Tipo","priorityNumbers":"Numero di priorità","proceedingsTitle":"Titolo degli atti","programmingLanguage":"Linguaggio di progr.","programTitle":"Titolo del programma","publicationTitle":"Titolo della pubblicazione","publicLawNumber":"Numero di legge pubblica","publisher":"Editore","references":"Riferimenti bibliografici","reporter":"Raccolta di giurisprudenza","reporterVolume":"Volume della raccolta","reportNumber":"Numero di report","reportType":"Tipo di report","repository":"Repository","rights":"Diritti","runningTime":"Durata","scale":"Scala","section":"Sezione","series":"Serie","seriesNumber":"Numero della serie","seriesText":"Testo della serie","seriesTitle":"Titolo della serie","session":"Sessione","shortTitle":"Titolo breve","studio":"Studio","subject":"Oggetto","system":"Sistema","thesisType":"Tipo","title":"Titolo","university":"Università","url":"URL","versionNumber":"Versione","videoRecordingFormat":"Formato","volume":"Volume","websiteTitle":"Nome del sito","websiteType":"Tipo di sito web"},"creatorTypes":{"artist":"Artista","attorneyAgent":"Procuratore o agente","author":"Autore","bookAuthor":"Autore del libro","cartographer":"Cartografo","castMember":"Componente del cast","commenter":"Commentatore","composer":"Compositore","contributor":"Collaboratore","cosponsor":"Co-finanziatore","counsel":"Consulente legale","director":"Regista","editor":"Curatore","guest":"Ospite","interviewee":"Intervista con","interviewer":"Intervistatore","inventor":"Inventore","performer":"Esecutore","podcaster":"Autore del podcast","presenter":"Presentatore","producer":"Produttore","programmer":"Programmatore","recipient":"Destinatario","reviewedAuthor":"Autore recensito","scriptwriter":"Sceneggiatore","seriesEditor":"Curatore della serie","sponsor":"Finanziatore","translator":"Traduttore","wordsBy":"Parole di"}},"ja-JP":{"itemTypes":{"annotation":"注釈","artwork":"芸術作品","attachment":"添付ファイル","audioRecording":"録音","bill":"議案","blogPost":"ブログ記事","book":"書籍","bookSection":"書籍の章","case":"訴訟","computerProgram":"ソフトウェア","conferencePaper":"学会発表","dictionaryEntry":"辞書項目","document":"文書","email":"電子メール","encyclopediaArticle":"百科事典項目","film":"映画","forumPost":"掲示板への投稿","hearing":"公聴会","instantMessage":"インスタントメッセージ","interview":"インタビュー","journalArticle":"学術論文","letter":"手紙","magazineArticle":"雑誌記事","manuscript":"原稿","map":"地図","newspaperArticle":"新聞記事","note":"メモ","patent":"特許","podcast":"ポッドキャスト","preprint":"プレプリント","presentation":"プレゼンテーション","radioBroadcast":"ラジオ放送","report":"レポート","statute":"法律","thesis":"学位論文","tvBroadcast":"テレビ放送","videoRecording":"録画","webpage":"ウェブページ"},"fields":{"abstractNote":"抄録","accessDate":"アクセス日時","applicationNumber":"出願番号","archive":"アーカイブ","archiveID":"アーカイブ ID","archiveLocation":"アーカイブ番号","artworkMedium":"素材・技法","artworkSize":"芸術作品のサイズ","assignee":"譲受人","audioFileType":"ファイルの種類","audioRecordingFormat":"フォーマット","billNumber":"法規番号","blogTitle":"ブログ名","bookTitle":"書籍名","callNumber":"図書整理番号","caseName":"事件名","citationKey":"Citation Key","code":"コード","codeNumber":"コード番号","codePages":"法典のページ","codeVolume":"法典の巻","committee":"委員会","company":"会社名","conferenceName":"学会名","country":"国名","court":"裁判所","date":"出版年月日","dateAdded":"追加日時","dateDecided":"決定期日","dateEnacted":"施行期日","dateModified":"更新日時","dictionaryTitle":"辞書名","distributor":"配布／販売している会社","docketNumber":"事件整理番号","documentNumber":"文書番号","DOI":"DOI","edition":"版","encyclopediaTitle":"百科事典名","episodeNumber":"エピソードの番号","extra":"その他","filingDate":"出願日","firstPage":"最初のページ","forumTitle":"掲示板 / リストサーブの名称","genre":"ジャンル","history":"歴史","institution":"機関","interviewMedium":"メディア","ISBN":"ISBN","ISSN":"ISSN","issue":"号","issueDate":"発行日","issuingAuthority":"発行機関","itemType":"種類","journalAbbreviation":"雑誌略誌名","label":"レーベル","language":"言語","legalStatus":"法的地位","legislativeBody":"立法機関","letterType":"種類","libraryCatalog":"書誌情報","manuscriptType":"種類","mapType":"種類","meetingName":"会議名","nameOfAct":"法令名","network":"ネットワーク","number":"番号","numberOfVolumes":"巻数","numPages":"#ページ","pages":"ページ数","patentNumber":"特許番号","place":"都市","postType":"書き込みの種類","presentationType":"種類","priorityNumbers":"優先番号","proceedingsTitle":"紀要名","programmingLanguage":"プログラミング言語","programTitle":"プログラム名","publicationTitle":"雑誌","publicLawNumber":"法律番号","publisher":"出版社","references":"文献","reporter":"レポーター","reporterVolume":"リポーター巻","reportNumber":"レポート番号","reportType":"レポートの種類","repository":"リポジトリ","rights":"権利","runningTime":"経過時間","scale":"縮尺","section":"章","series":"叢書","seriesNumber":"叢書番号","seriesText":"叢書テキスト","seriesTitle":"叢書名","session":"セッション","shortTitle":"題名 (略)","studio":"スタジオ","subject":"件名","system":"システム","thesisType":"種類","title":"題名","university":"大学名","url":"URL","versionNumber":"バージョン","videoRecordingFormat":"フォーマット","volume":"巻","websiteTitle":"ウェブサイト名","websiteType":"ウェブサイトの種類"},"creatorTypes":{"artist":"アーティスト","attorneyAgent":"弁護士／代理人","author":"著者名","bookAuthor":"書籍著者名","cartographer":"製図家","castMember":"キャスト","commenter":"評論家","composer":"作曲家","contributor":"寄稿者名","cosponsor":"共同スポンサー","counsel":"顧問弁護士","director":"監督","editor":"編集者名","guest":"ゲスト","interviewee":"インタビュー対象:","interviewer":"インタビュアー","inventor":"発明者名","performer":"演奏者","podcaster":"ポッドキャスト送信者","presenter":"発表者","producer":"プロデューサー","programmer":"プログラマー","recipient":"受取人","reviewedAuthor":"レビューされた著者","scriptwriter":"脚本家","seriesEditor":"叢書編集者名","sponsor":"スポンサー","translator":"翻訳者名","wordsBy":"作詞"}},"km":{"itemTypes":{"annotation":"ចំណារពន្យល់","artwork":"សិល្បៈ","attachment":"ឯកសារកម្ជាប់","audioRecording":"ខ្សែអាត់សំឡេង","bill":"គម្រោងច្បាប់","blogPost":"ការផ្សាយគេហទំព័រប្លុក","book":"សៀវភៅ","bookSection":"ផ្នែកនៃសៀវភៅ","case":"ករណី/រឿងក្តី","computerProgram":"Software","conferencePaper":"ឯកសារសន្និសីទ","dictionaryEntry":"វចនានុក្រម","document":"ឯកសារ","email":"សារអេឡិចត្រូនិច","encyclopediaArticle":"សព្វវចនាធិប្បាយ","film":"ភាពយន្ត","forumPost":"ការផ្សាយវេទិកា","hearing":"សវនាការ","instantMessage":"សារបន្ទាន់","interview":"បទសម្ភាសន៍","journalArticle":"អត្ថបទទនានុប្បវត្តិ","letter":"សំបុត្រ","magazineArticle":"អត្ថបទទស្សនាវដ្តី","manuscript":"ហត្ថាអត្ថបទ","map":"ផែនទី","newspaperArticle":"អត្ថបទកាសែត","note":"កំណត់ចំណាំ","patent":"តត្តកម្ម","podcast":"ផដខាស្ត៍","preprint":"Preprint","presentation":"ឧទ្ទេសបទ","radioBroadcast":"កម្មវិធីវិទ្យុ","report":"របាយការណ៍","statute":"ច្បាប់","thesis":"និក្ខេបបទ","tvBroadcast":"កម្មវិធីទូរទស្សន៍","videoRecording":"ខ្សែអាត់វីដេអូ","webpage":"គេហទំព័រ"},"fields":{"abstractNote":"ខ្លឹមសារសង្ខេប","accessDate":"ចូលមើល","applicationNumber":"ពាក្យសុំលេខ","archive":"បណ្ណាសារ","archiveID":"Archive ID","archiveLocation":"ទីតាំងក្នុងបណ្ណាសារ","artworkMedium":"សារព័ត៌មាន","artworkSize":"សិល្បៈ","assignee":"អ្នទទួលភារកិច្ច","audioFileType":"ប្រភេទឯកសារ","audioRecordingFormat":"ទម្រង់","billNumber":"លេខគម្រោងច្បាប់","blogTitle":"ចំណងជើងគេហទំព័រប្លុក","bookTitle":"ចំណងជើងសៀវភៅ","callNumber":"លេខហៅ","caseName":"ចំណងជើងករណី/រឿងក្តី","citationKey":"Citation Key","code":"ក្រម","codeNumber":"លេខក្រម","codePages":"ទំព័រក្រម","codeVolume":"វ៉ុលក្រម","committee":"គណៈកម្មាធិការ","company":"ក្រុមហ៊ុន","conferenceName":"ឈ្មោះសន្និសីទកាសែត","country":"ប្រទេស","court":"តុលាការ","date":"កាលបរិច្ឆេទ","dateAdded":"កាលបរិច្ឆេទបញ្ចូល","dateDecided":"កាលបរិច្ឆេទសម្រេច","dateEnacted":"កាលបរិច្ឆេទអនុម័ត","dateModified":"កែតម្រូវ","dictionaryTitle":"ចំណងជើងវចនានុក្រម","distributor":"ចែកចាយ","docketNumber":"លេខសំណុំរឿង","documentNumber":"លេខឯកសារ","DOI":"ឌីអូអាយ","edition":"កំណែតម្រូវ","encyclopediaTitle":"ចំណងជើងសព្វវចនាធិប្បាយ","episodeNumber":"លេខអង្គហេតុ","extra":"បន្ថែម","filingDate":"កាលបរិច្ឆេទតម្កល់","firstPage":"ទំព័រទីមួយ","forumTitle":"ចំណងជើងវេទិកា","genre":"អត្តសញ្ញាណពិសេស","history":"ប្រវត្តិសាស្ត្រ","institution":"ស្ថាប័ន","interviewMedium":"សារព័ត៌មាន","ISBN":"អាយអេសប៊ីអិន","ISSN":"អាយអេសអេសអិន","issue":"ចេញផ្សាយ","issueDate":"កាលបរិច្ឆទចេញផ្សាយ","issuingAuthority":"អាជ្ញាធរចេញផ្សាយ","itemType":"ប្រភេទ","journalAbbreviation":"ពាក្យកាត់ទនានុបុ្បវត្តិ","label":"ស្លាក","language":"ភាសា","legalStatus":"លក្ខខណ្ឌច្បាប់","legislativeBody":"អង្គនីតិប្បញ្ញត្តិ","letterType":"ប្រភេទ","libraryCatalog":"កាតាឡុកបណ្ណាល័យ","manuscriptType":"ប្រភេទ","mapType":"ប្រភេទ","meetingName":"ឈ្មោះកិច្ចប្រជុំ","nameOfAct":"ចំណងជើងច្បាប់","network":"បណ្តាញ","number":"លេខ","numberOfVolumes":"លេខវ៉ុល","numPages":"លេខទំព័រ","pages":"ទំព័រ","patentNumber":"លេខតត្តកម្ម","place":"ទីតាំង","postType":"ប្រភេទផ្សាយ","presentationType":"ប្រភេទ","priorityNumbers":"លេខអាទិភាព","proceedingsTitle":"ចំណងជើងនីតិវិធី","programmingLanguage":"Prog. Language","programTitle":"ចំណងជើងកម្មវិធី","publicationTitle":"បោះពុម្ពផ្សាយ","publicLawNumber":"លេខច្បាប់","publisher":"អ្នកបោះពុម្ព","references":"កំណត់យោង","reporter":"អ្នកធ្វើរបាយការណ៍","reporterVolume":"វ៉ុលរបាយការណ៍","reportNumber":"លេខរបាយការណ៍","reportType":"ប្រភេទរបាយការណ៍","repository":"Repository","rights":"សិទ្ធិ","runningTime":"ម៉ោងដំណើរការ","scale":"កម្រិត","section":"ផ្នែក","series":"លេខរៀង","seriesNumber":"លំដាប់លេខរៀង","seriesText":"អត្ថបទលេខរៀង","seriesTitle":"ចំណងជើងលេខរៀង","session":"សម័យកាល","shortTitle":"ចំណងជើងខ្លី","studio":"ស្ថានីយថតសំឡេង","subject":"ប្រធានបទ","system":"ប្រព័ន្ធ","thesisType":"ប្រភេទ","title":"ចំណងជើង","university":"សាកលវិទ្យាល័យ","url":"គេហទំព័រ","versionNumber":"កំណែថ្មី","videoRecordingFormat":"ទម្រង់","volume":"វ៉ុល","websiteTitle":"ចំណងជើងគេហទំព័រ","websiteType":"ប្រភេទគេហទំព័រ"},"creatorTypes":{"artist":"សិល្បករ","attorneyAgent":"មេធាវី/ភ្នាក់ងារ","author":"អ្នកនិពន្ធ","bookAuthor":"អ្នកនិពន្ធសៀវភៅ","cartographer":"អ្នករៀបចំប្លង់","castMember":"តួសំដែង","commenter":"អ្នកផ្តល់មតិយោបល់","composer":"អ្នកនិពន្ធទំនុក","contributor":"អ្នកចូលរួម","cosponsor":"សហអ្នកឧបត្ថម្ភ","counsel":"ក្រុមប្រឹក្សា","director":"នាយក","editor":"អ្នកកែតម្រូវ","guest":"ភ្ញៀវ","interviewee":"សម្ភាសន៍ជាមួយ","interviewer":"អ្នកសម្ភាសន៍","inventor":"អ្នកបង្កើត","performer":"អ្នកសំដែង","podcaster":"អ្នកថតសំឡេងផដខាស្ត៍","presenter":"អ្នកអត្ថាធិប្បាយ","producer":"ផលិតករ","programmer":"អ្នករៀបចំកម្មវិធី","recipient":"អ្នកទទួល","reviewedAuthor":"អ្នកនិពន្ធត្រួតពិនិត្យ","scriptwriter":"អ្នកសរសេរអត្ថបទ","seriesEditor":"អ្នកកែតម្រូវតាមលេខរៀង","sponsor":"អ្នកឧបត្ថម្ភ","translator":"អ្នកបកប្រែ","wordsBy":"ពាក្យដោយ"}},"ko-KR":{"itemTypes":{"annotation":"주석","artwork":"예술품","attachment":"첨부","audioRecording":"녹음","bill":"의안","blogPost":"블로그 게시물","book":"서적","bookSection":"책 소개 면","case":"소송","computerProgram":"소프트웨어","conferencePaper":"회의문","dictionaryEntry":"사전 항목","document":"문서","email":"이메일","encyclopediaArticle":"백과사전 항목","film":"영화","forumPost":"토론 게시물","hearing":"공청회","instantMessage":"긴급 메시지","interview":"인터뷰","journalArticle":"저널 기사","letter":"편지","magazineArticle":"잡지 기사","manuscript":"원고","map":"지도","newspaperArticle":"신문 기사","note":"노트","patent":"특허","podcast":"팟캐스트","preprint":"Preprint","presentation":"발표","radioBroadcast":"라디오 방송","report":"보고서","statute":"법령","thesis":"학위논문","tvBroadcast":"TV 방송","videoRecording":"녹화","webpage":"웹 페이지"},"fields":{"abstractNote":"요약","accessDate":"접근일","applicationNumber":"출원 번호","archive":"아카이브","archiveID":"Archive ID","archiveLocation":"아카이브 위치","artworkMedium":"소재·기법","artworkSize":"예술품의 크기","assignee":"양수인","audioFileType":"파일 형식","audioRecordingFormat":"형식","billNumber":"의안 번호","blogTitle":"블로그 제목","bookTitle":"책 제목","callNumber":"도서 번호","caseName":"사건명","citationKey":"Citation Key","code":"코드","codeNumber":"코드 번호","codePages":"법전 페이지","codeVolume":"법제목","committee":"위원회","company":"회사명","conferenceName":"협의 명","country":"국가","court":"법원","date":"날짜","dateAdded":"입력일","dateDecided":"판결일","dateEnacted":"제정일","dateModified":"변경일","dictionaryTitle":"사전 명","distributor":"배급자","docketNumber":"사건 번호","documentNumber":"문서 번호","DOI":"DOI","edition":"판본","encyclopediaTitle":"백과사전 명","episodeNumber":"에피소드 번호","extra":"추가사항","filingDate":"Filing Date","firstPage":"첫 페이지","forumTitle":"토론/Listserv 제목","genre":"장르","history":"역사","institution":"학회","interviewMedium":"매체","ISBN":"ISBN","ISSN":"ISSN","issue":"호","issueDate":"발행일","issuingAuthority":"Issuing Authority","itemType":"형식","journalAbbreviation":"저널 약어","label":"레이블","language":"언어","legalStatus":"법적지위","legislativeBody":"입법 기관","letterType":"형식","libraryCatalog":"도서 목록","manuscriptType":"형식","mapType":"형식","meetingName":"회의명","nameOfAct":"법령 이름","network":"네트워크","number":"번호","numberOfVolumes":"권수","numPages":"총 페이지수","pages":"쪽","patentNumber":"특허 번호","place":"발행지","postType":"게시물 종류","presentationType":"형식","priorityNumbers":"우선 번호","proceedingsTitle":"의사록","programmingLanguage":"프로그래밍 언어","programTitle":"프로그램 제목","publicationTitle":"간행","publicLawNumber":"공법 번호","publisher":"출판사","references":"참조","reporter":"보고자","reporterVolume":"보고서 권수","reportNumber":"보고서 번호","reportType":"보고 형식","repository":"Repository","rights":"소유권","runningTime":"동작 시간","scale":"축척","section":"구역","series":"시리즈","seriesNumber":"시리즈 번호","seriesText":"시리즈 텍스트","seriesTitle":"시리즈 제목","session":"세션","shortTitle":"짧은 제목","studio":"스튜디오","subject":"부제","system":"시스템","thesisType":"형식","title":"제목","university":"대학","url":"URL","versionNumber":"버전","videoRecordingFormat":"형식","volume":"권","websiteTitle":"웹사이트 명","websiteType":"웹사이트 형식"},"creatorTypes":{"artist":"예술가","attorneyAgent":"변호사/대리인","author":"저자","bookAuthor":"책 저자","cartographer":"지도 제작자","castMember":"출연자","commenter":"비평가","composer":"작곡가","contributor":"공헌자","cosponsor":"Cosponsor","counsel":"회의","director":"감독","editor":"편집자","guest":"손님","interviewee":"인터뷰：","interviewer":"인터뷰진행자","inventor":"발명자","performer":"연주자","podcaster":"팟캐스터","presenter":"제출자","producer":"제작자","programmer":"프로그래머","recipient":"수령인","reviewedAuthor":"평론가","scriptwriter":"각본가","seriesEditor":"시리즈 편집자","sponsor":"후원자","translator":"번역자","wordsBy":"작사"}},"lt-LT":{"itemTypes":{"annotation":"Anotacija","artwork":"Iliustracija","attachment":"Priedas","audioRecording":"Garso įrašas","bill":"Įstatymo projektas","blogPost":"Tinklaraščio įrašas","book":"Knyga","bookSection":"Knygos skyrius","case":"Byla","computerProgram":"Programinė įranga","conferencePaper":"Pranešimas konferencijoje","dictionaryEntry":"Žodyno įrašas","document":"Dokumentas","email":"El. laiškas","encyclopediaArticle":"Straipsnelis enciklopedijoje","film":"Filmas","forumPost":"Žinutė forume","hearing":"Bylos nagrinėjimas, svarstymas","instantMessage":"Žinutė","interview":"Pokalbis","journalArticle":"Žurnalo straipsnis","letter":"Laiškas","magazineArticle":"Periodinio žurnalo straipsnis","manuscript":"Rankraštis","map":"Žemėlapis","newspaperArticle":"Laikraščio straipsnis","note":"Pastaba","patent":"Patentas","podcast":"Tinklalaidė","preprint":"Preprint","presentation":"Pateiktis","radioBroadcast":"Radijo laida","report":"Ataskaita/pranešimas","statute":"Įstatymas","thesis":"Disertacija, baigiamasis darbas","tvBroadcast":"TV laida","videoRecording":"Vaizdo įrašas","webpage":"Tinklalapis"},"fields":{"abstractNote":"Santrauka","accessDate":"Žiūrėta","applicationNumber":"Pareiškimo numeris","archive":"Archyvas","archiveID":"Archive ID","archiveLocation":"Vieta archyve","artworkMedium":"Laikmena","artworkSize":"Paveikslo dydis","assignee":"Atstovas","audioFileType":"Failo tipas","audioRecordingFormat":"Formatas","billNumber":"Įstatymo numeris","blogTitle":"Tinklaraščio pavadinimas","bookTitle":"Knygos pavad.","callNumber":"Šifras","caseName":"Bylos pavadinimas","citationKey":"Citation Key","code":"Kodas","codeNumber":"Kodekso numeris","codePages":"Puslapiai kodekse","codeVolume":"Kodekso tomas","committee":"Komisija","company":"Įmonė","conferenceName":"Konferencijos pavadinimas","country":"Valstybė","court":"Teismas","date":"Data","dateAdded":"Pridėta","dateDecided":"Sprendimo data","dateEnacted":"Paskelbimo data","dateModified":"Pakeista","dictionaryTitle":"Žodyno pavadinimas","distributor":"Platintojas","docketNumber":"Priedo numeris","documentNumber":"Dokumento numeris","DOI":"DOI","edition":"Leidimas, Nr.","encyclopediaTitle":"Enciklopedijos pavadinimas","episodeNumber":"Epizodo numeris","extra":"Papildoma","filingDate":"Užpildymo data","firstPage":"Pirmas puslapis","forumTitle":"Forumo pavadinimas","genre":"Žanras","history":"Istorija","institution":"Įstaiga","interviewMedium":"Laikmena","ISBN":"ISBN","ISSN":"ISSN","issue":"Numeris","issueDate":"Išleidimo data","issuingAuthority":"Išdavusi įstaiga","itemType":"Tipas","journalAbbreviation":"Žurnalo santrumpa","label":"Etiketė","language":"Kalba","legalStatus":"Teisinis statusas","legislativeBody":"Įstatymų leidžiamoji valdžia","letterType":"Tipas","libraryCatalog":"Bibl. katalogas","manuscriptType":"Tipas","mapType":"Tipas","meetingName":"Susitikimo pavadinimas","nameOfAct":"Akto pavadinimas","network":"Tinklas","number":"Numeris","numberOfVolumes":"Tomų skaičius","numPages":"Puslapių kiekis","pages":"Puslapiai","patentNumber":"Patento numeris","place":"Vieta","postType":"Pranešimo tipas","presentationType":"Tipas","priorityNumbers":"Prioriteto numeris","proceedingsTitle":"Įvykio pavadinimas","programmingLanguage":"Prog. kalba","programTitle":"Programos pavadinimas","publicationTitle":"Leidinys","publicLawNumber":"Oficialaus rašto numeris","publisher":"Leidėjas","references":"Nuorodos","reporter":"Pranešėjas","reporterVolume":"Pranešimo tomas","reportNumber":"Pranešimo numeris","reportType":"Pranešimo tipas","repository":"Repository","rights":"Teisės","runningTime":"Trukmė","scale":"Skalė","section":"Skirsnis","series":"Serija","seriesNumber":"Serijos Nr.","seriesText":"Serijos tekstas","seriesTitle":"Serijos pavadinimas","session":"Sesija","shortTitle":"Trumpas pavad.","studio":"Dirbtuvė/studija","subject":"Tema","system":"Sistema","thesisType":"Tipas","title":"Pavadinimas","university":"Universitetas","url":"URL","versionNumber":"Versija","videoRecordingFormat":"Formatas","volume":"Tomas","websiteTitle":"Svetainės pavadinimas","websiteType":"Svetainės tipas"},"creatorTypes":{"artist":"Menininkas/aktorius","attorneyAgent":"Įgaliotasis asmuo","author":"Autorius","bookAuthor":"Knygos autorius","cartographer":"Kartografas","castMember":"Atlikėjas/artistas","commenter":"Komentuotojas","composer":"Kūrėjas/kompozitorius","contributor":"Bendradarbis","cosponsor":"Kitas rėmėjas","counsel":"Advokatas","director":"Vadovas","editor":"Redaktorius","guest":"Svečias","interviewee":"Pokalbis su","interviewer":"Apklausėjas","inventor":"išradėjas","performer":"Atlikėjas","podcaster":"Transliuotojas","presenter":"Vedėjas","producer":"Prodiuseris","programmer":"Programuotojas","recipient":"Gavėjas","reviewedAuthor":"Peržiūrėtas autorius","scriptwriter":"Scenaristas","seriesEditor":"Serijos sudarytojas","sponsor":"Rėmėjas","translator":"Vertėjas","wordsBy":"Žodžiai"}},"mn-MN":{"itemTypes":{"annotation":"Annotation","artwork":"Artwork","attachment":"Хавсралт","audioRecording":"Audio Recording","bill":"Bill","blogPost":"Блог бичлэг","book":"Ном","bookSection":"Номын хэсэг","case":"Case","computerProgram":"Software","conferencePaper":"Хурлын өгүүлэл","dictionaryEntry":"Dictionary Entry","document":"Баримт","email":"Электрон шуудан","encyclopediaArticle":"Тайлбар толийн өгүүлэл","film":"Кино","forumPost":"Forum Post","hearing":"Hearing","instantMessage":"Instant Message","interview":"Ярилцлага","journalArticle":"Сэтгүүлийн өгүүлэл","letter":"Захиа","magazineArticle":"Magazine Article","manuscript":"Manuscript","map":"Газрын зураг","newspaperArticle":"Сонины нийтлэл","note":"Тэмдэглэл","patent":"Патент","podcast":"Podcast","preprint":"Preprint","presentation":"Танилцууллага","radioBroadcast":"Radio Broadcast","report":"Тайлан","statute":"Statute","thesis":"Thesis","tvBroadcast":"TV Broadcast","videoRecording":"Video Recording","webpage":"Вэб хуудас"},"fields":{"abstractNote":"Abstract","accessDate":"Accessed","applicationNumber":"Application Number","archive":"Archive","archiveID":"Archive ID","archiveLocation":"Loc. in Archive","artworkMedium":"Дунд","artworkSize":"Artwork Size","assignee":"Assignee","audioFileType":"Файлын төрөл","audioRecordingFormat":"Format","billNumber":"Bill Number","blogTitle":"Блог гарчиг","bookTitle":"Номын гарчиг","callNumber":"Call Number","caseName":"Case Name","citationKey":"Citation Key","code":"Код","codeNumber":"Кодын дугаар","codePages":"Code Pages","codeVolume":"Code Volume","committee":"Committee","company":"Компани","conferenceName":"Хурлын нэр","country":"Улс","court":"Court","date":"Он сар өдөр","dateAdded":"Date Added","dateDecided":"Date Decided","dateEnacted":"Date Enacted","dateModified":"Modified","dictionaryTitle":"Толь бичгийн гарчиг","distributor":"Distributor","docketNumber":"Docket Number","documentNumber":"Баримт бичгийн дугаар","DOI":"DOI","edition":"Edition","encyclopediaTitle":"Нэвтэрхий тольны гарчиг","episodeNumber":"Episode Number","extra":"Extra","filingDate":"Filing Date","firstPage":"Эхний хуудас","forumTitle":"Forum/Listserv Title","genre":"Genre","history":"Түүх","institution":"Хүрээлэн/Албан байгууллага","interviewMedium":"Дунд","ISBN":"ISBN","ISSN":"ISSN","issue":"Issue","issueDate":"Issue Date","issuingAuthority":"Issuing Authority","itemType":"Төрөл","journalAbbreviation":"Journal Abbr","label":"Шошго","language":"Хэл","legalStatus":"Legal Status","legislativeBody":"Legislative Body","letterType":"Төрөл","libraryCatalog":"Library Catalog","manuscriptType":"Төрөл","mapType":"Төрөл","meetingName":"Уулзалтын нэр","nameOfAct":"Name of Act","network":"Сүлжээ","number":"Тоо","numberOfVolumes":"# of Volumes","numPages":"# of Pages","pages":"Хуудасууд","patentNumber":"Патентын дугаар","place":"Place","postType":"Бичлэгийн төрөл","presentationType":"Төрөл","priorityNumbers":"Priority Numbers","proceedingsTitle":"Proceedings Title","programmingLanguage":"Prog. Language","programTitle":"Program Title","publicationTitle":"Хэвлэл","publicLawNumber":"Public Law Number","publisher":"Хэвлэгч","references":"References","reporter":"Reporter","reporterVolume":"Reporter Volume","reportNumber":"Тайлангийн дугаар","reportType":"Тайлангийн төрөл","repository":"Repository","rights":"Эрхүүд","runningTime":"Running Time","scale":"Масштаб","section":"Section","series":"Series","seriesNumber":"Series Number","seriesText":"Series Text","seriesTitle":"Series Title","session":"Session","shortTitle":"Богино гарчиг","studio":"Studio","subject":"Subject","system":"Систем","thesisType":"Төрөл","title":"Гарчиг","university":"Их сургууль","url":"URL","versionNumber":"Хувилбар","videoRecordingFormat":"Format","volume":"Volume","websiteTitle":"Вэб сайтын гарчиг","websiteType":"Вэб сайтын төрөл"},"creatorTypes":{"artist":"Artist","attorneyAgent":"Attorney/Agent","author":"Зохиогч","bookAuthor":"Book Author","cartographer":"Cartographer","castMember":"Cast Member","commenter":"Commenter","composer":"Composer","contributor":"Contributor","cosponsor":"Cosponsor","counsel":"Counsel","director":"Захирал","editor":"Editor","guest":"Guest","interviewee":"Interview With","interviewer":"Interviewer","inventor":"Inventor","performer":"Performer","podcaster":"Podcaster","presenter":"Presenter","producer":"Producer","programmer":"Programmer","recipient":"Recipient","reviewedAuthor":"Reviewed Author","scriptwriter":"Scriptwriter","seriesEditor":"Series Editor","sponsor":"Ивээн тэтгэгч","translator":"Орчуулагч","wordsBy":"Words By"}},"nb-NO":{"itemTypes":{"annotation":"Merknad","artwork":"Kunstverk","attachment":"Vedlegg","audioRecording":"Lydopptak","bill":"Lovforslag","blogPost":"Blogginnlegg","book":"Bok","bookSection":"Del av bok","case":"Sak","computerProgram":"Programvare","conferencePaper":"Konferanseinnlegg","dictionaryEntry":"Oppslag i ordbok","document":"Dokument","email":"E-post","encyclopediaArticle":"Artikkel i oppslagsverk","film":"Film","forumPost":"Foruminnlegg","hearing":"Høring","instantMessage":"Hurtigmelding","interview":"Intervju","journalArticle":"Tidsskriftsartikkel","letter":"Brev","magazineArticle":"Magasinartikkel","manuscript":"Manuskript","map":"Kart","newspaperArticle":"Avisartikkel","note":"Notat","patent":"Patent","podcast":"Podcast","preprint":"Forhåndstrykk","presentation":"Presentasjon","radioBroadcast":"Radiosending","report":"Rapport","statute":"Statutt","thesis":"Avhandling","tvBroadcast":"TV-sending","videoRecording":"Videoopptak","webpage":"Nettside"},"fields":{"abstractNote":"Sammendrag","accessDate":"Lest","applicationNumber":"Programvarenummer","archive":"Arkiv","archiveID":"Arkiv ID","archiveLocation":"Lokalisering i arkiv","artworkMedium":"Medium","artworkSize":"Kunstverk-størrelse","assignee":"Fullmektig","audioFileType":"Filtype","audioRecordingFormat":"Format","billNumber":"Lov-nummer","blogTitle":"Bloggtittel","bookTitle":"Boktittel","callNumber":"Plass-signatur","caseName":"Saksnavn","citationKey":"Henvisningsnøkkel","code":"Kode","codeNumber":"Tekst nummer","codePages":"Sider i tekst","codeVolume":"Lov-volum","committee":"Komité","company":"Selskap","conferenceName":"Konferansens navn","country":"Land","court":"Rett","date":"Dato","dateAdded":"Dato lagt til","dateDecided":"Avgjort (dato)","dateEnacted":"Innført (dato)","dateModified":"Endret","dictionaryTitle":"Ordbok","distributor":"Distributør","docketNumber":"Registreringsnummer","documentNumber":"Dokumentnummer","DOI":"DOI","edition":"Utgave","encyclopediaTitle":"Oppslagverk","episodeNumber":"Episodenummer","extra":"Ekstra","filingDate":"Innleveringsdato","firstPage":"Første side","forumTitle":"Forum-/listserv-tittel","genre":"Sjanger","history":"Historie","institution":"Institusjon","interviewMedium":"Medium","ISBN":"ISBN","ISSN":"ISSN","issue":"Nummer","issueDate":"Kjennelsesdato","issuingAuthority":"Utstedende myndighet","itemType":"Type","journalAbbreviation":"Tidsskriftsforkortelse","label":"Plateselskap","language":"Språk","legalStatus":"Rettslig status","legislativeBody":"Lovgivende organ","letterType":"Type","libraryCatalog":"Bibliotekskatalog","manuscriptType":"Type","mapType":"Type","meetingName":"Møtenavn","nameOfAct":"Navn på loven","network":"Nettverk","number":"Nummer","numberOfVolumes":"# av volumer","numPages":"# av sider","pages":"Sider","patentNumber":"Patentnummer","place":"Sted","postType":"Posttype","presentationType":"Type","priorityNumbers":"Prioritetsnummer","proceedingsTitle":"Sakstittel","programmingLanguage":"Programmeringsspråk","programTitle":"Program tittel","publicationTitle":"Publikasjon","publicLawNumber":"Offentlig lov, nummer","publisher":"Utgiver","references":"Referanser","reporter":"Reporter","reporterVolume":"Reporter volum","reportNumber":"Rapportnummer","reportType":"Rapporttype","repository":"Magasin","rights":"Rettigheter","runningTime":"Lengde","scale":"Skala","section":"Seksjon","series":"Serie","seriesNumber":"Serienummer","seriesText":"Serietekst","seriesTitle":"Serietittel","session":"Sesjon","shortTitle":"Kort tittel","studio":"Studio","subject":"Emne","system":"System","thesisType":"Type","title":"Tittel","university":"Universitet","url":"URL","versionNumber":"Versjon","videoRecordingFormat":"Format","volume":"Volum","websiteTitle":"Nettsidens tittel","websiteType":"Nettstedtype"},"creatorTypes":{"artist":"Artist","attorneyAgent":"Advokat/Agent","author":"Forfatter","bookAuthor":"Bokforfatter","cartographer":"Kartograf","castMember":"Skuespiller","commenter":"Kommentator","composer":"Komponist","contributor":"Medforfatter","cosponsor":"Medsponsor","counsel":"Rådgiver","director":"Instruktør","editor":"Redaktør","guest":"Gjest","interviewee":"Intervju med","interviewer":"Intervjuer","inventor":"Oppfinner","performer":"Utøver","podcaster":"Podcaster","presenter":"Presentatør","producer":"Produsent","programmer":"Programmerer","recipient":"Mottaker","reviewedAuthor":"Anmeldt forfatter","scriptwriter":"Manusforfatter","seriesEditor":"Serieredaktør","sponsor":"Sponsor","translator":"Oversetter","wordsBy":"Tekster av"}},"nl-NL":{"itemTypes":{"annotation":"Annotatie","artwork":"Kunstwerk","attachment":"Bijlage","audioRecording":"Geluidsopname","bill":"Kamerstukken / Handelingen / Wetsvoorstel","blogPost":"Blogbericht","book":"Boek","bookSection":"Boek-sectie","case":"Rechtszaak","computerProgram":"Software","conferencePaper":"Conferentiebijdrage","dictionaryEntry":"Lemma","document":"Document","email":"E-mail","encyclopediaArticle":"Encyclopedie-artikel","film":"Film","forumPost":"Forumbericht","hearing":"Hoorzitting","instantMessage":"Instant message","interview":"Interview","journalArticle":"Artikel in academisch tijdschrift","letter":"Brief","magazineArticle":"Artikel in magazine","manuscript":"Manuscript","map":"Kaart","newspaperArticle":"Krantenartikel","note":"Aantekening","patent":"Patent / Octrooi","podcast":"Podcast","preprint":"Preprint","presentation":"Presentatie","radioBroadcast":"Radio-uitzending","report":"Rapport","statute":"Wet","thesis":"Proefschrift","tvBroadcast":"Televisie-uitzending","videoRecording":"Video-opname","webpage":"Webpagina"},"fields":{"abstractNote":"Samenvatting","accessDate":"Geraadpleegd","applicationNumber":"Aanvraagnummer","archive":"Archief","archiveID":"Archive ID","archiveLocation":"Locatie in archief","artworkMedium":"Medium","artworkSize":"Afmetingen kunstwerk","assignee":"Rechthebbende","audioFileType":"Bestandstype","audioRecordingFormat":"Formaat","billNumber":"(Dossier)nummer","blogTitle":"Titel blog","bookTitle":"Boektitel","callNumber":"Indexnummer","caseName":"Naam rechtszaak","citationKey":"Citation Key","code":"Publicatiemedium","codeNumber":"... tranche van wet","codePages":"Nummer (binnen dossier)","codeVolume":"Wetgevingsjaargang","committee":"Commissie","company":"Bedrijf","conferenceName":"Conferentienaam","country":"Land","court":"Rechtbank","date":"Datum","dateAdded":"Datum toegevoegd","dateDecided":"Datum beslissing","dateEnacted":"Datum publicatie","dateModified":"Bewerkt","dictionaryTitle":"Woordenboek-titel","distributor":"Distributeur","docketNumber":"ECLI / Zaaknummer","documentNumber":"Documentnummer","DOI":"DOI","edition":"Druk","encyclopediaTitle":"Encyclopedie-titel","episodeNumber":"Afleveringsnummer","extra":"Extra","filingDate":"Indieningsdatum","firstPage":"Eerste pagina","forumTitle":"Naam forum","genre":"Genre","history":"Geschiedenis","institution":"(Onderzoeks)instituut","interviewMedium":"Medium","ISBN":"ISBN","ISSN":"ISSN","issue":"Editie","issueDate":"Publicatiedatum","issuingAuthority":"Uitgevende authoriteit","itemType":"Type","journalAbbreviation":"Tijdschrift-afkorting","label":"Label","language":"Taal","legalStatus":"Wettelijke status","legislativeBody":"(Wetgevend) orgaan","letterType":"Type","libraryCatalog":"Bibliotheekscatalogus","manuscriptType":"Type","mapType":"Type","meetingName":"Naam bijeenkomst","nameOfAct":"Citeertitel wet","network":"Netwerk","number":"Nummer","numberOfVolumes":"# delen","numPages":"Aantal pagina's","pages":"Pagina's","patentNumber":"Patentnummer","place":"Plaats","postType":"Type post","presentationType":"Type","priorityNumbers":"Prioriteitsnummers","proceedingsTitle":"Titel notulen","programmingLanguage":"Prog. taal","programTitle":"Programmatitel","publicationTitle":"Titel uitgave","publicLawNumber":"Public Law Number","publisher":"Uitgever","references":"Verwijzingen","reporter":"Jurisprudentietijdschrift","reporterVolume":"Jaargang(, Editie)","reportNumber":"Nummer (van het rapport)","reportType":"Rapport-type","repository":"Repository","rights":"Rechten","runningTime":"Duur","scale":"Schaal","section":"Sectie","series":"Reeks","seriesNumber":"Nummer (binnen de reeks)","seriesText":"Reeks (extra tekst)","seriesTitle":"Titel van de reeks","session":"Sessie","shortTitle":"Korte Titel","studio":"Studio","subject":"Onderwerp","system":"Systeem","thesisType":"Type","title":"Titel","university":"Universiteit","url":"URL","versionNumber":"Versie","videoRecordingFormat":"Formaat","volume":"Deel","websiteTitle":"Titel webpagina","websiteType":"Type website"},"creatorTypes":{"artist":"Kunstenaar","attorneyAgent":"Advocaat/Agent","author":"Auteur","bookAuthor":"Auteur van het boek","cartographer":"Cartograaf","castMember":"Cast-member","commenter":"Commentator","composer":"Componist","contributor":"Coauteur","cosponsor":"Cosponsor","counsel":"Raad","director":"Regisseur","editor":"Redacteur","guest":"Gast","interviewee":"Interview met","interviewer":"Interviewer","inventor":"Uitvinder","performer":"Uitvoerder","podcaster":"Podcaster","presenter":"Presentator","producer":"Producent","programmer":"Programmeur","recipient":"Ontvanger","reviewedAuthor":"Besproken auteur","scriptwriter":"Tekstschrijver","seriesEditor":"Redacteur van de reeks","sponsor":"Sponsor","translator":"Vertaler","wordsBy":"Tekst door"}},"nn-NO":{"itemTypes":{"annotation":"Kommentar","artwork":"Kunstverk","attachment":"Vedlegg","audioRecording":"Lydopptak","bill":"Lovforslag","blogPost":"Blogginnlegg","book":"Bok","bookSection":"Del av bok","case":"Sak","computerProgram":"Software","conferencePaper":"Konferanseinnlegg","dictionaryEntry":"Ordbokoppslag","document":"Dokument","email":"E-post","encyclopediaArticle":"Artikkel i oppslagsverk","film":"Film","forumPost":"Foruminnlegg","hearing":"Høyring","instantMessage":"Snøggmelding","interview":"Intervju","journalArticle":"Tidsskriftartikkel","letter":"Brev","magazineArticle":"Magasinartikkel","manuscript":"Manuskript","map":"Kart","newspaperArticle":"Avisartikkel","note":"Notat","patent":"Patent","podcast":"Podkast","preprint":"Preprint","presentation":"Presentasjon","radioBroadcast":"Radiosending","report":"Rapport","statute":"Statutt","thesis":"Avhandling","tvBroadcast":"TV-sending","videoRecording":"Videoopptak","webpage":"Nettside"},"fields":{"abstractNote":"Samandrag","accessDate":"Lest","applicationNumber":"Program-nummer","archive":"Arkiv\\n","archiveID":"Archive ID","archiveLocation":"Lokalisering i arkiv","artworkMedium":"Middels","artworkSize":"Kunstverk-storleik","assignee":"Fullmektig","audioFileType":"Filtype","audioRecordingFormat":"Format","billNumber":"Lov-nummer","blogTitle":"Bloggtittel","bookTitle":"Boktittel","callNumber":"Plass-signatur","caseName":"Saksnamn","citationKey":"Citation Key","code":"Kode","codeNumber":"Tekst nummer","codePages":"Sider i tekst","codeVolume":"Lov-volum","committee":"Komité","company":"Selskap","conferenceName":"Namnet på konferansen","country":"Land","court":"Rett","date":"Dato","dateAdded":"Lagt til","dateDecided":"Avgjort (dato)","dateEnacted":"Innført (dato)","dateModified":"Sist endra","dictionaryTitle":"Ordbok","distributor":"Distributør","docketNumber":"Docket Number","documentNumber":"Dokumentnummer","DOI":"DOI","edition":"Utgåve","encyclopediaTitle":"Oppslagverk","episodeNumber":"Episodenummer","extra":"Ekstra","filingDate":"Arkiveringsdato","firstPage":"Første side","forumTitle":"Forum-/listserv-tittel","genre":"Sjanger","history":"Historie","institution":"Institusjon","interviewMedium":"Middels","ISBN":"ISBN","ISSN":"ISSN","issue":"Nummer","issueDate":"Kjennelsesdato","issuingAuthority":"Issuing Authority","itemType":"Type","journalAbbreviation":"Tidsskriftforkorting","label":"Plateselskap","language":"Språk","legalStatus":"Rettsleg status","legislativeBody":"Lovgjevande organ","letterType":"Type","libraryCatalog":"Bibliotek-katalog","manuscriptType":"Type","mapType":"Type","meetingName":"Møtenamn","nameOfAct":"Namn på lova","network":"Nettverk","number":"Nummer","numberOfVolumes":"# av volum","numPages":"Tal sider","pages":"Sidetal","patentNumber":"Patentnummer","place":"Stad","postType":"Posttype","presentationType":"Type","priorityNumbers":"Prioritetnummer","proceedingsTitle":"Sakstittel","programmingLanguage":"Prog. Language","programTitle":"Programtittel","publicationTitle":"Publikasjon","publicLawNumber":"Offentleg lov, nummer","publisher":"Utgjevar","references":"Referansar","reporter":"Reporter","reporterVolume":"Reporter volum","reportNumber":"Rapportnummer","reportType":"Rapporttype","repository":"Repository","rights":"Rettar","runningTime":"Lengd","scale":"Skala","section":"Seksjon","series":"Serie","seriesNumber":"Serienummer","seriesText":"Serietekst","seriesTitle":"Serietittel","session":"Sesjon","shortTitle":"Kort tittel","studio":"Studio","subject":"Emne","system":"System","thesisType":"Type","title":"Tittel","university":"Universitet","url":"URL","versionNumber":"Versjon","videoRecordingFormat":"Format","volume":"Volum","websiteTitle":"Nettstadtittel","websiteType":"Nettstadtype"},"creatorTypes":{"artist":"Artist","attorneyAgent":"Advokat/Agent","author":"Forfattar","bookAuthor":"Bokforfattar","cartographer":"Kartograf","castMember":"Skodespelar","commenter":"Kommentator","composer":"Komponist","contributor":"Medforfatter","cosponsor":"Medsponsor","counsel":"Rådgjevar","director":"Instruktør","editor":"Redaktør","guest":"Gjest","interviewee":"Intervju med","interviewer":"Intervjuar","inventor":"Oppfinnar","performer":"Utøvar","podcaster":"Podkastar","presenter":"Presentatør","producer":"Produsent","programmer":"Programmerar","recipient":"Mottakar","reviewedAuthor":"Meld forfattar","scriptwriter":"Manusforfattar","seriesEditor":"Serieredaktør","sponsor":"Sponsor","translator":"Omsetjar","wordsBy":"Tekstar av"}},"pl-PL":{"itemTypes":{"annotation":"Adnotacja","artwork":"Dzieło sztuki","attachment":"Załącznik","audioRecording":"Nagranie audio","bill":"Projekt ustawy","blogPost":"Wpis w blogu","book":"Książka","bookSection":"Rozdział","case":"Sprawa sądowa","computerProgram":"Oprogramowanie","conferencePaper":"Materiał konferencyjny","dictionaryEntry":"Hasło słownikowe","document":"Dokument","email":"E-mail","encyclopediaArticle":"Artykuł w encyklopedii","film":"Film","forumPost":"Wpis na forum","hearing":"Rozprawa","instantMessage":"Krótka wiadomość","interview":"Wywiad","journalArticle":"Artykuł z czasopisma","letter":"List","magazineArticle":"Artykuł z magazynu","manuscript":"Rękopis","map":"Mapa","newspaperArticle":"Artykuł z gazety","note":"Notatka","patent":"Patent","podcast":"Podcast","preprint":"Preprint","presentation":"Prezentacja","radioBroadcast":"Audycja radiowa","report":"Raport","statute":"Statut","thesis":"Praca dyplomowa","tvBroadcast":"Program telewizyjny","videoRecording":"Nagranie wideo","webpage":"Strona internetowa"},"fields":{"abstractNote":"Krótki opis","accessDate":"Dostęp","applicationNumber":"Numer zgłoszenia","archive":"Archiwum","archiveID":"Identyfikator archiwum","archiveLocation":"Miejsce w archiwum","artworkMedium":"Technika","artworkSize":"Wielkość dzieła","assignee":"Beneficjent","audioFileType":"Typ pliku","audioRecordingFormat":"Format","billNumber":"Numer projektu ustawy","blogTitle":"Tytuł blogu","bookTitle":"Tytuł książki","callNumber":"Nr klasyfikacyjny","caseName":"Tytuł sprawy","citationKey":"Klucz cytowania","code":"Kod","codeNumber":"Numer kodu","codePages":"Kod stron","codeVolume":"Kod tomu","committee":"Komitet","company":"Firma","conferenceName":"Nazwa konferencji","country":"Kraj","court":"Sąd","date":"Data","dateAdded":"Data dodania","dateDecided":"Data decyzji","dateEnacted":"Data wydania","dateModified":"Zmodyfikowany","dictionaryTitle":"Tytuł słownika","distributor":"Dystrybutor","docketNumber":"Numer wokandy","documentNumber":"Numer dokumentu","DOI":"DOI","edition":"Wydanie","encyclopediaTitle":"Tytuł encyklopedii","episodeNumber":"Numer odcinka","extra":"Dodatkowe","filingDate":"Data wypełnienia","firstPage":"Pierwsza strona","forumTitle":"Nazwa Forum/Listserv","genre":"Rodzaj","history":"Historia","institution":"Instytucja","interviewMedium":"Nośnik","ISBN":"ISBN","ISSN":"ISSN","issue":"Numer","issueDate":"Data wydania","issuingAuthority":"Organ wydający","itemType":"Typ","journalAbbreviation":"Skrót czasopisma","label":"Etykieta","language":"Język","legalStatus":"Status prawny","legislativeBody":"Ciało ustawodawcze","letterType":"Typ","libraryCatalog":"Usługa katalogowa","manuscriptType":"Typ","mapType":"Typ","meetingName":"Nazwa spotkania","nameOfAct":"Tytuł aktu","network":"Sieć","number":"Numer","numberOfVolumes":"Liczba tomów","numPages":"Liczba stron","pages":"Strony","patentNumber":"Numer patentu","place":"Miejsce","postType":"Typ wpisu","presentationType":"Typ","priorityNumbers":"Numery priorytetu","proceedingsTitle":"Tytuł sprawozdania","programmingLanguage":"Jęz. programowania","programTitle":"Tytuł programu","publicationTitle":"Publikacja","publicLawNumber":"Numer prawa publicznego","publisher":"Wydawca","references":"Referencje","reporter":"Zbiór orzecznictwa","reporterVolume":"Tom w zbiorze orzecznictwa","reportNumber":"Numer raportu","reportType":"Typ raportu","repository":"Repozytorium","rights":"Przepisy/Prawa","runningTime":"Czas trwania","scale":"Skala","section":"Sekcja","series":"Seria","seriesNumber":"Numer serii","seriesText":"Tekst serii","seriesTitle":"Tytuł serii","session":"Sesja","shortTitle":"Krótki tytuł","studio":"Studio","subject":"Temat","system":"System","thesisType":"Typ","title":"Tytuł","university":"Uniwersytet","url":"Adres URL","versionNumber":"Wersja","videoRecordingFormat":"Format","volume":"Tom","websiteTitle":"Tytuł strony","websiteType":"Typ witryny"},"creatorTypes":{"artist":"Artysta","attorneyAgent":"Adwokat/Agent","author":"Autor","bookAuthor":"Autor książki","cartographer":"Kartograf","castMember":"Aktor","commenter":"Komentator","composer":"Kompozytor","contributor":"Współautor","cosponsor":"Współsponsor","counsel":"Prawnik","director":"Reżyser","editor":"Redaktor","guest":"Gość","interviewee":"Wywiad z","interviewer":"Prowadzący wywiad","inventor":"Wynalazca","performer":"Odtwórca","podcaster":"Autor podcastu","presenter":"Prezenter","producer":"Producent","programmer":"Programista","recipient":"Odbiorca","reviewedAuthor":"Autor recenzji","scriptwriter":"Scenarzysta","seriesEditor":"Redaktor serii","sponsor":"Fundator","translator":"Tłumacz","wordsBy":"Autor słów"}},"pt-BR":{"itemTypes":{"annotation":"Anotação","artwork":"Obra de arte","attachment":"Anexo","audioRecording":"Gravação de áudio","bill":"Legislação","blogPost":"Envio de blog","book":"Livro","bookSection":"Seção de livro","case":"Caso","computerProgram":"Programa","conferencePaper":"Conferência","dictionaryEntry":"Verbete de dicionário","document":"Documento","email":"Correio eletrônico","encyclopediaArticle":"Verbete de enciclopédia","film":"Filme","forumPost":"Envio de fórum","hearing":"Audiência","instantMessage":"Mensagem instantânea","interview":"Entrevista","journalArticle":"Artigo de periódico","letter":"Carta","magazineArticle":"Artigo de revista","manuscript":"Manuscrito","map":"Mapa","newspaperArticle":"Artigo de jornal","note":"Nota","patent":"Patente","podcast":"Podcast","preprint":"Pré-impressão","presentation":"Apresentação","radioBroadcast":"Transmissão de rádio","report":"Relatório","statute":"Estatuto","thesis":"Tese","tvBroadcast":"Transmissão de TV","videoRecording":"Gravação de vídeo","webpage":"Página web"},"fields":{"abstractNote":"Resumo","accessDate":"Data de acesso","applicationNumber":"Número da inscrição","archive":"Arquivo","archiveID":"ID do Arquivo","archiveLocation":"Localização no arquivo","artworkMedium":"Suporte","artworkSize":"Dimensões","assignee":"Beneficiário","audioFileType":"Tipo de arquivo","audioRecordingFormat":"Formato","billNumber":"Número da lei","blogTitle":"Título do blog","bookTitle":"Título do livro","callNumber":"Número de chamada","caseName":"Nome do caso","citationKey":"Chave de Citação","code":"Código","codeNumber":"Número de código","codePages":"Páginas do código","codeVolume":"Volume do código","committee":"Comitê","company":"Companhia","conferenceName":"Nome da conferência","country":"País","court":"Corte","date":"Data","dateAdded":"Data de adição","dateDecided":"Data da decisão","dateEnacted":"Data de aprovação","dateModified":"Data de modificação","dictionaryTitle":"Título do dicionário","distributor":"Distribuidor","docketNumber":"Número da ata","documentNumber":"Número do documento","DOI":"DOI","edition":"Número da edição","encyclopediaTitle":"Título da enciclopédia","episodeNumber":"Número do episódio","extra":"Extra","filingDate":"Data de arquivamento","firstPage":"Primeira página","forumTitle":"Título do fórum","genre":"Gênero","history":"Histórico","institution":"Instituição","interviewMedium":"Suporte","ISBN":"ISBN","ISSN":"ISSN","issue":"Edição","issueDate":"Data da edição","issuingAuthority":"Autoridade emissora","itemType":"Tipo","journalAbbreviation":"Abreviatura do periódico","label":"Etiqueta","language":"Idioma","legalStatus":"Estatuto legal","legislativeBody":"Corpo legislativo","letterType":"Tipo","libraryCatalog":"Catálogo de biblioteca","manuscriptType":"Tipo","mapType":"Tipo","meetingName":"Nome do evento","nameOfAct":"Nome da lei","network":"Rede","number":"Número","numberOfVolumes":"# de volumes","numPages":"# de páginas","pages":"Páginas","patentNumber":"Número da Patente","place":"Lugar","postType":"Tipo de envio","presentationType":"Tipo","priorityNumbers":"Números prioritários","proceedingsTitle":"Título dos anais","programmingLanguage":"Linguagem de programação","programTitle":"Título do programa","publicationTitle":"Título da publicação","publicLawNumber":"Número da lei","publisher":"Editor","references":"Referências","reporter":"Relator","reporterVolume":"Volume do Reporter","reportNumber":"Número do relatório","reportType":"Tipo de relatório","repository":"Repositório","rights":"Direitos","runningTime":"Tempo de execução","scale":"Escala","section":"Seção","series":"Série","seriesNumber":"Número na série","seriesText":"Texto da série","seriesTitle":"Título da série","session":"Sessão","shortTitle":"Título curto","studio":"Estúdio","subject":"Assunto","system":"Sistema","thesisType":"Tipo","title":"Título","university":"Universidade","url":"URL","versionNumber":"Versão","videoRecordingFormat":"Formato","volume":"Volume","websiteTitle":"Título do site","websiteType":"Tipo de site"},"creatorTypes":{"artist":"Artista","attorneyAgent":"Procurador/Agente","author":"Autor","bookAuthor":"Autor do livro","cartographer":"Cartógrafo","castMember":"Membro do elenco","commenter":"Comentarista","composer":"Compositor","contributor":"Contribuidor","cosponsor":"Co-patrocinador","counsel":"Conselho","director":"Diretor","editor":"Organizador","guest":"Convidado","interviewee":"Entrevista com","interviewer":"Entrevistador","inventor":"Inventor","performer":"Ator","podcaster":"Fonte do podcast","presenter":"Apresentador","producer":"Produtor","programmer":"Programador","recipient":"Destinatário","reviewedAuthor":"Autor resenhado","scriptwriter":"Roteirista","seriesEditor":"Editor da série","sponsor":"Propositor","translator":"Tradutor","wordsBy":"Escrito por"}},"pt-PT":{"itemTypes":{"annotation":"Anotação","artwork":"Obra de Arte","attachment":"Anexo","audioRecording":"Gravação Áudio","bill":"Diploma Legal","blogPost":"Entrada em Blogue","book":"Livro","bookSection":"Secção de Livro","case":"Caso","computerProgram":"Programa de Computador","conferencePaper":"Artigo em Conferência","dictionaryEntry":"Verbete de Dicionário","document":"Documento","email":"Mensagem de Correio Electrónico","encyclopediaArticle":"Artigo de Enciclopédia","film":"Filme","forumPost":"Entrada em Fórum","hearing":"Audição","instantMessage":"Mensagem Instantânea","interview":"Entrevista","journalArticle":"Artigo em Revista Científica","letter":"Carta","magazineArticle":"Artigo em Revista","manuscript":"Manuscrito","map":"Mapa","newspaperArticle":"Artigo em Jornal","note":"Nota","patent":"Patente","podcast":"Emissão Pod","preprint":"Pré-impressão","presentation":"Apresentação","radioBroadcast":"Emissão Radiofónica","report":"Relatório","statute":"Estatuto","thesis":"Dissertação","tvBroadcast":"Emissão Televisiva","videoRecording":"Gravação Vídeo","webpage":"Página Web"},"fields":{"abstractNote":"Resumo","accessDate":"Acedido","applicationNumber":"Número da Candidatura","archive":"Arquivo","archiveID":"ID do Arquivo","archiveLocation":"Localização no Arquivo","artworkMedium":"Suporte Artístico","artworkSize":"Dimensão da Obra de Arte","assignee":"Responsável","audioFileType":"Tipo do Arquivo","audioRecordingFormat":"Formato","billNumber":"Número do Diploma Legal","blogTitle":"Título do Blogue","bookTitle":"Título do Livro","callNumber":"Número de Chamada","caseName":"Nome do Caso","citationKey":"Chave de Citação","code":"Código","codeNumber":"Número de Código","codePages":"Páginas do Código","codeVolume":"Volume do Código","committee":"Comité","company":"Empresa","conferenceName":"Nome da Conferência","country":"País","court":"Tribunal","date":"Data","dateAdded":"Data de Adição","dateDecided":"Data da Decisão","dateEnacted":"Data de Promulgação","dateModified":"Modificado","dictionaryTitle":"Título do Dicionário","distributor":"Distribuidor","docketNumber":"Número de Expediente","documentNumber":"Número do Documento","DOI":"DOI","edition":"Edição","encyclopediaTitle":"Título da Enciclopédia","episodeNumber":"Número do Episódio","extra":"Extra","filingDate":"Data de Arquivo","firstPage":"Primeira Página","forumTitle":"Título do Fórum/Lista de Correio Electrónico","genre":"Género","history":"História","institution":"Instituição","interviewMedium":"Suporte","ISBN":"ISBN","ISSN":"ISSN","issue":"Número","issueDate":"Data de Emissão","issuingAuthority":"Autoridade Emissora","itemType":"Tipo","journalAbbreviation":"Abreviatura da Publicação","label":"Etiqueta","language":"Língua","legalStatus":"Estado Legal","legislativeBody":"Entidade Legislativa","letterType":"Tipo","libraryCatalog":"Catálogo de Biblioteca","manuscriptType":"Tipo","mapType":"Tipo","meetingName":"Nome da Reunião","nameOfAct":"Nome do Decreto","network":"Rede","number":"Número","numberOfVolumes":"N.º de Volumes","numPages":"N.º de Páginas","pages":"Páginas","patentNumber":"Número de Patente","place":"Local","postType":"Pós-Tipo","presentationType":"Tipo","priorityNumbers":"Números de Prioridade","proceedingsTitle":"Título das Actas","programmingLanguage":"Linguagem de Programação","programTitle":"Título do Programa","publicationTitle":"Publicação","publicLawNumber":"Número da Lei Pública","publisher":"Editora","references":"Referências","reporter":"Relator","reporterVolume":"Volume do Relator","reportNumber":"Número do Relatório","reportType":"Tipo de Relatório","repository":"Repositório","rights":"Direitos","runningTime":"Duração","scale":"Escala","section":"Secção","series":"Série","seriesNumber":"Número da Série","seriesText":"Texto da Série","seriesTitle":"Título da Série","session":"Sessão","shortTitle":"Título Curto","studio":"Estúdio","subject":"Assunto","system":"Sistema","thesisType":"Tipo","title":"Título","university":"Universidade","url":"URL","versionNumber":"Versão","videoRecordingFormat":"Formato","volume":"Volume","websiteTitle":"Título da Página Web","websiteType":"Tipo de Página Web"},"creatorTypes":{"artist":"Artista","attorneyAgent":"Advogado/Agente","author":"Autor","bookAuthor":"Autor do Livro","cartographer":"Cartógrafo","castMember":"Membro do Elenco","commenter":"Comentador","composer":"Compositor","contributor":"Colaborador","cosponsor":"Co-patrocinador","counsel":"Conselho","director":"Realizador","editor":"Editor","guest":"Convidado","interviewee":"Entrevista Com","interviewer":"Entrevistador","inventor":"Inventor","performer":"Performer","podcaster":"Locutor de Emissão Pod","presenter":"Apresentador","producer":"Produtor","programmer":"Programador","recipient":"Receptor","reviewedAuthor":"Autor Revisto","scriptwriter":"Guionista","seriesEditor":"Editor da Série","sponsor":"Patrocinador","translator":"Tradutor","wordsBy":"Texto De"}},"ro-RO":{"itemTypes":{"annotation":"Adnotare","artwork":"Lucrare de artă","attachment":"Anexă","audioRecording":"Înregistrare audio","bill":"Proiect de lege","blogPost":"Articol blog","book":"Carte","bookSection":"Secțiune de carte","case":"Proces","computerProgram":"Software","conferencePaper":"Conferință","dictionaryEntry":"Articol de dicționar","document":"Document","email":"E-mail","encyclopediaArticle":"Articol de enciclopedie","film":"Film","forumPost":"Comentariu forum","hearing":"Audiere","instantMessage":"Mesaj instantaneu","interview":"Interviu","journalArticle":"Articol de revistă","letter":"Scrisoare","magazineArticle":"Articol de revistă magazin","manuscript":"Manuscris","map":"Hartă","newspaperArticle":"Articol de ziar","note":"Notă","patent":"Brevet","podcast":"Multimedia","preprint":"Preprint","presentation":"Prezentare","radioBroadcast":"Emisiune radio","report":"Raport","statute":"Statut","thesis":"Teză","tvBroadcast":"Emisiune TV","videoRecording":"Înregistrare video","webpage":"Pagină web"},"fields":{"abstractNote":"Rezumat","accessDate":"Data accesării","applicationNumber":"Număr aplicație","archive":"Arhivă","archiveID":"Archive ID","archiveLocation":"Locație în arhivă","artworkMedium":"Mediu","artworkSize":"Mărime lucrare de artă","assignee":"Reprezentant","audioFileType":"Tip de fișier","audioRecordingFormat":"Formatare","billNumber":"Număr proiect de lege","blogTitle":"Titlu blog","bookTitle":"Titlu carte","callNumber":"Număr de tel.","caseName":"Nume proces","citationKey":"Citation Key","code":"Cod","codeNumber":"Număr de cod","codePages":"Cod pagini","codeVolume":"Cod volum","committee":"Comitet","company":"Companie","conferenceName":"Titlu conferință","country":"Țară","court":"Curte","date":"Dată","dateAdded":"Adăugat la data","dateDecided":"Data deciziei","dateEnacted":"Dată decret","dateModified":"Modificat","dictionaryTitle":"Titlu dicționar","distributor":"Distribuitor","docketNumber":"Număr agendă de birou","documentNumber":"Număr document","DOI":"DOI","edition":"Ediție","encyclopediaTitle":"Titlu enciclopedie","episodeNumber":"Număr episod","extra":"Extra","filingDate":"Data completării","firstPage":"Prima pagină","forumTitle":"Titlu forum","genre":"Gen","history":"Istorie","institution":"Instituție","interviewMedium":"Mediu","ISBN":"ISBN","ISSN":"ISSN","issue":"Număr","issueDate":"Data apariției","issuingAuthority":"Autoritate emitentă","itemType":"Tip","journalAbbreviation":"Abreviere jurnal","label":"Etichetă","language":"Limbă","legalStatus":"Statut legal","legislativeBody":"Corp legislativ","letterType":"Tip","libraryCatalog":"Catalog bibliotecă","manuscriptType":"Tip","mapType":"Tip","meetingName":"Nume de contact","nameOfAct":"Nume act","network":"Rețea","number":"Număr","numberOfVolumes":"Nr. de volume","numPages":"Nr. de pagini","pages":"Pagini","patentNumber":"Număr brevet","place":"Loc","postType":"Tip de comentariu","presentationType":"Tip","priorityNumbers":"Numere de prioritate","proceedingsTitle":"Titlu dare de seamă","programmingLanguage":"Limbaj de programare","programTitle":"Titlu program","publicationTitle":"Publicație","publicLawNumber":"Număr lege","publisher":"Editură","references":"Referințe","reporter":"Reporter","reporterVolume":"Volum reporter","reportNumber":"Număr raport","reportType":"Tip de raport","repository":"Repository","rights":"Drepturi","runningTime":"Timp de funcționare","scale":"Scară","section":"Secțiune","series":"Colecție","seriesNumber":"Număr colecție","seriesText":"Text colecție","seriesTitle":"Titlu colecție","session":"Sesiune","shortTitle":"Titlu scurt","studio":"Studio","subject":"Subiect","system":"Sistem","thesisType":"Tip","title":"Titlu","university":"Universitate","url":"URL","versionNumber":"Versiune","videoRecordingFormat":"Formatare","volume":"Volum","websiteTitle":"Titlu site web","websiteType":"Tip de site web"},"creatorTypes":{"artist":"Artist","attorneyAgent":"Avocat/Agent","author":"Autor","bookAuthor":"Autor carte","cartographer":"Cartograf","castMember":"Membru în distribuție","commenter":"Comentator","composer":"Compozitor","contributor":"Colaborator","cosponsor":"Sponsor asociat","counsel":"Consiliu","director":"Director","editor":"Editor (coord.)","guest":"Oaspete","interviewee":"Interviu cu","interviewer":"Interviu de","inventor":"Inventator","performer":"Interpret","podcaster":"Autor multimedia","presenter":"Prezentator","producer":"Producător","programmer":"Programator","recipient":"Recipient","reviewedAuthor":"Autor recenzat","scriptwriter":"Scriitor (de mână)","seriesEditor":"Coordonator colecție","sponsor":"Sponsor","translator":"Traducător","wordsBy":"Cuvinte de"}},"ru-RU":{"itemTypes":{"annotation":"Аннотация","artwork":"Художественная работа","attachment":"Вложение","audioRecording":"Звукозапись","bill":"Законопроект","blogPost":"Сообщение в блоге","book":"Книга","bookSection":"Раздел книги","case":"Дело","computerProgram":"Компьютерная программа","conferencePaper":"Документ конференции","dictionaryEntry":"Словарная статья","document":"Документ","email":"Электронная почта","encyclopediaArticle":"Статья из энциклопедии","film":"Фильм","forumPost":"Сообщение на форуме","hearing":"Слушание","instantMessage":"Мгновенное сообщение","interview":"Интервью","journalArticle":"Статья из рецензируемого журнала","letter":"Письмо","magazineArticle":"Статья из прочей периодики","manuscript":"Рукопись","map":"Карта","newspaperArticle":"Газетная статья","note":"Заметка","patent":"Патент","podcast":"Подкаст","preprint":"Препринт","presentation":"Презентация","radioBroadcast":"Радиопередача","report":"Отчет","statute":"Норм. прав. акт","thesis":"Диссертация","tvBroadcast":"Телепередача","videoRecording":"Видеозапись","webpage":"Веб-страница"},"fields":{"abstractNote":"Аннотация","accessDate":"Дата доступа","applicationNumber":"Номер заявки","archive":"Архив","archiveID":"ID на archive.org","archiveLocation":"Место в архиве","artworkMedium":"Худож. средство","artworkSize":"Размер работы","assignee":"Представитель","audioFileType":"Тип файла","audioRecordingFormat":"Формат","billNumber":"Номер законопр.","blogTitle":"Название блога","bookTitle":"Название книги","callNumber":"Шифр (номер вызова)","caseName":"Номер дела","citationKey":"Ключ цитирования","code":"Кодекс/сборник","codeNumber":"Том кодекса","codePages":"Страницы кодекса","codeVolume":"Том кодекса","committee":"Комитет","company":"Компания","conferenceName":"Назв. конфер.","country":"Страна","court":"Суд","date":"Дата","dateAdded":"Добавлен","dateDecided":"Дата решения","dateEnacted":"Дата акта","dateModified":"Изменён","dictionaryTitle":"Назв. словаря","distributor":"Распределитель","docketNumber":"Номер выписки","documentNumber":"Номер документа","DOI":"ЦИО/DOI","edition":"Издание","encyclopediaTitle":"Назв. энцикл.","episodeNumber":"Номер эпизода","extra":"Дополнительно","filingDate":"Дата заявки","firstPage":"Первая стр.","forumTitle":"Форум/Listserv","genre":"Жанр","history":"История","institution":"Учреждение","interviewMedium":"Средство","ISBN":"ISBN","ISSN":"ISSN","issue":"Выпуск","issueDate":"Дата выпуска","issuingAuthority":"Кем выдан","itemType":"Тип","journalAbbreviation":"Сокращ. журнала","label":"Надпись","language":"Язык","legalStatus":"Правовой статус","legislativeBody":"Законод. орган","letterType":"Тип письма","libraryCatalog":"Библ. каталог","manuscriptType":"Тип рукописи","mapType":"Тип карты","meetingName":"Назв. встречи","nameOfAct":"Назв. акта.","network":"Сеть","number":"Номер","numberOfVolumes":"Кол-во томов","numPages":"Число страниц","pages":"Страницы","patentNumber":"Номер патента","place":"Место","postType":"Тип сообщения","presentationType":"Тип","priorityNumbers":"Номера приоритетов","proceedingsTitle":"Назв. трудов","programmingLanguage":"Прогр. яз.","programTitle":"Назв. программы","publicationTitle":"Заголовок публикации","publicLawNumber":"Номер акта","publisher":"Издатель","references":"Ссылки","reporter":"Сборник суд. реш.","reporterVolume":"Том отчета","reportNumber":"Номер отчета","reportType":"Тип отчета","repository":"Репозиторий","rights":"Права","runningTime":"Продолжит.","scale":"Масштаб","section":"Раздел","series":"Серия","seriesNumber":"Номер в серии","seriesText":"Текст серии","seriesTitle":"Название серии","session":"Сессия","shortTitle":"Краткое назв.","studio":"Студия","subject":"Тема","system":"Система","thesisType":"Тип","title":"Название","university":"Университет","url":"URL-адрес","versionNumber":"Версия","videoRecordingFormat":"Формат","volume":"Том","websiteTitle":"Назв. веб-сайта","websiteType":"Тип веб-сайта"},"creatorTypes":{"artist":"Художник","attorneyAgent":"Адвокат/Агент","author":"Автор","bookAuthor":"Автор книги","cartographer":"Картограф","castMember":"Актер","commenter":"Комментатор","composer":"Композитор","contributor":"Соавтор","cosponsor":"Совм. спонсор","counsel":"Советник","director":"Режиссер","editor":"Редактор","guest":"Гость","interviewee":"Интервью с","interviewer":"Интервьюер","inventor":"Изобретатель","performer":"Исполнитель","podcaster":"Подкастер","presenter":"Докладчик","producer":"Продюсер","programmer":"Программист","recipient":"Получатель","reviewedAuthor":"Реценз. автор","scriptwriter":"Сценарист","seriesEditor":"Редактор серии","sponsor":"Спонсор","translator":"Переводчик","wordsBy":"Автор слов"}},"sk-SK":{"itemTypes":{"annotation":"Anotácia","artwork":"Umelecké dielo","attachment":"Príloha","audioRecording":"Audionahrávka","bill":"Legislatívny dokument","blogPost":"Príspevok na blogu","book":"Kniha","bookSection":"Časť knihy","case":"Prípad (súdny)","computerProgram":"Počítačový program","conferencePaper":"Príspevok na konferenciu","dictionaryEntry":"Heslo v slovníku","document":"Dokument","email":"E-mail","encyclopediaArticle":"Článok v encyklopédii","film":"Film","forumPost":"Príspevok do fóra","hearing":"Výsluch (konanie)","instantMessage":"Chatová správa","interview":"Osobná komunikácia","journalArticle":"Článok v odbornom časopise","letter":"List","magazineArticle":"Článok v populárnom časopise","manuscript":"Rukopis","map":"Mapa","newspaperArticle":"Článok v novinách","note":"Poznámka","patent":"Patent","podcast":"Podcast","preprint":"Preprint","presentation":"Prezentácia","radioBroadcast":"Rádio","report":"Správa","statute":"Nariadenie","thesis":"Záverečná práca","tvBroadcast":"Televízne vysielanie","videoRecording":"Videonahrávka","webpage":"Webová stránka"},"fields":{"abstractNote":"Abstrakt","accessDate":"Citované","applicationNumber":"Číslo prihlášky","archive":"Archív","archiveID":"Archive ID","archiveLocation":"Lokácia","artworkMedium":"Médium","artworkSize":"Rozmery diela","assignee":"Prihlasovateľ","audioFileType":"Typ súboru","audioRecordingFormat":"Formát","billNumber":"Číslo","blogTitle":"Názov blogu","bookTitle":"Názov knihy","callNumber":"Signatúra","caseName":"Názov prípadu","citationKey":"Citation Key","code":"Zákonník","codeNumber":"Kódové číslo","codePages":"Strany","codeVolume":"Ročník","committee":"Výbor/porota","company":"Spoločnosť","conferenceName":"Názov konferencie","country":"Štát","court":"Súd","date":"Dátum","dateAdded":"Pridané","dateDecided":"Dátum rozhodnutia","dateEnacted":"D. vstúp. do platnosti","dateModified":"Zmenené","dictionaryTitle":"Názov slovníka","distributor":"Distribútor","docketNumber":"Číslo konania","documentNumber":"Číslo dokumentu","DOI":"DOI","edition":"Vydanie","encyclopediaTitle":"Názov encyklopédie","episodeNumber":"Číslo epizódy","extra":"Extra","filingDate":"Dátum zápisu","firstPage":"Prvá strana","forumTitle":"Názov fóra/disk. sk.","genre":"Žáner","history":"História","institution":"Inštitúcia","interviewMedium":"Médium","ISBN":"ISBN","ISSN":"ISSN","issue":"Číslo","issueDate":"Dátum vydania","issuingAuthority":"Vydávajúci úrad","itemType":"Typ","journalAbbreviation":"Skratka časopisu","label":"Vydavateľstvo","language":"Jazyk","legalStatus":"Právny status","legislativeBody":"Legislatívny orgán","letterType":"Druh listu","libraryCatalog":"Knižničný katalóg","manuscriptType":"Druh rukopisu","mapType":"Druh mapy","meetingName":"Názov stretnutia","nameOfAct":"Názov zákona","network":"Sieť","number":"Číslo","numberOfVolumes":"Počet zväzkov","numPages":"Počet strán","pages":"Strany","patentNumber":"Číslo patentu","place":"Miesto","postType":"Druh príspevku","presentationType":"Typ prezentácie","priorityNumbers":"Čísla priority","proceedingsTitle":"Názov zborníka","programmingLanguage":"Program. jazyk","programTitle":"Názov programu","publicationTitle":"Názov publikácie","publicLawNumber":"Číslo zákona","publisher":"Vydavateľ","references":"Odkazy","reporter":"Zbierka súd. rozhodnutí","reporterVolume":"Ročník","reportNumber":"Číslo správy","reportType":"Druh správy","repository":"Repository","rights":"Práva","runningTime":"Dĺžka","scale":"Mierka","section":"Sekcia","series":"Edícia","seriesNumber":"Číslo edície","seriesText":"Text edície","seriesTitle":"Názov edície","session":"Zasadnutie","shortTitle":"Krátky názov","studio":"Štúdio","subject":"Predmet","system":"Operačný systém","thesisType":"Druh záv. práce","title":"Názov","university":"Univerzita","url":"URL","versionNumber":"Verzia","videoRecordingFormat":"Formát","volume":"Zväzok","websiteTitle":"Názov stránky","websiteType":"Druh sídla"},"creatorTypes":{"artist":"Umelec","attorneyAgent":"Advokát/Zástupca","author":"Autor","bookAuthor":"Autor knihy","cartographer":"Kartograf","castMember":"Účinkujúci","commenter":"Komentátor","composer":"Skladateľ","contributor":"Prispievateľ","cosponsor":"Spolusponzor","counsel":"Právny zástupca","director":"Režisér","editor":"Zostavovateľ","guest":"Hosť","interviewee":"Rozhovor s","interviewer":"Spytujúci sa","inventor":"Vynálezca","performer":"Interpret","podcaster":"Autor podcastu","presenter":"Prezentujúci","producer":"Producent","programmer":"Programátor","recipient":"Príjemca","reviewedAuthor":"Recenzent","scriptwriter":"Scenárista","seriesEditor":"Zostavovateľ edície","sponsor":"Navrhovateľ","translator":"Prekladateľ","wordsBy":"Autor textu"}},"sl-SI":{"itemTypes":{"annotation":"Zaznamek","artwork":"Umetniško delo","attachment":"Priponka","audioRecording":"Zvočni posnetek","bill":"Gledališki list","blogPost":"Objava na blogu","book":"Knjiga","bookSection":"Odsek knjige","case":"Primer","computerProgram":"Programje","conferencePaper":"Konferenčni članek","dictionaryEntry":"Slovarski vnos","document":"Dokument","email":"E-pismo","encyclopediaArticle":"Enciklopedični članek","film":"Film","forumPost":"Objava na forumu","hearing":"Zaslišanje","instantMessage":"Neposredno sporočilo","interview":"Intervju","journalArticle":"Strokovni članek","letter":"Pismo","magazineArticle":"Revijalni članek","manuscript":"Rokopis","map":"Zemljevid","newspaperArticle":"Časopisni članek","note":"Opomba","patent":"Patent","podcast":"Podcast","preprint":"Predobjava","presentation":"Predstavitev","radioBroadcast":"Radijska oddaja","report":"Poročilo","statute":"Statut","thesis":"Teza","tvBroadcast":"TV oddaja","videoRecording":"Videoposnetek","webpage":"Spletna stran"},"fields":{"abstractNote":"Povzetek","accessDate":"Dostopano","applicationNumber":"Številka vloge","archive":"Arhiv","archiveID":"ID arhiva","archiveLocation":"Mesto v arhivu","artworkMedium":"Medij","artworkSize":"Velikost umetniškega dela","assignee":"Dodeljeni","audioFileType":"Vrsta datoteke","audioRecordingFormat":"Zapis","billNumber":"Številka računa","blogTitle":"Naslov bloga","bookTitle":"Naslov knjige","callNumber":"Številka klica","caseName":"Ime primera","citationKey":"Ključ citata","code":"Koda","codeNumber":"Številka kode","codePages":"Strani kode","codeVolume":"Zbirka kode","committee":"Odbor","company":"Družba","conferenceName":"Ime konference","country":"Država","court":"Sodišče","date":"Datum","dateAdded":"Dodano dne","dateDecided":"Datum odločbe","dateEnacted":"Datum uveljavitve","dateModified":"Spremenjeno","dictionaryTitle":"Naslov slovarja","distributor":"Distributer","docketNumber":"Seznamska številka","documentNumber":"Številka dokumenta","DOI":"DOI","edition":"Edicija","encyclopediaTitle":"Naslov enciklopedije","episodeNumber":"Številka epizode","extra":"Dodatno","filingDate":"Datum vknjižbe","firstPage":"Naslovnica","forumTitle":"Naslov foruma","genre":"Žanr","history":"Zgodovina","institution":"Ustanova","interviewMedium":"Medij","ISBN":"ISBN","ISSN":"ISSN","issue":"Številka","issueDate":"Datum objave","issuingAuthority":"Izdajatelj","itemType":"Vrsta","journalAbbreviation":"Okraj. revije","label":"Vrsta","language":"Jezik","legalStatus":"Pravni status","legislativeBody":"Zakonodajno telo","letterType":"Vrsta","libraryCatalog":"Knjižnični katalog","manuscriptType":"Vrsta","mapType":"Vrsta","meetingName":"Ime srečanja","nameOfAct":"Ime akta","network":"TV postaja","number":"Številka","numberOfVolumes":"Št. letnikov","numPages":"Št. strani","pages":"Strani","patentNumber":"Številka patenta","place":"Kraj","postType":"Vrsta objave","presentationType":"Vrsta","priorityNumbers":"Številke prioritete","proceedingsTitle":"Naslov zapisnika razprave","programmingLanguage":"Programski jezik","programTitle":"Naslov programa","publicationTitle":"Publikacija","publicLawNumber":"Javna pravna številka","publisher":"Izdajatelj","references":"Sklici","reporter":"Poročevalec","reporterVolume":"Zbirka poročil","reportNumber":"Številka poročila","reportType":"Vrsta poročila","repository":"Skladišče","rights":"Pravice","runningTime":"Dolžina","scale":"Merilo","section":"Odsek","series":"Zbirka","seriesNumber":"Številka zbirke","seriesText":"Besedilo zbirke","seriesTitle":"Naslov zbirke","session":"Zasedanje","shortTitle":"Kratki naslov","studio":"Studio","subject":"Zadeva","system":"Sistem","thesisType":"Vrsta","title":"Naslov","university":"Univerza","url":"URL","versionNumber":"Različica","videoRecordingFormat":"Zapis","volume":"Letnik","websiteTitle":"Naslov spletne strani","websiteType":"Vrsta spletnega mesta"},"creatorTypes":{"artist":"Umetnik","attorneyAgent":"Odvetnik/agent","author":"Avtor","bookAuthor":"Avtor knjige","cartographer":"Kartograf","castMember":"Nastopajoči","commenter":"Komentator","composer":"Skladatelj","contributor":"Avtor prispevka","cosponsor":"Sosponzor","counsel":"Odvetnik","director":"Režiser","editor":"Urednik","guest":"Gost","interviewee":"Intervju z","interviewer":"Intervju opravil","inventor":"Izumitelj","performer":"Izvajalec","podcaster":"Avtor podcasta","presenter":"Predstavitelj","producer":"Producent","programmer":"Programer","recipient":"Prejemnik","reviewedAuthor":"Ocenjeni avtor","scriptwriter":"Scenarist","seriesEditor":"Urednik zbirke","sponsor":"Sponzor","translator":"Prevajalec","wordsBy":"Pisec besedila"}},"sr-RS":{"itemTypes":{"annotation":"Забелешка","artwork":"Уметничко дело","attachment":"Прилог","audioRecording":"Звучни снимак","bill":"Рачун","blogPost":"Блог порука","book":"Књига","bookSection":"Поглавље у књизи","case":"Случај","computerProgram":"Software","conferencePaper":"Папир са конференције","dictionaryEntry":"Унос из речника","document":"Документ","email":"Е-пошта","encyclopediaArticle":"Чланак из енциклопедије","film":"Филм","forumPost":"Порука на форуму","hearing":"Саслушање","instantMessage":"Брза порука","interview":"Интервју","journalArticle":"Чланак у часопису","letter":"Писмо","magazineArticle":"Чланак у магазину","manuscript":"Рукопис","map":"Мапа","newspaperArticle":"Чланак из новина","note":"Белешка","patent":"Патент","podcast":"Подкаст","preprint":"Preprint","presentation":"Презентација","radioBroadcast":"Радио пренос","report":"Извештај","statute":"Уредба","thesis":"Теза","tvBroadcast":"ТВ пренос","videoRecording":"Видео снимак","webpage":"Веб страница"},"fields":{"abstractNote":"Сажетак","accessDate":"Приступљено","applicationNumber":"Број апликације","archive":"Архива","archiveID":"Archive ID","archiveLocation":"Место у архиви","artworkMedium":"Медијум","artworkSize":"Величина уметничког дела","assignee":"Пуномоћник","audioFileType":"Врста датотеке","audioRecordingFormat":"Формат","billNumber":"Број рачуна","blogTitle":"Наслов блога","bookTitle":"Наслов књиге","callNumber":"Сигнатура","caseName":"Број случаја","citationKey":"Citation Key","code":"Код","codeNumber":"Број кода","codePages":"Код страница","codeVolume":"Код тома","committee":"Комисија","company":"Предузеће","conferenceName":"Име конференције","country":"Држава","court":"Суд","date":"Датум","dateAdded":"Датум додавања","dateDecided":"Датум одлуке","dateEnacted":"Датум озакоњена","dateModified":"Датум измене","dictionaryTitle":"Наслов речника","distributor":"Дистрибутер","docketNumber":"Docket Number","documentNumber":"Број документа","DOI":"ДОИ","edition":"Едиција","encyclopediaTitle":"Наслов енциклопедије","episodeNumber":"Број епизоде","extra":"Додатни подаци","filingDate":"Filing Date","firstPage":"Прва страница","forumTitle":"Наслов форума или listserv-а","genre":"Жанр","history":"Историја","institution":"Институција","interviewMedium":"Медијум","ISBN":"ИСБН","ISSN":"ИССН","issue":"Брoj издања","issueDate":"Датум издања","issuingAuthority":"Issuing Authority","itemType":"Врста","journalAbbreviation":"Скраћеница часописа","label":"Ознака","language":"Језик","legalStatus":"Правни статус","legislativeBody":"Законодавно тело","letterType":"Врста","libraryCatalog":"Каталог библиотеке","manuscriptType":"Врста","mapType":"Врста","meetingName":"Име састанка","nameOfAct":"Име указа","network":"Мрежа","number":"Број","numberOfVolumes":"Бр. томова","numPages":"Брoj страница","pages":"Странице","patentNumber":"Број патента","place":"Место","postType":"Врста поруке","presentationType":"Врста","priorityNumbers":"Бројеви приоритета","proceedingsTitle":"Наслов зборника","programmingLanguage":"Prog. Language","programTitle":"Назив програма","publicationTitle":"Издање","publicLawNumber":"Број јавног закона","publisher":"Издавач","references":"Референце","reporter":"Известилац","reporterVolume":"Том известиоца","reportNumber":"Број извештаја","reportType":"Врста извештаја","repository":"Repository","rights":"Права","runningTime":"Дужина трајања","scale":"Опсег","section":"Секција","series":"Серије","seriesNumber":"Број серије","seriesText":"Текст серије","seriesTitle":"Наслов серије","session":"Сесија","shortTitle":"Скраћени наслов","studio":"Студио","subject":"Субјекат","system":"Систем","thesisType":"Врста","title":"Наслов","university":"Универзитет","url":"УРЛ","versionNumber":"Верзија","videoRecordingFormat":"Формат","volume":"Том","websiteTitle":"Наслов веб странице","websiteType":"Врста веб места"},"creatorTypes":{"artist":"Уметник","attorneyAgent":"Адвокат/Представник","author":"Аутор","bookAuthor":"Аутор књиге","cartographer":"Картограф","castMember":"Глумац","commenter":"Коментатор","composer":"Композитор","contributor":"Сарадник","cosponsor":"Cosponsor","counsel":"Савет","director":"Директор","editor":"Уредник","guest":"Гост","interviewee":"Разговор са","interviewer":"Водич интервјуа","inventor":"Проналазач","performer":"Извођач","podcaster":"Подкастер","presenter":"Презентер","producer":"Продуцент","programmer":"Програмер","recipient":"Прималац","reviewedAuthor":"Оцењени аутор","scriptwriter":"Сценариста","seriesEditor":"Уредник серије","sponsor":"Спонзор","translator":"Преводилац","wordsBy":"Речи написао"}},"sv-SE":{"itemTypes":{"annotation":"Kommentar","artwork":"Konstverk","attachment":"Bilaga","audioRecording":"Ljudinspelning","bill":"Lagförarbete","blogPost":"Blogginlägg","book":"Bok","bookSection":"Bokavsnitt","case":"Rättsfall","computerProgram":"Programvara","conferencePaper":"Konferensartikel","dictionaryEntry":"Uppslag i ordbok","document":"Dokument","email":"E-postbrev","encyclopediaArticle":"Artikel i uppslagsverk","film":"Film","forumPost":"Foruminlägg","hearing":"Offentlig utfrågning","instantMessage":"Chattmeddelande","interview":"Intervju","journalArticle":"Tidskriftsartikel","letter":"Brev","magazineArticle":"Magasinsartikel","manuscript":"Manuskript","map":"Karta","newspaperArticle":"Dagstidningsartikel","note":"Anteckning","patent":"Patent","podcast":"Poddsändning","preprint":"Preprint","presentation":"Presentation","radioBroadcast":"Radiosändning","report":"Rapport","statute":"Författning","thesis":"Uppsats","tvBroadcast":"TV-sändning","videoRecording":"Videoinspelning","webpage":"Webbsida"},"fields":{"abstractNote":"Sammanfattning","accessDate":"Hämtad den","applicationNumber":"Anmälningsnummer","archive":"Arkiv","archiveID":"Archive ID","archiveLocation":"Plats i arkiv","artworkMedium":"Medium för konstverk","artworkSize":"Storlek på konstverk","assignee":"Representant","audioFileType":"Filtyp","audioRecordingFormat":"Format","billNumber":"Förarbetets ref. nr.","blogTitle":"Bloggnamn","bookTitle":"Boktitel","callNumber":"Hyllkod","caseName":"Rättsfallsnamn","citationKey":"Citation Key","code":"Författningssamling","codeNumber":"Författningsnummer","codePages":"Sidkod","codeVolume":"Lagband","committee":"Kommitté","company":"Företag","conferenceName":"Namn på konferens","country":"Land","court":"Domstol","date":"Datum","dateAdded":"Tillagd den","dateDecided":"Avgörandedatum","dateEnacted":"Datum för ikraftträdande","dateModified":"Ändrad den","dictionaryTitle":"Ordbokstitel","distributor":"Distributör","docketNumber":"Målnummer","documentNumber":"Dokumentnummer","DOI":"DOI","edition":"Upplaga","encyclopediaTitle":"Uppslagsverkstitel","episodeNumber":"Avsnittsnummer","extra":"Extra","filingDate":"Ansökningsdatum","firstPage":"Första sida","forumTitle":"Titel på forum/listserver","genre":"Genre","history":"Historia","institution":"Institution","interviewMedium":"Media","ISBN":"ISBN","ISSN":"ISSN","issue":"Nummer","issueDate":"Utgivningsdatum","issuingAuthority":"Utgivare","itemType":"Typ","journalAbbreviation":"Tidskriftsförkortning","label":"Stämpel","language":"Språk","legalStatus":"Rättslig status","legislativeBody":"Lagstiftande organ","letterType":"Brevtyp","libraryCatalog":"Bibliotekskatalog","manuscriptType":"Manustyp","mapType":"Karttyp","meetingName":"Namn på möte","nameOfAct":"Författningens namn","network":"Nätverk","number":"Nummer","numberOfVolumes":"# volymer","numPages":"# sidor","pages":"Sidor","patentNumber":"Patentnummer","place":"Ort","postType":"Källtyp","presentationType":"Presentationstyp","priorityNumbers":"Prioritetsnummer","proceedingsTitle":"Protokolltitel","programmingLanguage":"Prog. språk","programTitle":"Programtitel","publicationTitle":"Publikation","publicLawNumber":"Public Law Number","publisher":"Utgivare","references":"Källhänvisningar","reporter":"Referatsamling","reporterVolume":"Referattyp","reportNumber":"Rapportnummer","reportType":"Rapporttyp","repository":"Repository","rights":"Rättigheter","runningTime":"Inspelningslängd","scale":"Skala","section":"Avsnitt","series":"Bokserie","seriesNumber":"Nummer i bokserie","seriesText":"Bokseries text","seriesTitle":"Titel på bokserie","session":"Session","shortTitle":"Kort titel","studio":"Studio","subject":"Ämne","system":"System","thesisType":"Uppsatstyp","title":"Titel","university":"Lärosäte","url":"Webbadress","versionNumber":"Version","videoRecordingFormat":"Format","volume":"Band/Årgång","websiteTitle":"Titel på webbplats","websiteType":"Webbplatstyp"},"creatorTypes":{"artist":"Konstnär","attorneyAgent":"Ombud/Agent","author":"Författare","bookAuthor":"Bokförfattare","cartographer":"Kartograf","castMember":"Skådespelare","commenter":"Kommentator","composer":"Kompositör","contributor":"Medarbetare","cosponsor":"Medsponsor","counsel":"Handledare","director":"Regissör","editor":"Redaktör","guest":"Gäst","interviewee":"Intervju med","interviewer":"Intervjuare","inventor":"Uppfinnare","performer":"Artist","podcaster":"Poddsändare","presenter":"Presentatör","producer":"Producent","programmer":"Programmerare","recipient":"Mottagare","reviewedAuthor":"Recenserad författare","scriptwriter":"Manusförfattare","seriesEditor":"Redaktör för bokserie","sponsor":"Förslagsläggare","translator":"Översättare","wordsBy":"Text av"}},"th-TH":{"itemTypes":{"annotation":"ความเห็นประกอบ","artwork":"งานศิลป์","attachment":"แฟ้มแนบ","audioRecording":"โสตวัสดุ","bill":"เอกสารกฎหมาย","blogPost":"บทความบล็อก","book":"หนังสือ","bookSection":"บทหนึ่งในหนังสือ","case":"เหตุการณ์/คดี","computerProgram":"Software","conferencePaper":"เอกสารประชุมวิชาการ","dictionaryEntry":"พจนานุกรม","document":"เอกสาร","email":"อีเมล","encyclopediaArticle":"บทความสารานุกรม","film":"ภาพยนตร์","forumPost":"ข้อความในฟอรั่ม","hearing":"การฟังความคิดเห็น","instantMessage":"ข้อความด่วน","interview":"บทสัมภาษณ์","journalArticle":"บทความวารสาร","letter":"จดหมาย","magazineArticle":"บทความนิตยสาร","manuscript":"เอกสารต้นฉบับ","map":"แผนที่","newspaperArticle":"บทความหนังสือพิมพ์","note":"บันทึก","patent":"สิทธิบัตร","podcast":"พอดคาสต์","preprint":"Preprint","presentation":"เอกสารการนำเสนอ","radioBroadcast":"รายการวิทยุ","report":"รายงาน","statute":"บัญญัติ","thesis":"วิทยานิพนธ์","tvBroadcast":"รายการโทรทัศน์","videoRecording":"วีดิทัศน์","webpage":"หน้าเว็บ"},"fields":{"abstractNote":"บทคัดย่อ","accessDate":"สืบค้นเมื่อ","applicationNumber":"หมายเลขคำขอ","archive":"เอกสารสำคัญ","archiveID":"Archive ID","archiveLocation":"ที่เก็บเอกสารสำคัญ","artworkMedium":"สื่อ","artworkSize":"ขนาดอาร์ตเวิร์ก","assignee":"ผู้รับโอนสิทธิ์","audioFileType":"ประเภทแฟ้ม","audioRecordingFormat":"รูปแบบ","billNumber":"หมายเลขเอกสารกฎหมาย","blogTitle":"ชื่อบล็อก","bookTitle":"ชื่อหนังสือ","callNumber":"หมายเลขหิ้งหนังสือ","caseName":"หมายเลขคดี","citationKey":"Citation Key","code":"ประมวลกฎหมาย","codeNumber":"หมายเลขประมวลกฎหมาย","codePages":"เลขหน้าประมวลกฎหมาย","codeVolume":"หมวดประมวลกฎหมาย","committee":"คณะกรรมการ","company":"บริษัท","conferenceName":"ชื่อการประชุม","country":"ประเทศ","court":"ศาล","date":"วันที่","dateAdded":"วันที่เพิ่ม","dateDecided":"วันที่พิจารณา","dateEnacted":"วันที่ออกกฎหมาย","dateModified":"แก้ไข","dictionaryTitle":"ชื่อพจนานุกรม","distributor":"ผู้แจกจ่าย","docketNumber":"หมายเลขคำพิพากษา","documentNumber":"หมายเลขเอกสาร","DOI":"DOI","edition":"ครั้งที่พิมพ์","encyclopediaTitle":"ชื่อสารานุกรม","episodeNumber":"ตอนที่","extra":"สิ่งที่เพิ่มเติม","filingDate":"วันที่เข้าแฟ้ม","firstPage":"หน้าแรก","forumTitle":"ชื่อฟอรั่ม","genre":"ประเภท","history":"ประวัติ","institution":"สถาบัน","interviewMedium":"สื่อ","ISBN":"ISBN","ISSN":"ISSN","issue":"ฉบับที่","issueDate":"วันที่ออกหนังสือ","issuingAuthority":"อำนาจการออกเอกสาร","itemType":"ประเภท","journalAbbreviation":"ชื่อย่อวารสาร","label":"ป้าย","language":"ภาษา","legalStatus":"สถานภาพตามกฎหมาย","legislativeBody":"สภานิติบัญญัติ","letterType":"ประเภท","libraryCatalog":"ฐานข้อมูลห้องสมุด","manuscriptType":"ประเภท","mapType":"ประเภท","meetingName":"ชื่อการประชุม","nameOfAct":"ชื่อพ.ร.บ.","network":"เครือข่าย","number":"หมายเลข","numberOfVolumes":"จำนวนเล่ม","numPages":"จำนวนหน้า","pages":"เลขหน้า","patentNumber":"หมายเลขสิทธิบัตร","place":"สถานที่พิมพ์","postType":"ประเภทข้อความ","presentationType":"ประเภท","priorityNumbers":"หมายเลขลำดับก่อน","proceedingsTitle":"ชื่อเอกสารการประชุม","programmingLanguage":"Prog. Language","programTitle":"ชื่อโปรแกรม","publicationTitle":"สิ่งพิมพ์เผยแพร่","publicLawNumber":"หมายเลขกฎหมายมหาชน","publisher":"สำนักพิมพ์","references":"เอกสารอ้างอิง","reporter":"ผู้รายงาน","reporterVolume":"รายงานเล่มที่","reportNumber":"หมายเลขรายงาน","reportType":"ประเภทรายงาน","repository":"Repository","rights":"ลิขสิทธิ์","runningTime":"ระยะเวลาเล่นต่อเนื่อง","scale":"มาตราส่วน","section":"ส่วน","series":"ชุด","seriesNumber":"หมายเลขชุด","seriesText":"หัวข้อชุด","seriesTitle":"ชื่อชุด","session":"สมัยประชุม","shortTitle":"ชื่อย่อเรื่อง","studio":"สตูดิโอ","subject":"เรื่อง","system":"ระบบ","thesisType":"ประเภท","title":"ชื่อเรื่อง","university":"มหาวิทยาลัย","url":"URL","versionNumber":"รุ่น","videoRecordingFormat":"รูปแบบ","volume":"ปีที่พิมพ์","websiteTitle":"ชื่อเว็บไซต์","websiteType":"ประเภทเว็บไซต์"},"creatorTypes":{"artist":"ศิลปิน","attorneyAgent":"ผู้รับมอบอำนาจ/ตัวแทน","author":"ผู้แต่ง","bookAuthor":"ผู้แต่งหนังสือ","cartographer":"ผู้ทำแผนที่","castMember":"นักแสดง","commenter":"ผู้ออกความเห็น","composer":"นักแต่งเพลง","contributor":"ผู้ช่วยเหลือ","cosponsor":"ผู้อุปถัมภ์ร่วม","counsel":"ทนายความ","director":"ผู้อำนวยการ","editor":"บรรณาธิการ","guest":"ผู้รับเชิญ","interviewee":"สัมภาษณ์กับ","interviewer":"ผู้สัมภาษณ์","inventor":"ผู้ประดิษฐ์","performer":"นักแสดง","podcaster":"ผู้สร้างพอดคาสต์","presenter":"ผู้นำเสนอ","producer":"ผู้กำกับ","programmer":"นักเขียนโปรแกรม","recipient":"ผู้รับ","reviewedAuthor":"ผู้เขียนบทวิจารณ์","scriptwriter":"ผู้เขียนบท","seriesEditor":"บรรณาธิการชุดย่อย","sponsor":"ผู้อุปถัมภ์","translator":"ผู้แปล","wordsBy":"สุนทรพจน์โดย"}},"tr-TR":{"itemTypes":{"annotation":"Ek Açıklama","artwork":"Sanat eseri","attachment":"Ek","audioRecording":"Ses Kaydı","bill":"Kanun önergesi","blogPost":"Günlük Yazısı","book":"Kitap","bookSection":"Kitap Bölümü","case":"Dava","computerProgram":"Yazılım","conferencePaper":"Konferans Bildirisi","dictionaryEntry":"Sözlük Girdisi","document":"Doküman","email":"E-posta","encyclopediaArticle":"Ansiklopedi Makalesi","film":"Film","forumPost":"Forum İletisi","hearing":"Kurul ifadesi","instantMessage":"Anlık İleti","interview":"Görüşme","journalArticle":"Bilimsel Dergi Makalesi","letter":"Mektup","magazineArticle":"Genel Dergi Makalesi","manuscript":"El Yazması","map":"Harita","newspaperArticle":"Gazete Makalesi","note":"Not","patent":"Patent","podcast":"Podcast","preprint":"Ön Baskı","presentation":"Sunum","radioBroadcast":"Radyo Yayını","report":"Rapor","statute":"Kanun","thesis":"Tez","tvBroadcast":"TV Yayını","videoRecording":"Video Kaydı","webpage":"Web Sayfası"},"fields":{"abstractNote":"Özet","accessDate":"Son Erişim","applicationNumber":"Uygulama Numarası","archive":"Arşiv","archiveID":"Arşiv Kimlik Numarası","archiveLocation":"Arşivdeki Yeri","artworkMedium":"Sanat Eseri Ortamı","artworkSize":"Sanat Eserinin Boyutu","assignee":"Devralan","audioFileType":"Dosya Türü","audioRecordingFormat":"Biçim","billNumber":"Kanun Önerge Numarası","blogTitle":"Blog Başlığı","bookTitle":"Kitap Başlığı","callNumber":"Yer Numarası","caseName":"Dava Adı","citationKey":"Alıntı Anahtarı","code":"Kanun","codeNumber":"Kanun Numarası","codePages":"Kanun Sayfası","codeVolume":"Kanun Cildi","committee":"Kurul","company":"Şirket","conferenceName":"Konferans Adı","country":"Ülke","court":"Mahkeme","date":"Tarih","dateAdded":"Eklendiği Tarih","dateDecided":"Kesin Tarih","dateEnacted":"Kabul Tarihi","dateModified":"Değiştirme","dictionaryTitle":"Sözlük Başlığı","distributor":"Dağıtımcı","docketNumber":"Dava Numarası","documentNumber":"Doküman Numarası","DOI":"DOI","edition":"Baskı","encyclopediaTitle":"Ansiklopedi Başlığı","episodeNumber":"Bölüm Numarası","extra":"İlave","filingDate":"Başvuru Tarihi","firstPage":"İlk Sayfa","forumTitle":"Forum/Liste Başlığı","genre":"Çeşit","history":"Tarihçe","institution":"Kurum","interviewMedium":"Ortam","ISBN":"ISBN","ISSN":"ISSN","issue":"Sayı","issueDate":"Yayın Tarihi","issuingAuthority":"Düzenleyen Makam","itemType":"Tür","journalAbbreviation":"Dergi Kısaltması","label":"Plak şirketi","language":"Dil","legalStatus":"Hukuki Durum","legislativeBody":"Yasama Organı","letterType":"Tür","libraryCatalog":"Kütüphane Kataloğu","manuscriptType":"Tür","mapType":"Tür","meetingName":"Toplantı Adı","nameOfAct":"Kanun Adı","network":"Ağ","number":"Numara","numberOfVolumes":"Cilt Sayısı","numPages":"Sayfa Sayısı","pages":"Sayfa","patentNumber":"Patent Numarası","place":"Yayın Yeri","postType":"Post Türü","presentationType":"Tür","priorityNumbers":"Rüçhan Numarası","proceedingsTitle":"Bildiriler Başlığı","programmingLanguage":"Prog. Dili","programTitle":"Program Başlığı","publicationTitle":"Yayın","publicLawNumber":"Kamu Hukuku Numarası","publisher":"Yayıncı","references":"Kaynakça","reporter":"Raporlayan Kitap","reporterVolume":"Raporlayon Kitabın Cildi","reportNumber":"Rapor Numarası","reportType":"Rapor Türü","repository":"Depo","rights":"Telif","runningTime":"Çalma Süresi","scale":"Boyutları","section":"Bölüm","series":"Dizi","seriesNumber":"Dizi Numarası","seriesText":"Dizi Metni","seriesTitle":"Dizi Başlığı","session":"Oturum","shortTitle":"Kısa Başlık","studio":"Stüdyo","subject":"Konu","system":"Sistem","thesisType":"Tür","title":"Başlık","university":"Üniversite","url":"URL","versionNumber":"Sürüm","videoRecordingFormat":"Biçim","volume":"Cilt","websiteTitle":"Web sitesi Başlığı","websiteType":"Website Türü"},"creatorTypes":{"artist":"Sanatçı","attorneyAgent":"Avukat/Vekil","author":"Yazar","bookAuthor":"Kitap Yazarı","cartographer":"Haritacı","castMember":"Oyuncu","commenter":"Yorumcu","composer":"Besteci","contributor":"Katkıda Bulunan","cosponsor":"Birlikte Destekleyen","counsel":"Avukat","director":"Yönetmen","editor":"Editör","guest":"Konuk","interviewee":"Görüşme Yapılan","interviewer":"Görüşmeci","inventor":"Buluş Sahibi","performer":"Yorumcu","podcaster":"Podcast yapan","presenter":"Sunucu","producer":"Yapımcı","programmer":"Programcı","recipient":"Alıcı","reviewedAuthor":"Eleştirilen Yazar","scriptwriter":"Senaryo Yazarı","seriesEditor":"Dizi Editörü","sponsor":"Destekleyen","translator":"Çevirmen","wordsBy":"Yazan"}},"uk-UA":{"itemTypes":{"annotation":"Анотація","artwork":"Витвір мистецтва","attachment":"Вкладення","audioRecording":"Аудіозапис","bill":"Законопроект","blogPost":"Запис в блозі","book":"Книга","bookSection":"Глава книги","case":"Справа","computerProgram":"Software","conferencePaper":"Документ конференції","dictionaryEntry":"Стаття зі словника","document":"Документ","email":"E-mail","encyclopediaArticle":"Стаття з екциклопедії","film":"Фільм","forumPost":"Запис на форумі","hearing":"Слухання","instantMessage":"Миттєве повідомлення","interview":"Інтерв'ю","journalArticle":"Стаття з журналу","letter":"Лист","magazineArticle":"Стаття з періодики","manuscript":"Рукопис","map":"Карта","newspaperArticle":"Стаття з газети","note":"Примітка","patent":"Патент","podcast":"Подкаст","preprint":"Preprint","presentation":"Презентація","radioBroadcast":"Радіо передача","report":"Звіт","statute":"Статут","thesis":"Дисертація","tvBroadcast":"Телевізійна передача","videoRecording":"Відео запис","webpage":"Веб сторінка"},"fields":{"abstractNote":"Анотація","accessDate":"Дата доступу","applicationNumber":"Номер заявки","archive":"Архів","archiveID":"Archive ID","archiveLocation":"Місце в архіві","artworkMedium":"Художній засіб","artworkSize":"Розмір роботи","assignee":"Представник","audioFileType":"Тип файлу","audioRecordingFormat":"Формат","billNumber":"Номер законопр.","blogTitle":"Назва блогу","bookTitle":"Назва книги","callNumber":"Шифр","caseName":"Номер справи","citationKey":"Citation Key","code":"Код","codeNumber":"Номер коду","codePages":"Код сторінки","codeVolume":"Код тому","committee":"Комітет","company":"Компанія","conferenceName":"Назва конфер.","country":"Країна","court":"Суд","date":"Дата","dateAdded":"Дата додавання","dateDecided":"Дата рішення","dateEnacted":"Дата постанови","dateModified":"Дата зміни","dictionaryTitle":"Назва словника","distributor":"Бібл. каталог","docketNumber":"Номер виставки","documentNumber":"Номер документа","DOI":"DOI","edition":"Видання","encyclopediaTitle":"Назва енцикл.","episodeNumber":"Номер епізоду","extra":"Додатково","filingDate":"Дата заявки","firstPage":"Перша стор.","forumTitle":"Форум/Listserv","genre":"Жанр","history":"Історія","institution":"Заклад","interviewMedium":"Засіб","ISBN":"ISBN","ISSN":"ISSN","issue":"Випуск","issueDate":"Дата випуску","issuingAuthority":"Ким видана","itemType":"Тип","journalAbbreviation":"Журнал скор.","label":"Напис","language":"Мова","legalStatus":"Правовий статус","legislativeBody":"Законотвор. орган","letterType":"Тип","libraryCatalog":"Бібл. каталог","manuscriptType":"Тип","mapType":"Тип","meetingName":"Назва зустрічі","nameOfAct":"Назва постанови","network":"Мережа","number":"Номер","numberOfVolumes":"Кільк. томів","numPages":"Кільк. сторінок","pages":"Сторінки","patentNumber":"Номер патенту","place":"Місце","postType":"Тип повідомлення","presentationType":"Тип","priorityNumbers":"Номер пріоритету","proceedingsTitle":"Назва праць","programmingLanguage":"Prog. Language","programTitle":"Назва програми","publicationTitle":"Публікація","publicLawNumber":"Номер закону","publisher":"Видавник","references":"Посилання","reporter":"Репортер","reporterVolume":"Том звіту","reportNumber":"Номер звіту","reportType":"Тип звіту","repository":"Repository","rights":"Права","runningTime":"Тривалість","scale":"Масштаб","section":"Розділ","series":"Серія","seriesNumber":"Номер серії","seriesText":"Текст серії","seriesTitle":"Назва серії","session":"Сесія","shortTitle":"Скор. назва","studio":"Студія","subject":"Тема","system":"Система","thesisType":"Тип","title":"Назва","university":"Університет","url":"URL","versionNumber":"Версія","videoRecordingFormat":"Формат","volume":"Том","websiteTitle":"Назва веб-сайту\\n","websiteType":"Тип веб-сайту"},"creatorTypes":{"artist":"Художник","attorneyAgent":"Адвокат/Агент","author":"Автор","bookAuthor":"Автор книги","cartographer":"Картограф","castMember":"Актор","commenter":"Коментатор","composer":"Композитор","contributor":"Співавтор","cosponsor":"Спонсор","counsel":"Радник","director":"Режисер","editor":"Редактор","guest":"Гість","interviewee":"Співбесіда з","interviewer":"Інтерв'юер","inventor":"Винахідник","performer":"Виконавець","podcaster":"Підкастер","presenter":"Доповідач","producer":"Продюсер","programmer":"Програміст","recipient":"Отримувач","reviewedAuthor":"Реценз. автор","scriptwriter":"Сценарист","seriesEditor":"Редактор серії","sponsor":"Спонсор","translator":"Перекладач","wordsBy":"Автор слів"}},"vi-VN":{"itemTypes":{"annotation":"Ghi chú","artwork":"Minh họa","attachment":"Phần đính kèm","audioRecording":"Ghi âm","bill":"Dự thảo luật","blogPost":"Bài viết trên Blog","book":"Sách","bookSection":"Đoạn Sách","case":"Vụ việc","computerProgram":"Software","conferencePaper":"Báo cáo Hội thảo","dictionaryEntry":"Mục từ trong Từ điển","document":"Tài liệu","email":"Thư điện tử","encyclopediaArticle":"Bài viết trong Bách khoa toàn thư","film":"Phim","forumPost":"Bài viết trên Diễn đàn","hearing":"Phiên xét xử","instantMessage":"Tin nhắn","interview":"Phỏng vấn","journalArticle":"Bài viết trong Tập san","letter":"Thư","magazineArticle":"Bài viết trong Tạp chí","manuscript":"Bản thảo","map":"Bản đồ","newspaperArticle":"Bài viết trên Báo","note":"Ghi chép","patent":"Bằng sáng chế/Giấy phép độc quyền","podcast":"Podcast","preprint":"Preprint","presentation":"Trình bày","radioBroadcast":"Tiết mục Truyền thanh","report":"Phóng sự/Báo cáo","statute":"Quy chế","thesis":"Luận văn","tvBroadcast":"Tiết mục Truyền hình","videoRecording":"Ghi hình","webpage":"Trang Web"},"fields":{"abstractNote":"Tóm tắt","accessDate":"Ngày truy cập","applicationNumber":"Số đơn","archive":"Lưu","archiveID":"Archive ID","archiveLocation":"Vị trí trong Lưu trữ","artworkMedium":"Chất liệu của tác phẩm","artworkSize":"Kích thước tác phẩm","assignee":"Bên được ủy quyền","audioFileType":"Kiểu Tập tin","audioRecordingFormat":"Định dạng","billNumber":"Số Dự thảo","blogTitle":"Nhan đề Blog","bookTitle":"Nhan đề sách","callNumber":"Ký hiệu Xếp giá","caseName":"Tên của Vụ việc","citationKey":"Citation Key","code":"Mã","codeNumber":"Code Number","codePages":"Trang","codeVolume":"Số tập trong Bộ luật","committee":"Ủy ban","company":"Công ty","conferenceName":"Tên Hội thảo","country":"Quốc gia","court":"Tòa án","date":"Ngày","dateAdded":"Ngày Tạo lập","dateDecided":"Ngày Phán Xử","dateEnacted":"Ngày có Hiệu lực","dateModified":"Ngày Thay đổi","dictionaryTitle":"Tên của Từ Điển","distributor":"Nhà phân phối","docketNumber":"Docket Number","documentNumber":"Số Văn bản","DOI":"DOI","edition":"Ấn bản","encyclopediaTitle":"Tên của Bách Khoa Toàn Thư","episodeNumber":"Số Hồi","extra":"Phần bổ sung","filingDate":"Filing Date","firstPage":"Trang đầu","forumTitle":"Tên của Diễn đàn/Danh sách Thư điện tử","genre":"Thể loại","history":"Lịch sử","institution":"Tổ chức/Cơ quan","interviewMedium":"Phương tiện","ISBN":"ISBN","ISSN":"ISSN","issue":"Lần phát hành","issueDate":"Ngày cấp","issuingAuthority":"Issuing Authority","itemType":"Kiểu","journalAbbreviation":"Tên rút ngắn của Tập san","label":"Nhãn","language":"Ngôn ngữ","legalStatus":"Tình trạng Pháp lý","legislativeBody":"Cơ quan Lập pháp","letterType":"Kiểu","libraryCatalog":"Loại thư viện","manuscriptType":"Kiểu","mapType":"Kiểu","meetingName":"Tên Cuộc họp","nameOfAct":"Tên của Bộ Luật","network":"Mạng","number":"Số","numberOfVolumes":"Số Tập","numPages":"# of Pages","pages":"Trang","patentNumber":"Số Bắng sáng chế","place":"Nơi xuất bản","postType":"Kiểu Bài viết","presentationType":"Kiểu","priorityNumbers":"Số Ưu tiên","proceedingsTitle":"Nhan đề của Kỷ yếu Hội nghị","programmingLanguage":"Prog. Language","programTitle":"Program Title","publicationTitle":"Ấn phẩm","publicLawNumber":"Số Luật Dân sự","publisher":"Nhà xuất bản","references":"Tham khảo","reporter":"Phóng viên","reporterVolume":"Tập Báo cáo Luật","reportNumber":"Số Phóng sự/Báo cáo","reportType":"Kiểu Phóng sự/Báo cáo","repository":"Repository","rights":"Quyền hạn","runningTime":"Độ dài Thời gian","scale":"Tỷ lệ","section":"Đoạn","series":"Tùng thư","seriesNumber":"Số Tùng thư","seriesText":"Miêu tả Tùng thư","seriesTitle":"Nhan đề của Tùng thư","session":"Phiên","shortTitle":"Nhan đề thu gọn","studio":"Xưởng sản xuất","subject":"Chủ đề","system":"Hệ thống","thesisType":"Kiểu","title":"Nhan đề","university":"Trường Đại Học","url":"URL","versionNumber":"Phiên bản","videoRecordingFormat":"Định dạng","volume":"Tập","websiteTitle":"Tên Website","websiteType":"Kiểu Website"},"creatorTypes":{"artist":"Nghệ sĩ","attorneyAgent":"Luật sư/Đại diện pháp lý","author":"Tác giả","bookAuthor":"Book Author","cartographer":"Người vẽ bản đồ","castMember":"Thành viên đoàn kịch","commenter":"Bình luận viên","composer":"Nhà soạn nhạc","contributor":"Cộng tác viên","cosponsor":"Cosponsor","counsel":"Nhà tư vấn","director":"Đạo diễn","editor":"Biên tập viên","guest":"Khách mời","interviewee":"Người được phỏng vấn","interviewer":"Người phỏng vấn","inventor":"Nhà phát minh","performer":"Người biểu diễn","podcaster":"Podcaster","presenter":"Dẫn chương trình","producer":"Nhà sản xuất","programmer":"Lập trình viên","recipient":"Người nhận","reviewedAuthor":"Nhà phê bình/Người phản biện","scriptwriter":"Tác giả Kịch bản","seriesEditor":"Biên tập viên của Tùng thư","sponsor":"Tài trợ/Đỡ đầu","translator":"Biên dịch viên","wordsBy":"Viết lời"}},"zh-CN":{"itemTypes":{"annotation":"注释","artwork":"艺术品","attachment":"附件","audioRecording":"音频","bill":"法案","blogPost":"博客帖子","book":"书籍","bookSection":"图书章节","case":"司法案例","computerProgram":"软件","conferencePaper":"会议论文","dictionaryEntry":"词条","document":"文档","email":"E-mail","encyclopediaArticle":"百科全书文章","film":"电影","forumPost":"论坛帖子","hearing":"听证会","instantMessage":"即时讯息","interview":"采访稿","journalArticle":"期刊文章","letter":"信件","magazineArticle":"杂志文章","manuscript":"手稿","map":"地图","newspaperArticle":"报纸文章","note":"笔记","patent":"专利","podcast":"播客","preprint":"预印本","presentation":"演示文档","radioBroadcast":"电台广播","report":"报告","statute":"法规","thesis":"学位论文","tvBroadcast":"电视广播","videoRecording":"视频","webpage":"网页"},"fields":{"abstractNote":"摘要","accessDate":"访问时间","applicationNumber":"申请号","archive":"档案","archiveID":"存档ID","archiveLocation":"存档位置","artworkMedium":"艺术品媒介","artworkSize":"艺术品尺寸","assignee":"受托人","audioFileType":"音频文件类型","audioRecordingFormat":"音频格式","billNumber":"法案编号","blogTitle":"博客标题","bookTitle":"书名","callNumber":"索书号","caseName":"案例名称","citationKey":"引用关键词","code":"法典","codeNumber":"法典编号","codePages":"法典页码","codeVolume":"法典卷次","committee":"委员会","company":"公司","conferenceName":"会议名称","country":"国家","court":"审判法院","date":"日期","dateAdded":"添加日期","dateDecided":"裁判时间","dateEnacted":"颁布日期","dateModified":"修改日期","dictionaryTitle":"词典标题","distributor":"分发者","docketNumber":"案号","documentNumber":"文档编号","DOI":"DOI","edition":"版本","encyclopediaTitle":"百科全书标题","episodeNumber":"集数","extra":"其它","filingDate":"申请日期","firstPage":"起始页","forumTitle":"论坛/列表服务标题","genre":"流派","history":"历史","institution":"机构组织","interviewMedium":"采访媒体","ISBN":"ISBN","ISSN":"ISSN","issue":"期号","issueDate":"公告日期","issuingAuthority":"颁发机构","itemType":"类型","journalAbbreviation":"刊名缩写","label":"标记","language":"语言","legalStatus":"法律状态","legislativeBody":"立法机构","letterType":"信件类型","libraryCatalog":"馆藏目录","manuscriptType":"手稿类型","mapType":"地图类型","meetingName":"会议名称","nameOfAct":"法律名称","network":"网络","number":"号码","numberOfVolumes":"总卷数","numPages":"总页数","pages":"页码","patentNumber":"专利号","place":"地点","postType":"帖子类型","presentationType":"演稿类型","priorityNumbers":"优先申请号","proceedingsTitle":"会议论文集标题","programmingLanguage":"编程语言","programTitle":"节目名称","publicationTitle":"期刊","publicLawNumber":"公法号","publisher":"出版社","references":"参考文献","reporter":"报告系统","reporterVolume":"报告系统卷次","reportNumber":"报告编号","reportType":"报告类型","repository":"仓库","rights":"版权","runningTime":"时长","scale":"比例","section":"条文序号","series":"系列","seriesNumber":"系列编号","seriesText":"系列文本","seriesTitle":"系列标题","session":"会期","shortTitle":"短标题","studio":"工作室","subject":"主题","system":"系统","thesisType":"论文类型","title":"标题","university":"大学","url":"URL","versionNumber":"版本","videoRecordingFormat":"视频格式","volume":"卷次","websiteTitle":"网站标题","websiteType":"网站类型"},"creatorTypes":{"artist":"艺术家","attorneyAgent":"律师/代理人","author":"作者","bookAuthor":"图书作者","cartographer":"制图人","castMember":"演员阵容","commenter":"评论人","composer":"创作者","contributor":"贡献者","cosponsor":"共同发起人","counsel":"顾问","director":"导演","editor":"编辑","guest":"宾客","interviewee":"采访对象","interviewer":"采访者","inventor":"发明人","performer":"表演者","podcaster":"播客","presenter":"报告人","producer":"制片人","programmer":"程序员","recipient":"接收者","reviewedAuthor":"审稿人","scriptwriter":"编剧","seriesEditor":"丛书编辑","sponsor":"发起人","translator":"译者","wordsBy":"作词"}},"zh-TW":{"itemTypes":{"annotation":"備註","artwork":"藝術作品","attachment":"附件檔","audioRecording":"錄音","bill":"法案","blogPost":"部落格貼文","book":"書","bookSection":"書的章節","case":"案例","computerProgram":"軟體","conferencePaper":"會議論文","dictionaryEntry":"字典條目","document":"文件","email":"電子郵件","encyclopediaArticle":"百科全書文章","film":"影片","forumPost":"論壇貼文","hearing":"聽證會","instantMessage":"即時訊息","interview":"訪談","journalArticle":"期刊文章","letter":"信件","magazineArticle":"雜誌文章","manuscript":"手稿","map":"地圖","newspaperArticle":"報紙文章","note":"筆記","patent":"專利","podcast":"播客","preprint":"预印本","presentation":"簡報","radioBroadcast":"電台廣播","report":"報告","statute":"法規","thesis":"碩博士論文","tvBroadcast":"電視廣播","videoRecording":"錄影","webpage":"網頁"},"fields":{"abstractNote":"摘要","accessDate":"取用","applicationNumber":"申請號碼","archive":"存庫","archiveID":"存档ID","archiveLocation":"文件庫中的位置","artworkMedium":"中","artworkSize":"藝術作品大小","assignee":"代理人","audioFileType":"檔案類型","audioRecordingFormat":"格式","billNumber":"法案編號","blogTitle":"部落格標題","bookTitle":"書名","callNumber":"索書號","caseName":"案件名稱","citationKey":"引用关键词","code":"法規(code)","codeNumber":"法規(code)編號","codePages":"法規(code)頁次","codeVolume":"法規(code)卷次","committee":"委員會","company":"公司","conferenceName":"會議名稱","country":"國家","court":"法庭","date":"日期","dateAdded":"加入日期","dateDecided":"決定日期","dateEnacted":"頒布日期","dateModified":"修改日期","dictionaryTitle":"字典名稱","distributor":"發行人","docketNumber":"表件號碼","documentNumber":"文件號碼","DOI":"數位物件識別號(DOI)","edition":"版本","encyclopediaTitle":"百科全書書名","episodeNumber":"劇集號碼","extra":"額外增列","filingDate":"歸檔日期","firstPage":"起始頁","forumTitle":"論壇/郵寄服務標題","genre":"流派","history":"歷史","institution":"機構","interviewMedium":"中","ISBN":"國際標準書號(ISBN)","ISSN":"國際標準期刊號(ISSN)","issue":"期號","issueDate":"發刊日期","issuingAuthority":"發行當局","itemType":"類型","journalAbbreviation":"期刊簡寫","label":"商標","language":"語言","legalStatus":"法律地位","legislativeBody":"立法機構","letterType":"類型","libraryCatalog":"文獻庫目錄","manuscriptType":"類型","mapType":"類型","meetingName":"會議名稱","nameOfAct":"法令(Act)名稱","network":"網路","number":"號碼","numberOfVolumes":"總卷數","numPages":"頁數","pages":"頁","patentNumber":"專利號","place":"所在地","postType":"貼文類型","presentationType":"類型","priorityNumbers":"優先權案號","proceedingsTitle":"會議論文集標題","programmingLanguage":"Prog. 语言","programTitle":"節目標題","publicationTitle":"著作","publicLawNumber":"公法號碼","publisher":"出版者","references":"參考文獻","reporter":"報告人","reporterVolume":"報告人卷次","reportNumber":"報告編號","reportType":"報告類型","repository":"仓库","rights":"權利","runningTime":"播放時間","scale":"比例","section":"章節","series":"系列","seriesNumber":"系列號數","seriesText":"系列文","seriesTitle":"系列標題","session":"會議時程","shortTitle":"短名","studio":"工作室","subject":"主題","system":"系統","thesisType":"類型","title":"標題","university":"大學","url":"URL","versionNumber":"版本","videoRecordingFormat":"格式","volume":"卷次","websiteTitle":"網站標題","websiteType":"網站類型"},"creatorTypes":{"artist":"藝術家","attorneyAgent":"律師/代理人","author":"作者","bookAuthor":"書籍作者","cartographer":"製圖者","castMember":"演員陣容","commenter":"評論家","composer":"作曲者","contributor":"貢獻者","cosponsor":"共同贊助者","counsel":"顧問","director":"導演","editor":"編輯者","guest":"來賓","interviewee":"受訪者","interviewer":"訪談者","inventor":"發明人","performer":"表演者","podcaster":"播客","presenter":"簡報者","producer":"製作人","programmer":"節目設計者","recipient":"領受者","reviewedAuthor":"所評論的作者","scriptwriter":"編劇","seriesEditor":"系列編輯者","sponsor":"贊助者","translator":"翻譯者","wordsBy":"敘述者"}}}});

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var g = _globalThis__default["default"];
g.Zotero = _objectSpread$2({
  debug: console.log,
  Date: Utilities_Date,
  Schema: {
    init: Schema.init
  },
  Utilities: _objectSpread$2(_objectSpread$2({}, Utilities), {}, {
    Item: Utilities_Item
  })
}, CachedTypes);
g.Zotero.locale = 'en-US';
g.Zotero.Schema.init(schemaJSON);
g.Zotero.setTypeSchema(ZOTERO_TYPE_SCHEMA$1);
g.Zotero.Date.init(dateFormats);
var collator = new Intl.Collator([g.Zotero.locale], {
  numeric: true,
  sensitivity: 'base'
});
g.Zotero.localeCompare = collator.compare;
var Zotero$1 = g.Zotero;

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var isLikeZoteroItem = item => item && typeof item === 'object' && 'itemType' in item;
var mergeFetchOptions = (init, globalOpts, localOpts) => {
  var _globalOpts$init, _localOpts$init;

  var headers = _objectSpread$1(_objectSpread$1(_objectSpread$1({}, init.headers || {}), ((_globalOpts$init = globalOpts.init) === null || _globalOpts$init === void 0 ? void 0 : _globalOpts$init.headers) || {}), ((_localOpts$init = localOpts.init) === null || _localOpts$init === void 0 ? void 0 : _localOpts$init.headers) || {});

  return _objectSpread$1(_objectSpread$1(_objectSpread$1(_objectSpread$1({}, init), globalOpts.init || {}), localOpts.init || {}), {}, {
    headers
  });
};

var _excluded = ["endpoint"],
    _excluded2 = ["endpoint"],
    _excluded3 = ["endpoint"],
    _excluded4 = ["endpoint"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var [COMPLETE, MULTIPLE_CHOICES, FAILED] = ['COMPLETE', 'MULTIPLE_CHOICES', 'FAILED'];

class ZoteroTranslationClient {
  constructor(opts) {
    this.opts = _objectSpread(_objectSpread({}, defaults()), opts);

    if (this.opts.persist && this.opts.storage) {
      if (!('getItem' in this.opts.storage || 'setItem' in this.opts.storage || 'clear' in this.opts.storage)) {
        throw new Error('Invalid storage engine provided');
      }

      if (this.opts.override) {
        this.clearItems();
      }

      this.items = [...this.opts.initialItems, ...this.getItemsStorage()].filter(isLikeZoteroItem);
      this.setItemsStorage(this.items);
    } else {
      this.items = [...this.opts.initialItems].filter(isLikeZoteroItem);
    }
  }

  getItemsStorage() {
    var items = this.opts.storage.getItem("".concat(this.opts.storagePrefix, "-items"));
    return items ? JSON.parse(items) : [];
  }

  setItemsStorage(items) {
    this.opts.storage.setItem("".concat(this.opts.storagePrefix, "-items"), JSON.stringify(items));
  }

  reloadItems() {
    this.items = this.getItemsStorage();
  }

  addItem(item) {
    if (!isLikeZoteroItem(item)) {
      throw new Error('Failed to add item');
    }

    this.items.push(item);

    if (this.opts.persist) {
      this.setItemsStorage(this.items);
    }
  }

  updateItem(index, item) {
    this.items[index] = item;

    if (this.opts.persist) {
      this.setItemsStorage(this.items);
    }
  }

  removeItem(item) {
    var index = this.items.indexOf(item);

    if (index !== -1) {
      this.items.splice(index, 1);

      if (this.opts.persist) {
        this.setItemsStorage(this.items);
      }

      return item;
    }

    return false;
  }

  clearItems() {
    this.items = [];

    if (this.opts.persist) {
      this.setItemsStorage(this.items);
    }
  }

  get itemsCSL() {
    return this.items.map(i => Zotero$1.Utilities.Item.itemToCSLJSON(_objectSpread(_objectSpread({}, i), {}, {
      uri: i.key
    })));
  }

  get itemsRaw() {
    return this.items;
  }

  exportItems(format) {
    var _arguments = arguments,
        _this = this;

    return _asyncToGenerator__default["default"](function* () {
      var opts = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
      var translateURL = "".concat(_this.opts.translateURL, "/").concat(_this.opts.translatePrefix, "export?format=").concat(format);
      var fetchOptions = mergeFetchOptions({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(_this.items.filter(i => 'key' in i))
      }, _this.opts, opts);
      var response = yield fetch(translateURL, fetchOptions);

      if (response.ok) {
        return yield response.text();
      } else {
        throw new Error('Failed to export items');
      }
    })();
  }

  translateIdentifier(identifier) {
    var _arguments2 = arguments,
        _this2 = this;

    return _asyncToGenerator__default["default"](function* () {
      var _ref = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {},
          {
        endpoint = '/search'
      } = _ref,
          opts = _objectWithoutProperties__default["default"](_ref, _excluded);

      var translateURL = "".concat(_this2.opts.translateURL).concat(_this2.opts.translatePrefix).concat(endpoint);
      var init = mergeFetchOptions({
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: identifier
      }, _this2.opts, opts);
      return yield _this2.translate(translateURL, init, opts);
    })();
  }

  translateUrlItems(url, items) {
    var _arguments3 = arguments,
        _this3 = this;

    return _asyncToGenerator__default["default"](function* () {
      var _ref2 = _arguments3.length > 2 && _arguments3[2] !== undefined ? _arguments3[2] : {},
          {
        endpoint = '/web'
      } = _ref2,
          opts = _objectWithoutProperties__default["default"](_ref2, _excluded2);

      var translateURL = "".concat(_this3.opts.translateURL).concat(_this3.opts.translatePrefix).concat(endpoint);

      var data = _objectSpread({
        url,
        items,
        session: _this3.session
      }, _this3.opts.request);

      var init = mergeFetchOptions({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }, _this3.opts, opts);
      return yield _this3.translate(translateURL, init, opts);
    })();
  }

  translateUrl(url) {
    var _arguments4 = arguments,
        _this4 = this;

    return _asyncToGenerator__default["default"](function* () {
      var _ref3 = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : {},
          {
        endpoint = '/web'
      } = _ref3,
          opts = _objectWithoutProperties__default["default"](_ref3, _excluded3);

      var translateURL = "".concat(_this4.opts.translateURL).concat(_this4.opts.translatePrefix).concat(endpoint);
      var init = mergeFetchOptions({
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: url
      }, _this4.opts, opts);
      return yield _this4.translate(translateURL, init, opts);
    })();
  }

  translateImport(data) {
    var _arguments5 = arguments,
        _this5 = this;

    return _asyncToGenerator__default["default"](function* () {
      var _ref4 = _arguments5.length > 1 && _arguments5[1] !== undefined ? _arguments5[1] : {},
          {
        endpoint = '/import'
      } = _ref4,
          opts = _objectWithoutProperties__default["default"](_ref4, _excluded4);

      var translateURL = "".concat(_this5.opts.translateURL).concat(_this5.opts.translatePrefix).concat(endpoint);
      var init = mergeFetchOptions({
        method: 'POST',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: data
      }, _this5.opts, opts);
      return yield _this5.translate(translateURL, init, opts);
    })();
  }

  translate(url, fetchOptions) {
    var _arguments6 = arguments,
        _this6 = this;

    return _asyncToGenerator__default["default"](function* () {
      var {
        add = true
      } = _arguments6.length > 2 && _arguments6[2] !== undefined ? _arguments6[2] : {};
      var response = yield fetch(url, fetchOptions);
      var items,
          result,
          next = null;

      if (response.headers.has('link')) {
        var links = response.headers.get('link');
        var matches = links.match(/<(.*?)>;\s+rel="next"/i);

        if (matches && matches.length > 1) {
          next = matches[1];
        }
      }

      if (response.ok) {
        items = yield response.json();

        if (Array.isArray(items)) {
          items.forEach(item => {
            if (item.accessDate === 'CURRENT_TIMESTAMP') {
              var dt = new Date(Date.now());
              item.accessDate = Zotero$1.Date.dateToSQL(dt, true);
            }

            if (add) {
              _this6.addItem(item);
            }
          });
        }

        result = Array.isArray(items) ? COMPLETE : FAILED;
      } else if (response.status === 300) {
        var data = yield response.json();

        if ('items' in data && 'session' in data) {
          _this6.session = data.session;
          items = data.items;
        } else {
          items = data;
        }

        result = MULTIPLE_CHOICES;
      } else {
        result = FAILED;
      }

      return {
        result,
        items,
        response,
        next
      };
    })();
  }

  static get COMPLETE() {
    return COMPLETE;
  }

  static get MULTIPLE_CHOICES() {
    return MULTIPLE_CHOICES;
  }

  static get FAILED() {
    return FAILED;
  }

}

module.exports = ZoteroTranslationClient;
